(function () {
	'use strict';

	var serviceId = 'datacontext';
	angular.module('app').factory(serviceId, ['common', '_', datacontext]);

	function datacontext(common, _) {

		// #region Variables

		var $q = common.$q;
		var $http = common.$http;
		var urlAPI = '/api';
		var urlROOT = 'http://gol.ciapiweb.org';
		var controllerAccreditamento = '/Candidature/Accreditamento/#/CNDAccreditamento';
		var controllerAdesione = '/Candidature/Adesione/#/CNDAdesione';
		var controllerConvenzione = '/Candidature/Convenzione/#/CNDConvenzione';

		var controllerAccred = '/Candidature/Accreditamento/#';

		//Array condivisi su app - caricati su avvio app
		// Utilizzati esclusivamente su tag SELECT
		var _arrAziende = [];
		var _arrProfiliANPAL = [];
		var _arrProfiliDocente = [];
		var _arrProvince = [];
		var _arrComuni = [];
		var _arrProvinceByReg = [];
		var _arrPaesi = [];
		var _arrRisorse = [];       //solo dati non variabili (Id, Cognome, Nome, CodiceFiscale, ProfiloId, Profilo)
		var _arrTipoStatoRichieste = [];
		var _arrTipoRegistrazione = [];
		//Array tabelle tipo
		var _arrTipoLavoro = [];
		var _arrFormaGiuridica = [];
		var _arrTipoAteco = [];
		var _arrTitoloStudio = [];
		var _arrCondizioneMercato = [];
		var _arrCondizioneMercatoAll = [];
		var _arrDurataRicerca = [];
		var _arrGruppoVulnerabilita = [];
		var _arrStatoPartecipante = [];
		var _arrTCPI = [];
		var _arrAziendeCPI = [];
		var _arrTTirocini = [];
		var _arrTTirociniDLG = [];
		var _arrTTirociniSpese = [];
		var _arrContenutoFormativo = [];
		var _arrParams = [];
		var _arrTIndirizzo = [];
		var _arrStatiCivili = [];
		var _arrStatiOccup = [];
		var _arrTitoliStudio = [];
		var _arrCittadinanze = [];
		var _arrCNDCV_TPubb = [];
		var _arrCNDTProfili = [];
		var _arrTMisure = [];
		var _arrTQualifica = [];
		var _arrTRapportoLavoro = [];
		var _arrTAltraQualifica = [];
		var _arrTImpresa = [];
		var _arrTClasseImpresa = [];
		var _arrDBTAttivita = [];

		var _arrAvvisi = [
			{ Id: 1, Name: 'Avviso 1/2022', Percorsi: 'P1;P2;P3;P5;', SoggettoCode: 'AZD_PROM-LAV1', OrderItem: 1, ShowCOMM: true, ShowFORM: false }
			, { Id: 2, Name: 'Avviso 2/2022', Percorsi: 'P4;', SoggettoCode: 'AZD_PROM-FAM1', OrderItem: 2, ShowCOMM: true, ShowFORM: false }
			, { Id: 5, Name: 'Avviso 5/2024', Percorsi: 'P5;', SoggettoCode: 'AZD_FORM-LAV1', OrderItem: 3, ShowCOMM: false, ShowFORM: true }
			, { Id: 4, Name: 'Avviso 4/2024', Percorsi: 'P4;', SoggettoCode: 'AZD_FORM-FAM1', OrderItem: 4, ShowCOMM: false, ShowFORM: true }
		];

		var _arrPercorsi = [
			{ Id: 1, Code: 'P1;', Name: 'Percorso 1: reinserimento lavorativo', ShowFORM: false }
			, { Id: 2, Code: 'P2;', Name: 'Percorso 2: aggiornamento (upskilling)', ShowFORM: false }
			, { Id: 3, Code: 'P3;', Name: 'Percorso 3: riqualificazione (reskilling)', ShowFORM: false }
			, { Id: 4, Code: 'P4;', Name: 'Percorso 4: lavoro ed inclusione', ShowFORM: true }
			, { Id: 5, Code: 'P5;', Name: 'Percorso 5: ricollocazione collettiva', ShowFORM: true }
		];

		var _arrPercorsiLAV1 = [
			{ Id: 1, Code: 'P1;', Name: 'Percorso 1: reinserimento lavorativo' }
			, { Id: 2, Code: 'P2;', Name: 'Percorso 2: aggiornamento (upskilling)' }
			, { Id: 3, Code: 'P3;', Name: 'Percorso 3: riqualificazione (reskilling)' }
			, { Id: 5, Code: 'P5;', Name: 'Percorso 5: ricollocazione collettiva' }
		];

		var _arrPercorsiFAM1 = [
			{ Id: 4, Code: 'P4;', Name: 'Percorso 4: lavoro ed inclusione' }
		];

		var _arrPercorsiFORM = [
			{ Id: 4, Code: 'P4;', Name: 'Percorso 4: lavoro ed inclusione' }
			, { Id: 5, Code: 'P5;', Name: 'Percorso 5: ricollocazione collettiva' }
		];

		var _arrFilterCodes = [
			{ Id: 'All', Name: 'Visibilit\xE0 Globale' }
			, { Id: 'AllCompleted', Name: 'Visibilit\xE0 Completed' }
			, { Id: 'OnlyAPP', Name: 'Visibilit\xE0 APP' }
			, { Id: 'OnlyAPL', Name: 'Visibilit\xE0 APL' }
			, { Id: 'OnlyCPI', Name: 'Visibilit\xE0 CPI' }
			, { Id: ' ', Name: 'Nessuna Visibilit\xE0' }
		];

		var _arrMesi = [
			{ Id: 1, Name: 'Gennaio' },
			{ Id: 2, Name: 'Febbraio' },
			{ Id: 3, Name: 'Marzo' },
			{ Id: 4, Name: 'Aprile' },
			{ Id: 5, Name: 'Maggio' },
			{ Id: 6, Name: 'Giugno' },
			{ Id: 7, Name: 'Luglio' },
			{ Id: 8, Name: 'Agosto' },
			{ Id: 9, Name: 'Settembre' },
			{ Id: 10, Name: 'Ottobre' },
			{ Id: 11, Name: 'Novembre' },
			{ Id: 12, Name: 'Dicembre' }
		];

		var _arrMesiZero = [
			{ Id: 0, Name: '-- Selezionare --' },
			{ Id: 1, Name: 'Gennaio' },
			{ Id: 2, Name: 'Febbraio' },
			{ Id: 3, Name: 'Marzo' },
			{ Id: 4, Name: 'Aprile' },
			{ Id: 5, Name: 'Maggio' },
			{ Id: 6, Name: 'Giugno' },
			{ Id: 7, Name: 'Luglio' },
			{ Id: 8, Name: 'Agosto' },
			{ Id: 9, Name: 'Settembre' },
			{ Id: 10, Name: 'Ottobre' },
			{ Id: 11, Name: 'Novembre' },
			{ Id: 12, Name: 'Dicembre' }
		];

		var _arrRegTSourceCode = [
			{ Code: 'CLS', Name: 'Giornata Formazione' },
			{ Code: 'REGATT', Name: 'Presenza Formazione' },
			{ Code: 'TRC', Name: 'Attivit\xE0 Tirocinio' },
			{ Code: 'STAGE', Name: 'Stage Formazione' },
			{ Code: 'ORI', Name: 'Orientamento' },
			{ Code: 'ORI_1B', Name: 'Orientamento 1B' },
			{ Code: 'ORI_1C', Name: 'Orientamento 1C' },
			{ Code: 'AFM', Name: 'Attivit\xE0 Mis. 2C' },
			{ Code: 'C_S', Name: 'Attivit\xE0 Mis. 3' },
			{ Code: 'AIM', Name: 'Attivit\xE0 Mis. 7' },
			{ Code: 'ASZ', Name: 'Attivit\xE0 Servizio Mis. 7 ' }
		];

		var _arrDataType = [
			{ Code: 'int', Name: 'Numero intero' },
			{ Code: 'reference', Name: 'Riferimento' },
			{ Code: 'datetime', Name: 'Data' },
			{ Code: 'bit', Name: 'SI/NO' },
			{ Code: 'money', Name: 'Valuta' },
			{ Code: 'float', Name: 'Numero decimale' },
			{ Code: 'nvarchar', Name: 'Testo' }

		];

		var _arrCNDCandidatura = [
			{ Id: 1, Name: 'Accreditamento' },
			{ Id: 2, Name: 'Adesione' },
			{ Id: 3, Name: 'Convenzione' },
			{ Id: 4, Name: 'Register' },
		];

		var _arrCNDTRuoloCode = [
			{ Code: 'AZD_PROM-LAV1', Name: 'APL Avviso 1/22 - P1-2-3-5' },
			{ Code: 'AZD_PROM-FAM1', Name: 'APL Avviso 2/22 - P4' },
			{ Code: 'AZD_FORM-FAM1', Name: 'Enti Avviso 4/24 - P4' },
			{ Code: 'AZD_FORM-LAV1', Name: 'Enti Avviso 5/24 - P5' },
		];

		var _arrCNDTMisuraCode = [
			{ Code: 'LAV1', Name: 'Avviso 1/22 - P1-2-3-5' },
			{ Code: 'FAM1', Name: 'Avviso 2/22 - P4' },
			{ Code: 'FORM_FAM1', Name: 'Avviso 4/24 - P4' },
			{ Code: 'FORM_LAV1', Name: 'Avviso 5/24 - P5' },
		];

		var _arrCNDProgettoName = [
			{ Code: 'Fam1_Partecipazione', Name: 'Avviso 2/22 - Partecipazione', iOrder: 1 },
			{ Code: 'FAM1_Convenzione', Name: 'Avviso 2/22 - Convenzione', iOrder: 2 },
			{ Code: 'Fam1_FORM_Partecipazione', Name: 'Avviso 4/24 - Partecipazione', iOrder: 3 },
			{ Code: 'Fam1_FORM_Convenzione', Name: 'Avviso 4/24 - Convenzione', iOrder: 4 },
			{ Code: 'Lav1_Partecipazione', Name: 'Avviso 1/22 - Partecipazione', iOrder: 5 },
			{ Code: 'LAV1_Convenzione', Name: 'Avviso 1/22 - Convenzione', iOrder: 6 },
			{ Code: 'Lav1_FORM_Partecipazione', Name: 'Avviso 5/24 - Partecipazione', iOrder: 7 },
			{ Code: 'Lav1_FORM_Convenzione', Name: 'Avviso 5/24 - Convenzione', iOrder: 8 },
			{ Code: 'GOL_Accreditamento', Name: 'Accreditamento', iOrder: 9 },
			{ Code: 'GOL_Adesione', Name: 'Adesione', iOrder: 10 },
			{ Code: 'GOL_Convenzione', Name: 'Convenzione', iOrder: 11 },
			{ Code: 'GOL_Registrazione', Name: 'Registrazione', iOrder: 12 },
		];

		var _arrFORM_TAttivita = [
			{ Id: 'A', Name: 'Tipo A', iOrder: 1 }
			, { Id: 'B', Name: 'Tipo B - Long List', iOrder: 2 }
		];

		var _arrFORM_TProfilo = [
			{ Id: 'Breve', Name: 'Formazione breve', iOrder: 1, minA: 40, maxA: 79, maxB: 40 }
			, { Id: 'Upskilling', Name: 'Formazione per aggiornamento delle competenze', iOrder: 2, minA: 80, maxA: 150, maxB: 80 }
			, { Id: 'Reskilling', Name: 'Formazione per riqualificazione delle competenze', iOrder: 3, minA: 151, maxA: 0, maxB: 160 }
		];


		var service = {
			//Metodi pe caricamento dati condivisi su app
			//Array compilati solo a prima chiamata
			arrAziende: arrAziende,
			arrProfiliANPAL: arrProfiliANPAL,
			arrProfiliDocente: arrProfiliDocente,
			arrProvince: arrProvince,
			arrComuni: arrComuni,
			arrProvinceByReg: arrProvinceByReg,
			arrPaesi: arrPaesi,
			arrRisorse: arrRisorse,
			arrTipoStatoRichieste: arrTipoStatoRichieste,
			arrTipoRegistrazione: arrTipoRegistrazione,
			//Array per tabelle Tipo
			arrTipoLavoro: arrTipoLavoro,
			arrFormaGiuridica: arrFormaGiuridica,
			arrTipoAteco: arrTipoAteco,
			arrTitoloStudio: arrTitoloStudio,
			arrCondizioneMercato: arrCondizioneMercato,
			arrCondizioneMercatoAll: arrCondizioneMercatoAll,
			arrDurataRicerca: arrDurataRicerca,
			arrGruppoVulnerabilita: arrGruppoVulnerabilita,
			arrStatoPartecipante: arrStatoPartecipante,
			arrTCPI: arrTCPI,
			arrAziendeCPI: arrAziendeCPI,
			arrTTirocini: arrTTirocini,
			arrTTirociniDLG: arrTTirociniDLG,
			arrTTirociniSpese: arrTTirociniSpese,
			arrContenutoFormativo: arrContenutoFormativo,
			arrParams: arrParams,
			arrTIndirizzo: arrTIndirizzo,
			arrStatiCivili: arrStatiCivili,
			arrStatiOccup: arrStatiOccup,
			arrTitoliStudio: arrTitoliStudio,
			arrCittadinanze: arrCittadinanze,
			arrCNDCV_TPubb: arrCNDCV_TPubb,
			arrCNDTProfili: arrCNDTProfili,
			arrTMisure: arrTMisure,
			cndTProfilo_getAll: cndTProfilo_getAll,
			arrTQualifica: arrTQualifica,
			arrTRapportoLavoro: arrTRapportoLavoro,
			arrTAltraQualifica: arrTAltraQualifica,
			arrTImpresa: arrTImpresa,
			arrTClasseImpresa: arrTClasseImpresa,
			arrDBTAttivita: arrDBTAttivita,

			arrAvvisi: arrAvvisi,
			arrPercorsi: arrPercorsi,

			arrFilterCodes: arrFilterCodes,
			arrMesi: arrMesi,
			arrMesiZero: arrMesiZero,
			arrRegTSourceCode: arrRegTSourceCode,
			arrDataType: arrDataType,
			arrDataType_get: arrDataType_get,
			arrCNDCandidatura: arrCNDCandidatura,
			arrCNDTRuoloCode: arrCNDTRuoloCode,
			arrCNDTMisuraCode: arrCNDTMisuraCode,
			arrCNDProgettoName: arrCNDProgettoName,

			arrFORM_TAttivita: arrFORM_TAttivita,
			arrFORM_TProfilo: arrFORM_TProfilo,

			root_getURL: root_getURL,
			accred_getURL: accred_getURL,
			accreditamento_getURL: accreditamento_getURL,
			adesione_getURL: adesione_getURL,
			convenzione_getURL: convenzione_getURL,
			upload_getURL: upload_getURL,
			download_getURL: download_getURL,
			mail_upload_getURL: mail_upload_getURL,

			//-- CLASSE - Nuovi Metodi
			classe_getAllList: classe_getAllList,
			classe_getAll: classe_getAll,
			classe_countAll: classe_countAll,
			classe_get: classe_get,
			classe_add: classe_add,
			classe_update: classe_update,
			classe_updatebIntegrazione: classe_updatebIntegrazione,
			classe_merge: classe_merge,
			classe_change: classe_change,
			classe_delete: classe_delete,
			classe_exists: classe_exists,
			classe_unlock: classe_unlock,
			classe_addStage: classe_addStage,
			classe_addSelStage: classe_addSelStage,
			classe_changeState: classe_changeState,

			//-- SOGGETTO COLLEGATO
			soggettoC_getAllList: soggettoC_getAllList,
			soggettoC_getAll: soggettoC_getAll,
			soggettoC_countAll: soggettoC_countAll,
			soggettoC_exists: soggettoC_exists,
			soggettoC_get: soggettoC_get,
			soggettoC_add: soggettoC_add,
			soggettoC_update: soggettoC_update,
			soggettoC_merge: soggettoC_merge,
			soggettoC_delete: soggettoC_delete,

			//-- ASSEGNAZIONE
			assegnazione_getAllByCorso: assegnazione_getAllByCorso,
			assegnazione_getAllByRisorsa: assegnazione_getAllByRisorsa,
			assegnazione_getAllBySede: assegnazione_getAllBySede,
			assegnazione_get: assegnazione_get,
			assegnazione_add: assegnazione_add,
			assegnazione_update: assegnazione_update,
			assegnazione_delete: assegnazione_delete,

			//-- PARTECIPAZIONE
			partecipazione_getAllList: partecipazione_getAllList,
			partecipazione_getAll: partecipazione_getAll,
			partecipazione_countAll: partecipazione_countAll,
			partecipazione_get: partecipazione_get,
			partecipazione_add: partecipazione_add,
			partecipazione_addOrUpdate: partecipazione_addOrUpdate,
			partecipazione_update: partecipazione_update,
			partecipazione_merge: partecipazione_merge,
			partecipazione_mergeSuper: partecipazione_mergeSuper,
			partecipazione_delete: partecipazione_delete,
			partecipazione_restore: partecipazione_restore,
			partecipazione_clona: partecipazione_clona,
			partecipazione_unlock: partecipazione_unlock,
			partecipazione_unlockSent: partecipazione_unlockSent,
			partecipazione_setSent: partecipazione_setSent,
			partecipazione_setProtSent: partecipazione_setProtSent,
			partecipazione_unsetProtSent: partecipazione_unsetProtSent,
			partecipazione_setConvalida: partecipazione_setConvalida,
			partecipazione_unsetConvalida: partecipazione_unsetConvalida,
			partecipazione_setAnnulled: partecipazione_setAnnulled,
			partecipazione_printRicevuta: partecipazione_printRicevuta,
			/*partecipazione_printAllegato: partecipazione_printAllegato,*/
			partecipazione_changeItem: partecipazione_changeItem,
			partecipazione_convalidaSedi: partecipazione_convalidaSedi,
			//Anomalie
			partecipazione_changePresaIncarico: partecipazione_changePresaIncarico,
			fse_AccreditamentoSede_Get: fse_AccreditamentoSede_Get,

            //-- PARTECIPAZIONE-MODULO
            partecipazioneModulo_getAllList: partecipazioneModulo_getAllList,
            partecipazioneModulo_getAll: partecipazioneModulo_getAll,
            partecipazioneModulo_countAll: partecipazioneModulo_countAll,
            partecipazioneModulo_get: partecipazioneModulo_get,
            partecipazioneModulo_add: partecipazioneModulo_add,
            partecipazioneModulo_update: partecipazioneModulo_update,
            partecipazioneModulo_merge: partecipazioneModulo_merge,
            partecipazioneModulo_delete: partecipazioneModulo_delete,
            partecipazioneModulo_unlock: partecipazioneModulo_unlock,


            //--CND: COMPENTENZE - CONOSCENZE - ABILITA
            cndModCompetenza_get: cndModCompetenza_get,
            cndModCompetenza_getAll: cndModCompetenza_getAll,
            cndModAbilita_getAll: cndModAbilita_getAll,
            cndModConoscenza_getAll: cndModConoscenza_getAll,

            //-- PARTECIPAZIONE TIROCINI CATEGORIA
            pTirCateg_getAllList: pTirCateg_getAllList,
            pTirCateg_getAll: pTirCateg_getAll,
            pTirCateg_countAll: pTirCateg_countAll,
            pTirCateg_exist: pTirCateg_exist,
            pTirCateg_get: pTirCateg_get,
            pTirCateg_add: pTirCateg_add,
            pTirCateg_update: pTirCateg_update,
            pTirCateg_merge: pTirCateg_merge,
            pTirCateg_delete: pTirCateg_delete,
            pTirCateg_unlock: pTirCateg_unlock,
            pTirCateg_unassign: pTirCateg_unassign,

			//-- PROFILO PROFESSIONALE
			profiloProfess_getAllList: profiloProfess_getAllList,
			profiloProfess_getAll: profiloProfess_getAll,
			profiloProfess_countAll: profiloProfess_countAll,
			profiloProfess_get: profiloProfess_get,

			//-- SETTORI PROFESSIONALI
			settProfess_getAllList: settProfess_getAllList,
			settProfess_get: settProfess_get,

			//-- TIPOLOGIA PERCORSO - MISURA 2B
			tPercorso_getAllList: tPercorso_getAllList,
			tPercorso_get: tPercorso_get,

			//-- TIPO FIGURA PROFESSIONALE - MISURA 2B e MISURA 4A
			tFigProfessionale_getAll: tFigProfessionale_getAll,
			tFigProfessionale_getAllList: tFigProfessionale_getAllList,
			tFigProfessionale_get: tFigProfessionale_get,

			//-- TIPO RISORSA - MISURA 4A
			cndTRisorsa_getAllList: cndTRisorsa_getAllList,
			cndTRisorsa_get: cndTRisorsa_get,

			//-- TIPO AULA - MISURA 4A
			cndTAula_getAllList: cndTAula_getAllList,
			cndTAula_get: cndTAula_get,

			//-- TIPO AZIENDA - MISURA 5Bis
			cndTAzienda_getAllList: cndTAzienda_getAllList,
			cndTAzienda_get: cndTAzienda_get,

			//-- PARTECIPAZIONE AZIENDA
			pAzienda_getAllList: pAzienda_getAllList,
			pAzienda_getAll: pAzienda_getAll,
			pAzienda_countAll: pAzienda_countAll,
			pAzienda_exists: pAzienda_exists,
			pAzienda_get: pAzienda_get,
			pAzienda_add: pAzienda_add,
			pAzienda_update: pAzienda_update,
			pAzienda_merge: pAzienda_merge,
			pAzienda_delete: pAzienda_delete,
			pAzienda_addExt: pAzienda_addExt,

			//-- PARTECIPAZIONE BUDGET
			pBudget_getAllList: pBudget_getAllList,
			pBudget_getAll: pBudget_getAll,
			pBudget_countAll: pBudget_countAll,
			pBudget_get: pBudget_get,
			pBudget_add: pBudget_add,
			pBudget_update: pBudget_update,
			pBudget_merge: pBudget_merge,
			pBudget_delete: pBudget_delete,

			//-- PARTECIPAZIONE DOCENTE
			pDocente_getAllList: pDocente_getAllList,
			pDocente_getAll: pDocente_getAll,
			pDocente_countAll: pDocente_countAll,
			pDocente_get: pDocente_get,
			pDocente_add: pDocente_add,
			pDocente_update: pDocente_update,
			pDocente_merge: pDocente_merge,
			pDocente_delete: pDocente_delete,
			pDocente_exists: pDocente_exists,
			pDocente_unlock: pDocente_unlock,

			//-- PARTECIPAZIONE SEDE
			pSede_getAllList: pSede_getAllList,
			pSede_getAll: pSede_getAll,
			pSede_countAll: pSede_countAll,
			pSede_get: pSede_get,
			pSede_add: pSede_add,
			pSede_AddMultiplo: pSede_AddMultiplo,
			pSede_update: pSede_update,
			pSede_merge: pSede_merge,
			pSede_delete: pSede_delete,
			pSede_unlock: pSede_unlock,


			//-- PARTECIPAZIONE CATALOGO CORSO
			pCatalogoCorso_getAllList: pCatalogoCorso_getAllList,
			pCatalogoCorso_getAll: pCatalogoCorso_getAll,
			pCatalogoCorso_countAll: pCatalogoCorso_countAll,
			pCatalogoCorso_get: pCatalogoCorso_get,
			pCatalogoCorso_add: pCatalogoCorso_add,
			pCatalogoCorso_update: pCatalogoCorso_update,
			pCatalogoCorso_merge: pCatalogoCorso_merge,
			pCatalogoCorso_delete: pCatalogoCorso_delete,

			//-- PARTECIPAZIONE CORSO
			pCorso_getAllList: pCorso_getAllList,
			pCorso_getAll: pCorso_getAll,
			pCorso_countAll: pCorso_countAll,
			pCorso_get: pCorso_get,
			pCorso_add: pCorso_add,
			pCorso_create: pCorso_create,
			pCorso_update: pCorso_update,
			pCorso_merge: pCorso_merge,
			pCorso_delete: pCorso_delete,
			pCorso_restore: pCorso_restore,
			pCorso_assign: pCorso_assign,
			pCorso_unassign: pCorso_unassign,
			pCorso_unlock: pCorso_unlock,
			pCorso_setSent: pCorso_setSent,
			pCorso_unlockSent: pCorso_unlockSent,
			pCorso_setProtSent: pCorso_setProtSent,
			pCorso_unsetProtSent: pCorso_unsetProtSent,
			pCorso_setConvalida: pCorso_setConvalida,
			pCorso_unsetConvalida: pCorso_unsetConvalida,
			pCorso_printRicevuta: pCorso_printRicevuta,

			pCorso_setPresaIncarico: pCorso_setPresaIncarico,
			pCorso_unsetPresaIncarico: pCorso_unsetPresaIncarico,
			pCorso_setPresaIncaricoCPI: pCorso_setPresaIncaricoCPI,
			pCorso_unsetPresaIncaricoCPI: pCorso_unsetPresaIncaricoCPI,



			//-- CORSO
			corso_getAllList: corso_getAllList,
			corso_getAll: corso_getAll,
			corso_countAll: corso_countAll,
			corso_get: corso_get,
			corso_add: corso_add,
			corso_update: corso_update,
			corso_merge: corso_merge,
			corso_delete: corso_delete,
			corso_unlock: corso_unlock,

			//-- AZIENDA SEDE ACCREDITAMENTO
			azSedeAccr_getAllList: azSedeAccr_getAllList,
			azSedeAccr_getAll: azSedeAccr_getAll,
			azSedeAccr_countAll: azSedeAccr_countAll,
			azSedeAccr_get: azSedeAccr_get,
			azSedeAccr_add: azSedeAccr_add,
			azSedeAccr_update: azSedeAccr_update,
			azSedeAccr_delete: azSedeAccr_delete,

			//-- DOCENZE
			docenza_getAllList: docenza_getAllList,
			docenza_getAll: docenza_getAll,
			docenza_countAll: docenza_countAll,
			docenza_getAllByClasse: docenza_getAllByClasse,
			docenza_getAllByRisorsa: docenza_getAllByRisorsa,
			docenza_getAllByMateria: docenza_getAllByMateria,
			docenza_get: docenza_get,
			docenza_add: docenza_add,
			docenza_update: docenza_update,
			docenza_delete: docenza_delete,

			//-- TICKET
			ticket_getAllList: ticket_getAllList,
			ticket_getAll: ticket_getAll,
			ticket_countAll: ticket_countAll,
			ticket_get: ticket_get,
			ticket_add: ticket_add,
			ticket_update: ticket_update,
			ticket_setRead: ticket_setRead,
			ticket_delete: ticket_delete,
			ticket_unlock: ticket_unlock,

			//-- TTICKET
			tTicket_getAllList: tTicket_getAllList,
			tTicket_getAll: tTicket_getAll,
			tTicket_countAll: tTicket_countAll,
			tTicket_get: tTicket_get,
			tTicket_add: tTicket_add,
			tTicket_update: tTicket_update,
			tTicket_delete: tTicket_delete,

			//-- PROJECT
			project_getAllList: project_getAllList,
			project_getAllListByUsername: project_getAllListByUsername,
			project_getAll: project_getAll,
			project_countAll: project_countAll,
			project_get: project_get,
			project_add: project_add,
			project_update: project_update,
			project_delete: project_delete,

			//-- STATUS
			status_getAllList: status_getAllList,
			status_getAll: status_getAll,
			status_countAll: status_countAll,
			status_get: status_get,
			status_add: status_add,
			status_update: status_update,
			status_delete: status_delete,

			//-- TRACE
			trace_getAllList: trace_getAllList,
			trace_getAll: trace_getAll,
			trace_countAll: trace_countAll,
			trace_get: trace_get,
			trace_add: trace_add,
			trace_update: trace_update,
			trace_delete: trace_delete,


			//-- INCARICO
			incarico_getAll: incarico_getAll,
			incarico_countAll: incarico_countAll,
			incarico_getAllByClasse: incarico_getAllByClasse,
			incarico_getAllByRisorsa: incarico_getAllByRisorsa,
			incarico_add: incarico_add,
			incarico_update: incarico_update,
			incarico_delete: incarico_delete,

			//-- ISTAT
			istat_comune_getAllList: istat_comune_getAllList,
			istat_comune_get: istat_comune_get,

			//-- ISTITUTO          
			istituto_getAllList: istituto_getAllList,
			istituto_getAll: istituto_getAll,
			istituto_countAll: istituto_countAll,
			istituto_get: istituto_get,
			istituto_add: istituto_add,
			istituto_update: istituto_update,
			istituto_merge: istituto_merge,
			istituto_delete: istituto_delete,

			//-- LEZIONE
			lezione_getAll: lezione_getAll,
			lezione_countAll: lezione_countAll,
			lezione_get: lezione_get,
			lezione_getOreDocenze: lezione_getOreDocenze,
			lezione_getOrePresenzeStd: lezione_getOrePresenzeStd,
			lezione_add: lezione_add,
			lezione_update: lezione_update,
			lezione_merge: lezione_merge,
			lezione_unlock: lezione_unlock,
			lezione_delete: lezione_delete,

			//-- CLASSE LEZIONEGG
			classeLezioneGG_getAll: classeLezioneGG_getAll,
			classeLezioneGG_countAll: classeLezioneGG_countAll,
			classeLezioneGG_get: classeLezioneGG_get,

			//-- REGISTRO PRESENZE
			regAttivita_getAll: regAttivita_getAll,
			regAttivita_getCpiEqualApl: regAttivita_getCpiEqualApl,
			regAttivita_countAll: regAttivita_countAll,
			regAttivita_countCpiEqualApl: regAttivita_countCpiEqualApl,
			regAttivita_getByFoglio: regAttivita_getByFoglio,
			regAttivita_saveFoglio: regAttivita_saveFoglio,
			regAttivita_saveHelp: regAttivita_saveHelp,
			regAttivita_get: regAttivita_get,
			regAttivita_add: regAttivita_add,
			regAttivita_update: regAttivita_update,
			regAttivita_merge: regAttivita_merge,
			regAttivita_delete: regAttivita_delete,
			regAttivita_exists: regAttivita_exists,
			regAttivita_saveAndCompleted: regAttivita_saveAndCompleted,
			regAttivita_setCompleted: regAttivita_setCompleted,
			regAttivita_unsetCompleted: regAttivita_unsetCompleted,
			regAttivita_setRevisione: regAttivita_setRevisione,
			regAttivitaPlan_getAll: regAttivitaPlan_getAll,
			regAttivita_clona: regAttivita_clona,

			// ******************************
			//  tRegAttivita
			tRegAttivita_getAllList: tRegAttivita_getAllList,
			tRegAttivita_getAll: tRegAttivita_getAll,
			tRegAttivita_get: tRegAttivita_get,

			//-- MATERIA
			materia_getAllList: materia_getAllList,
			materia_getAllByCorso: materia_getAllByCorso,
			materia_getAll: materia_getAll,
			materia_countAll: materia_countAll,
			materia_get: materia_get,
			materia_add: materia_add,
			materia_update: materia_update,
			materia_delete: materia_delete,

			//-- T MISURA
			tMisura_getAllList: tMisura_getAllList,
			tMisura_getAllDefault: tMisura_getAllDefault,
			tMisura_getAll: tMisura_getAll,
			tMisura_get: tMisura_get,


			//-- CP2011 - Atlante del lavoro
			cp2011_getAllList: cp2011_getAllList,
			cp2011_getAll: cp2011_getAll,
			cp2011_get: cp2011_get,
			cp2011_getByCode: cp2011_getByCode,

			//-- ISTAT - Comune CAP
			comuneCAP_getAllList: comuneCAP_getAllList,
			comuneCAP_getAll: comuneCAP_getAll,
			comuneCAP_get: comuneCAP_get,
			comuneCAP_exists: comuneCAP_exists,

			//-- RISORSA
			risorsa_getAllListByText: risorsa_getAllListByText,
			risorsa_getAllList: risorsa_getAllList,
			risorsa_getByUsernameList: risorsa_getByUsernameList,
			risorsa_getAll: risorsa_getAll,
			risorsa_countAll: risorsa_countAll,
			risorsa_existsCF: risorsa_existsCF,
			risorsa_getByUsername: risorsa_getByUsername,
			risorsa_getByUsername2: risorsa_getByUsername2,
			risorsa_get: risorsa_get,
			risorsa_add: risorsa_add,
			risorsa_update: risorsa_update,
			risorsa_delete: risorsa_delete,
			risorsa_resetPassword: risorsa_resetPassword,
			risorsa_setRinuncia: risorsa_setRinuncia,
			risorsa_unsetRinuncia: risorsa_unsetRinuncia,
			// AVATAR
			risorsa_upload: risorsa_upload,
			risorsa_deleteAvatar: risorsa_deleteAvatar,
			// END

			//-RISORSA AZIONE
			risorsaAzione_getList: risorsaAzione_getList,
			risorsaAzione_getAll: risorsaAzione_getAll,
			risorsaAzione_countAll: risorsaAzione_countAll,
			risorsaAzione_get: risorsaAzione_get,
			risorsaAzione_add: risorsaAzione_add,
			risorsaAzione_update: risorsaAzione_update,
			risorsaAzione_delete: risorsaAzione_delete,
			risorsaAzione_unlock: risorsaAzione_unlock,
			risorsaAzione_setRinuncia: risorsaAzione_setRinuncia,
			risorsaAzione_unsetRinuncia: risorsaAzione_unsetRinuncia,

			//-- DESTINATARIO
			destinatario_getAllList: destinatario_getAllList,
			destinatario_getAll: destinatario_getAll,
			destinatario_countAll: destinatario_countAll,
			destinatario_get: destinatario_get,
			destinatario_add: destinatario_add,
			destinatario_addByAPL: destinatario_addByAPL,
			destinatario_update: destinatario_update,
			destinatario_delete: destinatario_delete,
			destinatario_exists: destinatario_exists,
			destinatario_assign: destinatario_assign,
			destinatario_status: destinatario_status,
			destinatario_setRinuncia: destinatario_setRinuncia,
			destinatario_unsetRinuncia: destinatario_unsetRinuncia,


			//-- DESTINATARIO INDENNITA
			destinatarioIndennita_getAllList: destinatarioIndennita_getAllList,
			destinatarioIndennita_getAll: destinatarioIndennita_getAll,
			destinatarioIndennita_countAll: destinatarioIndennita_countAll,
			destinatarioIndennita_exists: destinatarioIndennita_exists,
			destinatarioIndennita_get: destinatarioIndennita_get,
			destinatarioIndennita_add: destinatarioIndennita_add,
			destinatarioIndennita_addMultiplo: destinatarioIndennita_addMultiplo,
			destinatarioIndennita_update: destinatarioIndennita_update,
			destinatarioIndennita_merge: destinatarioIndennita_merge,
			destinatarioIndennita_delete: destinatarioIndennita_delete,
			destinatarioIndennita_changeState: destinatarioIndennita_changeState,
			destinatarioIndennita_getParametri: destinatarioIndennita_getParametri,
			destinatarioIndennita_changePresaIncarico: destinatarioIndennita_changePresaIncarico,

			//-- DESTINATARIO INDENNITA INPS
			destinatarioIndennitaINPS_getAllList: destinatarioIndennitaINPS_getAllList,
			destinatarioIndennitaINPS_getAll: destinatarioIndennitaINPS_getAll,
			destinatarioIndennitaINPS_countAll: destinatarioIndennitaINPS_countAll,
			destinatarioIndennitaINPS_get: destinatarioIndennitaINPS_get,
			destinatarioIndennitaINPS_add: destinatarioIndennitaINPS_add,
			destinatarioIndennitaINPS_update: destinatarioIndennitaINPS_update,
			destinatarioIndennitaINPS_merge: destinatarioIndennitaINPS_merge,
			destinatarioIndennitaINPS_delete: destinatarioIndennitaINPS_delete,
			destinatarioIndennitaINPS_changeStatus: destinatarioIndennitaINPS_changeStatus,
			destinatarioIndennitaINPS_create: destinatarioIndennitaINPS_create,
			destinatarioIndennitaINPS_writeXML: destinatarioIndennitaINPS_writeXML,

			//-- DESTINATARIO INDENNITA INPS EXPORT
			destinatarioIndennitaINPSExport_getAllList: destinatarioIndennitaINPSExport_getAllList,
			destinatarioIndennitaINPSExport_getAll: destinatarioIndennitaINPSExport_getAll,
			destinatarioIndennitaINPSExport_countAll: destinatarioIndennitaINPSExport_countAll,
			destinatarioIndennitaINPSExport_get: destinatarioIndennitaINPSExport_get,
			destinatarioIndennitaINPSExport_add: destinatarioIndennitaINPSExport_add,
			destinatarioIndennitaINPSExport_update: destinatarioIndennitaINPSExport_update,
			destinatarioIndennitaINPSExport_merge: destinatarioIndennitaINPSExport_merge,
			destinatarioIndennitaINPSExport_delete: destinatarioIndennitaINPSExport_delete,
			destinatarioIndennitaINPSExport_restore: destinatarioIndennitaINPSExport_restore,

			//-- PERCORSOMISURA
			percorsoMisura_getAll: percorsoMisura_getAll,
			percorsoMisura_get: percorsoMisura_get,

			//-- PERCORSI LEP-UCS
			percorsiLEPUCS_getAll: percorsiLEPUCS_getAll,
			percorsiLEPUCS_countAll: percorsiLEPUCS_countAll,
			percorsiLEPUCS_get: percorsiLEPUCS_get,

			//-- PERCORSI LEP-ECONOMIE
			percorsiLEPEconomie_getAll: percorsiLEPEconomie_getAll,
			percorsiLEPEconomie_countAll: percorsiLEPEconomie_countAll,
			percorsiLEPEconomie_get: percorsiLEPEconomie_get,

			//-- DIARIO DI BORDO
			diario_getAllList: diario_getAllList,
			diario_getAll: diario_getAll,
			diario_countAll: diario_countAll,
			diario_get: diario_get,
			diario_delete: diario_delete,
			diario_add: diario_add,
			diario_update: diario_update,
			diario_changeState: diario_changeState,
			diario_unlock: diario_unlock,

			//-- DIARIO DI BORDO DTL
			diarioDtl_getAll: diarioDtl_getAll,
			diarioDtl_countAll: diarioDtl_countAll,
			diarioDtl_get: diarioDtl_get,
			diarioDtl_delete: diarioDtl_delete,
			diarioDtl_add: diarioDtl_add,
			diarioDtl_update: diarioDtl_update,
			diarioDtl_createPdf: diarioDtl_createPdf,
			diarioDtl_saveSheet: diarioDtl_saveSheet,

			//-- HTMLTEMPLATE
			htmlTemplate_getAllList: htmlTemplate_getAllList,
			htmlTemplate_getAll: htmlTemplate_getAll,
			htmlTemplate_countAll: htmlTemplate_countAll,
			htmlTemplate_get: htmlTemplate_get,
			htmlTemplate_add: htmlTemplate_add,
			htmlTemplate_update: htmlTemplate_update,
			htmlTemplate_merge: htmlTemplate_merge,
			htmlTemplate_delete: htmlTemplate_delete,

			//-- DESTINATARIO MISURA
			destMisura_getAllList: destMisura_getAllList,
			destMisura_getAll: destMisura_getAll,
			destMisura_countAll: destMisura_countAll,
			destMisura_get: destMisura_get,
			destMisura_add: destMisura_add,
			destMisura_update: destMisura_update,
			destMisura_merge: destMisura_merge,
			destMisura_delete: destMisura_delete,
			destMisura_setRinuncia: destMisura_setRinuncia,
			destMisura_unsetRinuncia: destMisura_unsetRinuncia,
			destMisura_setDecaduto: destMisura_setDecaduto,
			destMisura_unsetDecaduto: destMisura_unsetDecaduto,
			destMisura_exist: destMisura_exist,
			destMisura_status: destMisura_status,
			destMisura_changeState: destMisura_changeState,
			destMisura_assign: destMisura_assign,
			destMisura_sendEmail: destMisura_sendEmail,
			destMisura_setConvalida: destMisura_setConvalida,

			//-- DESTINATARIO PROFILING
			destProfiling_getAllList: destProfiling_getAllList,
			destProfiling_getAll: destProfiling_getAll,
			destProfiling_countAll: destProfiling_countAll,
			destProfiling_getAllByDestinatario: destProfiling_getAllByDestinatario,
			destProfiling_get: destProfiling_get,
			destProfiling_add: destProfiling_add,
			destProfiling_update: destProfiling_update,
			destProfiling_delete: destProfiling_delete,
			destProfiling_unlock: destProfiling_unlock,
			destProfiling_print: destProfiling_print,

			//CHECKLISTMODEL
			checkListModel_getList: checkListModel_getList,
			checkListModel_getAll: checkListModel_getAll,
			checkListModel_countAll: checkListModel_countAll,
			checkListModel_get: checkListModel_get,
			checkListModel_getByCode: checkListModel_getByCode,
			checkListModel_add: checkListModel_add,
			checkListModel_update: checkListModel_update,
			checkListModel_delete: checkListModel_delete,
			checkListModel_generaRevisione: checkListModel_generaRevisione,
			checkListModel_clona: checkListModel_clona,
			checkListModel_setCompleted: checkListModel_setCompleted,
			checkListModel_unsetCompleted: checkListModel_unsetCompleted,

			//CHECKLISTMODELDTL
			checkListModelDtl_getList: checkListModelDtl_getList,
			checkListModelDtl_getAll: checkListModelDtl_getAll,
			checkListModelDtl_countAll: checkListModelDtl_countAll,
			checkListModelDtl_get: checkListModelDtl_get,
			checkListModelDtl_add: checkListModelDtl_add,
			checkListModelDtl_update: checkListModelDtl_update,
			checkListModelDtl_delete: checkListModelDtl_delete,
			checkListModelDtl_setGroup: checkListModelDtl_setGroup,

			//CHECKLISTMODELDTLACTION
			checkListModelDtlAction_getList: checkListModelDtlAction_getList,
			checkListModelDtlAction_getAll: checkListModelDtlAction_getAll,
			checkListModelDtlAction_countAll: checkListModelDtlAction_countAll,
			checkListModelDtlAction_get: checkListModelDtlAction_get,
			checkListModelDtlAction_add: checkListModelDtlAction_add,
			checkListModelDtlAction_update: checkListModelDtlAction_update,
			checkListModelDtlAction_delete: checkListModelDtlAction_delete,

			//CHECKLIST
			checkList_getList: checkList_getList,
			checkList_getAll: checkList_getAll,
			checkList_countAll: checkList_countAll,
			checkList_exists: checkList_exists,
			checkList_get: checkList_get,
			checkList_add: checkList_add,
			checkList_make: checkList_make,
			checkList_update: checkList_update,
			checkList_delete: checkList_delete,
			checkList_unlock: checkList_unlock,
			checklist_unlockSent: checklist_unlockSent,
			checkList_unsetPresaIncarico: checkList_unsetPresaIncarico,
			checklist_print: checklist_print,
			//checkList_isValidHelper: checkList_isValidHelper,

			//CHECKLISTDTL
			checkListDtl_getList: checkListDtl_getList,
			checkListDtl_getAll: checkListDtl_getAll,
			checkListDtl_countAll: checkListDtl_countAll,
			checkListDtl_get: checkListDtl_get,
			checkListDtl_add: checkListDtl_add,
			checkListDtl_update: checkListDtl_update,
			checkListDtl_updateAllList: checkListDtl_updateAllList,
			checkListDtl_delete: checkListDtl_delete,

			//CHECKLISTDTLACTION
			checkListDtlAction_getList: checkListDtlAction_getList,
			checkListDtlAction_getAll: checkListDtlAction_getAll,
			checkListDtlAction_countAll: checkListDtlAction_countAll,
			checkListDtlAction_get: checkListDtlAction_get,
			checkListDtlAction_add: checkListDtlAction_add,
			checkListDtlAction_update: checkListDtlAction_update,
			checkListDtlAction_delete: checkListDtlAction_delete,
			checkListDtlAction_saveAll: checkListDtlAction_saveAll,

			//CHECKLISTHDR
			checkListHdr_getList: checkListHdr_getList,
			checkListHdr_getAll: checkListHdr_getAll,
			checkListHdr_countAll: checkListHdr_countAll,
			checkListHdr_get: checkListHdr_get,
			checkListHdr_add: checkListHdr_add,
			checkListHdr_update: checkListHdr_update,
			checkListHdr_updateAllList: checkListHdr_updateAllList,
			checkListHdr_delete: checkListHdr_delete,

			//CHECKLISTMODELHDR
			checkListModelHdr_getList: checkListModelHdr_getList,
			checkListModelHdr_getAll: checkListModelHdr_getAll,
			checkListModelHdr_countAll: checkListModelHdr_countAll,
			checkListModelHdr_get: checkListModelHdr_get,
			checkListModelHdr_add: checkListModelHdr_add,
			checkListModelHdr_update: checkListModelHdr_update,
			checkListModelHdr_delete: checkListModelHdr_delete,

			pdf_getChecklist: pdf_getChecklist,

			//**********************************************//

			//--VALIDAZIONE CF E IBAN
			validazione_cf: validazione_cf,
			validazione_piva: validazione_piva,
			validazione_iban: validazione_iban,
			validazione_fieldsCF: validazione_fieldsCF,
			validazione_cfName: validazione_cfName,
			validazione_existUsername: validazione_existUsername,
			validazione_existAzienda: validazione_existAzienda,

			//-- AUTOIMPIEGO - Nuovi Metodi
			aim_getAllList: aim_getAllList,
			aim_getAll: aim_getAll,
			aim_countAll: aim_countAll,
			aim_assign: aim_assign,
			aim_status: aim_status,
			aim_unlock: aim_unlock,
			aim_unlockSent: aim_unlockSent,
			aim_setRinuncia: aim_setRinuncia,
			aim_unsetRinuncia: aim_unsetRinuncia,
			aim_unlockProroga: aim_unlockProroga,
			aim_get: aim_get,
			aim_add: aim_add,
			aim_update: aim_update,
			aim_merge: aim_merge,
			aim_updateAttivita: aim_updateAttivita,
			aim_delete: aim_delete,
			aim_unsetPresaIncarico: aim_unsetPresaIncarico,
			aim_unsetPresaIncaricoCPI: aim_unsetPresaIncaricoCPI,
			aim_setCompleted: aim_setCompleted,
			aim_unsetCompleted: aim_unsetCompleted,
			aim_setSent: aim_setSent,

			//-- AIM-SERVIZIO
			aimServizio_getAllList: aimServizio_getAllList,
			aimServizio_getAll: aimServizio_getAll,
			aimServizio_countAll: aimServizio_countAll,
			aimServizio_get: aimServizio_get,
			aimServizio_add: aimServizio_add,
			aimServizio_update: aimServizio_update,
			aimServizio_delete: aimServizio_delete,
			aimServizio_unlock: aimServizio_unlock,

			//-- AUTOIMPIEGO RIMBORSO - Nuovi Metodi
			aimRmb_getAllList: aimRmb_getAllList,
			aimRmb_getAll: aimRmb_getAll,
			aimRmb_countAll: aimRmb_countAll,
			aimRmb_get: aimRmb_get,
			aimRmb_add: aimRmb_add,
			aimRmb_update: aimRmb_update,
			aimRmb_changeState: aimRmb_changeState,
			aimRmb_updateDatiAssess: aimRmb_updateDatiAssess,
			aimRmb_delete: aimRmb_delete,
			aimRmb_unlock: aimRmb_unlock,
			aimRmb_unsetPresaIncarico: aimRmb_unsetPresaIncarico,
			aimRmb_unsetPresaIncaricoCPI: aimRmb_unsetPresaIncaricoCPI,
			aimRmb_unsetIssuePay: aimRmb_unsetIssuePay,

			//-- AIM-SPETTANZE
			aimSpettanze_getAll: aimSpettanze_getAll,
			aimSpettanze_countAll: aimSpettanze_countAll,

			//-- ASSFORM - MISURA 2C
			assForm_getAllList: assForm_getAllList,
			assForm_getAll: assForm_getAll,
			assForm_countAll: assForm_countAll,
			assForm_get: assForm_get,
			assForm_add: assForm_add,
			assForm_update: assForm_update,
			assForm_merge: assForm_merge,
			assForm_delete: assForm_delete,
			assForm_assign: assForm_assign,
			assForm_status: assForm_status,
			assForm_changeState: assForm_changeState,
			assForm_unlock: assForm_unlock,
			assForm_unlockSent: assForm_unlockSent,
			assForm_unsetRinuncia: assForm_unsetRinuncia,

			//-- ASSFORM RIMBORSO - MISURA 2C 
			assFormRmb_getAllList: assFormRmb_getAllList,
			assFormRmb_getAll: assFormRmb_getAll,
			assFormRmb_countAll: assFormRmb_countAll,
			assFormRmb_get: assFormRmb_get,
			assFormRmb_add: assFormRmb_add,
			assFormRmb_update: assFormRmb_update,
			assFormRmb_changeState: assFormRmb_changeState,
			assFormRmb_updateDatiAssess: assFormRmb_updateDatiAssess,
			assFormRmb_delete: assFormRmb_delete,
			assFormRmb_unlock: assFormRmb_unlock,
			//assFormRmb_unsetPresaIncarico: assFormRmb_unsetPresaIncarico,
			//assFormRmb_unsetPresaIncaricoCPI: assFormRmb_unsetPresaIncaricoCPI,
			//assFormRmb_unsetIssuePay: assFormRmb_unsetIssuePay,

			//-ISSUE-LOG
			issueLog_getAll: issueLog_getAll,
			issueLog_countAll: issueLog_countAll,
			issueLog_get: issueLog_get,
			issueLog_add: issueLog_add,
			issueLog_addMultiplo: issueLog_addMultiplo,
			issueLog_update: issueLog_update,
			issueLog_delete: issueLog_delete,
			issueLog_setState: issueLog_setState,
			issueLog_sendEmail: issueLog_sendEmail,

			//-- MY LOG
			myLog_getAllList: myLog_getAllList,
			myLog_getAll: myLog_getAll,
			myLog_countAll: myLog_countAll,
			myLog_get: myLog_get,
			myLog_add: myLog_add,
			myLog_update: myLog_update,
			myLog_merge: myLog_merge,
			myLog_delete: myLog_delete,

			//--SAP
			sap_getAllList: sap_getAllList,
			sap_getAll: sap_getAll,
			sap_countAll: sap_countAll,
			sap_get: sap_get,
			sap_add: sap_add,
			sap_update: sap_update,
			sap_delete: sap_delete,
			sap_writeXML: sap_writeXML,
			sap_joinXML: sap_joinXML,
			sap_upload_getURL: sap_upload_getURL,

			//--SAP_DatiAnag
			sap_DatiAnag_getAllList: sap_DatiAnag_getAllList,
			sap_DatiAnag_getAll: sap_DatiAnag_getAll,
			sap_DatiAnag_countAll: sap_DatiAnag_countAll,
			sap_DatiAnag_get: sap_DatiAnag_get,
			sap_DatiAnag_add: sap_DatiAnag_add,
			sap_DatiAnag_update: sap_DatiAnag_update,
			sap_DatiAnag_delete: sap_DatiAnag_delete,

			//--SAP_DatiAmm
			sap_DatiAmm_getAllList: sap_DatiAmm_getAllList,
			sap_DatiAmm_getAll: sap_DatiAmm_getAll,
			sap_DatiAmm_countAll: sap_DatiAmm_countAll,
			sap_DatiAmm_get: sap_DatiAmm_get,
			sap_DatiAmm_add: sap_DatiAmm_add,
			sap_DatiAmm_update: sap_DatiAmm_update,
			sap_DatiAmm_delete: sap_DatiAmm_delete,

			//--SAP_EspProf
			sap_EspProf_getAllList: sap_EspProf_getAllList,
			sap_EspProf_getAll: sap_EspProf_getAll,
			sap_EspProf_countAll: sap_EspProf_countAll,
			sap_EspProf_get: sap_EspProf_get,
			sap_EspProf_add: sap_EspProf_add,
			sap_EspProf_update: sap_EspProf_update,
			sap_EspProf_delete: sap_EspProf_delete,

			//--SAP_CV_TitStud
			sap_CV_TitStud_getAllList: sap_CV_TitStud_getAllList,
			sap_CV_TitStud_getAll: sap_CV_TitStud_getAll,
			sap_CV_TitStud_countAll: sap_CV_TitStud_countAll,
			sap_CV_TitStud_get: sap_CV_TitStud_get,
			sap_CV_TitStud_add: sap_CV_TitStud_add,
			sap_CV_TitStud_update: sap_CV_TitStud_update,
			sap_CV_TitStud_delete: sap_CV_TitStud_delete,

			//--SAP_CV_FormProf
			sap_CV_FormProf_getAllList: sap_CV_FormProf_getAllList,
			sap_CV_FormProf_getAll: sap_CV_FormProf_getAll,
			sap_CV_FormProf_countAll: sap_CV_FormProf_countAll,
			sap_CV_FormProf_get: sap_CV_FormProf_get,
			sap_CV_FormProf_add: sap_CV_FormProf_add,
			sap_CV_FormProf_update: sap_CV_FormProf_update,
			sap_CV_FormProf_delete: sap_CV_FormProf_delete,

			//--SAP_CV_Lingue
			sap_CV_Lingue_getAllList: sap_CV_Lingue_getAllList,
			sap_CV_Lingue_getAll: sap_CV_Lingue_getAll,
			sap_CV_Lingue_countAll: sap_CV_Lingue_countAll,
			sap_CV_Lingue_get: sap_CV_Lingue_get,
			sap_CV_Lingue_add: sap_CV_Lingue_add,
			sap_CV_Lingue_update: sap_CV_Lingue_update,
			sap_CV_Lingue_delete: sap_CV_Lingue_delete,

			//--SAP_CV_Inform
			sap_CV_Inform_getAllList: sap_CV_Inform_getAllList,
			sap_CV_Inform_getAll: sap_CV_Inform_getAll,
			sap_CV_Inform_countAll: sap_CV_Inform_countAll,
			sap_CV_Inform_get: sap_CV_Inform_get,
			sap_CV_Inform_add: sap_CV_Inform_add,
			sap_CV_Inform_update: sap_CV_Inform_update,
			sap_CV_Inform_delete: sap_CV_Inform_delete,

			//--SAP_CV_Altro
			sap_CV_Altro_getAllList: sap_CV_Altro_getAllList,
			sap_CV_Altro_getAll: sap_CV_Altro_getAll,
			sap_CV_Altro_countAll: sap_CV_Altro_countAll,
			sap_CV_Altro_get: sap_CV_Altro_get,
			sap_CV_Altro_add: sap_CV_Altro_add,
			sap_CV_Altro_update: sap_CV_Altro_update,
			sap_CV_Altro_delete: sap_CV_Altro_delete,

			//--SAP_PolAtt
			sap_PolAtt_getAllList: sap_PolAtt_getAllList,
			sap_PolAtt_getAll: sap_PolAtt_getAll,
			sap_PolAtt_countAll: sap_PolAtt_countAll,
			sap_PolAtt_get: sap_PolAtt_get,
			sap_PolAtt_add: sap_PolAtt_add,
			sap_PolAtt_update: sap_PolAtt_update,
			sap_PolAtt_delete: sap_PolAtt_delete,

			//--PAGAMENTO
			pagamento_getAllList: pagamento_getAllList,
			pagamento_getAll: pagamento_getAll,
			pagamento_countAll: pagamento_countAll,
			pagamento_get: pagamento_get,
			pagamento_add: pagamento_add,
			pagamento_update: pagamento_update,
			pagamento_updateDatiAssess: pagamento_updateDatiAssess,
			pagamento_changeState: pagamento_changeState,
			pagamento_delete: pagamento_delete,
			pagamento_unlock: pagamento_unlock,
			pagamento_unsetPresaIncarico: pagamento_unsetPresaIncarico,

			//-- PAGAMENTO DETAIL
			pagamentoDtl_getAllList: pagamentoDtl_getAllList,
			pagamentoDtl_getAll: pagamentoDtl_getAll,
			pagamentoDtl_countAll: pagamentoDtl_countAll,
			pagamentoDtl_get: pagamentoDtl_get,
			pagamentoDtl_add: pagamentoDtl_add,
			pagamentoDtl_update: pagamentoDtl_update,
			pagamentoDtl_delete: pagamentoDtl_delete,
			pagamentoDtl_unlock: pagamentoDtl_unlock,

			//--APLDOMANDERIMBORSO
			aplDomandeRimborso_getAllList: aplDomandeRimborso_getAllList,
			aplDomandeRimborso_getAll: aplDomandeRimborso_getAll,
			aplDomandeRimborso_countAll: aplDomandeRimborso_countAll,
			aplDomandeRimborso_get: aplDomandeRimborso_get,

			//--ORIENTAMENTO
			orientamento_getList: orientamento_getList,
			orientamento_getAll: orientamento_getAll,
			orientamento_countAll: orientamento_countAll,
			orientamento_getAllListByRmbDtl: orientamento_getAllListByRmbDtl,
			orientamento_get: orientamento_get,
			orientamento_add: orientamento_add,
			orientamento_update: orientamento_update,
			orientamento_delete: orientamento_delete,
			orientamento_unlock: orientamento_unlock,

			//--ORIENTAMENTODEST
			orientamentoDest_getList: orientamentoDest_getList,
			orientamentoDest_getAll: orientamentoDest_getAll,
			orientamentoDest_countAll: orientamentoDest_countAll,
			orientamentoDest_clona: orientamentoDest_clona,
			orientamentoDest_get: orientamentoDest_get,
			orientamentoDest_add: orientamentoDest_add,
			orientamentoDest_update: orientamentoDest_update,
			orientamentoDest_delete: orientamentoDest_delete,

			//-- ORI-RIMBORSO
			oriRmb_getAllList: oriRmb_getAllList,
			oriRmb_getAll: oriRmb_getAll,
			oriRmb_countAll: oriRmb_countAll,
			oriRmb_get: oriRmb_get,
			oriRmb_add: oriRmb_add,
			oriRmb_update: oriRmb_update,
			oriRmb_merge: oriRmb_merge,
			oriRmb_delete: oriRmb_delete,
			oriRmb_changeState: oriRmb_changeState,

			//--PROFILO DOCENTE
			tProfiloDocente_getAll: tProfiloDocente_getAll,

			//--PROFILO ANPAL
			tProfiloANPAL_getAll: tProfiloANPAL_getAll,

			//--TRuolo
			tRuolo_getAll: tRuolo_getAll,
			tRuolo_getByCode: tRuolo_getByCode,

			//-- SEDE       
			sede_getAllList: sede_getAllList,
			sede_getAll: sede_getAll,
			sede_countAll: sede_countAll,
			sede_get: sede_get,
			sede_add: sede_add,
			sede_update: sede_update,
			sede_merge: sede_merge,
			sede_delete: sede_delete,

			//-- SIGNATURE
			signature_getAllList: signature_getAllList,
			signature_getAll: signature_getAll,
			signature_countAll: signature_countAll,
			signature_upload: signature_upload,
			signature_get: signature_get,
			signature_add: signature_add,
			signature_update: signature_update,
			signature_delete: signature_delete,



			//-- AZIENDA - Nuovi Metodi
			azienda_getAllList: azienda_getAllList,
			azienda_getAll: azienda_getAll,
			azienda_countAll: azienda_countAll,
			azienda_exists: azienda_exists,
			azienda_statusFondi: azienda_statusFondi,
			azienda_getDecretato: azienda_getDecretato,
			azienda_getByUsername: azienda_getByUsername,
			azienda_getByUsername2: azienda_getByUsername2,
			azienda_get: azienda_get,
			azienda_add: azienda_add,
			azienda_update: azienda_update,
			azienda_merge: azienda_merge,
			azienda_saveComplete: azienda_saveComplete,
			azienda_changeState: azienda_changeState,
			azienda_delete: azienda_delete,
			azienda_upload: azienda_upload,
			azienda_deleteCartaIntestata: azienda_deleteCartaIntestata,

			//-- AZIENDA-SEDE
			aziendaSede_getAllList: aziendaSede_getAllList,
			aziendaSede_getAll: aziendaSede_getAll,
			aziendaSede_countAll: aziendaSede_countAll,
			aziendaSede_changeState: aziendaSede_changeState,
			aziendaSede_get: aziendaSede_get,
			aziendaSede_add: aziendaSede_add,
			aziendaSede_update: aziendaSede_update,
			aziendaSede_merge: aziendaSede_merge,
			aziendaSede_delete: aziendaSede_delete,
			aziendaSede_unlock: aziendaSede_unlock,
			aziendaSede_changePresaIncarico: aziendaSede_changePresaIncarico,

			//-- AZIENDA-RPOVINCIA
			aziendaProvincia_getAllList: aziendaProvincia_getAllList,
			aziendaProvincia_getAll: aziendaProvincia_getAll,
			aziendaProvincia_countAll: aziendaProvincia_countAll,
			aziendaProvincia_get: aziendaProvincia_get,
			aziendaProvincia_add: aziendaProvincia_add,
			aziendaProvincia_update: aziendaProvincia_update,
			aziendaProvincia_delete: aziendaProvincia_delete,
			aziendaProvincia_unlock: aziendaProvincia_unlock,

			// -- AZIENDA-CODICE-INTERMEDIARIO
			aziendaCodiceIntermediario_getAllList: aziendaCodiceIntermediario_getAllList,
			aziendaCodiceIntermediario_getAll: aziendaCodiceIntermediario_getAll,
			aziendaCodiceIntermediario_countAll: aziendaCodiceIntermediario_countAll,
			aziendaCodiceIntermediario_get: aziendaCodiceIntermediario_get,
			aziendaCodiceIntermediario_add: aziendaCodiceIntermediario_add,
			aziendaCodiceIntermediario_update: aziendaCodiceIntermediario_update,
			aziendaCodiceIntermediario_merge: aziendaCodiceIntermediario_merge,
			aziendaCodiceIntermediario_delete: aziendaCodiceIntermediario_delete,


			//-- TIROCINIO
			tirocinio_getAllList: tirocinio_getAllList,
			tirocinio_getAll: tirocinio_getAll,
			tirocinio_countAll: tirocinio_countAll,
			tirocinio_exists: tirocinio_exists,
			tirocinio_get: tirocinio_get,
			tirocinio_add: tirocinio_add,
			tirocinio_update: tirocinio_update,
			tirocinio_merge: tirocinio_merge,
			tirocinio_change: tirocinio_change,
			tirocinio_delete: tirocinio_delete,
			tirocinio_unlock: tirocinio_unlock,
			tirocinio_setFuoriOrario: tirocinio_setFuoriOrario,
			tirocinio_changeState: tirocinio_changeState,
			tirocinio_setNoBenefit: tirocinio_setNoBenefit,
			tirocinio_unsetNoBenefit: tirocinio_unsetNoBenefit,
			tirocinio_disassignRlz: tirocinio_disassignRlz,
			tirocinio_status: tirocinio_status,
			tirocinio_assign: tirocinio_assign,
			tirocinio_reassign: tirocinio_reassign,
			tirocinio_rinuncia: tirocinio_rinuncia,
			tirocinio_rlzSuspended: tirocinio_rlzSuspended,
			tirocinio_setPresaIncarico: tirocinio_setPresaIncarico,
			tirocinio_unsetPresaIncarico: tirocinio_unsetPresaIncarico,
			tirocinio_setPresaIncaricoCPI: tirocinio_setPresaIncaricoCPI,
			tirocinio_unsetPresaIncaricoCPI: tirocinio_unsetPresaIncaricoCPI,
			tirocinio_getAllByIndennita: tirocinio_getAllByIndennita,

			//-- TIROCINIO LOG
			tirLog_getAllList: tirLog_getAllList,
			tirLog_getAll: tirLog_getAll,
			tirLog_countAll: tirLog_countAll,
			tirLog_get: tirLog_get,
			tirLog_add: tirLog_add,
			tirLog_update: tirLog_update,
			tirLog_delete: tirLog_delete,


			//-- TIROCINI-SPESE
			tirocinioSpesa_getAllList: tirocinioSpesa_getAllList,
			tirocinioSpesa_getAll: tirocinioSpesa_getAll,
			tirocinioSpesa_countAll: tirocinioSpesa_countAll,
			tirocinioSpesa_get: tirocinioSpesa_get,
			tirocinioSpesa_add: tirocinioSpesa_add,
			tirocinioSpesa_update: tirocinioSpesa_update,
			tirocinioSpesa_delete: tirocinioSpesa_delete,

			//-- TIROCINI-PAGAMENTI
			tirocinioPagamento_getAllList: tirocinioPagamento_getAllList,
			tirocinioPagamento_getAll: tirocinioPagamento_getAll,
			tirocinioPagamento_countAll: tirocinioPagamento_countAll,
			tirocinioPagamento_get: tirocinioPagamento_get,
			tirocinioPagamento_add: tirocinioPagamento_add,
			tirocinioPagamento_update: tirocinioPagamento_update,
			tirocinioPagamento_delete: tirocinioPagamento_delete,

			//-- TIROCINIO RIMBORSO
			tirRimborso_getAllList: tirRimborso_getAllList,
			tirRimborso_getAll: tirRimborso_getAll,
			tirRimborso_countAll: tirRimborso_countAll,
			tirRimborso_get: tirRimborso_get,
			tirRimborso_add: tirRimborso_add,
			tirRimborso_update: tirRimborso_update,
			tirRimborso_merge: tirRimborso_merge,
			tirRimborso_delete: tirRimborso_delete,
			tirRimborso_updateDatiAssess: tirRimborso_updateDatiAssess,
			tirRimborso_changeState: tirRimborso_changeState,
			tirRimborso_changePresaIncarico: tirRimborso_changePresaIncarico,
			tirRimborso_changePeriodo: tirRimborso_changePeriodo,
			tirRimborso_calcolaImportoRichiesto: tirRimborso_calcolaImportoRichiesto,

			//-- TIROCINIO RIMBORSO DTL
			tirRimborsoDtl_getAllList: tirRimborsoDtl_getAllList,
			tirRimborsoDtl_getAll: tirRimborsoDtl_getAll,
			tirRimborsoDtl_countAll: tirRimborsoDtl_countAll,
			tirRimborsoDtl_get: tirRimborsoDtl_get,
			tirRimborsoDtl_add: tirRimborsoDtl_add,
			tirRimborsoDtl_update: tirRimborsoDtl_update,
			tirRimborsoDtl_delete: tirRimborsoDtl_delete,

			//-- TIROCINIO SOSPENSIONE
			tirSospensione_getAllByTirocinioId: tirSospensione_getAllByTirocinioId,
			tirSospensione_get: tirSospensione_get,
			tirSospensione_add: tirSospensione_add,
			tirSospensione_update: tirSospensione_update,
			tirSospensione_merge: tirSospensione_merge,
			tirSospensione_delete: tirSospensione_delete,

			//-- COLLOCAMENTO
			collocamento_getAllList: collocamento_getAllList,
			collocamento_getAll: collocamento_getAll,
			collocamento_countAll: collocamento_countAll,
			collocamento_statusCF: collocamento_statusCF,
			collocamento_assign: collocamento_assign,
			collocamento_get: collocamento_get,
			collocamento_add: collocamento_add,
			collocamento_update: collocamento_update,
			collocamento_merge: collocamento_merge,
			collocamento_delete: collocamento_delete,
			collocamento_unlock: collocamento_unlock,
			collocamento_setCompleted: collocamento_setCompleted,
			collocamento_setSent: collocamento_setSent,
			collocamento_unlockSent: collocamento_unlockSent,

			collocamento_proroga: collocamento_proroga,
			collocamento_unlockProroga: collocamento_unlockProroga,

			//-- COLL-RIMBORSO
			collRimborso_getAllList: collRimborso_getAllList,
			collRimborso_getAll: collRimborso_getAll,
			collRimborso_countAll: collRimborso_countAll,
			collRimborso_get: collRimborso_get,
			collRimborso_add: collRimborso_add,
			collRimborso_update: collRimborso_update,
			collRimborso_merge: collRimborso_merge,
			collRimborso_delete: collRimborso_delete,
			collRimborso_changeState: collRimborso_changeState,

			//-- COLL-SERVIZIO
			collServizio_getAllList: collServizio_getAllList,
			collServizio_getAll: collServizio_getAll,
			collServizio_countAll: collServizio_countAll,
			collServizio_get: collServizio_get,
			collServizio_add: collServizio_add,
			collServizio_update: collServizio_update,
			collServizio_delete: collServizio_delete,
			collServizio_changeState: collServizio_changeState,

			//-- COLL-CONTRATTO (ASSUNZIONE)
			collContratto_getAllList: collContratto_getAllList,
			collContratto_getOneByFilter: collContratto_getOneByFilter,
			collContratto_getAll: collContratto_getAll,
			collContratto_countAll: collContratto_countAll,
			collContratto_get: collContratto_get,
			collContratto_add: collContratto_add,
			collContratto_update: collContratto_update,
			collContratto_delete: collContratto_delete,
			collContratto_unlock: collContratto_unlock,



			//-- TContratto          
			tContratto_getAllList: tContratto_getAllList,
			tContratto_getAll: tContratto_getAll,
			tContratto_get: tContratto_get,

			//-- CLASSE RIMBORSO
			classeRimborso_getAllList: classeRimborso_getAllList,
			classeRimborso_getAll: classeRimborso_getAll,
			classeRimborso_countAll: classeRimborso_countAll,
			classeRimborso_get: classeRimborso_get,
			classeRimborso_add: classeRimborso_add,
			classeRimborso_create: classeRimborso_create,
			classeRimborso_update: classeRimborso_update,
			classeRimborso_merge: classeRimborso_merge,
			classeRimborso_updateDatiAssess: classeRimborso_updateDatiAssess,
			classeRimborso_changeState: classeRimborso_changeState,
			classeRimborso_delete: classeRimborso_delete,
			classeRimborso_unlock: classeRimborso_unlock,
			classeRimborso_unsetIssuePay: classeRimborso_unsetIssuePay,
			classeRimborso_setPresaIncarico: classeRimborso_setPresaIncarico,
			classeRimborso_unsetPresaIncarico: classeRimborso_unsetPresaIncarico,
			classeRimborso_setPresaIncaricoCPI: classeRimborso_setPresaIncaricoCPI,
			classeRimborso_unsetPresaIncaricoCPI: classeRimborso_unsetPresaIncaricoCPI,

			//-- CLASSE RIMBORSO DOCENZA
			classeRmbDocenza_getAll: classeRmbDocenza_getAll,
			classeRmbDocenza_countAll: classeRmbDocenza_countAll,
			classeRmbDocenza_get: classeRmbDocenza_get,
			classeRmbDocenza_add: classeRmbDocenza_add,
			classeRmbDocenza_update: classeRmbDocenza_update,
			classeRmbDocenza_merge: classeRmbDocenza_merge,
			classeRmbDocenza_delete: classeRmbDocenza_delete,

			//-- CLASSE RIMBORSO ALLIEVO
			classeRmbAllievo_getAll: classeRmbAllievo_getAll,
			classeRmbAllievo_countAll: classeRmbAllievo_countAll,
			classeRmbAllievo_get: classeRmbAllievo_get,
			classeRmbAllievo_add: classeRmbAllievo_add,
			classeRmbAllievo_update: classeRmbAllievo_update,
			classeRmbAllievo_merge: classeRmbAllievo_merge,
			classeRmbAllievo_delete: classeRmbAllievo_delete,


			//-- CLASSE STUDENTE
			classeStudente_getAll: classeStudente_getAll,
			classeStudente_countAll: classeStudente_countAll,
			classeStudente_exists: classeStudente_exists,
			classeStudente_getAllByClasse_Date: classeStudente_getAllByClasse_Date,
			classeStudente_getMaxByStudenteId: classeStudente_getMaxByStudenteId,
			classeStudente_get: classeStudente_get,
			classeStudente_add: classeStudente_add,
			classeStudente_addSpecial: classeStudente_addSpecial,
			classeStudente_update: classeStudente_update,
			classeStudente_delete: classeStudente_delete,

			//-- CLASSE STUDENTE SOSPENSIONE
			classeStdSospensione_getAllBySourceId: classeStdSospensione_getAllBySourceId,
			classeStdSospensione_get: classeStdSospensione_get,
			classeStdSospensione_create: classeStdSospensione_create,
			classeStdSospensione_add: classeStdSospensione_add,
			classeStdSospensione_update: classeStdSospensione_update,
			classeStdSospensione_merge: classeStdSospensione_merge,
			classeStdSospensione_delete: classeStdSospensione_delete,

			//-- USER
			user_getAllList: user_getAllList,
			user_getAllListActive: user_getAllListActive,
			user_getAll: user_getAll,
			user_countAll: user_countAll,
			user_get: user_get,
			user_add: user_add,
			user_update: user_update,
			user_exists: user_exists,
			user_setPassword: user_setPassword,
			user_activate: user_activate,
			user_deactivate: user_deactivate,
			user_resetPassword: user_resetPassword,
			user_invioCredenziali: user_invioCredenziali,
			user_GeneraPassword: user_GeneraPassword,
			user_UnlockAccount: user_UnlockAccount,
			user_createNewAccount: user_createNewAccount,
			user_changePassword: user_changePassword,
			user_sendMassive: user_sendMassive,
			//user_delete: user_delete,

			//-- ROLE
			role_getAllList: role_getAllList,
			role_getAll: role_getAll,
			role_get: role_get,
			role_getDto: role_getDto,
			role_getAllUser: role_getAllUser,
			role_countAllUser: role_countAllUser,
			role_add: role_add,
			role_update: role_update,
			role_delete: role_delete,

			roleUser_add: roleUser_add,
			roleUser_delete: roleUser_delete,
			deleteChildrenOfRoleIdOrUserId: deleteChildrenOfRoleIdOrUserId,

			//-- ROLE USER
			userRole_getAll: userRole_getAll,
			userRole_add: userRole_add,
			userRole_delete: userRole_delete,

			//-- AUTHORIZATION
			authorization_get: authorization_get,
			authorization_getById: authorization_getById,
			authorization_getAllByUser: authorization_getAllByUser,
			authorization_getAllByFilter: authorization_getAllByFilter,
			authorization_countAllByFilter: authorization_countAllByFilter,
			authorization_add: authorization_add,
			authorization_update: authorization_update,
			authorization_delete: authorization_delete,

			//-- AREA
			area_getAllList: area_getAllList,
			area_getAll: area_getAll,
			area_getAllByFilter: area_getAllByFilter,
			area_getMaxId: area_getMaxId,
			area_get: area_get,
			area_add: area_add,
			area_update: area_update,
			area_delete: area_delete,

			//=========== NEWSLETTER
			//-- MAIL_EMAIL
			newsletter_email_getAllList: newsletter_email_getAllList,
			newsletter_email_getAll: newsletter_email_getAll,
			newsletter_email_countAll: newsletter_email_countAll,
			newsletter_email_get: newsletter_email_get,
			newsletter_email_add: newsletter_email_add,
			newsletter_email_update: newsletter_email_update,
			newsletter_email_confirmSent: newsletter_email_confirmSent,
			newsletter_email_delete: newsletter_email_delete,
			newsletter_email_invioEmail: newsletter_email_invioEmail,
			newsletter_email_invioEmails: newsletter_email_invioEmails,
			newsletter_email_getTemplate: newsletter_email_getTemplate,

			//-- MAIL_ATTACHMENT
			newsletter_attachment_getAllList: newsletter_attachment_getAllList,
			newsletter_attachment_getAll: newsletter_attachment_getAll,
			newsletter_attachment_getByEmailId: newsletter_attachment_getByEmailId,
			newsletter_attachment_countByEmailId: newsletter_attachment_countByEmailId,
			newsletter_attachment_countAll: newsletter_attachment_countAll,
			newsletter_attachment_get: newsletter_attachment_get,
			newsletter_attachment_add: newsletter_attachment_add,
			newsletter_attachment_update: newsletter_attachment_update,
			newsletter_attachment_delete: newsletter_attachment_delete,

			//-- MAIL_TSOURCE
			newsletter_tSource_getAllList: newsletter_tSource_getAllList,
			newsletter_tSource_getAll: newsletter_tSource_getAll,
			newsletter_tSource_countAll: newsletter_tSource_countAll,
			newsletter_tSource_get: newsletter_tSource_get,
			newsletter_tSource_getByTable: newsletter_tSource_getByTable,
			newsletter_tSource_Entity_getList: newsletter_tSource_Entity_getList,
			newsletter_tSource_Entity_countByFilter: newsletter_tSource_Entity_countByFilter,
			newsletter_tSource_Entity_getAllByFilter: newsletter_tSource_Entity_getAllByFilter,


			//-- MAIL_RECEIVERS
			newsletter_receivers_getAllList: newsletter_receivers_getAllList,
			newsletter_receivers_getAll: newsletter_receivers_getAll,
			newsletter_receivers_countAll: newsletter_receivers_countAll,
			newsletter_receivers_getByEmailId: newsletter_receivers_getByEmailId,
			newsletter_receivers_countByEmailId: newsletter_receivers_countByEmailId,
			newsletter_receivers_getByTSourceId: newsletter_receivers_getByTSourceId,
			newsletter_receivers_get: newsletter_receivers_get,
			newsletter_receivers_add: newsletter_receivers_add,
			newsletter_receivers_update: newsletter_receivers_update,
			newsletter_receivers_delete: newsletter_receivers_delete,

			//============================================

			//-- ATTACH - Nuovi Metodi
			faq_getAllList: faq_getAllList,
			faq_getAll: faq_getAll,
			faq_countAll: faq_countAll,
			faq_get: faq_get,
			faq_add: faq_add,
			faq_update: faq_update,
			faq_merge: faq_merge,
			faq_delete: faq_delete,

			//-- Tfaq          
			tFaq_getAllList: tFaq_getAllList,
			tFaq_get: tFaq_get,

			//-- ATTACH - Nuovi Metodi
			attach_getAllList: attach_getAllList,
			attach_getAll: attach_getAll,
			attach_countAll: attach_countAll,
			attach_getAllCND: attach_getAllCND,
			attach_countAllCND: attach_countAllCND,
			attach_getReadyToLockCND: attach_getReadyToLockCND,
			attach_get: attach_get,
			attach_add: attach_add,
			attach_AddMultiplo: attach_AddMultiplo,
			attach_update: attach_update,
			attach_merge: attach_merge,
			attach_delete: attach_delete,
			attach_changeState: attach_changeState,
			attach_setCompleted: attach_setCompleted,
			attach_unsetCompleted: attach_unsetCompleted,

			attach_setIssue: attach_setIssue,
			attach_unsetIssue: attach_unsetIssue,
			attach_updateIssue: attach_updateIssue,

			attach_unlock: attach_unlock,

			//Estrazione documentazione dalla piattaforma
			attach_download: attach_download,
			attach_getBySource: attach_getBySource,
			attach_extract: attach_extract,
			attach_extractDigitalSignInfo: attach_extractDigitalSignInfo,
			attach_safeDownload: attach_safeDownload,


			//-- ATTACHHASH - Nuovi Metodi
			attachHash_getAllList: attachHash_getAllList,
			attachHash_getAll: attachHash_getAll,
			attachHash_countAll: attachHash_countAll,
			attachHash_get: attachHash_get,
			attachHash_add: attachHash_add,
			attachHash_delete: attachHash_delete,
			attachHash_create: attachHash_create,


			//-- TATTACH          
			tAttach_getAllList: tAttach_getAllList,
			tAttach_getAllModal: tAttach_getAllModal,
			tAttach_getAll: tAttach_getAll,
			tAttach_countAll: tAttach_countAll,
			tAttach_get: tAttach_get,
			tAttach_getByCode: tAttach_getByCode,
			tAttach_add: tAttach_add,
			tAttach_update: tAttach_update,
			tAttach_delete: tAttach_delete,

			//-- TATTACHVISIBILITY
			tAttachVisibility_getAuth: tAttachVisibility_getAuth,
			tAttachVisibility_getAll: tAttachVisibility_getAll,
			tAttachVisibility_add: tAttachVisibility_add,
			tAttachVisibility_update: tAttachVisibility_update,
			tAttachVisibility_delete: tAttachVisibility_delete,

			//-- TATTACHFILETYPE
			tAttachFileType_getAll: tAttachFileType_getAll,
			tAttachFileType_add: tAttachFileType_add,
			tAttachFileType_update: tAttachFileType_update,
			tAttachFileType_delete: tAttachFileType_delete,

			//-- TSOURCE          
			tSource_getAllList: tSource_getAllList,
			tSource_getAll: tSource_getAll,
			tSource_get: tSource_get,
			tSource_getByCode: tSource_getByCode,
			tSource_countAll: tSource_countAll,
			tSource_add: tSource_add,
			tSource_update: tSource_update,
			tSource_delete: tSource_delete,

			//-- SOURCE
			source_getAllList: source_getAllList,

			//-- RUOLO AMM
			tRuoloAmm_get: tRuoloAmm_get,

			//-- RUOLO AMM
			tRuoloDid_get: tRuoloDid_get,


			//-- QUERY
			query_countByFilter: query_countByFilter,
			query_getAllByFilter: query_getAllByFilter,
			query_get: query_get,
			query_add: query_add,
			query_update: query_update,
			query_delete: query_delete,
			queryEntity_download: queryEntity_download,
			queryEntity_countByFilter: queryEntity_countByFilter,
			queryEntity_getAllByFilter: queryEntity_getAllByFilter,
			query_exportToExcel: query_exportToExcel,
			query_exportToPDF: query_exportToPDF,
			query_make: query_make,
			query_generateExcel: query_generateExcel,

			//-- QUERYVisibility
			queryVisibility_countByFilter: queryVisibility_countByFilter,
			queryVisibility_getAllByFilter: queryVisibility_getAllByFilter,
			queryVisibility_get: queryVisibility_get,
			queryVisibility_add: queryVisibility_add,
			queryVisibility_update: queryVisibility_update,
			queryVisibility_AddMultiplo: queryVisibility_AddMultiplo,
			queryVisibility_delete: queryVisibility_delete,
			
			//-- NOTIFICATION
			notification_countByFilter: notification_countByFilter,
			notification_getAllByFilter: notification_getAllByFilter,

			//-- NOTIFICATION da BackOffice
			notification_getAll: notification_getAll,
			notification_countAll: notification_countAll,
			notification_getDto: notification_getDto,
			notification_add: notification_add,
			notification_update: notification_update,
			notification_delete: notification_delete,

			//-- NOTIFICATION-VISIBILITY
			notificationVisibility_getAll: notificationVisibility_getAll,
			notificationVisibility_add: notificationVisibility_add,
			notificationVisibility_addList: notificationVisibility_addList,
			notificationVisibility_update: notificationVisibility_update,
			notificationVisibility_delete: notificationVisibility_delete,

			//-- NOTIFICATION-USER
			notificationUser_getAll: notificationUser_getAll,
			notificationUser_push: notificationUser_push,
			notificationUser_update: notificationUser_update,
			notificationUser_delete: notificationUser_delete,

			//-- DOWNLOAD
			download_countByFilter: download_countByFilter,
			download_getList: download_getList,
			download_getAllByFilter: download_getAllByFilter,

			//-- DOWNLOAD da BackOffice
			download_getAll: download_getAll,
			download_countAll: download_countAll,
			download_getDto: download_getDto,
			download_add: download_add,
			download_update: download_update,
			download_merge: download_merge,
			download_delete: download_delete,

			//-- DOWNLOAD-VISIBILITY
			downloadVisibility_getAll: downloadVisibility_getAll,
			downloadVisibility_addRole: downloadVisibility_addRole,
			downloadVisibility_updateRole: downloadVisibility_updateRole,
			downloadVisibility_deleteRole: downloadVisibility_deleteRole,

			//-- VIDEOGUIDA
			videoGuida_countByFilter: videoGuida_countByFilter,
			videoGuida_getAllByFilter: videoGuida_getAllByFilter,

			//-- VIDEOGUIDA da BackOffice
			videoGuida_getAll: videoGuida_getAll,
			videoGuida_countAll: videoGuida_countAll,
			videoGuida_getDto: videoGuida_getDto,
			videoGuida_add: videoGuida_add,
			videoGuida_merge: videoGuida_merge,
			videoGuida_delete: videoGuida_delete,

			//-- VIDEOGUIDA-VISIBILITY
			videoGuidaVisibility_getAll: videoGuidaVisibility_getAll,
			videoGuidaVisibility_add: videoGuidaVisibility_add,
			videoGuidaVisibility_update: videoGuidaVisibility_update,
			videoGuidaVisibility_delete: videoGuidaVisibility_delete,

			//--ACCOUNT
			account_getDaysValidityPassword: account_getDaysValidityPassword,

			//--PARAMS
			params_get: params_get,
			params_exists: params_exists,
			params_getAllList: params_getAllList,
			params_getAll: params_getAll,
			params_countAll: params_countAll,
			params_getById: params_getById,
			params_add: params_add,
			params_update: params_update,
			params_merge: params_merge,
			params_delete: params_delete,

			//-- PROTOCOLLO
			protocollo_getAll: protocollo_getAll,
			protocollo_countAll: protocollo_countAll,
			protocolloAPL_getAll: protocolloAPL_getAll,
			protocolloAPL_countAll: protocolloAPL_countAll,
			protocolloCPI_getAll: protocolloCPI_getAll,
			protocolloCPI_countAll: protocolloCPI_countAll,
			protocolloCodEvento_getAll: protocolloCodEvento_getAll,
			protocollo_getEnteSAC: protocollo_getEnteSAC,
			protocollo_syncImport: protocollo_syncImport,
			protocollo_syncImportAnagrafica: protocollo_syncImportAnagrafica,

			//-- RIMBORSO
			rimborso_getAllList: rimborso_getAllList,
			rimborso_getAll: rimborso_getAll,
			rimborso_countAll: rimborso_countAll,
			rimborso_exists: rimborso_exists,
			rimborso_get: rimborso_get,
			rimborso_add: rimborso_add,
			rimborso_update: rimborso_update,
			rimborso_merge: rimborso_merge,
			rimborso_delete: rimborso_delete,
			rimborso_changeState: rimborso_changeState,
			rimborso_changePresaIncarico: rimborso_changePresaIncarico,

			//-- RIMBORSO-DEST
			rimborsoDest_getList: rimborsoDest_getList,
			rimborsoDest_getAll: rimborsoDest_getAll,
			rimborsoDest_countAll: rimborsoDest_countAll,
			rimborsoDest_get: rimborsoDest_get,
			rimborsoDest_add: rimborsoDest_add,
			rimborsoDest_update: rimborsoDest_update,
			rimborsoDest_delete: rimborsoDest_delete,

			//-- RIMBORSO DTL
			rimborsoDtl_getAllList: rimborsoDtl_getAllList,
			rimborsoDtl_getAll: rimborsoDtl_getAll,
			rimborsoDtl_countAll: rimborsoDtl_countAll,
			rimborsoDtl_get: rimborsoDtl_get,
			rimborsoDtl_add: rimborsoDtl_add,
			rimborsoDtl_addUpdate: rimborsoDtl_addUpdate,
			rimborsoDtl_update: rimborsoDtl_update,
			rimborsoDtl_merge: rimborsoDtl_merge,
			rimborsoDtl_delete: rimborsoDtl_delete,
			rimborsoDtl_changeState: rimborsoDtl_changeState,

			//-- OUTCOMES
			outcome_getAllList: outcome_getAllList,
			outcome_getAll: outcome_getAll,
			outcome_countAll: outcome_countAll,
			outcome_get: outcome_get,
			outcome_add: outcome_add,
			outcome_update: outcome_update,
			outcome_merge: outcome_merge,
			outcome_delete: outcome_delete,
			outcome_changeState: outcome_changeState,
			outcome_changePresaIncarico: outcome_changePresaIncarico,

			//-- OUTCOMES-DTL
			outcomeDtl_getAllList: outcomeDtl_getAllList,
			outcomeDtl_getAll: outcomeDtl_getAll,
			outcomeDtl_countAll: outcomeDtl_countAll,
			outcomeDtl_get: outcomeDtl_get,
			outcomeDtl_add: outcomeDtl_add,
			outcomeDtl_update: outcomeDtl_update,
			outcomeDtl_merge: outcomeDtl_merge,
			outcomeDtl_delete: outcomeDtl_delete,
			outcomeDtl_AddMultiplo: outcomeDtl_AddMultiplo,
			outcomeDtl_AddMultiploByProc: outcomeDtl_AddMultiploByProc,
			outcomeDtl_changeState: outcomeDtl_changeState,

			//-- COMMISSIONS
			commission_getAllList: commission_getAllList,
			commission_getAll: commission_getAll,
			commission_countAll: commission_countAll,
			commission_get: commission_get,
			commission_add: commission_add,
			commission_addSpecial: commission_addSpecial,
			commission_update: commission_update,
			commission_merge: commission_merge,
			commission_delete: commission_delete,
			commission_changeState: commission_changeState,

			//-- COMMISSIONS-DTL
			commissionDtl_getAllList: commissionDtl_getAllList,
			commissionDtl_getAll: commissionDtl_getAll,
			commissionDtl_countAll: commissionDtl_countAll,
			commissionDtl_get: commissionDtl_get,
			commissionDtl_add: commissionDtl_add,
			commissionDtl_update: commissionDtl_update,
			commissionDtl_merge: commissionDtl_merge,
			commissionDtl_delete: commissionDtl_delete,
			commissionDtl_AddMultiplo: commissionDtl_AddMultiplo,
			commissionDtl_AddMultiploByProc: commissionDtl_AddMultiploByProc,
			commissionDtl_changeState: commissionDtl_changeState,

			//-- FATTURE
			fatture_getAll: fatture_getAll,
			fatture_merge: fatture_merge,
			fatture_add: fatture_add,
			fatture_delete: fatture_delete,

			//-- ASSISTANCES
			assistance_getAllList: assistance_getAllList,
			assistance_getAll: assistance_getAll,
			assistance_countAll: assistance_countAll,
			assistance_get: assistance_get,
			assistance_add: assistance_add,
			assistance_update: assistance_update,
			assistance_merge: assistance_merge,
			assistance_delete: assistance_delete,

			//-- TTirocinanteProfilo          
			tTirocinanteProfilo_getAllList: tTirocinanteProfilo_getAllList,
			tTirocinanteProfilo_get: tTirocinanteProfilo_get,

			//-- TTirocinanteProfilo          
			tTirocinio_getAllList: tTirocinio_getAllList,
			tTirocinio_get: tTirocinio_get,

			//-- TTirocinanteProfilo          
			tTirocinioDLG_getAllList: tTirocinioDLG_getAllList,
			tTirocinioDLG_get: tTirocinioDLG_get,

			//-- TLavoro          
			tLavoro_getAllList: tLavoro_getAllList,
			tLavoro_get: tLavoro_get,

			//-- TFormaGiuridica          
			tFormaGiuridica_getAllList: tFormaGiuridica_getAllList,
			tFormaGiuridica_get: tFormaGiuridica_get,

			//-- TAteco          
			tAteco_getAllList: tAteco_getAllList,
			tAteco_get: tAteco_get,
			tAteco_getByText: tAteco_getByText,

			//-- TIndirizzo          
			tIndirizzo_getAllList: tIndirizzo_getAllList,
			tIndirizzo_get: tIndirizzo_get,

			//-- TTitoloStudio          
			tTitoloStudio_getAllList: tTitoloStudio_getAllList,
			tTitoloStudio_get: tTitoloStudio_get,

			//-- TCondizioneMercato          
			tCondizioneMercato_getAllList: tCondizioneMercato_getAllList,
			tCondizioneMercato_get: tCondizioneMercato_get,

			//-- TDurataRicerca          
			tDurataRicerca_getAllList: tDurataRicerca_getAllList,
			tDurataRicerca_get: tDurataRicerca_get,

			//-- TGruppoVulnerabilita          
			tGruppoVulnerabilita_getAllList: tGruppoVulnerabilita_getAllList,
			tGruppoVulnerabilita_get: tGruppoVulnerabilita_get,

			//-- TStatoPartecipante          
			tStatoPartecipante_getAllList: tStatoPartecipante_getAllList,
			tStatoPartecipante_get: tStatoPartecipante_get,

			//-- TCPI          
			tCPI_getAllList: tCPI_getAllList,
			tCPI_get: tCPI_get,

			//-- TTirociniSpese         
			tTirociniSpese_getAllList: tTirociniSpese_getAllList,
			tTirociniSpese_get: tTirociniSpese_get,

			//-- TAteco          
			contenutoFormativo_getAllList: contenutoFormativo_getAllList,
			contenutoFormativo_get: contenutoFormativo_get,

			//-- TEST
			test_getAllList: test_getAllList,
			test_getAllListExclude: test_getAllListExclude,
			test_count: test_count,
			test_countByFilter: test_countByFilter,
			test_getAll: test_getAll,
			test_getAllByFilter: test_getAllByFilter,
			test_get: test_get,
			test_update: test_update,
			test_delete: test_delete,
			test_add: test_add,

			//-- question
			question_getAllList: question_getAllList,
			question_getAllListInTest: question_getAllListInTest,
			question_getAllListNotInTest: question_getAllListNotInTest,
			question_count: question_count,
			question_countByFilter: question_countByFilter,
			question_getAll: question_getAll,
			question_getAllByFilter: question_getAllByFilter,
			question_getAllByTest: question_getAllByTest,
			question_get: question_get,
			question_update: question_update,
			question_delete: question_delete,
			question_add: question_add,
			question_addToTest: question_addToTest,
			question_upload: question_upload,
			question_deleteFiles: question_deleteFiles,

			//-- choice
			choice_getAllList: choice_getAllList,
			choice_count: choice_count,
			choice_countByFilter: choice_countByFilter,
			choice_getAll: choice_getAll,
			choice_getAllByQuestion: choice_getAllByQuestion,
			choice_get: choice_get,
			choice_update: choice_update,
			choice_delete: choice_delete,
			choice_add: choice_add,
			choice_upload: choice_upload,

			//-- questionTest
			questionTest_getAllList: questionTest_getAllList,
			questionTest_count: questionTest_count,
			questionTest_countByFilter: questionTest_countByFilter,
			questionTest_getAll: questionTest_getAll,
			questionTest_getAllByFilter: questionTest_getAllByFilter,
			questionTest_getAllByTest: questionTest_getAllByTest,
			questionTest_getAllByQuestion: questionTest_getAllByQuestion,
			questionTest_get: questionTest_get,
			questionTest_update: questionTest_update,
			questionTest_changeSequence: questionTest_changeSequence,
			questionTest_delete: questionTest_delete,
			questionTest_add: questionTest_add,
			questionTest_importList: questionTest_importList,
			questionTest_addByParams: questionTest_addByParams,

			//-- SESSION
			session_getAllList: session_getAllList,
			session_count: session_count,
			session_countByFilter: session_countByFilter,
			session_getAll: session_getAll,
			session_getAllByFilter: session_getAllByFilter,
			session_get: session_get,
			session_add: session_add,
			session_update: session_update,
			session_delete: session_delete,
			session_activate: session_activate,
			session_inactivate: session_inactivate,

			//-- SESSION STUDENTE
			studenteSession_getAllList: studenteSession_getAllList,
			studenteSession_addList: studenteSession_addList,
			studenteSession_count: studenteSession_count,
			studenteSession_countByFilter: studenteSession_countByFilter,
			studenteSession_getAll: studenteSession_getAll,
			studenteSession_getAllByFilter: studenteSession_getAllByFilter,
			studenteSession_get: studenteSession_get,
			studenteSession_update: studenteSession_update,
			studenteSession_delete: studenteSession_delete,

			//--- DASHBOARD - APP
			app_dashboard_get: app_dashboard_get,
			app_dashboard_getByProfileId: app_dashboard_getByProfileId,
			app_dashboard_getAllProfiles: app_dashboard_getAllProfiles,

			//--- APP - PROFILES
			app_profiles_getAllList: app_profiles_getAllList,

			//--- APP PROFILES USER
			app_profilesUser_getAll: app_profilesUser_getAll,
			app_userProfile_exists: app_userProfile_exists,
			app_userProfile_get: app_userProfile_get,
			app_userProfile_add: app_userProfile_add,
			app_userProfile_update: app_userProfile_update,
			app_userProfile_delete: app_userProfile_delete,

			//--- BACHECA
			dashboard_getAll: dashboard_getAll,

			//System Method
			getWhoAmI: getWhoAmI,

			//-- CANDIDATURE: REGISTER
			cndRegister_save: cndRegister_save,

			//-- CANDIDATURE: ACCREDITAMENTO
			cndAccreditamento_getAllList: cndAccreditamento_getAllList,
			cndAccreditamento_getAll: cndAccreditamento_getAll,
			cndAccreditamento_countAll: cndAccreditamento_countAll,
			cndAccreditamento_exists: cndAccreditamento_exists,
			cndAccreditamento_restore: cndAccreditamento_restore,
			cndAccreditamento_get: cndAccreditamento_get,
			cndAccreditamento_getByUID: cndAccreditamento_getByUID,
			cndAccreditamento_unlock: cndAccreditamento_unlock,
			cndAccreditamento_setStatus: cndAccreditamento_setStatus,
			cndAccreditamento_printAll: cndAccreditamento_printAll,
			cndAccreditamento_printRicevuta: cndAccreditamento_printRicevuta,
			cndAccreditamento_findAll: cndAccreditamento_findAll,
			cndAccreditamento_add: cndAccreditamento_add,
			cndAccreditamento_update: cndAccreditamento_update,
			cndAccreditamento_delete: cndAccreditamento_delete,
			cndAccreditamento_setAnnulled: cndAccreditamento_setAnnulled,

			cndAccreditamento_setProtSent: cndAccreditamento_setProtSent,
			cndAccreditamento_unsetProtSent: cndAccreditamento_unsetProtSent,
			cndAccreditamento_setConvalida: cndAccreditamento_setConvalida,
			cndAccreditamento_unsetConvalida: cndAccreditamento_unsetConvalida,

			//-- CNDAccreditamento-SEDE
			cndAccreditamentoSede_getAllList: cndAccreditamentoSede_getAllList,
			cndAccreditamentoSede_getAll: cndAccreditamentoSede_getAll,
			cndAccreditamentoSede_countAll: cndAccreditamentoSede_countAll,
			cndAccreditamentoSede_get: cndAccreditamentoSede_get,
			cndAccreditamentoSede_add: cndAccreditamentoSede_add,
			cndAccreditamentoSede_update: cndAccreditamentoSede_update,
			cndAccreditamentoSede_delete: cndAccreditamentoSede_delete,
			cndAccreditamentoSede_exists: cndAccreditamentoSede_exists,

			//-- CNDAccreditamento-SETTORE
			cndAccreditamentoSettore_getAllList: cndAccreditamentoSettore_getAllList,
			cndAccreditamentoSettore_getAll: cndAccreditamentoSettore_getAll,
			cndAccreditamentoSettore_countAll: cndAccreditamentoSettore_countAll,
			cndAccreditamentoSettore_get: cndAccreditamentoSettore_get,
			cndAccreditamentoSettore_add: cndAccreditamentoSettore_add,
			cndAccreditamentoSettore_update: cndAccreditamentoSettore_update,
			cndAccreditamentoSettore_delete: cndAccreditamentoSettore_delete,
			cndAccreditamentoSettore_exists: cndAccreditamentoSettore_exists,

			//-- CNDSETTORE
			cndSettore_getAllList: cndSettore_getAllList,
			cndSettore_getAll: cndSettore_getAll,
			cndSettore_get: cndSettore_get,

			//-- CANDIDATURE: DOMANDA DI ADESIONE
			cndAdesione_getAllList: cndAdesione_getAllList,
			cndAdesione_getAll: cndAdesione_getAll,
			cndAdesione_countAll: cndAdesione_countAll,
			cndAdesione_getListCPI: cndAdesione_getListCPI, //Metodo dedicato senza [Authorize]
			cndAdesione_getAllPartecipazione: cndAdesione_getAllPartecipazione, //Metodo dedicato senza [Authorize]
			cndAdesione_getAllPsede: cndAdesione_getAllPsede, //Metodo dedicato senza [Authorize]
			cndAdesione_exists: cndAdesione_exists,
			cndAdesione_status: cndAdesione_status,
			cndAdesione_get: cndAdesione_get,
			cndAdesione_getByUID: cndAdesione_getByUID,
			cndAdesione_add: cndAdesione_add,
			cndAdesione_update: cndAdesione_update,
			cndAdesione_delete: cndAdesione_delete,
			cndAdesione_changeStatus: cndAdesione_changeStatus,

            //-- CANDIDATURE: CONVENZIONI
            cndConvenzione_getAllList: cndConvenzione_getAllList,
            cndConvenzione_getAll: cndConvenzione_getAll,
            cndConvenzione_countAll: cndConvenzione_countAll,
            cndConvenzione_exists: cndConvenzione_exists,
            cndConvenzione_specialAnnulled: cndConvenzione_specialAnnulled,
            cndConvenzione_create: cndConvenzione_create,
            cndConvenzione_get: cndConvenzione_get,
            cndConvenzione_getByUID: cndConvenzione_getByUID,
            cndConvenzione_setStatus: cndConvenzione_setStatus,
            cndConvenzione_add: cndConvenzione_add,
            cndConvenzione_addOrUpdate: cndConvenzione_addOrUpdate,
            cndConvenzione_update: cndConvenzione_update,
            cndConvenzione_merge: cndConvenzione_merge,
            cndConvenzione_delete: cndConvenzione_delete,
            cndConvenzione_setAnnulled: cndConvenzione_setAnnulled,
            cndConvenzione_unlock: cndConvenzione_unlock,
            cndConvenzione_sendConvenzione: cndConvenzione_sendConvenzione,
            cndConvenzione_sendConvenzioneReOpen: cndConvenzione_sendConvenzioneReOpen,
			cndConvenzione_sendConvEsito: cndConvenzione_sendConvEsito,

			//-- CANDIDATURE: CONVENZIONI-DETTAGLIO
			cndConvenzioneDtl_get: cndConvenzioneDtl_get,
			cndConvenzioneDtl_merge: cndConvenzioneDtl_merge,

			//-- SEND LINK ACCESSO FROM EMAIL AND CODICE FISCALE
			cndProgetto_sendLnkAccesso: cndProgetto_sendLnkAccesso,

			//-- CANDIDATURE: DOMANDA DI ADESIONE
			cndProgetto_getAllList: cndProgetto_getAllList,
			cndProgetto_getAll: cndProgetto_getAll,
			cndProgetto_countAll: cndProgetto_countAll,
			cndProgetto_get: cndProgetto_get,
			cndProgetto_getByUID: cndProgetto_getByUID,
			cndProgetto_add: cndProgetto_add,
			cndProgetto_update: cndProgetto_update,
			cndProgetto_delete: cndProgetto_delete,

			//-- CANDIDATURE: Curriculum Vitae
			cndCV_getAllList: cndCV_getAllList,
			cndCV_getAll: cndCV_getAll,
			cndCV_countAll: cndCV_countAll,
			cndCV_get: cndCV_get,
			cndCV_getByDomandaId: cndCV_getByDomandaId,
			cndCV_getByDomandaUID: cndCV_getByDomandaUID,
			cndCV_unlock: cndCV_unlock,
			cndCV_printPDF: cndCV_printPDF,
			cndCV_findCV: cndCV_findCV,
			cndCV_add: cndCV_add,
			cndCV_update: cndCV_update,
			cndCV_delete: cndCV_delete,

			//-- CANDIDATURE: CV Abilit
			cndCVAbilit_getAllList: cndCVAbilit_getAllList,
			cndCVAbilit_getAll: cndCVAbilit_getAll,
			cndCVAbilit_countAll: cndCVAbilit_countAll,
			cndCVAbilit_get: cndCVAbilit_get,
			cndCVAbilit_add: cndCVAbilit_add,
			cndCVAbilit_update: cndCVAbilit_update,
			cndCVAbilit_delete: cndCVAbilit_delete,

			//-- CANDIDATURE: CV Servizio
			cndCVServizio_getAllList: cndCVServizio_getAllList,
			cndCVServizio_getAll: cndCVServizio_getAll,
			cndCVServizio_countAll: cndCVServizio_countAll,
			cndCVServizio_get: cndCVServizio_get,
			cndCVServizio_add: cndCVServizio_add,
			cndCVServizio_saveAll: cndCVServizio_saveAll,
			cndCVServizio_update: cndCVServizio_update,
			cndCVServizio_delete: cndCVServizio_delete,

			//-- CANDIDATURE: CV Corso
			cndCVCorso_getAllList: cndCVCorso_getAllList,
			cndCVCorso_getAll: cndCVCorso_getAll,
			cndCVCorso_countAll: cndCVCorso_countAll,
			cndCVCorso_get: cndCVCorso_get,
			cndCVCorso_add: cndCVCorso_add,
			cndCVCorso_update: cndCVCorso_update,
			cndCVCorso_delete: cndCVCorso_delete,

			//-- CANDIDATURE: CV Pubb
			cndCVPubb_getAllList: cndCVPubb_getAllList,
			cndCVPubb_getAll: cndCVPubb_getAll,
			cndCVPubb_countAll: cndCVPubb_countAll,
			cndCVPubb_get: cndCVPubb_get,
			cndCVPubb_add: cndCVPubb_add,
			cndCVPubb_update: cndCVPubb_update,
			cndCVPubb_delete: cndCVPubb_delete,

			//-- CANDIDATURE: CV Spec
			cndCVSpec_getAllList: cndCVSpec_getAllList,
			cndCVSpec_getAll: cndCVSpec_getAll,
			cndCVSpec_countAll: cndCVSpec_countAll,
			cndCVSpec_get: cndCVSpec_get,
			cndCVSpec_add: cndCVSpec_add,
			cndCVSpec_saveAll: cndCVSpec_saveAll,
			cndCVSpec_update: cndCVSpec_update,
			cndCVSpec_delete: cndCVSpec_delete,

			//-- CANDIDATURE: CV Idoneita
			cndCVIdoneita_getAllList: cndCVIdoneita_getAllList,
			cndCVIdoneita_getAll: cndCVIdoneita_getAll,
			cndCVIdoneita_countAll: cndCVIdoneita_countAll,
			cndCVIdoneita_get: cndCVIdoneita_get,
			cndCVIdoneita_add: cndCVIdoneita_add,
			cndCVIdoneita_update: cndCVIdoneita_update,
			cndCVIdoneita_delete: cndCVIdoneita_delete

			// #region PDF CONTROLLER

			, pdf_printAttach: pdf_printAttach
			, pdf_printAttach2: pdf_printAttach2
			, pdf_findAttach: pdf_findAttach
			, pdf_printRicevuta: pdf_printRicevuta
			, pdf_printRicevuta2: pdf_printRicevuta2
			, pdf_printConvenzione: pdf_printConvenzione
			, pdf_printConvenzioneRicevuta: pdf_printConvenzioneRicevuta
			, pdf_printClasseRmb: pdf_printClasseRmb
			, pdf_printRegistro: pdf_printRegistro
			, pdf_printConv1C3: pdf_printConv1C3
			, pdf_printConv7: pdf_printConv7
			, pdf_printRmb: pdf_printRmb
			, pdf_printOrientamenti: pdf_printOrientamenti
			, pdf_printFormazione: pdf_printFormazione
			, pdf_printOutcome: pdf_printOutcome
			, pdf_printCommission: pdf_printCommission
			, pdf_formazione_GetAllegato: pdf_formazione_GetAllegato

			// #endregion
		};

		// #endregion

		return service;

		// #region Funzioni Generiche
		function getAll(objName) {
			//console.log("getAll(%s)", objName);
			return $http.get(urlAPI + '/' + objName + '/GetAll')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllList(objName) {
			//console.log("getAllList(%s)", objName);
			return $http.get(urlAPI + '/' + objName + '/GetAllList')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllNoParam(objName, actionName) {
			var url = urlAPI + '/' + objName + '/' + actionName;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll NO Param for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllByParam(objName, actionName, paramName, paramValue) {
			var url = urlAPI + '/' + objName + '/' + actionName + '?' + paramName + '=' + paramValue;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function getAllByParams(objName, actionName, paramArray) {
			var url = urlAPI + '/' + objName + '/' + actionName;

			var numParams = paramArray.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += paramArray[i].name + '=' + paramArray[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getAllByParams for %s: %s', objName, message, message.status);
					return message.status;
				});
		}

		function getPDFByParams(objName, actionName, paramArray) {
			var url = urlAPI + '/' + objName + '/' + actionName;

			var numParams = paramArray.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += paramArray[i].name + '=' + paramArray[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllByParams for %s: %s', objName, message);
					return message;
				});
		}

		function getById(objName, id) {
			return $http.get(urlAPI + '/' + objName + '/Get/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getById for %s: %s', objName, message);
					return message.status;
				});
		}

		function getBaseById(objName, id) {
			return $http.get(urlAPI + '/' + objName + '/GetBase/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getBaseById for %s: %s', objName, message);
					return message.status;
				});
		}

		function addObj(objName, objValue) {
			return $http.post(urlAPI + '/' + objName + '/Post', objValue)
				.then(function (response) {
					//console.info('addObj() -> response.data', response.data);
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function updateObj(objName, objValue) {
			return $http.put(urlAPI + '/' + objName + '/Put', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function mergeObj(objName, objValue) {
			return $http.put(urlAPI + '/' + objName + '/Merge', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed mergeObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function deleteObj(objName, id) {
			return $http.delete(urlAPI + '/' + objName + '/Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function postMethod(objName, objMethod, objValue) {
			return $http.post(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed postObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function postMethodHibryd(objName, objMethod, paramArray, objValue) {
			var url = urlAPI + '/' + objName + '/' + objMethod;

			var numParams = paramArray.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += paramArray[i].name + '=' + paramArray[i].value;
			}

			return $http.post(url, objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed postObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function putMethod(objName, objMethod, objValue) {
			return $http.put(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function putStatus(objName, objMethod, objValue) {
			return $http.put(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function deleteMethod(objName, objMethod, objValue) {
			return $http.delete(urlAPI + '/' + objName + '/' + objMethod, objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion  END - Funzioni Generiche

		// #region Funzioni Pubbliche - esposte su interfaccia Service

		function root_getURL() {
			return urlROOT + '/';
		}

		function accred_getURL() {
			return urlROOT + controllerAccred + '/';
		}

		function accreditamento_getURL() {
			return urlROOT + controllerAccreditamento + '/';
		}

		function adesione_getURL() {
			return urlROOT + controllerAdesione + '/';
		}

		function convenzione_getURL() {
			return urlROOT + controllerConvenzione + '/';
		}

		function upload_getURL() {
			var controller = 'Attach';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		function download_getURL() {
			var controller = 'Download';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		function mail_upload_getURL() {
			var controller = 'Newsletter_Attachment';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}

		// #endregion ******************************

		// #region Metodi init per array condivisi

		function arrAziende() {
			if (_arrAziende.length == 0) {
				return getAllList('classe').then(function (data) {
					_arrAziende = data;
					return _arrAziende;
				});
			}
			return $q.when(_arrAziende);
		}

		function arrProfiliANPAL() {
			if (_arrProfiliANPAL.length == 0) {
				return getAll('TProfiloANPAL').then(function (data) {
					_arrProfiliANPAL = data;
					return _arrProfiliANPAL;
				});
			}
			return $q.when(_arrProfiliANPAL);
		}

		function arrProfiliDocente() {
			if (_arrProfiliDocente.length == 0) {
				return getAll('TProfiloDocente').then(function (data) {
					_arrProfiliDocente = data;
					return _arrProfiliDocente;
				});
			}
			return $q.when(_arrProfiliDocente);
		}


		function arrProvince() {
			if (_arrProvince.length == 0) {
				return getAll('provincia').then(function (data) {
					_arrProvince = data;
					return _arrProvince;
				});
			}
			return $q.when(_arrProvince);
		}

		function arrComuni() {
			if (_arrComuni.length == 0) {
				return getAll('comune').then(function (data) {
					_arrComuni = data;
					return _arrComuni;
				});
			}
			return $q.when(_arrComuni);
		}

		function arrProvinceByReg(regioneId) {
			if (_arrProvinceByReg.length == 0) {
				if (typeof regioneId == 'undefined') { regioneId = 0; }
				var params = [];
				params.push({ name: 'regioneId', value: regioneId });

				_arrProvinceByReg = getAllByParams('provincia', 'GetAllByRegId', params);
				return _arrProvinceByReg;
			}
			return $q.when(_arrProvinceByReg);
		}

		function arrPaesi() {
			if (_arrPaesi.length == 0) {
				return getAll('paese').then(function (data) {
					_arrPaesi = data;
					return _arrPaesi;
				});
			}
			return $q.when(_arrPaesi);
		}


		function arrRisorse() {
			if (_arrRisorse.length == 0) {
				return getAllNoParam('risorsa', 'GetAllBase').then(function (data) {
					_arrRisorse = data;
					return _arrRisorse;
				});
			}
			return $q.when(_arrRisorse);
		}

		function arrTipoStatoRichieste() {
			if (_arrTipoStatoRichieste.length == 0) {
				return getAll('tipoStatoRichiesta').then(function (data) {
					_arrTipoStatoRichieste = data;
					return _arrTipoStatoRichieste;
				});
			}
			return $q.when(_arrTipoStatoRichieste);
		}

		function arrTipoRegistrazione() {
			if (_arrTipoRegistrazione.length == 0) {
				return getAll('tipoRegistrazione').then(function (data) {
					_arrTipoRegistrazione = data;
					return _arrTipoRegistrazione;
				});
			}
			return $q.when(_arrTipoRegistrazione);
		}

		//Inizializzazione array statici delle tabelle tipo
		//T45, da TC24 a TC32, TCPI

		function arrTipoLavoro() {
			if (_arrTipoLavoro.length == 0) {
				return getAllList('tLavoro').then(function (data) {
					_arrTipoLavoro = data;
					return _arrTipoLavoro;
				});
			}
			return $q.when(_arrTipoLavoro);
		}

		function arrFormaGiuridica() {
			if (_arrFormaGiuridica.length == 0) {
				return getAllList('tFormaGiuridica').then(function (data) {
					_arrFormaGiuridica = data;
					return _arrFormaGiuridica;
				});
			}
			return $q.when(_arrFormaGiuridica);
		}

		function arrTipoAteco() {
			if (_arrTipoAteco.length == 0) {
				return getAllList('tAteco').then(function (data) {
					_arrTipoAteco = data;
					return _arrTipoAteco;
				});
			}
			return $q.when(_arrTipoAteco);
		}

		function arrTitoloStudio() {
			if (_arrTitoloStudio.length == 0) {
				return getAllList('tTitoloStudio').then(function (data) {
					_arrTitoloStudio = data;
					return _arrTitoloStudio;
				});
			}
			return $q.when(_arrTitoloStudio);
		}

		function arrCondizioneMercato() {
			if (_arrCondizioneMercato.length == 0) {
				return getAllList('tCondizioneMercato').then(function (data) {
					_arrCondizioneMercato = data;
					return _arrCondizioneMercato;
				});
			}
			return $q.when(_arrCondizioneMercato);
		}

		function arrCondizioneMercatoAll() {
			if (_arrCondizioneMercatoAll.length == 0) {
				return getAllList('tCondizioneMercato').then(function (data) {
					_arrCondizioneMercatoAll = data;
					return _arrCondizioneMercatoAll;
				});
			}
			return $q.when(_arrCondizioneMercatoAll);
		}

		function arrDurataRicerca() {
			if (_arrDurataRicerca.length == 0) {
				return getAllList('tDurataRicerca').then(function (data) {
					_arrDurataRicerca = data;
					return _arrDurataRicerca;
				});
			}
			return $q.when(_arrDurataRicerca);
		}

		function arrGruppoVulnerabilita() {
			if (_arrGruppoVulnerabilita.length == 0) {
				return getAllList('tGruppoVulnerabilita').then(function (data) {
					_arrGruppoVulnerabilita = data;
					return _arrGruppoVulnerabilita;
				});
			}
			return $q.when(_arrGruppoVulnerabilita);
		}

		function arrStatoPartecipante() {
			if (_arrStatoPartecipante.length == 0) {
				return getAllList('tStatoPartecipante').then(function (data) {
					_arrStatoPartecipante = data;
					return _arrStatoPartecipante;
				});
			}
			return $q.when(_arrStatoPartecipante);
		}

		function arrTCPI() {
			if (_arrTCPI.length == 0) {
				return getAllList('tCPI').then(function (data) {
					_arrTCPI = data;
					return _arrTCPI;
				});
			}
			return $q.when(_arrTCPI);
		}

		function arrAziendeCPI() {
			if (_arrAziendeCPI.length == 0) {
				return azienda_getAllList('', '', 0, 'AZD_CPI', '', '', 0, 0, 0, '', '', '', 0).then(function (data) {
					_arrAziendeCPI = data;
					return _arrAziendeCPI;
				});
			}
			return $q.when(_arrAziendeCPI);
		}

		function arrTTirocini() {
			if (_arrTTirocini.length == 0) {
				return getAllList('tTirocinio').then(function (data) {
					_arrTTirocini = data;
					return _arrTTirocini;
				});
			}
			return $q.when(_arrTTirocini);
		}

		function arrTTirociniDLG() {
			if (_arrTTirociniDLG.length == 0) {
				return getAllList('tTirocinioDLG').then(function (data) {
					_arrTTirociniDLG = data;
					return _arrTTirociniDLG;
				});
			}
			return $q.when(_arrTTirociniDLG);
		}

		function arrTTirociniSpese() {
			if (_arrTTirociniSpese.length == 0) {
				return getAllList('tTirocinioSpesa').then(function (data) {
					_arrTTirociniSpese = data;
					return _arrTTirociniSpese;
				});
			}
			return $q.when(_arrTTirociniSpese);
		}

		function arrContenutoFormativo() {
			if (_arrContenutoFormativo.length == 0) {
				return getAllList('contenutoFormativo').then(function (data) {
					_arrContenutoFormativo = data;
					return _arrContenutoFormativo;
				});
			}
			return $q.when(_arrContenutoFormativo);
		}

		function arrTIndirizzo() {
			if (_arrTIndirizzo.length == 0) {
				return getAllList('TIndirizzo').then(function (data) {
					_arrTIndirizzo = data;
					return _arrTIndirizzo;
				});
			}
			return $q.when(_arrTIndirizzo);
		}

		function arrParams() {
			if (_arrParams.length == 0) {
				return getAllList('Params').then(function (data) {
					_arrParams = data;
					return _arrParams;
				});
			}
			return $q.when(_arrParams);
		}

		function arrStatiCivili() {
			if (_arrStatiCivili.length == 0) {
				return getAll('StatoCivile').then(function (data) {
					_arrStatiCivili = data;
					return _arrStatiCivili;
				});
			}
			return $q.when(_arrStatiCivili);
		}

		function arrStatiOccup() {
			if (_arrStatiOccup.length == 0) {
				return getAll('StatoOccup').then(function (data) {
					_arrStatiOccup = data;
					return _arrStatiOccup;
				});
			}
			return $q.when(_arrStatiOccup);
		}

		function arrTitoliStudio() {
			if (_arrTitoliStudio.length == 0) {
				return getAll('TitoloStudio').then(function (data) {
					_arrTitoliStudio = data;
					return _arrTitoliStudio;
				});
			}
			return $q.when(_arrTitoliStudio);
		}

		function arrCittadinanze() {
			if (_arrCittadinanze.length == 0) {
				return getAll('Cittadinanza').then(function (data) {
					_arrCittadinanze = data;
					return _arrCittadinanze;
				});
			}
			return $q.when(_arrCittadinanze);
		}

		function arrCNDCV_TPubb() {
			if (_arrCNDCV_TPubbi.length == 0) {
				return getAll('CNDCV_TPubb').then(function (data) {
					_arrCNDCV_TPubb = data;
					return _arrCNDCV_TPubb;
				});
			}
			return $q.when(_arrCNDCV_TPubb);
		}

		function arrCNDTProfili() {
			if (_arrCNDTProfili.length == 0) {
				return getAll('CNDTProfilo').then(function (data) {
					_arrCNDTProfili = data;
					return _arrCNDTProfili;
				});
			}
			return $q.when(_arrCNDTProfili);
		}

		function cndTProfilo_getAll(progettoId) {
			if (typeof progettoId == 'undefined') { progettoId = 0; }

			var params = [];
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('CNDTProfilo', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function arrTMisure() {
			if (_arrTMisure.length == 0) {
				return getAll('TMisura').then(function (data) {
					_arrTMisure = data;
					return _arrTMisure;
				});
			}
			return $q.when(_arrTMisure);
		}

		function arrTQualifica() {
			if (_arrTQualifica.length == 0) {
				return getAllList('TQualifica').then(function (data) {
					_arrTQualifica = data;
					return _arrTQualifica;
				});
			}
			return $q.when(_arrTQualifica);
		}

		function arrTRapportoLavoro() {
			if (_arrTRapportoLavoro.length == 0) {
				return getAllList('TRapportoLavoro').then(function (data) {
					_arrTRapportoLavoro = data;
					return _arrTRapportoLavoro;
				});
			}
			return $q.when(_arrTRapportoLavoro);
		}

		function arrTAltraQualifica() {
			if (_arrTAltraQualifica.length == 0) {
				return getAllList('TAltraQualifica').then(function (data) {
					_arrTAltraQualifica = data;
					return _arrTAltraQualifica;
				});
			}
			return $q.when(_arrTAltraQualifica);
		}

		function arrTImpresa() {
			if (_arrTImpresa.length == 0) {
				return getAllList('TImpresa').then(function (data) {
					_arrTImpresa = data;
					return _arrTImpresa;
				});
			}
			return $q.when(_arrTImpresa);
		}

		function arrTClasseImpresa() {
			if (_arrTClasseImpresa.length == 0) {
				return getAllList('TClasseImpresa').then(function (data) {
					_arrTClasseImpresa = data;
					return _arrTClasseImpresa;
				});
			}
			return $q.when(_arrTClasseImpresa);
		}

		function arrDBTAttivita() {
			if (_arrDBTAttivita.length == 0) {
				return getAllList('DBTAttivita').then(function (data) {
					_arrDBTAttivita = data;
					return _arrDBTAttivita;
				});
			}
			return $q.when(_arrDBTAttivita);
		}

		function arrFilterCodes() {
			if (_arrFilterCodes.length == 0) {
				return _arrFilterCodes;
			}
			return $q.when(_arrFilterCodes);
		}

		function arrAvvisi() {
			return _arrAvvisi;
		}

		function arrPercorsi(code) {
			switch (code) {
				case 'FAM1':
					return _arrPercorsiFAM1;
				case 'LAV1':
					return _arrPercorsiLAV1;
				case 'FORM':
					return _arrPercorsiFORM;
				default:
					return _arrPercorsi;
			}
		}

		function arrMesi() {
			return _arrMesi;
		}

		function arrMesiZero() {
			return _arrMesiZero;
		}

		function arrRegTSourceCode() {
			return _arrRegTSourceCode;
		}

		function arrDataType() {
			return _arrDataType;
		}

		function arrDataType_get(code) {
			var retVal = '';
			_arrDataType.forEach(function (el) {
				if (el.Code == code)
					retVal = el.Name;
			});

			return retVal;
		}

		function arrCNDCandidatura() {
			return _arrCNDCandidatura;
		}

		function arrCNDTRuoloCode() {
			return _arrCNDTRuoloCode;
		}

		function arrCNDTMisuraCode() {
			return _arrCNDTMisuraCode;
		}

		function arrCNDProgettoName() {
			return _arrCNDProgettoName;
		}

		function arrFORM_TAttivita() {
			return _arrFORM_TAttivita;
		}

		function arrFORM_TProfilo() {
			return _arrFORM_TProfilo;
		}


		// #endregion ******************************

		// #region ASSEGNAZIONE
		function assegnazione_getAll() {
			var data = getAll('assegnazione');
			return $q.when(data);
		}

		function assegnazione_getAllByCorso(id) {
			var data = getAllByParam('assegnazione', 'GetAllByCorso', 'id', id);
			return $q.when(data);
		}

		function assegnazione_getAllByRisorsa(id) {
			var data = getAllByParam('assegnazione', 'GetAllByRisorsa', 'id', id);
			return $q.when(data);
		}

		function assegnazione_getAllBySede(id) {
			var data = getAllByParam('assegnazione', 'GetAllBySede', 'id', id);
			return $q.when(data);
		}

		function assegnazione_get(id) {
			var data = getById('assegnazione', id);
			return $q.when(data);
		}

		function assegnazione_add(item) {
			var data = addObj('assegnazione', item);
			return $q.when(data);
		}

		function assegnazione_update(item) {
			var data = updateObj('assegnazione', item);
			return $q.when(data);
		}

		function assegnazione_delete(id) {
			var data = deleteObj('assegnazione', id);
			return $q.when(data);
		}



		// #endregion ******************************

		// #region  CLASSE - NUOVI METODI
		function classe_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof tAttivita == 'undefined') { tAttivita = ''; }
			if (typeof tProfilo == 'undefined') { tProfilo = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'tAttivita', value: tAttivita });
			params.push({ name: 'tProfilo', value: tProfilo });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function classe_getAllList(testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato) {
			var params = classe_setParams(false, 0, 0, '', testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato);
			var data = getAllByParams('classe', 'GetAllList', params);
			return $q.when(data);
		}
		function classe_getAll(pageSize, page, testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato, order) {
			var params = classe_setParams(true, pageSize, page, order, testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato);
			var data = getAllByParams('classe', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function classe_countAll(testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato) {
			var params = classe_setParams(false, 0, 0, '', testuale, tMisuraCode, percorso, tAttivita, tProfilo, aplId, cpiId, mese, anno, iStato);
			var data = getAllByParams('classe', 'CountByFilter', params);
			return $q.when(data);
		}

		function classe_get(id) {
			var data = getById('classe', id);
			return $q.when(data);
		}

		function classe_add(item) {
			var data = addObj('classe', item);
			return $q.when(data);
		}

		function classe_update(item) {
			var data = updateObj('classe', item);
			return $q.when(data);
		}
		function classe_updatebIntegrazione(item) {
			return $http.put(urlAPI + '/' + 'classe' + '/MergebIntegrazione', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		function classe_merge(item) {
			var data = mergeObj('classe', item);
			return $q.when(data);
		}

		function classe_change(item) {
			var data = putMethod('classe', 'Change', item);
			return $q.when(data);
		}

		function classe_delete(id) {
			var data = deleteObj('classe', id);
			return $q.when(data);
		}

		function classe_exists(tMisuraCode, aplId, corsoId, istitutoId, cpiId, cup, classeId) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }
			if (typeof istitutoId == 'undefined') { istitutoId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof cup == 'undefined') { cup = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }

			var params = [];

			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'corsoId', value: corsoId });
			params.push({ name: 'istitutoId', value: istitutoId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'cup', value: cup });
			params.push({ name: 'classeId', value: classeId });

			var data = getAllByParams('classe', 'Exists', params);
			return $q.when(data);
		}


		function classe_unlock(item) {
			var objName = 'classe';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classe_addStage(item) {
			var objName = 'classe';

			return $http.post(urlAPI + '/' + objName + '/AddStage', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classe_addSelStage(items) {
			var objName = 'classe';

			return $http.post(urlAPI + '/' + objName + '/AddSelStage', items)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}


		function classe_changeState(code, id, tSourceCode) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') tSourceCode = '';

			var objName = 'classe';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id + '&tSourceCode=' + tSourceCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborso_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion

		// #region PARTECIPAZIONE

		// ******************************
		//  PARTECIPAZIONE
		function partecipazione_setParams(pageSize, page, testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof tAziendaId == 'undefined') { tAziendaId = 0; }
			if (typeof fType == 'undefined') { fType = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'tAziendaId', value: tAziendaId });
			params.push({ name: 'fType', value: fType });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function partecipazione_getAllList(testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato) {
			var params = partecipazione_setParams(0, 0, testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato, '', false);

			var data = getAllByParams('partecipazione', 'GetListByFilter', params);
			return $q.when(data);
		}

		function partecipazione_getAll(pageSize, page, testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato, order) {
			var params = partecipazione_setParams(pageSize, page, testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato, order, true);

			var data = getAllByParams('partecipazione', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function partecipazione_countAll(testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato) {
			var params = partecipazione_setParams(0, 0, testuale, aplId, tRuoloCode, iFinestra, tAziendaId, fType, iStato, '', false);

			var data = getAllByParams('partecipazione', 'CountByFilter', params);
			return $q.when(data);
		}

		function partecipazione_get(id) {
			var data = getById('partecipazione', id);
			return $q.when(data);
		}

		function partecipazione_add(item) {
			var data = addObj('partecipazione', item);
			return $q.when(data);
		}

		function partecipazione_addOrUpdate(item) {
			var objName = 'partecipazione';

			return $http.post(urlAPI + '/' + objName + '/AddOrUpdate', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_update(item) {
			var data = updateObj('partecipazione', item);
			return $q.when(data);
		}

		function partecipazione_merge(item) {
			var objName = 'partecipazione';
			return $http.put(urlAPI + '/' + objName + '/Merge', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed mergeObj for %s: %s', objName, message);
					return message;
				});

			//var data = mergeObj('partecipazione', item);
			//return $q.when(data);
		}

		function partecipazione_mergeSuper(item) {
			var data = putMethod('partecipazione', 'MergeSuper', item);
			return $q.when(data);
		}

		function partecipazione_delete(id) {
			var data = deleteObj('partecipazione', id);
			return $q.when(data);
		}

		function partecipazione_restore(partecipazioneId) {
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }

			var params = [];
			params.push({ name: 'partecipazioneId', value: partecipazioneId });

			var data = getAllByParams('partecipazione', 'Restore', params);
			return $q.when(data);
		}

		function partecipazione_clona(partecipazioneId) {
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }

			var params = [];
			params.push({ name: 'partecipazioneId', value: partecipazioneId });

			var data = getAllByParams('partecipazione', 'Clona', params);
			return $q.when(data);
		}

		function partecipazione_setSent(id) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/SetSent/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message;
				});
		}

		function partecipazione_setProtSent(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/SetProtSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setProtSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_unsetProtSent(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/UnsetProtSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed unsetProtSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_setConvalida(item, pCatalogoCorsiAmmessi, pCorsiAmmessi, pSedi) {
			var objName = 'partecipazione';

			var obj = {};
			obj.Partecipazione = item;
			obj.PCatalogoCorsi = pCatalogoCorsiAmmessi;
			obj.PCorsi = pCorsiAmmessi;
			obj.PSedi = pSedi;


			return $http.put(urlAPI + '/' + objName + '/SetConvalida', obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setConvalida for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_unsetConvalida(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/UnsetConvalida', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setConvalida for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_setAnnulled(id, locked, noteAnnulled) {
			if (typeof noteAnnulled == 'undefined') { noteAnnulled = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'locked', value: locked });
			params.push({ name: 'noteAnnulled', value: noteAnnulled });

			var data = getAllByParams('partecipazione', 'SetAnnulled', params);
			return $q.when(data);
		}

		function partecipazione_unlock(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function partecipazione_unlockSent(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockSentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		//function partecipazione_printAllegato(partecipazioneId, misuraCode, attachCode) {
		//    var params = [];
		//    params.push({ name: 'partecipazioneId', value: partecipazioneId });
		//    params.push({ name: 'misuraCode', value: misuraCode });
		//    params.push({ name: 'attachCode', value: attachCode });
		//    var data = getAllByParams('pdf', 'PrintAllegato', params);
		//    return $q.when(data);
		//}

		function partecipazione_printRicevuta(partecipazioneId, tRuoloCode, attachCode) {
			var params = [];
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'attachCode', value: attachCode });
			var data = getAllByParams('pdf', 'PrintRicevuta', params);
			return $q.when(data);
		}

		function partecipazione_changeItem(id) {
			var data = getAllByParam('partecipazione', 'changeItem', 'partecipazioneId', id);
			return $q.when(data);
		}

		function partecipazione_convalidaSedi(item) {
			var objName = 'partecipazione';

			return $http.put(urlAPI + '/' + objName + '/ConvalidaSedi', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockObj for %s: %s', objName, message);
					return message;
				});
		}

		function fse_AccreditamentoSede_Get(testuale, piva, codiceFiscale, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'piva', value: piva });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('partecipazione', 'FSE_AccreditamentoSede_Get', params);
			return $q.when(data);
		}

		//-------------------ANOMALIE--------------------------------------
		function partecipazione_changePresaIncarico(partecipazioneId, status) {
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof status == 'undefined') { status = ''; }

			var params = [];
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'status', value: status });

			var data = getAllByParams('partecipazione', 'ChangePresaIncarico', params);
			return $q.when(data);
		}
		//-------------------ANOMALIE--------------------------------------

        // #endregion

        // #region PARTECIPAZIONE TIROCINIO CATEGORIA

        // ******************************
        //  PARTECIPAZIONE TIROCINIO CATEGORIA
        function pTirCateg_setParams(pageSize, page, testuale, partecipazioneId, aplId, profProfessId, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof aplId == 'undefined') { aplId = 0; }
            if (typeof profProfessId == 'undefined') { profProfessId = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'profProfessId', value: profProfessId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pTirCateg_getAllList(testuale, partecipazioneId, aplId, profProfessId, iStato) {
			var params = pTirCateg_setParams(0, 0, testuale, partecipazioneId, aplId, profProfessId, iStato, '', false);

			var data = getAllByParams('pTirociniCateg', 'GetListByFilter', params);
			return $q.when(data);
		}

		function pTirCateg_getAll(pageSize, page, testuale, partecipazioneId, aplId, profProfessId, iStato, order) {
			var params = pTirCateg_setParams(pageSize, page, testuale, partecipazioneId, aplId, profProfessId, iStato, order, true);

			var data = getAllByParams('pTirociniCateg', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function pTirCateg_countAll(testuale, partecipazioneId, aplId, profProfessId, iStato) {
			var params = pTirCateg_setParams(0, 0, testuale, partecipazioneId, aplId, profProfessId, iStato, '', false);

			var data = getAllByParams('pTirociniCateg', 'CountByFilter', params);
			return $q.when(data);
		}

		function pTirCateg_exist(aplId, tirCategId, profiloProfessId) {
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof tirCategId == 'undefined') { tirCategId = 0; }
			if (typeof profiloProfessId == 'undefined') { profiloProfessId = 0; }

			var params = [];
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tirCategId', value: tirCategId });
			params.push({ name: 'profiloProfessId', value: profiloProfessId });

			var data = getAllByParams('pTirociniCateg', 'Exist', params);
			return $q.when(data);
		}

		function pTirCateg_get(id) {
			var data = getById('pTirociniCateg', id);
			return $q.when(data);
		}

		function pTirCateg_add(item) {
			var data = addObj('pTirociniCateg', item);
			return $q.when(data);
		}

		function pTirCateg_update(item) {
			var data = updateObj('pTirociniCateg', item);
			return $q.when(data);
		}

		function pTirCateg_merge(item) {
			var data = mergeObj('pTirociniCateg', item);
			return $q.when(data);
		}

		function pTirCateg_delete(id) {
			var data = deleteObj('pTirociniCateg', id);
			return $q.when(data);
		}

		function pTirCateg_unlock(item) {
			var objName = 'pTirociniCateg';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pTirCateg_unassign(item) {
			var objName = 'pTirociniCateg';

			return $http.put(urlAPI + '/' + objName + '/Unassign', item)
				.then(function (response) {
					return response;
				})
				.catch(function (message) {
					console.log('XHR Failed unassign for %s: %s', objName, message);
					return message.status;
				});
		}

        // #endregion

        // #region PROFILO PROFESSIONALE

        // ******************************
        //  PROFILO PROFESSIONALE
        function profiloProfess_setParams(pageSize, page, testuale, settProfessId, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof settProfessId == 'undefined') { settProfessId = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'settProfessId', value: settProfessId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function profiloProfess_getAllList(testuale, settProfessId, iStato) {
			var params = profiloProfess_setParams(0, 0, testuale, settProfessId, iStato, iStato, '', false);

			var data = getAllByParams('profiloProfess', 'GetListByFilter', params);
			return $q.when(data);
		}

		function profiloProfess_getAll(pageSize, page, testuale, settProfessId, iStato, order) {
			var params = profiloProfess_setParams(pageSize, page, testuale, settProfessId, iStato, order, true);

			var data = getAllByParams('profiloProfess', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function profiloProfess_countAll(testuale, settProfessId, iStato) {
			var params = profiloProfesse_setParams(0, 0, testuale, settProfessId, iStato, '', false);

			var data = getAllByParams('profiloProfess', 'CountByFilter', params);
			return $q.when(data);
		}

		function profiloProfess_get(id) {
			var data = getById('profiloProfess', id);
			return $q.when(data);
		}


		// ******************************
		//  SETTORE PROFESSIONALE

		function settProfess_getAllList() {
			var data = getAllList('settProfess');
			return $q.when(data);
		}

		function settProfess_get(id) {
			var data = getById('settProfess', id);
			return $q.when(data);
		}

		// ******************************
		//  TIPOLOGIA PERCORSO - MISURA 2B

		function tPercorso_getAllList() {
			var data = getAllList('tPercorso');
			return $q.when(data);
		}

		function tPercorso_get(id) {
			var data = getById('tPercorso', id);
			return $q.when(data);
		}

		// ******************************
		//  TIPO FIGURA PROFESSIONALE - MISURA 2B e MISURA 4A
		function tFigProfessionale_getAll(code) {
			var data = getAllByParam('tFigProfessionale', 'GetAll', 'code', code);
			return $q.when(data);
		}

		function tFigProfessionale_getAllList(code) {
			var data = getAllByParam('tFigProfessionale', 'GetAllList', 'code', code);
			return $q.when(data);
		}

		function tFigProfessionale_get(id) {
			var data = getById('tFigProfessionale', id);
			return $q.when(data);
		}

		// ******************************
		//  TIPO Risorsa - MISURA 4A

		function cndTRisorsa_getAllList() {
			var data = getAllList('cndTRisorsa');
			return $q.when(data);
		}

		function cndTRisorsa_get(id) {
			var data = getById('cndTRisorsa', id);
			return $q.when(data);
		}

		// ******************************
		//  TIPO AULA - MISURA 4A

		function cndTAula_getAllList() {
			var data = getAllList('cndTAula');
			return $q.when(data);
		}

		function cndTAula_get(id) {
			var data = getById('cndTAula', id);
			return $q.when(data);
		}

		// ******************************
		//  TIPO AZIENDA - MISURA 5 Bis

		function cndTAzienda_getAllList() {
			var data = getAllList('cndTAzienda');
			return $q.when(data);
		}

		function cndTAzienda_get(id) {
			var data = getById('cndTAzienda', id);
			return $q.when(data);
		}

        // #endregion

        // #region PARTECIPAZIONE AZIENDA

        // ******************************
        //  PARTECIPAZIONE AZIENDA
        function pAzienda_setParams(pageSize, page, testuale, partecipazioneId, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pAzienda_getAllList(testuale, partecipazioneId, iStato) {
			var params = pAzienda_setParams(0, 0, testuale, partecipazioneId, iStato, '', false);

			var data = getAllByParams('pAzienda', 'GetListByFilter', params);
			return $q.when(data);
		}

		function pAzienda_getAll(pageSize, page, testuale, partecipazioneId, iStato, order) {
			var params = pAzienda_setParams(pageSize, page, testuale, partecipazioneId, iStato, order, true);

			var data = getAllByParams('pAzienda', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function pAzienda_countAll(testuale, partecipazioneId, iStato) {
			var params = pAzienda_setParams(0, 0, testuale, partecipazioneId, iStato, '', false);

			var data = getAllByParams('pAzienda', 'CountByFilter', params);
			return $q.when(data);
		}

		function pAzienda_exists(pAziendaId, parentId, partecipazioneId, codiceFiscale, piva) {
			if (typeof pAziendaId == 'undefined') { pAziendaId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }

			var params = [];
			params.push({ name: 'pAziendaId', value: pAziendaId });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });

			var data = getAllByParams('pAzienda', 'Exists', params);
			return $q.when(data);
		}

		function pAzienda_get(id) {
			var data = getById('pAzienda', id);
			return $q.when(data);
		}

		function pAzienda_add(item) {
			var data = addObj('pAzienda', item);
			return $q.when(data);
		}

		function pAzienda_update(item) {
			var data = updateObj('pAzienda', item);
			return $q.when(data);
		}

		function pAzienda_merge(item) {
			var data = mergeObj('pAzienda', item);
			return $q.when(data);
		}

		function pAzienda_delete(id) {
			var data = deleteObj('pAzienda', id);
			return $q.when(data);
		}

        function pAzienda_addExt(item) {
            var objName = 'pAzienda';
            var objValue = item;
            return $http.post(urlAPI + '/' + objName + '/PostExt', objValue)
                .then(function (response) {
                    //console.info('addObj() -> response.data', response.data);
                    return response.data;
                })
                .catch(function (message) {
                    //console.info('XHR Failed addObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        // #endregion

        // #region PARTECIPAZIONE BUDGET

        // ******************************
        //  PARTECIPAZIONE BUDGET
        function pBudget_setParams(pageSize, page, testuale, partecipazioneId, aplId, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof aplId == 'undefined') { aplId = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pBudget_getAllList(testuale, partecipazioneId, aplId, iStato) {
			var params = pBudget_setParams(0, 0, testuale, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pBudget', 'GetListByFilter', params);
			return $q.when(data);
		}

		function pBudget_getAll(pageSize, page, testuale, partecipazioneId, aplId, iStato, order) {
			var params = pBudget_setParams(pageSize, page, testuale, partecipazioneId, aplId, iStato, order, true);

			var data = getAllByParams('pBudget', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function pBudget_countAll(testuale, partecipazioneId, aplId, iStato) {
			var params = pBudget_setParams(0, 0, testuale, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pBudget', 'CountByFilter', params);
			return $q.when(data);
		}

		function pBudget_get(id) {
			var data = getById('pBudget', id);
			return $q.when(data);
		}

		function pBudget_add(item) {
			var data = addObj('pBudget', item);
			return $q.when(data);
		}

		function pBudget_update(item) {
			var data = updateObj('pBudget', item);
			return $q.when(data);
		}

		function pBudget_merge(item) {
			var data = mergeObj('pBudget', item);
			return $q.when(data);
		}

		function pBudget_delete(id) {
			var data = deleteObj('pBudget', id);
			return $q.when(data);
		}

        // #endregion

        // #region PARTECIPAZIONE DOCENTE

        // ******************************
        //  PARTECIPAZIONE DOCENTE
        function pDocente_setParams(pageSize, page, testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
            if (typeof tProfiloDocenteCode == 'undefined') { tProfiloDocenteCode = ''; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tProfiloDocenteCode', value: tProfiloDocenteCode });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pDocente_getAllList(testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato) {
			var params = pDocente_setParams(0, 0, testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato, '', false);

			var data = getAllByParams('pDocente', 'GetListByFilter', params);
			return $q.when(data);
		}

		function pDocente_getAll(pageSize, page, testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato, order) {
			var params = pDocente_setParams(pageSize, page, testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato, order, true);

			var data = getAllByParams('pDocente', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function pDocente_countAll(testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato) {
			var params = pDocente_setParams(0, 0, testuale, partecipazioneId, codiceFiscale, tProfiloDocenteCode, iStato, '', false);

			var data = getAllByParams('pDocente', 'CountByFilter', params);
			return $q.when(data);
		}

		function pDocente_get(id) {
			var data = getById('pDocente', id);
			return $q.when(data);
		}

		function pDocente_add(item) {
			var data = addObj('pDocente', item);
			return $q.when(data);
		}

		function pDocente_update(item) {
			var data = updateObj('pDocente', item);
			return $q.when(data);
		}

		function pDocente_merge(item) {
			var data = mergeObj('pDocente', item);
			return $q.when(data);
		}

		function pDocente_delete(id) {
			var data = deleteObj('pDocente', id);
			return $q.when(data);
		}

		function pDocente_exists(partecipazioneId, codiceFiscale, id) {
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'id', value: id });


			var data = getAllByParams('pDocente', 'Exists', params);
			return $q.when(data);
		}

		function pDocente_unlock(item) {
			var objName = 'pDocente';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

        // #endregion

        // #region PARTECIPAZIONE SEDE

        // ******************************
        //  PARTECIPAZIONE SEDE
        function pSede_setParams(pageSize, page, testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato, order, isGet) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof pAziendaId == 'undefined') { pAziendaId = 0; }
            if (typeof aplId == 'undefined') { aplId = 0; }
            if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
            if (typeof comuneId == 'undefined') { comuneId = 0; }
            if (typeof paeseId == 'undefined') { paeseId = -1; }
            if (typeof accred == 'undefined') { accred = 0; }
            if (typeof inCorso == 'undefined') { inCorso = 0; }
            if (typeof iAccredLav == 'undefined') { iAccredLav = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'pAziendaId', value: pAziendaId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'paeseId', value: paeseId });
			params.push({ name: 'accred', value: accred });
			params.push({ name: 'inCorso', value: inCorso });
			params.push({ name: 'iAccredLav', value: iAccredLav });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pSede_getAllList(testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato) {
			var params = pSede_setParams(0, 0, testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato, '', false);

			var data = getAllByParams('pSede', 'GetListByFilter', params);
			return $q.when(data);
		}

		function pSede_getAll(pageSize, page, testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato, order) {
			var params = pSede_setParams(pageSize, page, testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato, order, true);

			var data = getAllByParams('pSede', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function pSede_countAll(testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato) {
			var params = pSede_setParams(0, 0, testuale, partecipazioneId, pAziendaId, aplId, tRuoloCode, comuneId, paeseId, accred, inCorso, iAccredLav, iStato, '', false);

			var data = getAllByParams('pSede', 'CountByFilter', params);
			return $q.when(data);
		}

		function pSede_get(id) {
			var data = getById('pSede', id);
			return $q.when(data);
		}

		function pSede_add(item) {
			var data = addObj('pSede', item);
			return $q.when(data);
		}

		function pSede_AddMultiplo(list) {
			var objName = 'pSede';
			var actionName = 'AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_addList for %s: %s', objName, message);
					return message.status;
				});
		}

		function pSede_update(item) {
			var data = updateObj('pSede', item);
			return $q.when(data);
		}

		function pSede_merge(item) {
			var data = mergeObj('pSede', item);
			return $q.when(data);
		}

		function pSede_delete(id) {
			var data = deleteObj('pSede', id);
			return $q.when(data);
		}

		function pSede_unlock(item) {
			var objName = 'pSede';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

        // #endregion

        // #region PARTECIPAZIONE MODULO

        // ******************************
        //  PARTECIPAZIONE MODULO
        function partecipazioneModulo_setParams(isGet, pageSize, page, order, testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato) {
            if (isGet) {
                if (typeof pageSize == 'undefined') { pageSize = 0; }
                if (typeof page == 'undefined') { page = 0; }
                if (typeof order == 'undefined') { order = ''; }
            }
            if (typeof testuale == 'undefined') { testuale = ''; }
            if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
            if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
            if (typeof competenzaId == 'undefined') { competenzaId = 0; }
            if (typeof abilitaCode == 'undefined') { abilitaCode = ''; }
            if (typeof conoscenzaCode == 'undefined') { conoscenzaCode = ''; }
            if (typeof provinciaId == 'undefined') { provinciaId = 0; }
            if (typeof comuneId == 'undefined') { comuneId = 0; }
            if (typeof iStato == 'undefined') { iStato = 0; }

            var params = [];
            if (isGet) {
                params.push({ name: 'pageSize', value: pageSize });
                params.push({ name: 'page', value: page });
                params.push({ name: 'order', value: order });
            }
            params.push({ name: 'testuale', value: testuale });
            params.push({ name: 'partecipazioneId', value: partecipazioneId });
            params.push({ name: 'tRuoloCode', value: tRuoloCode });
            params.push({ name: 'competenzaId', value: competenzaId });
            params.push({ name: 'abilitaCode', value: abilitaCode });
            params.push({ name: 'conoscenzaCode', value: conoscenzaCode });
            params.push({ name: 'provinciaId', value: provinciaId });
            params.push({ name: 'comuneId', value: comuneId });
            params.push({ name: 'iStato', value: iStato });


            return params;
        }

        function partecipazioneModulo_getAllList(testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato) {
            var params = partecipazioneModulo_setParams(false, 0, 0, '', testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato);

            var data = getAllByParams('partecipazioneModulo', 'GetListByFilter', params);
            return $q.when(data);
        }

        function partecipazioneModulo_getAll(pageSize, page, testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato, order) {
            var params = partecipazioneModulo_setParams(true, pageSize, page, order, testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato);

            var data = getAllByParams('partecipazioneModulo', 'GetAllByFilter', params);
            return $q.when(data);
        }

        function partecipazioneModulo_countAll(testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato) {
            var params = partecipazioneModulo_setParams(false, 0, 0, '', testuale, partecipazioneId, tRuoloCode, competenzaId, abilitaCode, conoscenzaCode, provinciaId, comuneId, iStato);

            var data = getAllByParams('partecipazioneModulo', 'CountByFilter', params);
            return $q.when(data);
        }

        function partecipazioneModulo_get(id) {
            var data = getById('partecipazioneModulo', id);
            return $q.when(data);
        }

        function partecipazioneModulo_add(item) {
            var data = addObj('partecipazioneModulo', item);
            return $q.when(data);
        }

        function partecipazioneModulo_update(item) {
            var data = updateObj('partecipazioneModulo', item);
            return $q.when(data);
        }

        function partecipazioneModulo_merge(item) {
            var data = mergeObj('partecipazioneModulo', item);
            return $q.when(data);
        }

        function partecipazioneModulo_delete(id) {
            var data = deleteObj('partecipazioneModulo', id);
            return $q.when(data);
        }

        function partecipazioneModulo_unlock(item) {
            var data = putMethod('partecipazioneModulo', 'Unlock', item);
            return $q.when(data);
        }

        // #endregion

        // #region CND: COMPENTENZE - CONOSCENZE - ABILITA
        function cndModCompetenza_get(id) {
            var data = getById('CNDModCompetenza', id);
            return $q.when(data);
        }
        function cndModCompetenza_getAll(codiceFigura) {
            if (typeof codiceFigura == 'undefined') { codiceFigura = ''; }
            var data = getAllByParam('CNDModCompetenza', 'GetAllByFilter', 'codiceFigura', codiceFigura);
            return $q.when(data);
        }

        function cndModAbilita_getAll(codeCompetenza) {
            if (typeof codeCompetenza == 'undefined') { codeCompetenza = ''; }
            var data = getAllByParam('CNDModAbilita', 'GetAllByFilter', 'codeCompetenza', codeCompetenza);
            return $q.when(data);
        }

        function cndModConoscenza_getAll(codeCompetenza) {
            if (typeof codeCompetenza == 'undefined') { codeCompetenza = ''; }
            var data = getAllByParam('CNDModConoscenza', 'GetAllByFilter', 'codeCompetenza', codeCompetenza);
            return $q.when(data);
        }

        // #endregion


        // #region PARTECIPAZIONE CATALOGO CORSO

		// ******************************
		//  PARTECIPAZIONE CATALOGO CORSO
		function pCatalogoCorso_setParams(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pCatalogoCorso_getAllList(testuale, tMisuraCode, partecipazioneId, aplId, iStato) {
			var params = pCatalogoCorso_setParams(0, 0, testuale, tMisuraCode, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pCatalogoCorso', 'GetListByFilter', params);
			return $q.when(data);
		}
		function pCatalogoCorso_getAll(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order) {
			var params = pCatalogoCorso_setParams(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order, true);

			var data = getAllByParams('pCatalogoCorso', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function pCatalogoCorso_countAll(testuale, tMisuraCode, partecipazioneId, aplId, iStato) {
			var params = pCatalogoCorso_setParams(0, 0, testuale, tMisuraCode, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pCatalogoCorso', 'CountByFilter', params);
			return $q.when(data);
		}

		function pCatalogoCorso_get(id) {
			var data = getById('pCatalogoCorso', id);
			return $q.when(data);
		}

		function pCatalogoCorso_add(item) {
			var data = addObj('pCatalogoCorso', item);
			return $q.when(data);
		}

		function pCatalogoCorso_update(item) {
			var data = updateObj('pCatalogoCorso', item);
			return $q.when(data);
		}

		function pCatalogoCorso_merge(item) {
			var data = mergeObj('pCatalogoCorso', item);
			return $q.when(data);
		}

		function pCatalogoCorso_delete(id) {
			var data = deleteObj('pCatalogoCorso', id);
			return $q.when(data);
		}

		// #endregion

		// #region PARTECIPAZIONE CORSO

		// ******************************
		//  PARTECIPAZIONE CORSO
		function pCorso_setParams(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function pCorso_getAllList(testuale, tMisuraCode, partecipazioneId, aplId, iStato) {
			var params = pCorso_setParams(0, 0, testuale, tMisuraCode, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pCorso', 'GetListByFilter', params);
			return $q.when(data);
		}
		function pCorso_getAll(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order) {
			var params = pCorso_setParams(pageSize, page, testuale, tMisuraCode, partecipazioneId, aplId, iStato, order, true);

			var data = getAllByParams('pCorso', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function pCorso_countAll(testuale, tMisuraCode, partecipazioneId, aplId, iStato) {
			var params = pCorso_setParams(0, 0, testuale, tMisuraCode, partecipazioneId, aplId, iStato, '', false);

			var data = getAllByParams('pCorso', 'CountByFilter', params);
			return $q.when(data);
		}

		function pCorso_get(id) {
			var data = getById('pCorso', id);
			return $q.when(data);
		}

		function pCorso_add(item) {
			var data = addObj('pCorso', item);
			return $q.when(data);
		}

		function pCorso_create(item) {
			var data = postMethod('pCorso', 'Create', item);
			return $q.when(data);
		}

		function pCorso_update(item) {
			var data = updateObj('pCorso', item);
			return $q.when(data);
		}

		function pCorso_merge(item) {
			var data = mergeObj('pCorso', item);
			return $q.when(data);
		}

		function pCorso_restore(pCorsoId) {
			if (typeof pCorsoId == 'undefined') { pCorsoId = 0; }

			var params = [];
			params.push({ name: 'pCorsoId', value: pCorsoId });

			var data = getAllByParams('pCorso', 'Restore', params);
			return $q.when(data);
		}

		function pCorso_delete(id) {
			var data = deleteObj('pCorso', id);
			return $q.when(data);
		}

		function pCorso_assign(item) {
			var data = putMethod('pCorso', 'Assign', item);
			return $q.when(data);
		}

		function pCorso_unassign(item) {
			var data = putMethod('pCorso', 'Unassign', item);
			return $q.when(data);
		}

		function pCorso_unlock(item) {
			var data = putStatus('pCorso', 'Unlock', item);
			return $q.when(data);
		}

		function pCorso_setSent(id) {
			var objName = 'pCorso';
			var objMethod = 'SetSent';
			var objValue = id;

			return $http.put(urlAPI + '/' + objName + '/' + objMethod + '/' + objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed setSentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pCorso_unlockSent(item) {
			var data = putStatus('pCorso', 'UnlockSent', item);
			return $q.when(data);
		}

		function pCorso_setProtSent(item) {
			var data = putMethod('pCorso', 'SetProtSent', item);
			return $q.when(data);
		}

		function pCorso_unsetProtSent(item) {
			var data = putMethod('pCorso', 'UnsetProtSent', item);
			return $q.when(data);
		}

		function pCorso_setConvalida(item) {
			var data = putMethod('pCorso', 'SetConvalida', item);
			return $q.when(data);
		}

		function pCorso_unsetConvalida(item) {
			var data = putMethod('pCorso', 'UnsetConvalida', item);
			return $q.when(data);
		}

		function pCorso_printRicevuta(pCorsoId, misuraCode, attachCode) {

			var params = [];
			params.push({ name: 'pCorsoId', value: pCorsoId });
			params.push({ name: 'misuraCode', value: misuraCode });
			params.push({ name: 'attachCode', value: attachCode });

			var data = getAllByParams('pdf', 'PrintRicevuta', params);
			return $q.when(data);
		}

		//-------------------ANOMALIE--------------------------------------
		function pCorso_setPresaIncarico(item) {
			var objName = 'pCorso';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pCorso_unsetPresaIncarico(item) {
			var objName = 'pCorso';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pCorso_setPresaIncaricoCPI(item) {
			var objName = 'pCorso';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pCorso_unsetPresaIncaricoCPI(item) {
			var objName = 'pCorso';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}
		//-------------------ANOMALIE--------------------------------------

		// #endregion

		// #region  CORSO
		function corso_setParams(isGet, pageSize, page, order, testuale, classeId, aplId, tMisuraCode, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function corso_getAllList(testuale, classeId, aplId, tMisuraCode, iStato) {
			var params = corso_setParams(false, 0, 0, '', testuale, classeId, aplId, tMisuraCode, iStato);

			var data = getAllByParams('corso', 'GetListByFilter', params);
			return $q.when(data);
		}

		function corso_getAll(pageSize, page, testuale, classeId, aplId, tMisuraCode, iStato, order) {
			var params = corso_setParams(true, pageSize, page, order, testuale, classeId, aplId, tMisuraCode, iStato);

			var data = getAllByParams('corso', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function corso_countAll(testuale, classeId, aplId, tMisuraCode, iStato) {
			var params = corso_setParams(false, 0, 0, '', testuale, classeId, aplId, tMisuraCode, iStato);

			var data = getAllByParams('corso', 'CountByFilter', params);
			return $q.when(data);
		}

		function corso_get(id) {
			var data = getById('corso', id);
			return $q.when(data);
		}

		function corso_add(item) {
			var data = addObj('corso', item);
			return $q.when(data);
		}

		function corso_update(item) {
			var data = updateObj('corso', item);
			return $q.when(data);
		}

		function corso_merge(item) {
			var data = mergeObj('corso', item);
			return $q.when(data);
		}

		function corso_delete(id) {
			var data = deleteObj('corso', id);
			return $q.when(data);
		}

		function corso_unlock(item) {
			var objName = 'corso';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed unlock for %s: %s', objName, message);
					return message.status;
				});
		}



		// #endregion ******************************

		// #region  DOCENZA
		function docenza_setParams(isGet, pageSize, page, order, classeId, risorsaId, materiaId, incaricoId) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = _1; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof materiaId == 'undefined') { materiaId = 0; }
			if (typeof incaricoId == 'undefined') { incaricoId = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'materiaId', value: materiaId });
			params.push({ name: 'incaricoId', value: incaricoId });

			return params;
		}

		function docenza_getAllList(classeId, risorsaId, materiaId, incaricoId) {
			var params = docenza_setParams(false, 0, 0, '', classeId, risorsaId, materiaId, incaricoId);
			var data = getAllByParams('docenza', 'GetAll', params);
			return $q.when(data);
		}
		function docenza_getAll(pageSize, page, classeId, risorsaId, materiaId, incaricoId, order) {
			var params = docenza_setParams(true, pageSize, page, order, classeId, risorsaId, materiaId, incaricoId);
			var data = getAllByParams('docenza', 'GetAll', params);
			return $q.when(data);
		}
		function docenza_countAll(classeId, risorsaId, materiaId, incaricoId) {
			var params = docenza_setParams(false, 0, 0, '', classeId, risorsaId, materiaId, incaricoId);
			var data = getAllByParams('docenza', 'Count', params);
			return $q.when(data);
		}
		function docenza_getAllByClasse(id) {
			var params = docenza_setParams(true, 0, 0, '', id, 0, 0, 0);
			var data = getAllByParams('docenza', 'GetAll', params);
			return $q.when(data);
		}
		function docenza_getAllByRisorsa(id) {
			var params = docenza_setParams(true, 0, 0, '', 0, id, 0, 0);
			var data = getAllByParams('docenza', 'GetAll', params);
			return $q.when(data);
		}
		function docenza_getAllByMateria(classeId, materiaId) {
			var params = docenza_setParams(true, 0, 0, '', classeId, 0, materiaId, 0);
			var data = getAllByParams('docenza', 'GetAll', params);
			return $q.when(data);
		}

		function docenza_get(id) {
			var data = getById('docenza', id);
			return $q.when(data);
		}

		function docenza_add(item) {
			var data = addObj('docenza', item);
			return $q.when(data);
		}

		function docenza_update(item) {
			var data = updateObj('docenza', item);
			return $q.when(data);
		}

		function docenza_delete(id) {
			var data = deleteObj('docenza', id);
			return $q.when(data);
		}



		// #endregion ******************************

		// #region TICKET
		function ticket_getAllList(tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo) {
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = 0; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('ticket', 'GetList', params);
			return $q.when(data);
		}

		function ticket_getAll(pageSize, page, tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = -1; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('ticket', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function ticket_countAll(tTicketId, statusId, idParent, toRead, gruppoDidId, nominativo) {
			if (typeof tTicketId == 'undefined') { tTicketId = 0; }
			if (typeof statusId == 'undefined') { statusId = 0; }
			if (typeof idParent == 'undefined') { idParent = -1; }
			if (typeof toRead == 'undefined') { toRead = 0; }
			if (typeof gruppoDidId == 'undefined') { gruppoDidId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = 0; }

			var params = [];
			params.push({ name: 'tTicketId', value: tTicketId });
			params.push({ name: 'statusId', value: statusId });
			params.push({ name: 'idParent', value: idParent });
			params.push({ name: 'toRead', value: toRead });
			params.push({ name: 'gruppoDidId', value: gruppoDidId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('ticket', 'CountByFilter', params);
			return $q.when(data);
		}

		function ticket_get(id) {
			var data = getById('ticket', id);
			return $q.when(data);
		}

		function ticket_add(item) {
			var data = addObj('ticket', item);
			return $q.when(data);
		}

		function ticket_update(item) {
			var data = updateObj('ticket', item);
			return $q.when(data);
		}

		function ticket_setRead(ticketId) {
			if (typeof ticketId == 'undefined') { ticketId = 0; }

			var item = {};
			item.TicketId = ticketId;

			return $http.put(urlAPI + '/ticket/SetRead', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for SetRead: %s', message);
					return message.status;
				});
		}

		function ticket_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('ticket', id);
			return $q.when(data);
		}

		function ticket_unlock(item) {
			var objName = 'ticket';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion ******************************

		// #region  TTICKET
		function tTicket_getAllList() {
			var data = getAllList('tTicket');
			return $q.when(data);
		}

		function tTicket_getAll(pageSize, page, nome, projectId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof projectId == 'undefined') { projectId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'projectId', value: projectId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tTicket', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tTicket_countAll(tTicketId, status, projectId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof projectId == 'undefined') { projectId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'projectId', value: projectId });

			var data = getAllByParams('tTicket', 'CountByFilter', params);
			return $q.when(data);
		}

		function tTicket_get(id) {
			var data = getById('tTicket', id);
			return $q.when(data);
		}

		function tTicket_add(item) {
			var data = addObj('tTicket', item);
			return $q.when(data);
		}

		function tTicket_update(item) {
			var data = updateObj('tTicket', item);
			return $q.when(data);
		}

		function tTicket_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('tTicket', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  PROJECT
		function project_getAllList() {
			var data = getAllList('project');
			return $q.when(data);
		}

		function project_getAllListByUsername() {
			var data = getAllNoParam('project', 'GetAllListByUsername');
			return $q.when(data);
		}

		function project_getAll(pageSize, page, name, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof name == 'undefined') { name = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'name', value: name });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('project', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function project_countAll(name) {
			if (typeof name == 'undefined') { name = ''; }

			var params = [];
			params.push({ name: 'name', value: name });

			var data = getAllByParams('project', 'CountByFilter', params);
			return $q.when(data);
		}

		function project_get(id) {
			var data = getById('project', id);
			return $q.when(data);
		}

		function project_add(item) {
			var data = addObj('project', item);
			return $q.when(data);
		}

		function project_update(item) {
			var data = updateObj('project', item);
			return $q.when(data);
		}

		function project_delete(id) {
			console.log("deleteproject(%s)", id);

			var data = deleteObj('project', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  STATUS
		function status_getAllList() {
			var data = getAllList('status');
			return $q.when(data);
		}

		function status_getAll(pageSize, page, name, stato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof name == 'undefined') { name = ''; }
			if (typeof stato == 'undefined') { stato = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'name', value: name });
			params.push({ name: 'stato', value: stato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('status', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function status_countAll(name, stato) {
			if (typeof name == 'undefined') { name = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			params.push({ name: 'name', value: name });
			params.push({ name: 'stato', value: stato });

			var data = getAllByParams('status', 'CountByFilter', params);
			return $q.when(data);
		}

		function status_get(id) {
			var data = getById('status', id);
			return $q.when(data);
		}

		function status_add(item) {
			var data = addObj('status', item);
			return $q.when(data);
		}

		function status_update(item) {
			var data = updateObj('status', item);
			return $q.when(data);
		}

		function status_delete(id) {
			console.log("deletestatus(%s)", id);

			var data = deleteObj('status', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  TRACE
		function trace_getAllList() {
			var data = getAllList('trace');
			return $q.when(data);
		}

		function trace_getAll(pageSize, page, nome, ticketId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof ticketId == 'undefined') { ticketId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'ticketId', value: ticketId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('trace', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function trace_countAll(traceId, status, ticketId) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof ticketId == 'undefined') { ticketId = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'ticketId', value: ticketId });

			var data = getAllByParams('trace', 'CountByFilter', params);
			return $q.when(data);
		}

		function trace_get(id) {
			var data = getById('trace', id);
			return $q.when(data);
		}

		function trace_add(item) {
			var data = addObj('trace', item);
			return $q.when(data);
		}

		function trace_update(item) {
			var data = updateObj('trace', item);
			return $q.when(data);
		}

		function trace_delete(id) {
			console.log("deleteticket(%s)", id);

			var data = deleteObj('trace', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  ISTAT
		function istat_comune_getAllList(idprov) {
			var data = getAllByParam('comune', 'GetAllByIdProv', 'id', idprov);
			return $q.when(data);
		}

		function istat_comune_get(id) {
			var data = getById('comune', id);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  INCARICO
		function incarico_getAll(pageSize, page, nominativo, profiloId, classeId) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof profiloId == 'undefined') { profiloId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });

			var data = getAllByParams('incarico', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function incarico_countAll(nominativo, profiloId, classeId) {
			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'profiloId', value: profiloId });
			params.push({ name: 'classeId', value: classeId });

			var data = getAllByParams('incarico', 'CountByFilter', params);
			return $q.when(data);
		}

		function incarico_getAllByClasse(id) {
			var data = getAllByParam('incarico', 'GetAllByClasse', 'id', id);
			return $q.when(data);
		}

		function incarico_getAllByRisorsa(id) {
			var data = getAllByParam('incarico', 'GetAllByRisorsa', 'id', id);
			return $q.when(data);
		}

		function incarico_get(id) {
			var data = getById('incarico', id);
			return $q.when(data);
		}

		function incarico_getBase(id) {
			var data = getBaseById('incarico', id);
			return $q.when(data);
		}

		function incarico_add(item) {
			var data = addObj('incarico', item);
			return $q.when(data);
		}

		function incarico_update(item) {
			var data = updateObj('incarico', item);
			return $q.when(data);
		}

		function incarico_delete(id) {
			var data = deleteObj('incarico', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  ISTITUTO
		function istituto_setParams(isGet, pageSize, page, order, testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof sedeId == 'undefined') { sedeId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'sedeId', value: sedeId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function istituto_getAllList(testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato) {
			var params = istituto_setParams(false, 0, 0, '', testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('istituto', 'GetListByFilter', params);
			return $q.when(data);
		}

		function istituto_getAll(pageSize, page, testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato, order) {
			var params = istituto_setParams(true, pageSize, page, order, testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('istituto', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function istituto_countAll(testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato) {
			var params = istituto_setParams(false, 0, 0, '', testuale, aplId, sedeId, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('istituto', 'CountByFilter', params);
			return $q.when(data);
		}

		function istituto_get(id) {
			var data = getById('istituto', id);
			return $q.when(data);
		}

		function istituto_add(item) {
			var data = addObj('istituto', item);
			return $q.when(data);
		}

		function istituto_update(item) {
			var data = updateObj('istituto', item);
			return $q.when(data);
		}

		function istituto_merge(item) {
			var data = mergeObj('istituto', item);
			return $q.when(data);
		}

		function istituto_delete(id) {
			var data = deleteObj('istituto', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  LEZIONE
		function lezione_setParams(isGet, pageSize, page, order, testuale, docenzaId, docenteId, classeId, materiaId, lezGGId, data, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof docenzaId == 'undefined') { docenzaId = 0; }
			if (typeof docenteId == 'undefined') { docenteId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof materiaId == 'undefined') { materiaId = 0; }
			if (typeof lezGGId == 'undefined') { lezGGId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'docenzaId', value: docenzaId });
			params.push({ name: 'docenteId', value: docenteId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'materiaId', value: materiaId });
			params.push({ name: 'lezGGId', value: lezGGId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function lezione_getAll(pageSize, page, testuale, docenzaId, docenteId, classeId, materiaId, lezGGId, data, mese, anno, iStato, order) {
			var params = lezione_setParams(true, pageSize, page, order, testuale, docenzaId, docenteId, classeId, materiaId, lezGGId, data, mese, anno, iStato);
			var response = getAllByParams('lezione', 'GetAllByFilter', params);
			return $q.when(response);
		}
		function lezione_countAll(testuale, docenzaId, docenteId, classeId, materiaId, lezGGId, data, mese, anno, iStato) {
			var params = lezione_setParams(false, 0, 0, '', testuale, docenzaId, docenteId, classeId, materiaId, lezGGId, data, mese, anno, iStato);
			var response = getAllByParams('lezione', 'CountByFilter', params);
			return $q.when(response);
		}

		function lezione_get(id) {
			var data = getById('lezione', id);
			return $q.when(data);
		}

		function lezione_setParamsDocenze(tMisuraCode, tProfiloDocenteId, classeId, dtInizio, dtFine) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tProfiloDocenteId == 'undefined') { tProfiloDocenteId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof dtInizio == 'undefined') { dtInizio = ''; }
			if (typeof dtFine == 'undefined') { dtFine = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tProfiloDocenteId', value: tProfiloDocenteId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'dtInizio', value: dtInizio });
			params.push({ name: 'dtFine', value: dtFine });

			return params;
		}
		function lezione_getOreDocenze(tMisuraCode, tProfiloDocenteId, classeId, dtInizio, dtFine) {
			var params = lezione_setParamsDocenze(tMisuraCode, tProfiloDocenteId, classeId, dtInizio, dtFine);
			var data = getAllByParams('lezione', 'GetOreDocenze', params);
			return $q.when(data);
		}
		function lezione_getOrePresenzeStd(tMisuraCode, classeId, dtInizio, dtFine) {
			var params = lezione_setParamsDocenze(tMisuraCode, 0, classeId, dtInizio, dtFine);
			var data = getAllByParams('lezione', 'GetOrePresenzeStd', params);
			return $q.when(data);
		}

		function lezione_add(item) {
			var data = addObj('lezione', item);
			return $q.when(data);
		}

		function lezione_update(item) {
			var data = updateObj('lezione', item);
			return $q.when(data);
		}

		function lezione_merge(item) {
			var data = mergeObj('lezione', item);
			return $q.when(data);
		}

		function lezione_delete(id) {
			var data = deleteObj('lezione', id);
			return $q.when(data);
		}

		function lezione_unlock(classeId, dt) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }

			var paramArray = [];
			paramArray.push({ name: 'classeId', value: classeId });
			paramArray.push({ name: 'dt', value: dt });

			var url = urlAPI + '/Lezione/Unlock';

			var numParams = paramArray.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += paramArray[i].name + '=' + paramArray[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed lezione_unlock for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion ******************************

		// #region  CLASSE LEZIONEGG
		function classeLezioneGG_getAll(pageSize, page, classeId, data, anno, mese, aplId, cpiId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'order', value: order });


			var data1 = getAllByParams('classeLezioneGG', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function classeLezioneGG_countAll(classeId, data, anno, mese, aplId, cpiId) {
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });

			var data1 = getAllByParams('classeLezioneGG', 'CountByFilter', params);
			return $q.when(data1);
		}



		function classeLezioneGG_get(id) {
			var data = getById('classeLezioneGG', id);
			return $q.when(data);
		}



		// #endregion ******************************

		// #region  REGISTRO ATTIVITA
		function regAttivita_setParams(isGet, pageSize, page, order, tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof soggettoCollegatoId == 'undefined') { soggettoCollegatoId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof revDt == 'undefined') { revDt = ''; }
			if (typeof revINumber == 'undefined') { revINumber = 0; }
			if (typeof iAiuto == 'undefined') { iAiuto = 0; }
			if (typeof tMisCode == 'undefined') { tMisCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'soggettoCollegatoId', value: soggettoCollegatoId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'revDt', value: revDt });
			params.push({ name: 'revINumber', value: revINumber });
			params.push({ name: 'iAiuto', value: iAiuto });
			params.push({ name: 'tMisCode', value: tMisCode });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function regAttivita_getAll(pageSize, page, tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato, order) {
			var params = regAttivita_setParams(true, pageSize, page, order, tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato, false);
			var data = getAllByParams('regAttivita', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function regAttivita_getCpiEqualApl(pageSize, page, tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato, order) {
			var params = regAttivita_setParams(true, pageSize, page, order, tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato, true);
			var data = getAllByParams('regAttivita', 'GetCpiEqualApl', params);
			return $q.when(data);
		}
		function regAttivita_countAll(tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato) {
			var params = regAttivita_setParams(false, 0, 0, '', tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato);
			var data = getAllByParams('regAttivita', 'CountByFilter', params);
			return $q.when(data);
		}
		function regAttivita_countCpiEqualApl(tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato) {
			var params = regAttivita_setParams(false, 0, 0, '', tSourceCode, sourceId, destinatarioId, soggettoCollegatoId, data, anno, mese, dtStart, dtEnd, revDt, revINumber, iAiuto, tMisCode, iStato);
			var data = getAllByParams('regAttivita', 'CountCpiEqualApl', params);
			return $q.when(data);
		}

		function regAttivita_getByFoglio(tSourceCode, sourceId, destinatarioId, data, anno, mese, revDt, revINumber, tMisCode, iStato) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof revDt == 'undefined') { revDt = ''; }
			if (typeof revINumber == 'undefined') { revINumber = 0; }
			if (typeof tMisCode == 'undefined') { tMisCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'order', value: '' });

			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'soggettoCollegatoId', value: 0 });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dtStart', value: '' });
			params.push({ name: 'dtEnd', value: '' });
			params.push({ name: 'revDt', value: revDt });
			params.push({ name: 'revINumber', value: revINumber });
			params.push({ name: 'iAiuto', value: 0 });
			params.push({ name: 'tMisCode', value: tMisCode });
			params.push({ name: 'iStato', value: iStato });


			var data1 = getAllByParams('regAttivita', 'GetAllByFilter', params);
			return $q.when(data1);

		}

		function regAttivita_saveFoglio(objValue) {
			var objName = 'regAttivita';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_saveHelp(objValue) {
			var objName = 'regAttivita';
			return $http.put(urlAPI + '/' + objName + '/SaveHelp', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}


		function regAttivita_get(id) {
			var data = getById('regAttivita', id);
			return $q.when(data);
		}


		function regAttivita_add(item) {
			var data = addObj('regAttivita', item);
			return $q.when(data);
		}

		function regAttivita_update(item) {
			var data = updateObj('regAttivita', item);
			return $q.when(data);
		}

		function regAttivita_merge(item) {
			var data = mergeObj('regAttivita', item);
			return $q.when(data);
		}

		function regAttivita_delete(id) {
			var data = deleteObj('regAttivita', id);
			return $q.when(data);
		}

		function regAttivita_exists(tSourceCode, sourceId, data, tMisCode, tRegAttId, regAttId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof tMisCode == 'undefined') { tMisCode = ''; }
			if (typeof tRegAttId == 'undefined') { tRegAttId = 0; }
			if (typeof regAttId == 'undefined') { regAttId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'tMisCode', value: tMisCode });
			params.push({ name: 'tRegAttId', value: tRegAttId });
			params.push({ name: 'regAttId', value: regAttId });

			var data1 = getAllByParams('regAttivita', 'Exists', params);
			return $q.when(data1);
		}


		function regAttivita_saveAndCompleted(item) {
			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/SaveAndCompleted/', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed SaveAndCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_setCompleted(id) {
			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed regAttivita_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_unsetCompleted(id) {
			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed regAttivita_UnsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivita_setRevisione(tSourceCode, sourceId, dtStart, tMisCode) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof tMisCode == 'undefined') { tMisCode = ''; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'tMisCode', value: tMisCode });

			var data = getAllByParams('regAttivita', 'SetRevisione', params);
			return $q.when(data);
		}

		function regAttivita_clona(sourceId, tMisuraCode) {
			if (typeof sourceId == 'undefined') sourceId = 0;
			if (typeof tMisuraCode == 'undefined') tMisuraCode = '';

			var objName = 'regAttivita';

			return $http.put(urlAPI + '/' + objName + '/Clona?sourceId=' + sourceId + '&tMisuraCode=' + tMisuraCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborsoDtl_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		function regAttivitaPlan_getAll(pageSize, page, regAttivitaId, tMisuraCode, tSourceCode, sourceId, destinatarioId, dtInizio, dtFine, order) {
			if (typeof pageSize == 'undefined') { pageSize = ''; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof order == 'undefined') { order = ''; }

			if (typeof regAttivitaId == 'undefined') { regAttivitaId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof dtInizio == 'undefined') { dtInizio = ''; }
			if (typeof dtFine == 'undefined') { dtFine = ''; }


			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'order', value: order });

			params.push({ name: 'regAttivitaId', value: regAttivitaId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtInizio', value: dtInizio });
			params.push({ name: 'dtFine', value: dtFine });


			var data1 = getAllByParams('regAttivita', 'GetAllPlanByFilter', params);
			return $q.when(data1);
		}

		// #endregion ******************************

		// #region  tRegAttivita
		function tRegAttivita_getAllList(tSourceCode, parentId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'parentId', value: parentId });

			var data = getAllByParams('TRegAttivita', 'GetAllList', params);
			return $q.when(data);
		}

		function tRegAttivita_getAll(tSourceCode, parentId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'parentId', value: parentId });

			var data = getAllByParams('TRegAttivita', 'GetAll', params);
			return $q.when(data);
		}


		function tRegAttivita_get(id) {
			var data = getById('RegAttivita', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  MATERIA
		function materia_getAllList() {
			//var data = getAllByParam('materia', 'GetAllList');
			var data = getAllList('materia');
			return $q.when(data);
		}

		function materia_getAllByCorso(id) {
			var data = getAllByParam('materia', 'GetAllByCorso', 'id', id);
			return $q.when(data);

		}

		function materia_getAll(pageSize, page, testuale, corsoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'corsoId', value: corsoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('materia', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function materia_countAll(testuale, corsoId) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'corsoId', value: corsoId });

			var data = getAllByParams('materia', 'CountByFilter', params);
			return $q.when(data);

		}



		function materia_get(id) {
			var data = getById('materia', id);
			return $q.when(data);
		}

		function materia_add(item) {
			var data = addObj('materia', item);
			return $q.when(data);
		}

		function materia_update(item) {
			var data = updateObj('materia', item);
			return $q.when(data);
		}

		function materia_delete(id) {
			var data = deleteObj('materia', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  T MISURA
		function tMisura_getAllList() {
			var data = getAllList('tMisura', 'GetAllList');
			return $q.when(data);
		}

		function tMisura_getAllDefault() {
			var data = getAll('tMisura', 'GetAll');
			return $q.when(data);
		}

		function tMisura_getAll(pageSize, page, title) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof title == 'undefined') { title = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'title', value: title });

			var data = getAllByParams('tMisura', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tMisura_get(id) {
			var data = getById('tMisura', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  CP2011 - Atlante del lavoro

		function cp2011_setParams(isPaging, pageSize, page, order, code, testuale) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof code == 'undefined') { code = ''; }
			if (typeof testuale == 'undefined') { testuale = ''; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'code', value: code });
			params.push({ name: 'testuale', value: testuale });

			return params;
		}

		function cp2011_getAllList(code, testuale) {
			var params = cp2011_setParams(false, 0, 0, '', code, testuale);
			var data = getAllByParams('CP2011', 'GetAllList', params);
			return $q.when(data);
		}

		function cp2011_getAll(pageSize, page, code, testuale, order) {
			var params = cp2011_setParams(true, pageSize, page, order, code, testuale);
			var data = getAllByParams('CP2011', 'GetAll', params);
			return $q.when(data);
		}

		function cp2011_get(id) {
			var data = getById('cp2011', id);
			return $q.when(data);
		}

		function cp2011_getByCode(code) {
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'code', value: code });

			var data = getAllByParams('CP2011', 'GetByCode', params);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  ISTAT - Comune CAP

		function comuneCAP_setParams(isPaging, pageSize, page, order, testuale, cap, comuneId, provinciaId) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof cap == 'undefined') { cap = ''; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'cap', value: cap });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'provinciaId', value: provinciaId });

			return params;
		}

		function comuneCAP_getAllList(testuale, cap, comuneId, provinciaId) {
			var params = comuneCAP_setParams(false, 0, 0, '', testuale, cap, comuneId, provinciaId);
			var data = getAllByParams('comuneCAP', 'GetAllList', params);
			return $q.when(data);
		}

		function comuneCAP_getAll(pageSize, page, testuale, cap, comuneId, provinciaId, order) {
			var params = comuneCAP_setParams(true, pageSize, page, order, testuale, cap, comuneId, provinciaId);
			var data = getAllByParams('comuneCAP', 'GetAll', params);
			return $q.when(data);
		}

		function comuneCAP_get(id) {
			var data = getById('comuneCAP', id);
			return $q.when(data);
		}

		function comuneCAP_exists(cap, comuneId, provinciaId) {
			if (typeof cap == 'undefined') { cap = ''; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }

			var params = [];
			params.push({ name: 'cap', value: cap });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'provinciaId', value: provinciaId });

			var data = getAllByParams('comuneCAP', 'Exists', params);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  CLASSE RIMBORSO
		function classeRimborso_setParams(isGet, pageSize, page, order, testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof type == 'undefined') { type = ''; }
			if (typeof iStep == 'undefined') { iStep = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'type', value: type });
			params.push({ name: 'iStep', value: iStep });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function classeRimborso_getAllList(testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato) {
			var params = classeRimborso_setParams(false, 0, 0, '', testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato);
			var data = getAllByParams('classeRimborso', 'GetAllList', params);
			return $q.when(data);
		}
		function classeRimborso_getAll(pageSize, page, testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato, order) {
			var params = classeRimborso_setParams(true, pageSize, page, order, testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato);
			var data = getAllByParams('classeRimborso', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function classeRimborso_countAll(testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato) {
			var params = classeRimborso_setParams(false, 0, 0, '', testuale, classeId, tMisuraCode, type, iStep, aplId, cpiId, iStato);
			var data = getAllByParams('classeRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function classeRimborso_get(id) {
			var data = getById('classeRimborso', id);
			return $q.when(data);
		}


		function classeRimborso_add(item) {
			var data = addObj('classeRimborso', item);
			return $q.when(data);
		}

		function classeRimborso_create(item) {
			var data = postMethod('classeRimborso', 'Create', item);
			return $q.when(data);
		}

		function classeRimborso_update(item) {
			var data = updateObj('classeRimborso', item);
			return $q.when(data);
		}

		function classeRimborso_merge(item) {
			var data = mergeObj('classeRimborso', item);
			return $q.when(data);
		}

		function classeRimborso_updateDatiAssess(item) {
			var objName = 'classeRimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_changeState(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed sentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_delete(id) {
			var data = deleteObj('classeRimborso', id);
			return $q.when(data);
		}

		function classeRimborso_unlock(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_unsetIssuePay(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/RemoveIssuePay', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		//-------------------ANOMALIE--------------------------------------
		function classeRimborso_setPresaIncarico(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_unsetPresaIncarico(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_setPresaIncaricoCPI(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function classeRimborso_unsetPresaIncaricoCPI(item) {
			var objName = 'classeRimborso';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}
		//-------------------ANOMALIE--------------------------------------

		// #endregion ******************************

		// #region  CLASSE RIMBORSO DOCENZA
		function classeRmbDocenza_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, classeRmbId, docenzaId, docenteId, moduloId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'data crescente'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof classeRmbId == 'undefined') { classeRmbId = 0; }
			if (typeof docenzaId == 'undefined') { docenzaId = 0; }
			if (typeof docenteId == 'undefined') { docenteId = 0; }
			if (typeof moduloId == 'undefined') { moduloId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'classeRmbId', value: classeRmbId });
			params.push({ name: 'docenzaId', value: docenzaId });
			params.push({ name: 'docenteId', value: docenteId });
			params.push({ name: 'moduloId', value: moduloId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function classeRmbDocenza_getAll(pageSize, page, testuale, tMisuraCode, classeRmbId, docenzaId, docenteId, moduloId, iStato, order) {
			var params = classeRmbDocenza_setParams(true, pageSize, page, order, testuale, tMisuraCode, classeRmbId, docenzaId, docenteId, moduloId, iStato);
			var data = getAllByParams('ClasseRmbDocenza', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function classeRmbDocenza_countAll(testuale, tMisuraCode, classeRmbId, docenzaId, docenteId, moduloId, iStato) {
			var params = classeRmbDocenza_setParams(false, 0, 0, '', testuale, tMisuraCode, classeRmbId, docenzaId, docenteId, moduloId, iStato);
			var data = getAllByParams('ClasseRmbDocenza', 'CountByFilter', params);
			return $q.when(data);
		}

		function classeRmbDocenza_get(id) {
			var data = getById('ClasseRmbDocenza', id);
			return $q.when(data);
		}
		function classeRmbDocenza_add(item) {
			var data = addObj('ClasseRmbDocenza', item);
			return $q.when(data);
		}
		function classeRmbDocenza_update(item) {
			var data = updateObj('ClasseRmbDocenza', item);
			return $q.when(data);
		}
		function classeRmbDocenza_merge(item) {
			var data = mergeObj('ClasseRmbDocenza', item);
			return $q.when(data);
		}
		function classeRmbDocenza_delete(id) {
			var data = deleteObj('ClasseRmbDocenza', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  CLASSE RIMBORSO ALLIEVO
		function classeRmbAllievo_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, classeRmbId, classeStdId, destinatarioId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'data crescente'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof classeRmbId == 'undefined') { classeRmbId = 0; }
			if (typeof classeStdId == 'undefined') { classeStdId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'classeRmbId', value: classeRmbId });
			params.push({ name: 'classeStdId', value: classeStdId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function classeRmbAllievo_getAll(pageSize, page, testuale, tMisuraCode, classeRmbId, classeStdId, destinatarioId, iStato, order) {
			var params = classeRmbAllievo_setParams(true, pageSize, page, order, testuale, tMisuraCode, classeRmbId, classeStdId, destinatarioId, iStato);
			var data = getAllByParams('ClasseRmbAllievo', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function classeRmbAllievo_countAll(testuale, tMisuraCode, classeRmbId, classeStdId, destinatarioId, iStato) {
			var params = classeRmbAllievo_setParams(false, 0, 0, '', testuale, tMisuraCode, classeRmbId, classeStdId, destinatarioId, iStato);
			var data = getAllByParams('ClasseRmbAllievo', 'CountByFilter', params);
			return $q.when(data);
		}

		function classeRmbAllievo_get(id) {
			var data = getById('ClasseRmbAllievo', id);
			return $q.when(data);
		}
		function classeRmbAllievo_add(item) {
			var data = addObj('ClasseRmbAllievo', item);
			return $q.when(data);
		}
		function classeRmbAllievo_update(item) {
			var data = updateObj('ClasseRmbAllievo', item);
			return $q.when(data);
		}
		function classeRmbAllievo_merge(item) {
			var data = mergeObj('ClasseRmbAllievo', item);
			return $q.when(data);
		}
		function classeRmbAllievo_delete(id) {
			var data = deleteObj('ClasseRmbAllievo', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  CLASSE STUDENTE
		function classeStudente_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, classeId, studenteId, data, anno, mese, aplId, cpiId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'data crescente'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function classeStudente_getAll(pageSize, page, testuale, tMisuraCode, classeId, studenteId, dt, anno, mese, aplId, cpiId, iStato, order) {
			var params = classeStudente_setParams(true, pageSize, page, order, testuale, tMisuraCode, classeId, studenteId, dt, anno, mese, aplId, cpiId, iStato);
			var data = getAllByParams('ClasseStudente', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function classeStudente_countAll(testuale, tMisuraCode, classeId, studenteId, dt, anno, mese, aplId, cpiId, iStato) {
			var params = classeStudente_setParams(false, 0, 0, '', testuale, tMisuraCode, classeId, studenteId, dt, anno, mese, aplId, cpiId, iStato);
			var data = getAllByParams('ClasseStudente', 'CountByFilter', params);
			return $q.when(data);
		}

		function classeStudente_getAllByClasse_Date(tMisuraCode, classeId, dt) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'dt', value: dt });

			var data = getAllByParams('ClasseStudente', 'GetAllByClasse_Date', params);
			return $q.when(data);
		}

		function classeStudente_getMaxByStudenteId(tMisuraCode, studenteId) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof studenteId == 'undefined') { studenteId = 0; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'studenteId', value: studenteId });

			var data = getAllByParams('ClasseStudente', 'GetMaxByStudenteId', params);
			return $q.when(data);
		}

		function classeStudente_exists(tMisuraCode, classeId, studenteId, codiceFiscale, id) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof studenteId == 'undefined') { studenteId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'studenteId', value: studenteId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'id', value: id });


			var data = getAllByParams('ClasseStudente', 'Exists', params);
			return $q.when(data);
		}

		function classeStudente_get(id) {
			var data = getById('ClasseStudente', id);
			return $q.when(data);
		}


		function classeStudente_add(item) {
			var data = addObj('ClasseStudente', item);
			return $q.when(data);
		}

		function classeStudente_addSpecial(item) {
			var data = postMethod('ClasseStudente', 'DestinatarioAddSpecial', item);
			return $q.when(data);
		}

		function classeStudente_update(item) {
			var data = updateObj('ClasseStudente', item);
			return $q.when(data);
		}

		function classeStudente_delete(id) {
			var data = deleteObj('ClasseStudente', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  CLASSE STUDENTE SOSPENSIONE
		function classeStdSospensione_getAllBySourceId(classeStdId, iFestivo, iStato) {
			if (typeof classeStdId == 'undefined') { classeStdId = 0; }
			if (typeof iFestivo == 'undefined') { iFestivo = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'classeStdId', value: classeStdId });
			params.push({ name: 'iFestivo', value: iFestivo });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('ClasseStdSospensione', 'GetAllBySourceId', params);
			return $q.when(data);

		}

		function classeStdSospensione_get(id) {
			var data = getById('ClasseStdSospensione', id);
			return $q.when(data);
		}

		function classeStdSospensione_create(item) {
			var data = postMethod('ClasseStdSospensione', 'Create', item);
			return $q.when(data);
		}

		function classeStdSospensione_add(item) {
			var data = addObj('ClasseStdSospensione', item);
			return $q.when(data);
		}

		function classeStdSospensione_update(item) {
			var data = updateObj('ClasseStdSospensione', item);
			return $q.when(data);
		}

		function classeStdSospensione_merge(item) {
			var data = mergeObj('ClasseStdSospensione', item);
			return $q.when(data);
		}

		function classeStdSospensione_delete(id) {
			var data = deleteObj('ClasseStdSospensione', id);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  RISORSA
		function risorsa_getAllListByText(searchText) {
			if (typeof searchText == 'undefined') { searchText = ''; }

			var params = [];
			params.push({ name: 'searchText', value: searchText });

			var data = getAllByParams('risorsa', 'GetAllListByText', params);
			return $q.when(data);
		}

		function risorsa_getAllList(aziendaId, bStato) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			var params = [];
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'bStato', value: bStato });

			var data = getAllByParams('risorsa', 'GetAllListByFilter', params);

			return $q.when(data);
		}

		function risorsa_getByUsernameList() {
			var data = getAllNoParam('risorsa', 'GetByUsernameList');
			return $q.when(data);
		}

		function risorsa_getAll(pageSize, page, nominativo, aziendaId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('risorsa', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function risorsa_countAll(nominativo, aziendaId, bStato) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'bStato', value: bStato });

			var data = getAllByParams('risorsa', 'CountByFilter', params);
			return $q.when(data);
		}

		function risorsa_existsCF(risorsaId, codiceFiscale) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('risorsa', 'ExistsCF', params);
			return $q.when(data);
		}

		function risorsa_getByUsername() {
			var data = getAllNoParam('risorsa', 'GetByUsername');
			return $q.when(data);
		}

		function risorsa_getByUsername2(username) {
			var data = getAllByParam('risorsa', 'GetByUsername2', 'username', username);
			return $q.when(data);
		}

		function risorsa_get(id) {
			var data = getById('risorsa', id);
			return $q.when(data);
		}

		function risorsa_add(item) {
			var data = addObj('risorsa', item);
			return $q.when(data);
		}

		function risorsa_update(item) {
			var data = updateObj('risorsa', item);
			return $q.when(data);
		}

		function risorsa_delete(id) {
			var data = deleteObj('risorsa', id);
			return $q.when(data);
		}

		function risorsa_resetPassword(id) {
			if (typeof id == 'undefined') { id = 0; }

			var url = urlAPI + '/risorsa/ResetPassword?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_setRinuncia(risorsaId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }

			var url = urlAPI + '/risorsa/SetRinuncia?risorsaId=' + risorsaId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed ris_setRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_unsetRinuncia(risorsaId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }

			var url = urlAPI + '/risorsa/UnsetRinuncia?risorsaId=' + risorsaId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed ris_unsetRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_upload(filename, file) {
			var objName = 'risorsa';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;

			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed risorsa_upload for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsa_deleteAvatar(id) {
			var objName = 'risorsa';
			var method = 'DeleteAvatar';

			var url = urlAPI + '/' + objName + '/' + method + '/' + id;

			return $http.delete(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed risorsa_deleteAvatar for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion

		// #region RISORSA AZIONE
		function risorsaAzione_getList(testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });

			var data = getAllByParams('risorsaAzione', 'GetAllList', params);
			return $q.when(data);
		}

		function risorsaAzione_getAll(pageSize, page, testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }
			if (typeof order == 'undefined') { order = 'alfabetico'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('risorsaAzione', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function risorsaAzione_countAll(testuale, risorsaId, cpiId, profiloANPALId, rinunciaCPIId) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof profiloANPALId == 'undefined') { profiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'profiloANPALId', value: profiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });

			var data = getAllByParams('risorsaAzione', 'CountByFilter', params);
			return $q.when(data);
		}

		function risorsaAzione_get(id) {
			var data = getById('risorsaAzione', id);
			return $q.when(data);
		}

		function risorsaAzione_add(item) {
			var data = addObj('risorsaAzione', item);
			return $q.when(data);
		}

		function risorsaAzione_update(item) {
			var data = updateObj('risorsaAzione', item);
			return $q.when(data);
		}

		function risorsaAzione_delete(id) {
			var data = deleteObj('risorsaAzione', id);
			return $q.when(data);
		}

		function risorsaAzione_unlock(item) {
			var objName = 'risorsaAzione';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsaAzione_setRinuncia(item) {
			var objName = 'risorsaAzione';

			return $http.put(urlAPI + '/' + objName + '/SetRinuncia', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed risAz_setRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function risorsaAzione_unsetRinuncia(id) {
			if (typeof id == 'undefined') { id = 0; }

			var url = urlAPI + '/risorsaAzione/UnsetRinuncia?id=' + id;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed risAz_unsetRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}


		// #endregion ******************************

		// #region  DESTINATARIO

		function destinatario_setParams(isGet, pageSize, page, order, testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tProfiloANPALId == 'undefined') { tProfiloANPALId = 0; }
			if (typeof classeId == 'undefined') { classeId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof notIn == 'undefined') { notIn = 0; }
			if (typeof iFase == 'undefined') { iFase = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tProfiloANPALId', value: tProfiloANPALId });
			params.push({ name: 'classeId', value: classeId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'notIn', value: notIn });
			params.push({ name: 'iFase', value: iFase });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function destinatario_getAllList(testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato) {
			var params = destinatario_setParams(false, 0, 0, '', testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato);
			var data = getAllByParams('destinatario', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function destinatario_getAll(pageSize, page, testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato, order) {
			var params = destinatario_setParams(true, pageSize, page, order, testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato);
			var data = getAllByParams('destinatario', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function destinatario_countAll(testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato) {
			var params = destinatario_setParams(false, 0, 0, '', testuale, tProfiloANPALId, classeId, aziendaId, tMisuraCode, notIn, iFase, provinciaId, comuneId, cpiId, aplId, percorso, iStato);
			var data = getAllByParams('destinatario', 'CountByFilter', params);
			return $q.when(data);
		}

		function destinatario_get(id) {
			var data = getById('destinatario', id);
			return $q.when(data);
		}

		function destinatario_add(item) {
			var data = addObj('destinatario', item);
			return $q.when(data);
		}

		function destinatario_addByAPL(item) {
			var objName = 'destinatario';

			return $http.post(urlAPI + '/' + objName + '/PostByAPL', item)
				.then(function (response) {
					console.info('PostByAPL()', response);
					return response.data;
				})
				.catch(function (message) {
					return message;
				});
		}

		function destinatario_update(item) {
			var data = updateObj('destinatario', item);
			return $q.when(data);
		}

		function destinatario_delete(id) {
			var data = deleteObj('destinatario', id);
			return $q.when(data);
		}

		function destinatario_exists(destinatarioId, codiceFiscale) {
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			var params = [];
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('destinatario', 'Exists', params);
			return $q.when(data);
		}

		function destinatario_assign(item) {
			return $http.put(urlAPI + '/destinatario/Assign', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function destinatario_status(codiceFiscale, aziendaId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('destinatario', 'Status', params);
			return $q.when(data);
		}

		function destinatario_setRinuncia(destinatarioId) {
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }

			var url = urlAPI + '/destinatario/SetRinuncia?destinatarioId=' + destinatarioId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed ris_setRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function destinatario_unsetRinuncia(destinatarioId) {
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }

			var url = urlAPI + '/destinatario/UnsetRinuncia?destinatarioId=' + destinatarioId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed ris_unsetRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion ******************************

		// #region  DESTINATARIO INDENNITA

		function destinatarioIndennita_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof ospitanteId == 'undefined') { ospitanteId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof codiceXML == 'undefined') { codiceXML = ''; }
			if (typeof destIndINPSExportId == 'undefined') { destIndINPSExportId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof parentId == 'undefined') { parentId = -1; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'ospitanteId', value: ospitanteId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'data', value: data });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'codiceXML', value: codiceXML });
			params.push({ name: 'destIndINPSExportId', value: destIndINPSExportId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function destinatarioIndennita_getAllList(testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato) {
			var params = destinatarioIndennita_setParams(false, 0, 0, '', testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato);
			var data = getAllByParams('destinatarioIndennita', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function destinatarioIndennita_getAll(pageSize, page, testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato, order) {
			var params = destinatarioIndennita_setParams(true, pageSize, page, order, testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato);
			var data = getAllByParams('destinatarioIndennita', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function destinatarioIndennita_countAll(testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato) {
			var params = destinatarioIndennita_setParams(false, 0, 0, '', testuale, tMisuraCode, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, comuneId, data, mese, anno, codiceXML, destIndINPSExportId, percorso, parentId, iStato);
			var data = getAllByParams('destinatarioIndennita', 'CountByFilter', params);
			return $q.when(data);
		}

		function destinatarioIndennita_exists(tirocinioId, mese, anno, id, tMisuraCode, destinatarioId, cpiId, promotoreId, ospitanteId, percorso) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof ospitanteId == 'undefined') { ospitanteId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'id', value: id });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'ospitanteId', value: ospitanteId });
			params.push({ name: 'percorso', value: percorso });

			var data = getAllByParams('destinatarioIndennita', 'Exists', params);
			return $q.when(data);
		}

		function destinatarioIndennita_get(id) {
			var data = getById('destinatarioIndennita', id);
			return $q.when(data);
		}

		function destinatarioIndennita_add(item) {
			var data = addObj('destinatarioIndennita', item);
			return $q.when(data);
		}

		function destinatarioIndennita_addMultiplo(list) {
			var objName = 'DestinatarioIndennita';
			var actionName = 'DestinatarioIndennita_AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_addList for %s: %s', objName, message);
					return message.status;
				});
		}

		function destinatarioIndennita_update(item) {
			var data = updateObj('destinatarioIndennita', item);
			return $q.when(data);
		}

		function destinatarioIndennita_merge(item) {
			var data = mergeObj('destinatarioIndennita', item);
			return $q.when(data);
		}

		function destinatarioIndennita_delete(id) {
			var data = deleteObj('destinatarioIndennita', id);
			return $q.when(data);
		}

		function destinatarioIndennita_changeState(id, status, tSourceCode) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof status == 'undefined') { status = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'status', value: status });
			params.push({ name: 'tSourceCode', value: tSourceCode });

			var data = getAllByParams('destinatarioIndennita', 'ChangeState', params);
			return $q.when(data);
		}

		function destinatarioIndennita_getParametri(vm, tirocinioId, mese, anno) {
			vm.showNotaImporto = false;
			if (tirocinioId > 0 && mese > 0 && anno > 0) {
				vm.showNotaImporto = true;

				return tirocinio_get(tirocinioId).then(function (data) {
					if (data && data.Id == tirocinioId) {
						vm.record.NDaysSosp = 0;
						vm.record.ImportoMensileLordo = data.ImportoMensileLordo;
						return tirSospensione_getAllByTirocinioId(tirocinioId, 0, 2).then(function (tirSosp) { //iStato = 2; Solo "approvate" da CPI                            
							if (tirSosp && tirSosp.length > 0) {
								tirSosp.forEach(function (item) {
									if (item && item.NumGiorni > 0) {
										var dtStartSosp = moment(item.DtInizio);
										var dtEndSosp = moment(item.DtFine);
										var mStartSosp = dtStartSosp.month() + 1;
										var yStartSosp = dtStartSosp.year();
										var mEndSosp = dtEndSosp.month() + 1;
										var yEndSosp = dtEndSosp.year();

										if (anno == yStartSosp && anno == yEndSosp && mese >= mStartSosp && mese <= mEndSosp) {
											vm.record.NDaysSosp += parseInt(item.NumGiorni);
										}
										else if (yStartSosp != yEndSosp) {
											if ((mese >= mStartSosp && anno == yStartSosp) || (mese <= mEndSosp && anno == yEndSosp)) {
												vm.record.NDaysSosp += parseInt(item.NumGiorni);
											}
										}
									}
								});
							}

							var dtStart = moment(data.DtStart);
							var dtEnd = data.DtEnd == null ? moment(data.DtEndPrev) : moment(data.DtEnd);

							var dayStart = dtStart.date();
							var mStart = dtStart.month() + 1;
							var yStart = dtStart.year();
							var dayEnd = dtEnd.date();
							var mEnd = dtEnd.month() + 1;
							var yEnd = dtEnd.year();

							vm.validDate = false;
							if (anno == yStart && anno == yEnd && mese >= mStart && mese <= mEnd) {
								vm.validDate = true;
							}
							else if (yStart != yEnd) {
								if ((mese >= mStart && anno == yStart) || (mese <= mEnd && anno == yEnd)) {
									vm.validDate = true;
								}
							}

							//console.info('validDate -> ', vm.validDate);

							vm.record.GiorniCommerciali = 30; //Mese commerciale
							if (mStart == mese && yStart == anno) {
								vm.record.GiorniCommerciali = 30 - dayStart + 1;
							}
							else if (mEnd == mese && yEnd == anno) {
								vm.record.GiorniCommerciali = dayEnd;
							}

							if (vm.record.NDaysSosp > 0) {
								vm.record.GiorniCommerciali -= vm.record.NDaysSosp;
							}

							vm.record.QuotaParte = Math.round((vm.record.GiorniCommerciali / 30) * 100) / 100;
							vm.record.ImportoTeorico = Math.round((vm.record.GiorniCommerciali * vm.record.ImportoMensileLordo / 30) * 100) / 100;

							//console.info('ImportoMensileLordo -> ', vm.record.ImportoMensileLordo);
							//console.info('QuotaParte -> ', vm.record.QuotaParte);
							//console.info('NDaysSosp -> ', vm.record.NDaysSosp);
							//console.info('ImportoTeorico -> ', vm.record.ImportoTeorico);

							return vm;
						});
					}
				});
			}
		}

		function destinatarioIndennita_changePresaIncarico(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'DestinatarioIndennita';

			return $http.put(urlAPI + '/' + objName + '/ChangePresaIncarico?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed destinatarioIndennita_changePresaIncarico for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion ******************************

		// #region  DESTINATARIO INDENNITA INPS

		function destinatarioIndennitaINPS_setParams(isGet, pageSize, page, order, testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof destIndennitaId == 'undefined') { destIndennitaId = 0; }
			if (typeof destIndINPSExportId == 'undefined') { destIndINPSExportId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof ospitanteId == 'undefined') { ospitanteId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'destIndennitaId', value: destIndennitaId });
			params.push({ name: 'destIndINPSExportId', value: destIndINPSExportId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'ospitanteId', value: ospitanteId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function destinatarioIndennitaINPS_getAllList(testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato) {
			var params = destinatarioIndennitaINPS_setParams(false, 0, 0, '', testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPS', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function destinatarioIndennitaINPS_getAll(pageSize, page, testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato, order) {
			var params = destinatarioIndennitaINPS_setParams(true, pageSize, page, order, testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPS', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function destinatarioIndennitaINPS_countAll(testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato) {
			var params = destinatarioIndennitaINPS_setParams(false, 0, 0, '', testuale, destIndennitaId, destIndINPSExportId, destinatarioId, tirocinioId, cpiId, promotoreId, ospitanteId, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPS', 'CountByFilter', params);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_get(id) {
			var data = getById('destinatarioIndennitaINPS', id);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_add(item) {
			var data = addObj('destinatarioIndennitaINPS', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_update(item) {
			var data = updateObj('destinatarioIndennitaINPS', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_merge(item) {
			var data = mergeObj('destinatarioIndennitaINPS', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_delete(id) {
			var data = deleteObj('destinatarioIndennitaINPS', id);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_changeStatus(id, status) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof status == 'undefined') { status = ''; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'status', value: status });

			var data = getAllByParams('destinatarioIndennitaINPS', 'ChangeStatus', params);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_create(destinatarioIndennitaId) {
			var data = getAllByParam('destinatarioIndennitaINPS', 'Create', 'destinatarioIndennitaId', destinatarioIndennitaId);
			return $q.when(data);
		}

		function destinatarioIndennitaINPS_writeXML(mese, anno, items) {
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }

			var params = [];
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });

			var data = postMethodHibryd('destinatarioIndennitaINPS', 'WriteXML', params, items);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  DESTINATARIO INDENNITA INPS EXPORT

		function destinatarioIndennitaINPSExport_setParams(isGet, pageSize, page, order, testuale, cpiId, iExport, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iExport == 'undefined') { iExport = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iExport', value: iExport });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function destinatarioIndennitaINPSExport_getAllList(testuale, cpiId, iExport, mese, anno, iStato) {
			var params = destinatarioIndennitaINPSExport_setParams(false, 0, 0, '', testuale, cpiId, iExport, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPSExport', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function destinatarioIndennitaINPSExport_getAll(pageSize, page, testuale, cpiId, iExport, mese, anno, iStato, order) {
			var params = destinatarioIndennitaINPSExport_setParams(true, pageSize, page, order, testuale, cpiId, iExport, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPSExport', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function destinatarioIndennitaINPSExport_countAll(testuale, cpiId, iExport, mese, anno, iStato) {
			var params = destinatarioIndennitaINPSExport_setParams(false, 0, 0, '', testuale, cpiId, iExport, mese, anno, iStato);
			var data = getAllByParams('destinatarioIndennitaINPSExport', 'CountByFilter', params);
			return $q.when(data);
		}
		function destinatarioIndennitaINPSExport_restore(id) {
			var data = getAllByParam('destinatarioIndennitaINPSExport', 'RestoreByProc', 'id', id);
			return $q.when(data);
		}

		function destinatarioIndennitaINPSExport_get(id) {
			var data = getById('destinatarioIndennitaINPSExport', id);
			return $q.when(data);
		}

		function destinatarioIndennitaINPSExport_add(item) {
			var data = addObj('destinatarioIndennitaINPSExport', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPSExport_update(item) {
			var data = updateObj('destinatarioIndennitaINPSExport', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPSExport_merge(item) {
			var data = mergeObj('destinatarioIndennitaINPSExport', item);
			return $q.when(data);
		}

		function destinatarioIndennitaINPSExport_delete(id) {
			var data = deleteObj('destinatarioIndennitaINPSExport', id);
			return $q.when(data);
		}

		// #endregion ******************************

		// #region  PERCORSO MISURA

		function percorsoMisura_getAll(testuale, tMisuraCode) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });

			var data = getAllByParams('percorsoMisura', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function percorsoMisura_get(id) {
			var data = getById('percorsoMisura', id);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  PERCORSI LEP UCS

		function percorsiLEPUCS_getAll(code, percorsi, lep, tipologia, modalita, tContrattoCode) {
			if (typeof code == 'undefined') { code = ''; }
			if (typeof percorsi == 'undefined') { percorsi = ''; }
			if (typeof lep == 'undefined') { lep = ''; }
			if (typeof tipologia == 'undefined') { tipologia = ''; }
			if (typeof modalita == 'undefined') { modalita = ''; }
			if (typeof tContrattoCode == 'undefined') { tContrattoCode = ''; }

			var params = [];
			params.push({ name: 'code', value: code });
			params.push({ name: 'percorsi', value: percorsi });
			params.push({ name: 'lep', value: lep });
			params.push({ name: 'tipologia', value: tipologia });
			params.push({ name: 'modalita', value: modalita });
			params.push({ name: 'tContrattoCode', value: tContrattoCode });

			var data = getAllByParams('percorsiLEPUCS', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function percorsiLEPUCS_countAll(code, percorsi, lep, tipologia, modalita, tContrattoCode) {
			if (typeof code == 'undefined') { code = ''; }
			if (typeof percorsi == 'undefined') { percorsi = ''; }
			if (typeof lep == 'undefined') { lep = ''; }
			if (typeof tipologia == 'undefined') { tipologia = ''; }
			if (typeof modalita == 'undefined') { modalita = ''; }
			if (typeof tContrattoCode == 'undefined') { tContrattoCode = ''; }

			var params = [];
			params.push({ name: 'code', value: code });
			params.push({ name: 'percorsi', value: percorsi });
			params.push({ name: 'lep', value: lep });
			params.push({ name: 'tipologia', value: tipologia });
			params.push({ name: 'modalita', value: modalita });
			params.push({ name: 'tContrattoCode', value: tContrattoCode });

			var data = getAllByParams('percorsiLEPUCS', 'CountByFilter', params);
			return $q.when(data);
		}

		function percorsiLEPUCS_get(id) {
			var data = getById('percorsiLEPUCS', id);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  PERCORSI LEP ECONOMIE

		function percorsiLEPEconomie_getAll(anno, lep, percorso, typeCode) {
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof lep == 'undefined') { lep = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof typeCode == 'undefined') { typeCode = ''; }

			var params = [];
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'lep', value: lep });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'typeCode', value: typeCode });

			var data = getAllByParams('percorsiLEPEconomie', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function percorsiLEPEconomie_countAll(anno, lep, percorso, typeCode) {
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof lep == 'undefined') { lep = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof typeCode == 'undefined') { typeCode = ''; }

			var params = [];
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'lep', value: lep });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'typeCode', value: typeCode });

			var data = getAllByParams('percorsiLEPEconomie', 'CountByFilter', params);
			return $q.when(data);
		}

		function percorsiLEPEconomie_get(id) {
			var data = getById('percorsiLEPEconomie', id);
			return $q.when(data);
		}


		// #endregion ******************************

		// #region  DESTINATARIO MISURA

		function destMisura_setParams(pageSize, page, testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof iFase == 'undefined') { iFase = 0; }
			if (typeof tSourceRefId == 'undefined') { tSourceRefId = 0; }
			if (typeof sourceRefId == 'undefined') { sourceRefId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof tProfiloANPALId == 'undefined') { tProfiloANPALId = 0; }
			if (typeof rinunciaCPIId == 'undefined') { rinunciaCPIId = 0; }
			if (typeof dt1 == 'undefined') { dt1 = ''; }
			if (typeof dt2 == 'undefined') { dt2 = ''; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'iFase', value: iFase });
			params.push({ name: 'tSourceRefId', value: tSourceRefId });
			params.push({ name: 'sourceRefId', value: sourceRefId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'tProfiloANPALId', value: tProfiloANPALId });
			params.push({ name: 'rinunciaCPIId', value: rinunciaCPIId });
			params.push({ name: 'dt1', value: dt1 });
			params.push({ name: 'dt2', value: dt2 });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function destMisura_getAllList(testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato) {
			var params = destMisura_setParams(0, 0, testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato, '', false);

			var data = getAllByParams('destinatarioMisura', 'GetAllListByFilter', params);
			return $q.when(data);
		}

		function destMisura_getAll(pageSize, page, testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato, order) {
			var params = destMisura_setParams(pageSize, page, testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato, order, true);

			var data = getAllByParams('destinatarioMisura', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function destMisura_countAll(testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato) {
			var params = destMisura_setParams(0, 0, testuale, iFase, tSourceRefId, sourceRefId, destinatarioId, codiceFiscale, tMisuraCode, aplId, cpiId, tProfiloANPALId, rinunciaCPIId, dt1, dt2, mese, anno, iStato, '', false);

			var data = getAllByParams('destinatarioMisura', 'CountByFilter', params);
			return $q.when(data);
		}

		function destMisura_get(id) {
			var data = getById('destinatarioMisura', id);
			return $q.when(data);
		}

		function destMisura_add(item) {
			var data = addObj('destinatarioMisura', item);
			return $q.when(data);
		}

		function destMisura_update(item) {
			var data = updateObj('destinatarioMisura', item);
			return $q.when(data);
		}

		function destMisura_merge(item) {
			var data = mergeObj('destinatarioMisura', item);
			return $q.when(data);
		}

		function destMisura_delete(id) {
			var data = deleteObj('destinatarioMisura', id);
			return $q.when(data);
		}

		function destMisura_assign(item) {
			var data = postMethod('destinatarioMisura', 'Assign', item);
			return $q.when(data);
		}

		function destMisura_sendEmail(destMisuraId) {
			if (typeof destMisuraId == 'undefined') { destMisuraId = 0; }

			var params = [];
			params.push({ name: 'destMisuraId', value: destMisuraId });

			var data = getAllByParams('destinatarioMisura', 'SendEmail', params);
			return $q.when(data);
		}

		function destMisura_setConvalida(item, status) {
			if (typeof status == 'undefined') { status = ''; }

			var params = [];
			params.push({ name: 'status', value: status });

			var data = postMethodHibryd('destinatarioMisura', 'SetConvalida', params, item);
			return $q.when(data);
		}

		function destMisura_setRinuncia(item) {
			var objName = 'destinatarioMisura';

			return $http.put(urlAPI + '/' + objName + '/SetRinuncia', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed destMisura_setRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function destMisura_unsetRinuncia(destMisuraId) {
			if (typeof destMisuraId == 'undefined') { destMisuraId = 0; }

			var url = urlAPI + '/destinatarioMisura/UnsetRinuncia?destMisuraId=' + destMisuraId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed destMisura_unsetRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}

		function destMisura_exist(destMisId, tMisuraCode, aplId, codiceFiscale, dtPdSNew) {
			if (typeof destMisId == 'undefined') { destMisId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof dtPdSNew == 'undefined') { dtPdSNew = ''; }

			var params = [];
			params.push({ name: 'destMisId', value: destMisId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'dtPdSNew', value: dtPdSNew });

			var data = getAllByParams('destinatarioMisura', 'Exist', params);
			return $q.when(data);
		}

		function destMisura_status(tMisuraCode, aziendaId, codiceFiscale) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('destinatarioMisura', 'Status', params);
			return $q.when(data);
		}

		function destMisura_changeState(destMisuraId, state, dtEnd) {
			if (typeof destMisuraId == 'undefined') { destMisuraId = 0; }
			if (typeof state == 'undefined') { state = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }

			var params = [];
			params.push({ name: 'destMisuraId', value: destMisuraId });
			params.push({ name: 'state', value: state });
			params.push({ name: 'dtEnd', value: dtEnd });

			var data = getAllByParams('destinatarioMisura', 'ChangeState', params);
			return $q.when(data);
		}


		function destMisura_setDecaduto(destMisuraId) {
			if (typeof destMisuraId == 'undefined') { destMisuraId = 0; }

			var url = urlAPI + '/destinatarioMisura/SetDecaduto?destMisuraId=' + destMisuraId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed destMisura_setDecaduto for %s: %s', objName, message);
					return message.status;
				});
		}

		function destMisura_unsetDecaduto(destMisuraId) {
			if (typeof destMisuraId == 'undefined') { destMisuraId = 0; }

			var url = urlAPI + '/destinatarioMisura/UnsetDecaduto?destMisuraId=' + destMisuraId;
			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed destMisura_unsetDecaduto for %s: %s', objName, message);
					return message.status;
				});
		}



		// #endregion ******************************

		// #region  DESTINATARIO PROFILING
		function destProfiling_setParams(isGet, pageSize, page, order, nominativo, codiceFiscale, dtProfiling, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof dtProfiling == 'undefined') { dtProfiling = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'dtProfiling', value: dtProfiling });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function destProfiling_getAllList(nominativo, codiceFiscale, dtProfiling, iStato) {
			var params = destProfiling_setParams(false, 0, 0, '', nominativo, codiceFiscale, dtProfiling, iStato);
			var data = getAllByParams('destinatarioProfiling', 'getAllList', params);
			return $q.when(data);
		}
		function destProfiling_getAll(pageSize, page, nominativo, codiceFiscale, dtProfiling, iStato, order) {
			var params = destProfiling_setParams(true, pageSize, page, order, nominativo, codiceFiscale, dtProfiling, iStato);
			var data = getAllByParams('destinatarioProfiling', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function destProfiling_countAll(nominativo, codiceFiscale, dtProfiling, iStato) {
			var params = destProfiling_setParams(false, 0, 0, '', nominativo, codiceFiscale, dtProfiling, iStato);
			var data = getAllByParams('destinatarioProfiling', 'CountByFilter', params);
			return $q.when(data);
		}

		function destProfiling_getAllByDestinatario(codiceFiscale) {
			var params = destProfiling_setParams(true, 0, 0, '', '', codiceFiscale, '', 0);
			var data = getAllByParams('destinatarioProfiling', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function destProfiling_get(id) {
			var data = getById('destinatarioProfiling', id);
			return $q.when(data);
		}

		function destProfiling_add(item) {
			var data = addObj('destinatarioProfiling', item);
			return $q.when(data);
		}

		function destProfiling_update(item) {
			var data = updateObj('destinatarioProfiling', item);
			return $q.when(data);
		}

		function destProfiling_delete(id) {
			console.log("deletedestProfiling(%s)", id);

			var data = deleteObj('destinatarioProfiling', id);
			return $q.when(data);
		}

		function destProfiling_unlock(item) {
			var objName = 'destinatarioProfiling';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function destProfiling_print(destProfilingId) {
			if (typeof destProfilingId == 'undefined') { destProfilingId = 0; }

			var params = [];
			params.push({ name: 'destProfilingId', value: destProfilingId });

			var data = getAllByParams('PDF', 'DestinatarioProfiling_PrintAll', params);
			return $q.when(data);
		}

		// #endregion

		// #region HTML TEMPLATES

		//*********************************
		// HTMLTEMPLATE 
		//*********************************
		function htmlTemplate_setParams(isGet, pageSize, page, order, testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof controllerCandidatura == 'undefined') { controllerCandidatura = ''; }
			if (typeof iTCandidatura == 'undefined') { iTCandidatura = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'controllerCandidatura', value: controllerCandidatura });
			params.push({ name: 'iTCandidatura', value: iTCandidatura });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function htmlTemplate_getAllList(testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato) {
			var params = htmlTemplate_setParams(false, 0, 0, '', testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato);
			var data = getAllByParams('HtmlTemplate', 'GetAllList', params);
			return $q.when(data);
		}
		function htmlTemplate_getAll(pageSize, page, testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato, order) {
			var params = htmlTemplate_setParams(true, pageSize, page, order, testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato);
			var data = getAllByParams('HtmlTemplate', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function htmlTemplate_countAll(testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato) {
			var params = htmlTemplate_setParams(false, 0, 0, '', testuale, code, tMisuraCode, progettoId, controllerCandidatura, iTCandidatura, iFinestra, iStato);
			var data = getAllByParams('HtmlTemplate', 'CountByFilter', params);
			return $q.when(data);
		}

		function htmlTemplate_get(id) {
			var data = getById('HtmlTemplate', id);
			return $q.when(data);
		}

		function htmlTemplate_add(item) {
			var data = addObj('HtmlTemplate', item);
			return $q.when(data);
		}

		function htmlTemplate_update(item) {
			var data = updateObj('HtmlTemplate', item);
			return $q.when(data);
		}

		function htmlTemplate_merge(item) {
			var data = mergeObj('HtmlTemplate', item);
			return $q.when(data);
		}

		function htmlTemplate_delete(id) {
			var data = deleteObj('HtmlTemplate', id);
			return $q.when(data);
		}

		// #endregion

		// #region DIARIO DI BORDO
		//*********************************
		function diario_setParams(isGet, pageSize, page, order, testuale, risorsaId, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function diario_getAllList(testuale, risorsaId, mese, anno, iStato) {
			var params = diario_setParams(false, 0, 0, '', testuale, risorsaId, mese, anno, iStato);
			var data = getAllByParams('DiarioDiBordo', 'GetAllList', params);
			return $q.when(data);
		}
		function diario_getAll(pageSize, page, testuale, risorsaId, mese, anno, iStato, order) {
			var params = diario_setParams(true, pageSize, page, order, testuale, risorsaId, mese, anno, iStato);
			var data = getAllByParams('DiarioDiBordo', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function diario_countAll(testuale, risorsaId, mese, anno, iStato) {
			var params = diario_setParams(false, 0, 0, '', testuale, risorsaId, mese, anno, iStato);
			var data = getAllByParams('DiarioDiBordo', 'CountByFilter', params);
			return $q.when(data);
		}

		function diario_get(id) {
			var data = getById('DiarioDiBordo', id);
			return $q.when(data);
		}

		function diario_update(item) {
			var data = updateObj('DiarioDiBordo', item);
			return $q.when(data);
		}

		function diario_add(item) {
			var data = addObj('DiarioDiBordo', item);
			return $q.when(data);
		}

		function diario_delete(id) {
			var data = deleteObj('DiarioDiBordo', id);
			return $q.when(data);
		}

		function diario_changeState(item) {
			var objName = 'DiarioDiBordo';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed sentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function diario_unlock(item) {
			var objName = 'DiarioDiBordo';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion *********************************

		// #region DIARIO DI BORDO DTL
		//*********************************
		function diarioDtl_setParams(isGet, pageSize, page, order, testuale, diariodibordoId, data) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof diariodibordoId == 'undefined') { diariodibordoId = 0; }
			if (typeof data == 'undefined') { data = ''; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'diariodibordoId', value: diariodibordoId });
			params.push({ name: 'data', value: data });

			return params;
		}
		function diarioDtl_getAll(pageSize, page, testuale, diariodibordoId, data, order) {
			var params = diarioDtl_setParams(true, pageSize, page, order, testuale, diariodibordoId, data);
			var data = getAllByParams('DiarioDiBordoDtl', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function diarioDtl_countAll(testuale, diariodibordoId, data) {
			var params = diarioDtl_setParams(false, 0, 0, '', testuale, diariodibordoId, data);
			var data = getAllByParams('DiarioDiBordoDtl', 'CountByFilter', params);
			return $q.when(data);

		}

		function diarioDtl_get(id) {
			var data = getById('DiarioDiBordoDtl', id);
			return $q.when(data);
		}

		function diarioDtl_update(item) {
			var data = updateObj('DiarioDiBordoDtl', item);
			return $q.when(data);
		}

		function diarioDtl_add(item) {
			var data = addObj('DiarioDiBordoDtl', item);
			return $q.when(data);
		}

		function diarioDtl_delete(id) {
			console.log("diariodibordoDtl(%s)", id);

			var data = deleteObj('DiarioDiBordoDtl', id);
			return $q.when(data);
		}

		function diarioDtl_createPdf(objValue) {
			var objName = 'DiarioDiBordoDtl';
			return $http.post(urlAPI + '/' + objName + '/CreatePdf', objValue)
				.then(function (data) {
					return data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function diarioDtl_saveSheet(objValue) {
			var objName = 'DiarioDiBordoDtl';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (data) {
					console.info(data);
					return data;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion *********************************


		//*********************************
		//CHECKLISTMODEL
		function checkListModel_getList(testuale, code, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModel', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListModel_getAll(pageSize, page, testuale, code, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = 'source'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('checkListModel', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListModel_countAll(testuale, code, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'code', value: code });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModel', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListModel_get(id) {
			var data = getById('checkListModel', id);
			return $q.when(data);
		}

		function checkListModel_getByCode(code) {
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'code', value: code });

			var data = getAllByParams('checkListModel', 'GetByCode', params);
			return $q.when(data);
		}

		function checkListModel_add(item) {
			var data = addObj('checkListModel', item);
			return $q.when(data);
		}

		function checkListModel_update(item) {
			var data = updateObj('checkListModel', item);
			return $q.when(data);
		}

		function checkListModel_delete(id) {
			var data = deleteObj('checkListModel', id);
			return $q.when(data);
		}

		function checkListModel_generaRevisione(id) {
			if (typeof (id) == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('checkListModel', 'GeneraRevisione', params);
			return $q.when(data);
		}

		function checkListModel_clona(id) {
			if (typeof (id) == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('checkListModel', 'Clona', params);
			return $q.when(data);
		}

		function checkListModel_setCompleted(item) {
			var objName = 'checkListModel';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function checkListModel_unsetCompleted(item) {
			var objName = 'checkListModel';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed unsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		// #region ************ CHECKLIST **********

		//CHECKLISTMODELDTL
		function checkListModelDtl_getList(testuale, checkListModelId, iteratorGroup, entityCode, code, type, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof iteratorGroup == 'undefined') { iteratorGroup = 0; }
			if (typeof entityCode == 'undefined') { entityCode = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof type == 'undefined') { type = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'iteratorGroup', value: iteratorGroup });
			params.push({ name: 'entityCode', value: entityCode });
			params.push({ name: 'code', value: code });
			params.push({ name: 'type', value: type });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModelDtl', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListModelDtl_getAll(pageSize, page, testuale, checkListModelId, iteratorGroup, entityCode, code, type, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof iteratorGroup == 'undefined') { iteratorGroup = 0; }
			if (typeof entityCode == 'undefined') { entityCode = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof type == 'undefined') { type = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = 'source'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'iteratorGroup', value: iteratorGroup });
			params.push({ name: 'entityCode', value: entityCode });
			params.push({ name: 'code', value: code });
			params.push({ name: 'type', value: type });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('checkListModelDtl', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListModelDtl_countAll(testuale, checkListModelId, iteratorGroup, entityCode, code, type, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof iteratorGroup == 'undefined') { iteratorGroup = 0; }
			if (typeof entityCode == 'undefined') { entityCode = ''; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof type == 'undefined') { type = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'iteratorGroup', value: iteratorGroup });
			params.push({ name: 'entityCode', value: entityCode });
			params.push({ name: 'code', value: code });
			params.push({ name: 'type', value: type });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModelDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListModelDtl_get(id) {
			var data = getById('checkListModelDtl', id);
			return $q.when(data);
		}

		function checkListModelDtl_add(item) {
			var data = addObj('checkListModelDtl', item);
			return $q.when(data);
		}

		function checkListModelDtl_update(item) {
			var data = updateObj('checkListModelDtl', item);
			return $q.when(data);
		}

		function checkListModelDtl_delete(id) {
			var data = deleteObj('checkListModelDtl', id);
			return $q.when(data);
		}

		function checkListModelDtl_setGroup(elencoDomande) {
			var objName = 'checkListModelDtl';

			return $http.put(urlAPI + '/' + objName + '/SetGroup', elencoDomande)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setGroup for %s: %s', objName, message);
					return message.status;
				});
		}

		//CHECKLISTMODELDTLACTION
		function checkListModelDtlAction_setParams(isGet, pageSize, page, order, testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }

			if (typeof modelDtlId == 'undefined') { modelDtlId = 0; }

			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			if (typeof tSourceRefCode == 'undefined') { tSourceRefCode = ''; }
			if (typeof sourceRefId == 'undefined') { sourceRefId = 0; }

			if (typeof tSourceActionCode == 'undefined') { tSourceActionCode = ''; }
			if (typeof sourceActionId == 'undefined') { sourceActionId = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelDtlId', value: modelDtlId });

			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			params.push({ name: 'tSourceRefCode', value: tSourceRefCode });
			params.push({ name: 'sourceRefId', value: sourceRefId });

			params.push({ name: 'tSourceActionCode', value: tSourceActionCode });
			params.push({ name: 'sourceActionId', value: sourceActionId });

			return params;
		}

		function checkListModelDtlAction_getList(testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			var params = checkListModelDtlAction_setParams(false, 0, 0, '', testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListModelDtlAction', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListModelDtlAction_getAll(pageSize, page, testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId, order) {
			var params = checkListModelDtlAction_setParams(true, pageSize, page, order, testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListModelDtlAction', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListModelDtlAction_countAll(testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			var params = checkListModelDtlAction_setParams(false, 0, 0, '', testuale, modelDtlId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListModelDtlAction', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListModelDtlAction_get(id) {
			var data = getById('checkListModelDtlAction', id);
			return $q.when(data);
		}

		function checkListModelDtlAction_add(item) {
			var data = addObj('checkListModelDtlAction', item);
			return $q.when(data);
		}

		function checkListModelDtlAction_update(item) {
			var data = updateObj('checkListModelDtlAction', item);
			return $q.when(data);
		}

		function checkListModelDtlAction_delete(id) {
			var data = deleteObj('checkListModelDtlAction', id);
			return $q.when(data);
		}

		//*********************************
		//CHECKLIST
		function checkList_setParams(isPaging, pageSize, page, order, testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'source'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof modelId == 'undefined') { modelId = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelId', value: modelId });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function checkList_getList(testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato) {
			var params = checkList_setParams(false, 0, 0, '', testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkList', 'GetAllList', params);
			return $q.when(data);
		}
		function checkList_getAll(pageSize, page, testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato, order) {
			var params = checkList_setParams(true, pageSize, page, order, testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkList', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function checkList_countAll(testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato) {
			var params = checkList_setParams(false, 0, 0, '', testuale, modelId, modelCode, tSourceCode, sourceId, cpiId, anno, mese, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkList', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkList_exists(modelId, tSourceCode, sourceId, dtControllo, id) {
			if (typeof modelId == 'undefined') { modelId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof dtControllo == 'undefined') { dtControllo = ''; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'modelId', value: modelId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'dtControllo', value: dtControllo });
			params.push({ name: 'id', value: id });

			var data = getAllByParams('checkList', 'Exists', params);
			return $q.when(data);
		}

		function checkList_get(id) {
			var data = getById('checkList', id);
			return $q.when(data);
		}

		function checkList_add(item) {
			var data = addObj('checkList', item);
			return $q.when(data);
		}

		function checkList_make(item) {

			var objName = 'checkList';

			return $http.put(urlAPI + '/' + objName + '/MakeChecklist', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed MakeChecklist for %s: %s', objName, message);
					return message.status;
				});
		}

		function checkList_update(item) {
			var data = updateObj('checkList', item);
			return $q.when(data);
		}

		function checkList_delete(id) {
			var data = deleteObj('checkList', id);
			return $q.when(data);
		}

		function checkList_unlock(item) {
			var objName = 'checkList';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function checklist_unlockSent(item) {
			var objName = 'checkList';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed checklist_unlockSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function checkList_unsetPresaIncarico(item) {
			var objName = 'checkList';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed removeObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function checklist_print(item) {
			var objName = 'PDF';
			//return $http.put(urlAPI + '/' + objName + '/ChecklistPrintSelection', item, { responseType: 'arraybuffer' })
			return $http.put(urlAPI + '/' + objName + '/ChecklistPrintSelection', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed ChecklistPrintSelection for %s: %s', objName, message);
					return message.status;
				});
		}

		//*********************************
		//CHECKLISTDTL
		function checkListDtl_setParams(isPaging, pageSize, page, order, testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'source'; }
			}

			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof modelDtlId == 'undefined') { modelDtlId = 0; }
			if (typeof checkListId == 'undefined') { checkListId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}

			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelDtlId', value: modelDtlId });
			params.push({ name: 'checkListId', value: checkListId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function checkListDtl_getList(testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato) {
			var params = checkListDtl_setParams(false, 0, 0, '', testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkListDtl', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListDtl_getAll(pageSize, page, testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato, order) {
			var params = checkListDtl_setParams(true, pageSize, page, order, testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkListDtl', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListDtl_countAll(testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato) {
			var params = checkListDtl_setParams(false, 0, 0, '', testuale, modelDtlId, checkListId, sourceId, dtStart, dtEnd, iStato);
			var data = getAllByParams('checkListDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListDtl_get(id) {
			var data = getById('checkListDtl', id);
			return $q.when(data);
		}

		function checkListDtl_add(item) {
			var data = addObj('checkListDtl', item);
			return $q.when(data);
		}

		function checkListDtl_update(item) {
			var data = updateObj('checkListDtl', item);
			return $q.when(data);
		}

		function checkListDtl_updateAllList(item) {
			var objName = 'checkListDtl';

			return $http.put(urlAPI + '/' + objName + '/ChecklistDtlUpdateAllList', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function checkListDtl_delete(id) {
			var data = deleteObj('checkListDtl', id);
			return $q.when(data);
		}


		//CHECKLISTMODELDTLACTION
		function checkListDtlAction_setParams(isGet, pageSize, page, order, testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }

			if (typeof CLDtlId == 'undefined') { CLDtlId = 0; }
			if (typeof modelDtlActionId == 'undefined') { modelDtlActionId = 0; }

			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			if (typeof tSourceRefCode == 'undefined') { tSourceRefCode = ''; }
			if (typeof sourceRefId == 'undefined') { sourceRefId = 0; }

			if (typeof tSourceActionCode == 'undefined') { tSourceActionCode = ''; }
			if (typeof sourceActionId == 'undefined') { sourceActionId = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'CLDtlId', value: CLDtlId });
			params.push({ name: 'modelDtlActionId', value: modelDtlActionId });

			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			params.push({ name: 'tSourceRefCode', value: tSourceRefCode });
			params.push({ name: 'sourceRefId', value: sourceRefId });

			params.push({ name: 'tSourceActionCode', value: tSourceActionCode });
			params.push({ name: 'sourceActionId', value: sourceActionId });

			return params;
		}

		function checkListDtlAction_getList(testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			var params = checkListDtlAction_setParams(false, 0, 0, '', testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListDtlAction', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListDtlAction_getAll(pageSize, page, testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId, order) {
			var params = checkListDtlAction_setParams(true, pageSize, page, order, testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListDtlAction', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListDtlAction_countAll(testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId) {
			var params = checkListDtlAction_setParams(false, 0, 0, '', testuale, CLDtlId, modelDtlActionId, tSourceCode, sourceId, tSourceRefCode, sourceRefId, tSourceActionCode, sourceActionId);
			var data = getAllByParams('checkListDtlAction', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListDtlAction_get(id) {
			var data = getById('checkListDtlAction', id);
			return $q.when(data);
		}

		function checkListDtlAction_add(item) {
			var data = addObj('checkListDtlAction', item);
			return $q.when(data);
		}

		function checkListDtlAction_update(item) {
			var data = updateObj('checkListDtlAction', item);
			return $q.when(data);
		}

		function checkListDtlAction_delete(id) {
			var data = deleteObj('checkListDtlAction', id);
			return $q.when(data);
		}

		function checkListDtlAction_saveAll(objValue) {
			var objName = 'checkListDtlAction';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		//*********************************
		//CHECKLISTHDR
		function checkListHdr_getList(testuale, modelHdrId, checkListId, refValue, modelCode, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof modelHdrId == 'undefined') { modelHdrId = 0; }
			if (typeof checkListId == 'undefined') { checkListId = 0; }
			if (typeof refValue == 'undefined') { refValue = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelHdrId', value: modelHdrId });
			params.push({ name: 'checkListId', value: checkListId });
			params.push({ name: 'refValue', value: refValue });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListHdr', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListHdr_getAll(pageSize, page, testuale, modelHdrId, checkListId, refValue, modelCode, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof modelHdrId == 'undefined') { modelHdrId = 0; }
			if (typeof checkListId == 'undefined') { checkListId = 0; }
			if (typeof refValue == 'undefined') { refValue = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = 'source'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelHdrId', value: modelHdrId });
			params.push({ name: 'checkListId', value: checkListId });
			params.push({ name: 'refValue', value: refValue });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('checkListHdr', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListHdr_countAll(testuale, modelHdrId, checkListId, refValue, modelCode, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof modelHdrId == 'undefined') { modelHdrId = 0; }
			if (typeof checkListId == 'undefined') { checkListId = 0; }
			if (typeof refValue == 'undefined') { refValue = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'modelHdrId', value: modelHdrId });
			params.push({ name: 'checkListId', value: checkListId });
			params.push({ name: 'refValue', value: refValue });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListHdr', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListHdr_get(id) {
			var data = getById('checkListHdr', id);
			return $q.when(data);
		}

		function checkListHdr_add(item) {
			var data = addObj('checkListHdr', item);
			return $q.when(data);
		}

		function checkListHdr_update(item) {
			var data = updateObj('checkListHdr', item);
			return $q.when(data);
		}

		function checkListHdr_updateAllList(item) {
			var objName = 'checkListHdr';

			return $http.put(urlAPI + '/' + objName + '/checkListHdrUpdateAllList', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function checkListHdr_delete(id) {
			var data = deleteObj('checkListHdr', id);
			return $q.when(data);
		}

		//*********************************
		//CHECKLISTMODELHDR
		function checkListModelHdr_getList(testuale, checkListModelId, orderItem, iVisibility, modelCode, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof orderItem == 'undefined') { orderItem = 0; }
			if (typeof iVisibility == 'undefined') { iVisibility = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'orderItem', value: orderItem });
			params.push({ name: 'iVisibility', value: iVisibility });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModelHdr', 'GetAllList', params);
			return $q.when(data);
		}

		function checkListModelHdr_getAll(pageSize, page, testuale, checkListModelId, orderItem, iVisibility, modelCode, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof orderItem == 'undefined') { orderItem = 0; }
			if (typeof iVisibility == 'undefined') { iVisibility = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = 'source'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'orderItem', value: orderItem });
			params.push({ name: 'iVisibility', value: iVisibility });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('checkListModelHdr', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function checkListModelHdr_countAll(testuale, checkListModelId, orderItem, iVisibility, modelCode, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof checkListModelId == 'undefined') { checkListModelId = 0; }
			if (typeof orderItem == 'undefined') { orderItem = 0; }
			if (typeof iVisibility == 'undefined') { iVisibility = 0; }
			if (typeof modelCode == 'undefined') { modelCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'checkListModelId', value: checkListModelId });
			params.push({ name: 'orderItem', value: orderItem });
			params.push({ name: 'iVisibility', value: iVisibility });
			params.push({ name: 'modelCode', value: modelCode });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('checkListModelHdr', 'CountByFilter', params);
			return $q.when(data);
		}

		function checkListModelHdr_get(id) {
			var data = getById('checkListModelHdr', id);
			return $q.when(data);
		}

		function checkListModelHdr_add(item) {
			var data = addObj('checkListModelHdr', item);
			return $q.when(data);
		}

		function checkListModelHdr_update(item) {
			var data = updateObj('checkListModelHdr', item);
			return $q.when(data);
		}

		function checkListModelHdr_delete(id) {
			var data = deleteObj('checkListModelHdr', id);
			return $q.when(data);
		}

		function pdf_getChecklist(checklistId, code) {
			if (typeof checklistId == 'undefined') { checklistId = 0; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'checklistId', value: checklistId });
			params.push({ name: 'code', value: code });

			var data = getArrayBufferByParams('pdf', 'GetChecklist', params);
			return $q.when(data);
		}

		// #endregion **************************************************

		// #region --VALIDAZIONE CF E IBAN
		function validazione_cf(codiceFiscale, isEnte) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof isEnte == 'undefined') { isEnte = false; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'isEnte', value: isEnte });

			var data = getAllByParams('Validazione', 'GetValidCF', params);
			return $q.when(data);
		}

		function validazione_piva(piva) {
			if (typeof piva == 'undefined') { piva = ''; }

			var params = [];
			params.push({ name: 'piva', value: piva });

			var data = getAllByParams('Validazione', 'GetValidPIVA', params);
			return $q.when(data);
		}

		function validazione_iban(iban) {
			if (typeof iban == 'undefined') { iban = ''; }

			var params = [];
			params.push({ name: 'iban', value: iban });

			var data = getAllByParams('Validazione', 'GetValidIBAN', params);
			return $q.when(data);
		}

		function validazione_fieldsCF(codiceFiscale, nome, cognome, sesso, dtNasc, paeseId, comuneId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof sesso == 'undefined') { sesso = ''; }
			if (typeof dtNasc == 'undefined') { dtNasc = ''; }
			if (typeof paeseId == 'undefined') { paeseId = -1; }
			if (typeof comuneId == 'undefined') { comuneId = -1; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'sesso', value: sesso });
			params.push({ name: 'dtNasc', value: dtNasc });
			params.push({ name: 'paeseId', value: paeseId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('Validazione', 'GetValidFieldsCF', params);
			return $q.when(data);
		}

		function validazione_cfName(codiceFiscale, cognome, nome) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof nome == 'undefined') { nome = ''; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'nome', value: nome });

			var data = getAllByParams('Validazione', 'GetValidCFName', params);
			return $q.when(data);
		}

		function validazione_existUsername(username, email, userId) {
			if (typeof username == 'undefined') { username = ''; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'username', value: username });
			params.push({ name: 'email', value: email });
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('validazione', 'ExistsUsername', params);
			return $q.when(data);
		}

		function validazione_existAzienda(aziendaId, tRuoloCode, profiloCode, tMisuraCode, codiceFiscale, piva) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }

			var params = [];
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'parentId', value: 0 });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });

			var data = getAllByParams('Validazione', 'ExistsAzienda', params);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   AIM - NUOVI METODI
		function aim_setParams(isGet, pageSize, page, order, nominativo, cpiId, aplId, tMisuraCode, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof iStato == 'undefined') { iStato = -1; }


			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function aim_getAllList(nominativo, cpiId, aplId, tMisuraCode, iStato) {
			var params = aim_setParams(false, 0, 0, '', nominativo, cpiId, aplId, tMisuraCode, iStato);
			var data = getAllByParams('aim', 'GetAllList', params);
			return $q.when(data);
		}
		function aim_getAll(pageSize, page, nominativo, cpiId, aplId, tMisuraCode, iStato, order) {
			var params = aim_setParams(true, pageSize, page, order, nominativo, cpiId, aplId, tMisuraCode, iStato);
			var data = getAllByParams('aim', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function aim_countAll(nominativo, cpiId, aplId, tMisuraCode, iStato) {
			var params = aim_setParams(false, 0, 0, '', nominativo, cpiId, aplId, tMisuraCode, iStato);
			var data = getAllByParams('aim', 'CountByFilter', params);
			return $q.when(data);
		}

		function aim_assign(codiceFiscale, cpiId, tMisuraCode) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });

			var data = getAllByParams('aim', 'Assign', params);
			return $q.when(data);
		}

		function aim_status(codiceFiscale, tMisuraCode) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });

			var data = getAllByParams('aim', 'Status', params);
			return $q.when(data);
		}

		function aim_unlock(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_unlockSent(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_setRinuncia(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/SetRinuncia', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_unsetRinuncia(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/UnsetRinuncia', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_unlockProroga(item) {
			return $http.put(urlAPI + '/Aim/UnlockProroga', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockProroga for Aim: %s', message);
					return message.status;
				});
		}


		function aim_get(id) {
			var data = getById('aim', id);
			return $q.when(data);
		}

		function aim_add(item) {
			var data = addObj('aim', item);
			return $q.when(data);
		}

		function aim_update(item) {
			var data = updateObj('aim', item);
			return $q.when(data);
		}

		function aim_merge(item) {
			var data = mergeObj('aim', item);
			return $q.when(data);
		}

		function aim_updateAttivita(item) {
			return $http.put(urlAPI + '/Aim/PutAttivita', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockProroga for Aim: %s', message);
					return message.status;
				});
		}

		function aim_delete(id) {
			var data = deleteObj('aim', id);
			return $q.when(data);
		}

		function aim_unsetPresaIncarico(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_unsetPresaIncaricoCPI(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_setCompleted(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_unsetCompleted(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed unsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function aim_setSent(item) {
			var objName = 'aim';

			return $http.put(urlAPI + '/' + objName + '/SetSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setSent for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region   AIM RIMBORSO - NUOVI METODI

		function aimRmb_setParams(isGet, pageSize, page, order, nominativo, aimId, cpiId, aplId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aimId == 'undefined') { aimId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aimId', value: aimId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function aimRmb_getAllList(nominativo, aimId, cpiId, aplId, iStato) {
			var params = aimRmb_setParams(false, 0, 0, '', nominativo, aimId, cpiId, aplId, iStato);
			var data = getAllByParams('aimRmb', 'GetAllList', params);
			return $q.when(data);
		}
		function aimRmb_getAll(pageSize, page, nominativo, aimId, cpiId, aplId, iStato, order) {
			var params = aimRmb_setParams(true, pageSize, page, order, nominativo, aimId, cpiId, aplId, iStato);
			var data = getAllByParams('aimRmb', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function aimRmb_countAll(nominativo, aimId, cpiId, aplId, iStato) {
			var params = aimRmb_setParams(false, 0, 0, '', nominativo, aimId, cpiId, aplId, iStato);
			var data = getAllByParams('aimRmb', 'CountByFilter', params);
			return $q.when(data);
		}

		function aimRmb_get(id) {
			var data = getById('aimRmb', id);
			return $q.when(data);
		}


		function aimRmb_add(item) {
			var data = addObj('aimRmb', item);
			return $q.when(data);
		}

		function aimRmb_update(item) {
			var data = updateObj('aimRmb', item);
			return $q.when(data);
		}

		function aimRmb_changeState(item) {
			var objName = 'aimRmb';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed sentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aimRmb_updateDatiAssess(item) {
			var objName = 'aimRmb';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aimRmb_delete(id) {
			var data = deleteObj('aimRmb', id);
			return $q.when(data);
		}

		function aimRmb_unlock(item) {
			var objName = 'aimRmb';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aimRmb_unsetPresaIncarico(item) {
			var objName = 'aimRmb';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aimRmb_unsetPresaIncaricoCPI(item) {
			var objName = 'aimRmb';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function aimRmb_unsetIssuePay(item) {
			var objName = 'aimRmb';

			return $http.put(urlAPI + '/' + objName + '/RemoveIssuePay', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region   AIM-SERVIZIO
		function aimServizio_setParams(isGet, pageSize, page, order, descrizione, aimId, tContrattoId, aplId, cpiId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aimId == 'undefined') { aimId = 0; }
			if (typeof tContrattoId == 'undefined') { tContrattoId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aimId', value: aimId });
			params.push({ name: 'tContrattoId', value: tContrattoId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function aimServizio_getAllList(descrizione, aimId, tContrattoId, aplId, cpiId, iStato) {
			var params = aimServizio_setParams(false, 0, 0, '', descrizione, aimId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllByParams('aimServizio', 'GetAllList', params);
			return $q.when(data);
		}
		function aimServizio_getAll(pageSize, page, descrizione, aimId, tContrattoId, aplId, cpiId, iStato, order) {
			var params = aimServizio_setParams(true, pageSize, page, order, descrizione, aimId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllByParams('aimServizio', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function aimServizio_countAll(descrizione, aimId, tContrattoId, aplId, cpiId, iStato) {
			var params = aimServizio_setParams(false, 0, 0, '', descrizione, aimId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllByParams('aimServizio', 'CountByFilter', params);
			return $q.when(data);
		}

		function aimServizio_get(id) {
			var data = getById('aimServizio', id);
			return $q.when(data);
		}

		function aimServizio_add(item) {
			var data = addObj('aimServizio', item);
			return $q.when(data);
		}

		function aimServizio_update(item) {
			var data = updateObj('aimServizio', item);
			return $q.when(data);
		}

		function aimServizio_delete(id) {
			var data = deleteObj('aimServizio', id);
			return $q.when(data);
		}

		function aimServizio_unlock(item) {
			var objName = 'aimServizio';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region -- AIM-SPETTANZE
		function aimSpettanze_getAll(pageSize, page, aplId, cpiId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('aimSpettanze', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function aimSpettanze_countAll(aplId, cpiId) {
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('aimSpettanze', 'CountByFilter', params);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   ASSFORM - MISURA 2C - NUOVI METODI
		function assForm_setParams(isGet, pageSize, page, order, testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof datoreId == 'undefined') { datoreId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }


			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'datoreId', value: datoreId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function assForm_getAllList(testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato) {
			var params = assForm_setParams(false, 0, 0, '', testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato);
			var data = getAllByParams('assForm', 'GetAllList', params);
			return $q.when(data);
		}
		function assForm_getAll(pageSize, page, testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato, order) {
			var params = assForm_setParams(true, pageSize, page, order, testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato);
			var data = getAllByParams('assForm', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function assForm_countAll(testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato) {
			var params = assForm_setParams(false, 0, 0, '', testuale, cpiId, aplId, destinatarioId, datoreId, dt, iStato);
			var data = getAllByParams('assForm', 'CountByFilter', params);
			return $q.when(data);
		}

		function assForm_get(id) {
			var data = getById('assForm', id);
			return $q.when(data);
		}

		function assForm_add(item) {
			var data = addObj('assForm', item);
			return $q.when(data);
		}

		function assForm_update(item) {
			var data = updateObj('assForm', item);
			return $q.when(data);
		}

		function assForm_merge(item) {
			var data = mergeObj('assForm', item);
			return $q.when(data);
		}

		function assForm_delete(id) {
			var data = deleteObj('assForm', id);
			return $q.when(data);
		}

		function assForm_assign(cpiId, aplId, datoreId, codiceFiscale) {
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof datoreId == 'undefined') { datoreId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'datoreId', value: datoreId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('assForm', 'Assign', params);
			return $q.when(data);
		}

		function assForm_status(cpiId, datoreId, codiceFiscale) {
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof datoreId == 'undefined') { datoreId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'datoreId', value: datoreId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('assForm', 'Status', params);
			return $q.when(data);
		}

		function assForm_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'assForm';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function assForm_unlock(item) {
			var objName = 'assForm';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed Unlock for %s: %s', objName, message);
					return message.status;
				});
		}

		function assForm_unlockSent(item) {
			var objName = 'assForm';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnlockSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function assForm_unsetRinuncia(item) {
			var objName = 'assForm';

			return $http.put(urlAPI + '/' + objName + '/UnsetRinuncia', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed UnsetRinuncia for %s: %s', objName, message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   ASSFORM RIMBORSO - MISURA 2C

		function assFormRmb_setParams(isGet, pageSize, page, order, testuale, assFormId, cpiId, aplId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof assFormId == 'undefined') { assFormId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'assFormId', value: assFormId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function assFormRmb_getAllList(testuale, assFormId, cpiId, aplId, iStato) {
			var params = assFormRmb_setParams(false, 0, 0, '', testuale, assFormId, cpiId, aplId, iStato);
			var data = getAllByParams('assFormRmb', 'GetAllList', params);
			return $q.when(data);
		}
		function assFormRmb_getAll(pageSize, page, testuale, assFormId, cpiId, aplId, iStato, order) {
			var params = assFormRmb_setParams(true, pageSize, page, order, testuale, assFormId, cpiId, aplId, iStato);
			var data = getAllByParams('assFormRmb', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function assFormRmb_countAll(testuale, assFormId, cpiId, aplId, iStato) {
			var params = assFormRmb_setParams(false, 0, 0, '', testuale, assFormId, cpiId, aplId, iStato);
			var data = getAllByParams('assFormRmb', 'CountByFilter', params);
			return $q.when(data);
		}

		function assFormRmb_get(id) {
			var data = getById('assFormRmb', id);
			return $q.when(data);
		}


		function assFormRmb_add(item) {
			var data = addObj('assFormRmb', item);
			return $q.when(data);
		}

		function assFormRmb_update(item) {
			var data = updateObj('assFormRmb', item);
			return $q.when(data);
		}

		function assFormRmb_changeState(item) {
			var objName = 'assFormRmb';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed ChangeState for %s: %s', objName, message);
					return message.status;
				});
		}

		function assFormRmb_updateDatiAssess(item) {
			var objName = 'assFormRmb';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed PutDatiAssess for %s: %s', objName, message);
					return message.status;
				});
		}

		function assFormRmb_delete(id) {
			var data = deleteObj('assFormRmb', id);
			return $q.when(data);
		}

		function assFormRmb_unlock(item) {
			var objName = 'assFormRmb';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed Unlock for %s: %s', objName, message);
					return message.status;
				});
		}

		/*
		function assFormRmb_unsetPresaIncarico(item) {
			var objName = 'assFormRmb';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed RemovePresaIncarico for %s: %s', objName, message);
					return message.status;
				});
		}
		*/

		/*
		function assFormRmb_unsetPresaIncaricoCPI(item) {
			var objName = 'assFormRmb';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed RemovePresaIncaricoCPI for %s: %s', objName, message);
					return message.status;
				});
		}
		*/

		/*
		function assFormRmb_unsetIssuePay(item) {
			var objName = 'assFormRmb';

			return $http.put(urlAPI + '/' + objName + '/RemoveIssuePay', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed RemoveIssuePay for %s: %s', objName, message);
					return message.status;
				});
		}
		*/

		// #endregion  *********************************

		// #region  ISSUE-LOG
		function issueLog_getAll(pageSize, page, testuale, tSourceId, sourceId, tDestId, destId, parentId, iState, iRole, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tDestId == 'undefined') { tDestId = 0; }
			if (typeof destId == 'undefined') { destId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof iState == 'undefined') { iState = -2; }
			if (typeof iRole == 'undefined') { iRole = 0; }

			if (typeof order == 'undefined') { order = 'data'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tDestId', value: tDestId });
			params.push({ name: 'destId', value: destId });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iState', value: iState });
			params.push({ name: 'iRole', value: iRole });

			params.push({ name: 'order', value: order });

			var data = getAllByParams('IssueLog', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function issueLog_countAll(testuale, tSourceId, sourceId, tDestId, destId, parentId, iState, iRole) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tDestId == 'undefined') { tDestId = 0; }
			if (typeof destId == 'undefined') { destId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof iState == 'undefined') { iState = -2; }
			if (typeof iRole == 'undefined') { iRole = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tDestId', value: tDestId });
			params.push({ name: 'destId', value: destId });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'iState', value: iState });
			params.push({ name: 'iRole', value: iRole });

			var data = getAllByParams('IssueLog', 'CountByFilter', params);
			return $q.when(data);
		}

		function issueLog_get(id) {
			var data = getById('IssueLog', id);
			return $q.when(data);
		}

		function issueLog_add(item) {
			var data = addObj('IssueLog', item);
			return $q.when(data);
		}

		function issueLog_addMultiplo(list) {
			var objName = 'IssueLog';
			var actionName = 'AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed issueLog_addMultiplo for %s: %s', objName, message);
					return message.status;
				});
		}

		function issueLog_update(item) {
			var data = updateObj('IssueLog', item);
			return $q.when(data);
		}

		function issueLog_delete(id) {
			var data = deleteObj('IssueLog', id);
			return $q.when(data);
		}

		function issueLog_setState(id, iState) {

			if (typeof id == 'undefined') { id = 0; }
			if (typeof iState == 'undefined') { iState = -1; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'iState', value: iState });

			var data = getAllByParams('IssueLog', 'SetState', params);
			return $q.when(data);
		}

		function issueLog_sendEmail(issueLog) {
			var objName = 'IssueLog';

			return $http.put(urlAPI + '/' + objName + '/SendEmail', issueLog)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region  MY LOG

		function myLog_setParams(pageSize, page, testuale, type, anno, mese, dt, dtStart, dtEnd, iStato, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof type == 'undefined') { type = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'type', value: type });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function myLog_getAllList(testuale, type, anno, mese, dt, dtStart, dtEnd, iStato) {
			var params = myLog_setParams(0, 0, testuale, type, anno, mese, dt, dtStart, dtEnd, iStato, '', false);

			var data = getAllByParams('myLog', 'GetAllList', params);
			return $q.when(data);
		}

		function myLog_getAll(pageSize, page, testuale, type, anno, mese, dt, dtStart, dtEnd, iStato, order) {
			var params = myLog_setParams(pageSize, page, testuale, type, anno, mese, dt, dtStart, dtEnd, iStato, order, true);

			var data = getAllByParams('myLog', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function myLog_countAll(testuale, type, anno, mese, dt, dtStart, dtEnd, iStato) {
			var params = myLog_setParams(0, 0, testuale, type, anno, mese, dt, dtStart, dtEnd, iStato, '', false);

			var data = getAllByParams('myLog', 'CountByFilter', params);
			return $q.when(data);
		}

		function myLog_get(id) {
			var data = getById('myLog', id);
			return $q.when(data);
		}

		function myLog_add(item) {
			var data = addObj('myLog', item);
			return $q.when(data);
		}

		function myLog_update(item) {
			var data = updateObj('myLog', item);
			return $q.when(data);
		}

		function myLog_merge(item) {
			var data = mergeObj('myLog', item);
			return $q.when(data);
		}

		function myLog_delete(id) {
			var data = deleteObj('myLog', id);
			return $q.when(data);
		}



		// #endregion  *********************************

		// #region  SAP
		function sap_getAllList(testuale, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_getAll(pageSize, page, testuale, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_countAll(testuale, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_get(id) {
			var data = getById('sap', id);
			return $q.when(data);
		}

		function sap_add(item) {
			var data = addObj('sap', item);
			return $q.when(data);
		}

		function sap_update(item) {
			var data = updateObj('sap', item);
			return $q.when(data);
		}

		function sap_delete(id) {
			var data = deleteObj('sap', id);
			return $q.when(data);
		}

		function sap_writeXML(sapId) {
			if (typeof sapId == 'undefined') { sapId = 0; }

			var params = [];
			params.push({ name: 'sapId', value: sapId });

			var data = getAllByParams('sap', 'WriteXML', params);
			return $q.when(data);
		}

		function sap_joinXML(pathFile) {
			if (typeof pathFile == 'undefined') { pathFile = ''; }

			var params = [];
			params.push({ name: 'pathFile', value: pathFile });

			var data = getAllByParams('sap', 'JoinXML', params);
			return $q.when(data);
		}

		function sap_upload_getURL() {
			var controller = 'SAP';
			var action = 'Upload';

			return urlAPI + '/' + controller + '/' + action + '/';
		}


		// *********************************
		// SAP_DatiAnag
		function sap_DatiAnag_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_DatiAnag', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_DatiAnag_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_DatiAnag', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_DatiAnag_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_DatiAnag', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_DatiAnag_get(id) {
			var data = getById('sap_DatiAnag', id);
			return $q.when(data);
		}

		function sap_DatiAnag_add(item) {
			var data = addObj('sap_DatiAnag', item);
			return $q.when(data);
		}

		function sap_DatiAnag_update(item) {
			var data = updateObj('sap_DatiAnag', item);
			return $q.when(data);
		}

		function sap_DatiAnag_delete(id) {
			var data = deleteObj('sap_DatiAnag', id);
			return $q.when(data);
		}


		// *********************************
		// SAP_DatiAmm
		function sap_DatiAmm_getAllList(testuale, SAPId, mesiAnzianitaDisocc, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof mesiAnzianitaDisocc == 'undefined') { mesiAnzianitaDisocc = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'mesiAnzianitaDisocc', value: mesiAnzianitaDisocc });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_DatiAmm', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_DatiAmm_getAll(pageSize, page, testuale, SAPId, mesiAnzianitaDisocc, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof mesiAnzianitaDisocc == 'undefined') { mesiAnzianitaDisocc = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'mesiAnzianitaDisocc', value: mesiAnzianitaDisocc });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_DatiAmm', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_DatiAmm_countAll(testuale, SAPId, mesiAnzianitaDisocc, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof mesiAnzianitaDisocc == 'undefined') { mesiAnzianitaDisocc = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'mesiAnzianitaDisocc', value: mesiAnzianitaDisocc });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_DatiAmm', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_DatiAmm_get(id) {
			var data = getById('sap_DatiAmm', id);
			return $q.when(data);
		}

		function sap_DatiAmm_add(item) {
			var data = addObj('sap_DatiAmm', item);
			return $q.when(data);
		}

		function sap_DatiAmm_update(item) {
			var data = updateObj('sap_DatiAmm', item);
			return $q.when(data);
		}

		function sap_DatiAmm_delete(id) {
			var data = deleteObj('sap_DatiAmm', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_EspProf
		function sap_EspProf_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_EspProf', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_EspProf_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_EspProf', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_EspProf_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_EspProf', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_EspProf_get(id) {
			var data = getById('sap_EspProf', id);
			return $q.when(data);
		}

		function sap_EspProf_add(item) {
			var data = addObj('sap_EspProf', item);
			return $q.when(data);
		}

		function sap_EspProf_update(item) {
			var data = updateObj('sap_EspProf', item);
			return $q.when(data);
		}

		function sap_EspProf_delete(id) {
			var data = deleteObj('sap_EspProf', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_CV_TitStud
		function sap_CV_TitStud_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_TitStud', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_CV_TitStud_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_CV_TitStud', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_CV_TitStud_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_TitStud', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_CV_TitStud_get(id) {
			var data = getById('sap_CV_TitStud', id);
			return $q.when(data);
		}

		function sap_CV_TitStud_add(item) {
			var data = addObj('sap_CV_TitStud', item);
			return $q.when(data);
		}

		function sap_CV_TitStud_update(item) {
			var data = updateObj('sap_CV_TitStud', item);
			return $q.when(data);
		}

		function sap_CV_TitStud_delete(id) {
			var data = deleteObj('sap_CV_TitStud', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_CV_FormProf
		function sap_CV_FormProf_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_FormProf', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_CV_FormProf_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_CV_FormProf', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_CV_FormProf_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_FormProf', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_CV_FormProf_get(id) {
			var data = getById('sap_CV_FormProf', id);
			return $q.when(data);
		}

		function sap_CV_FormProf_add(item) {
			var data = addObj('sap_CV_FormProf', item);
			return $q.when(data);
		}

		function sap_CV_FormProf_update(item) {
			var data = updateObj('sap_CV_FormProf', item);
			return $q.when(data);
		}

		function sap_CV_FormProf_delete(id) {
			var data = deleteObj('sap_CV_FormProf', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_CV_Lingue
		function sap_CV_Lingue_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Lingue', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_CV_Lingue_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_CV_Lingue', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_CV_Lingue_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Lingue', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_CV_Lingue_get(id) {
			var data = getById('sap_CV_Lingue', id);
			return $q.when(data);
		}

		function sap_CV_Lingue_add(item) {
			var data = addObj('sap_CV_Lingue', item);
			return $q.when(data);
		}

		function sap_CV_Lingue_update(item) {
			var data = updateObj('sap_CV_Lingue', item);
			return $q.when(data);
		}

		function sap_CV_Lingue_delete(id) {
			var data = deleteObj('sap_CV_Lingue', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_CV_Inform
		function sap_CV_Inform_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Inform', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_CV_Inform_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_CV_Inform', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_CV_Inform_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Inform', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_CV_Inform_get(id) {
			var data = getById('sap_CV_Inform', id);
			return $q.when(data);
		}

		function sap_CV_Inform_add(item) {
			var data = addObj('sap_CV_Inform', item);
			return $q.when(data);
		}

		function sap_CV_Inform_update(item) {
			var data = updateObj('sap_CV_Inform', item);
			return $q.when(data);
		}

		function sap_CV_Inform_delete(id) {
			var data = deleteObj('sap_CV_Inform', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_CV_Altro
		function sap_CV_Altro_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Altro', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_CV_Altro_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_CV_Altro', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_CV_Altro_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_CV_Altro', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_CV_Altro_get(id) {
			var data = getById('sap_CV_Altro', id);
			return $q.when(data);
		}

		function sap_CV_Altro_add(item) {
			var data = addObj('sap_CV_Altro', item);
			return $q.when(data);
		}

		function sap_CV_Altro_update(item) {
			var data = updateObj('sap_CV_Altro', item);
			return $q.when(data);
		}

		function sap_CV_Altro_delete(id) {
			var data = deleteObj('sap_CV_Altro', id);
			return $q.when(data);
		}

		// *********************************
		// SAP_PolAtt
		function sap_PolAtt_getAllList(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_PolAtt', 'GetAllList', params);
			return $q.when(data1);
		}

		function sap_PolAtt_getAll(pageSize, page, testuale, SAPId, bStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			if (typeof order == 'undefined') { order = 'destinatario'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			params.push({ name: 'order', value: order });

			var data1 = getAllByParams('sap_PolAtt', 'GetAllByFilter', params);
			return $q.when(data1);
		}

		function sap_PolAtt_countAll(testuale, SAPId, bStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof SAPId == 'undefined') { SAPId = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'SAPId', value: SAPId });
			params.push({ name: 'bStato', value: bStato });

			var data1 = getAllByParams('sap_PolAtt', 'CountByFilter', params);
			return $q.when(data1);
		}


		function sap_PolAtt_get(id) {
			var data = getById('sap_PolAtt', id);
			return $q.when(data);
		}

		function sap_PolAtt_add(item) {
			var data = addObj('sap_PolAtt', item);
			return $q.when(data);
		}

		function sap_PolAtt_update(item) {
			var data = updateObj('sap_PolAtt', item);
			return $q.when(data);
		}

		function sap_PolAtt_delete(id) {
			var data = deleteObj('sap_PolAtt', id);
			return $q.when(data);
		}


		// #endregion  *********************************

		// #region  PAGAMENTO
		function pagamento_getAllList() {
			var data = getAllList('pagamento');
			return $q.when(data);
		}

		function pagamento_getAll(pageSize, page, bStato, descrizione, aziendaId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('pagamento', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function pagamento_countAll(bStato, descrizione, aziendaId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('pagamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function pagamento_get(id) {
			var data = getById('pagamento', id);
			return $q.when(data);
		}


		function pagamento_add(item) {
			var data = addObj('pagamento', item);
			return $q.when(data);
		}

		function pagamento_update(item) {
			var data = updateObj('pagamento', item);
			return $q.when(data);
		}

		function pagamento_updateDatiAssess(item) {
			var objName = 'pagamento';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/PutDatiAssess', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pagamento_changeState(item) {
			var objName = 'pagamento';

			return $http.put(urlAPI + '/' + objName + '/ChangeState', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed sentObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pagamento_delete(id) {
			var data = deleteObj('pagamento', id);
			return $q.when(data);
		}

		function pagamento_unlock(item) {
			var objName = 'pagamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function pagamento_unsetPresaIncarico(item) {
			var objName = 'pagamento';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}


		// ******************************
		//  PAGAMENTO DETAIL
		function pagamentoDtl_getAllList() {
			var data = getAllList('pagamentoDtl');
			return $q.when(data);
		}

		function pagamentoDtl_getAll(pageSize, page, bStato, descrizione, pagamentoId) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof pagamentoId == 'undefined') { pagamentoId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'pagamentoId', value: pagamentoId });

			var data = getAllByParams('pagamentoDtl', 'GetAllByFilter', params);
			return $q.when(data);

		}



		function pagamentoDtl_countAll(bStato, descrizione, pagamentoId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof pagamentoId == 'undefined') { pagamentoId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'pagamentoId', value: pagamentoId });

			var data = getAllByParams('pagamentoDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function pagamentoDtl_get(id) {
			var data = getById('pagamentoDtl', id);
			return $q.when(data);
		}


		function pagamentoDtl_add(item) {
			var data = addObj('pagamentoDtl', item);
			return $q.when(data);
		}

		function pagamentoDtl_update(item) {
			var data = updateObj('pagamentoDtl', item);
			return $q.when(data);
		}

		function pagamentoDtl_delete(id) {
			var data = deleteObj('pagamentoDtl', id);
			return $q.when(data);
		}

		function pagamentoDtl_unlock(item) {
			var objName = 'pagamentoDtl';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  *********************************

		// #region  APLDOMANDERIMBORSO
		function aplDomandeRimborso_getAllList() {
			var data = getAllList('aplDomandeRimborso');
			return $q.when(data);
		}

		function aplDomandeRimborso_getAll(pageSize, page, bStato, descrizione, aziendaId, cpiId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('aplDomandeRimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function aplDomandeRimborso_countAll(bStato, descrizione, aziendaId, cpiId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: aziendaId });

			var data = getAllByParams('aplDomandeRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function aplDomandeRimborso_get(id) {
			var data = getById('aplDomandeRimborso', id);
			return $q.when(data);
		}

		// #endregion  *********************************

		// #region  ORIENTAMENTO

		function orientamento_setParams(isGet, pageSize, page, order, testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'destinatario'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof omlsId == 'undefined') { omlsId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'omlsId', value: omlsId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'data', value: data });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'stato', value: stato });

			return params;
		}
		function orientamento_getList(testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato) {
			var params = orientamento_setParams(false, 0, 0, '', testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato);
			var data1 = getAllByParams('orientamento', 'GetAllList', params);
			return $q.when(data1);
		}
		function orientamento_getAll(pageSize, page, testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato, order) {
			var params = orientamento_setParams(true, pageSize, page, order, testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato);
			var data1 = getAllByParams('orientamento', 'GetAllByFilter', params);
			return $q.when(data1);
		}
		function orientamento_countAll(testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato) {
			var params = orientamento_setParams(false, 0, 0, '', testuale, destinatarioId, omlsId, aplId, cpiId, tMisuraCode, data, percorso, stato);
			var data1 = getAllByParams('orientamento', 'CountByFilter', params);
			return $q.when(data1);
		}

		function orientamento_getAllListByRmbDtl(oriRmbId, orientamentoId) {
			if (typeof oriRmbId == 'undefined') { oriRmbId = 0; }
			if (typeof orientamentoId == 'undefined') { orientamentoId = 0; }

			var params = [];
			params.push({ name: 'oriRmbId', value: oriRmbId });
			params.push({ name: 'orientamentoId', value: orientamentoId });

			var data = getAllByParams('orientamento', 'GetAllListByRmbDtl', params);
			return $q.when(data);
		}

		function orientamento_get(id) {
			var data = getById('orientamento', id);
			return $q.when(data);
		}

		function orientamento_add(item) {
			var data = addObj('orientamento', item);
			return $q.when(data);
		}

		function orientamento_update(item) {
			var data = updateObj('orientamento', item);
			return $q.when(data);
		}

		function orientamento_delete(id) {
			var data = deleteObj('orientamento', id);
			return $q.when(data);
		}

		function orientamento_unlock(item) {
			var objName = 'orientamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region  ORIENTAMENTO DESTINATARIO

		function orientamentoDest_setParams(isGet, pageSize, page, order, testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof orientamentoId == 'undefined') { orientamentoId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'orientamentoId', value: orientamentoId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'stato', value: stato });

			return params;
		}
		function orientamentoDest_getList(testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato) {
			var params = orientamentoDest_setParams(false, 0, 0, '', testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato);
			var data1 = getAllByParams('orientamentoDest', 'GetAllList', params);
			return $q.when(data1);
		}
		function orientamentoDest_getAll(pageSize, page, testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato, order) {
			var params = orientamentoDest_setParams(true, pageSize, page, order, testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato);
			var data1 = getAllByParams('orientamentoDest', 'GetAllByFilter', params);
			return $q.when(data1);
		}
		function orientamentoDest_countAll(testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato) {
			var params = orientamentoDest_setParams(false, 0, 0, '', testuale, orientamentoId, destinatarioId, dtStart, dtEnd, stato);
			var data1 = getAllByParams('orientamentoDest', 'CountByFilter', params);
			return $q.when(data1);
		}

		function orientamentoDest_clona(sourceId, tMisuraCode) {
			if (typeof sourceId == 'undefined') sourceId = 0;
			if (typeof tMisuraCode == 'undefined') tMisuraCode = '';

			var objName = 'orientamentoDest';

			return $http.put(urlAPI + '/' + objName + '/Clona?sourceId=' + sourceId + '&tMisuraCode=' + tMisuraCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborsoDtl_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		function orientamentoDest_get(id) {
			var data = getById('orientamentoDest', id);
			return $q.when(data);
		}

		function orientamentoDest_add(item) {
			var data = addObj('orientamentoDest', item);
			return $q.when(data);
		}

		function orientamentoDest_update(item) {
			var data = updateObj('orientamentoDest', item);
			return $q.when(data);
		}

		function orientamentoDest_delete(id) {
			var data = deleteObj('orientamentoDest', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   ORI-RIMBORSO
		function oriRmb_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof orientamentoId == 'undefined') { orientamentoId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'orientamentoId', value: orientamentoId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function oriRmb_getAllList(testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato) {
			var params = oriRmb_setParams(false, 0, 0, '', testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato);
			var data = getAllByParams('oriRmb', 'GetAllList', params);
			return $q.when(data);
		}
		function oriRmb_getAll(pageSize, page, testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato, order) {
			var params = oriRmb_setParams(true, pageSize, page, order, testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato);
			var data = getAllByParams('oriRmb', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function oriRmb_countAll(testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato) {
			var params = oriRmb_setParams(false, 0, 0, '', testuale, tMisuraCode, aplId, cpiId, orientamentoId, iStato);
			var data = getAllByParams('oriRmb', 'CountByFilter', params);
			return $q.when(data);
		}

		function oriRmb_get(id) {
			var data = getById('oriRmb', id);
			return $q.when(data);
		}


		function oriRmb_add(item) {
			var data = addObj('oriRmb', item);
			return $q.when(data);
		}

		function oriRmb_update(item) {
			var data = updateObj('oriRmb', item);
			return $q.when(data);
		}

		function oriRmb_merge(item) {
			var data = mergeObj('oriRmb', item);
			return $q.when(data);
		}

		function oriRmb_delete(id) {
			var data = deleteObj('oriRmb', id);
			return $q.when(data);
		}

		function oriRmb_changeState(rmbId, status) {
			if (typeof rmbId == 'undefined') { rmbId = 0; }
			if (typeof status == 'undefined') { status = ''; }

			var params = [];
			params.push({ name: 'rmbId', value: rmbId });
			params.push({ name: 'status', value: status });

			var data = getAllByParams('oriRmb', 'ChangeState', params);
			return $q.when(data);
		}


		// #endregion  *****************************

		// #region TYPES


		//-- RUOLO AMM
		function tRuoloAmm_get(id) {
			var data = getById('TRuoloAmm', id);
			return $q.when(data);
		}

		//-- RUOLO DID
		function tRuoloDid_get(id) {
			var data = getById('TRuoloDid', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinanteProfilo 
		function tTirocinanteProfilo_getAllList() {
			var data = getAllList('tTirocinanteProfilo');
			return $q.when(data);
		}

		function tTirocinanteProfilo_get(id) {
			var data = getById('tTirocinanteProfilo', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinio 
		function tTirocinio_getAllList() {
			var data = getAllList('tTirocinio');
			return $q.when(data);
		}

		function tTirocinio_get(id) {
			var data = getById('tTirocinio', id);
			return $q.when(data);
		}

		// ******************************
		//--  TTirocinioDLG 
		function tTirocinioDLG_getAllList() {
			var data = getAllList('tTirocinioDLG');
			return $q.when(data);
		}

		function tTirocinioDLG_get(id) {
			var data = getById('tTirocinioDLG', id);
			return $q.when(data);
		}

		// ******************************
		//--  TLavoro 
		function tLavoro_getAllList() {
			var data = getAllList('tLavoro');
			return $q.when(data);
		}

		function tLavoro_get(id) {
			var data = getById('tLavoro', id);
			return $q.when(data);
		}

		// ******************************
		//-- TFormaGiuridica        
		function tFormaGiuridica_getAllList() {
			var data = getAllList('tFormaGiuridica');
			return $q.when(data);
		}

		function tFormaGiuridica_get(id) {
			var data = getById('tFormaGiuridica', id);
			return $q.when(data);
		}

		// ******************************
		//-- TAteco          
		function tAteco_getAllList() {
			var data = getAllList('tAteco');
			return $q.when(data);
		}

		function tAteco_get(id) {
			if (typeof id == 'undefined') { id = 0; }
			var data = getById('tAteco', id);
			return $q.when(data);
		}

		function tAteco_getByText(text) {
			var data = getAllByParam('tAteco', 'GetByText', 'text', text);
			return $q.when(data);
		}

		// ******************************
		//-- TTitoloStudio          
		function tTitoloStudio_getAllList() {
			var data = getAllList('tTitoloStudio');
			return $q.when(data);
		}

		function tTitoloStudio_get(id) {
			var data = getById('tTitoloStudio', id);
			return $q.when(data);
		}

		// ******************************
		//-- TCondizioneMercato          
		function tCondizioneMercato_getAllList() {
			var data = getAllList('tCondizioneMercato');
			return $q.when(data);
		}

		function tCondizioneMercato_get(id) {
			var data = getById('tCondizioneMercato', id);
			return $q.when(data);
		}

		// ******************************
		//-- TDurataRicerca          
		function tDurataRicerca_getAllList() {
			var data = getAllList('tDurataRicerca');
			return $q.when(data);
		}

		function tDurataRicerca_get(id) {
			var data = getById('tDurataRicerca', id);
			return $q.when(data);
		}

		// ******************************
		//-- TGruppoVulnerabilita          
		function tGruppoVulnerabilita_getAllList() {
			var data = getAllList('tGruppoVulnerabilita');
			return $q.when(data);
		}

		function tGruppoVulnerabilita_get(id) {
			var data = getById('tGruppoVulnerabilita', id);
			return $q.when(data);
		}

		// ******************************
		//-- TStatoPartecipante          
		function tStatoPartecipante_getAllList() {
			var data = getAllList('tStatoPartecipante');
			return $q.when(data);
		}

		function tStatoPartecipante_get(id) {
			var data = getById('tStatoPartecipante', id);
			return $q.when(data);
		}

		// ******************************
		//-- TCPI          
		function tCPI_getAllList() {
			var data = getAllList('tCPI');
			return $q.when(data);
		}

		function tCPI_get(id) {
			var data = getById('tCPI', id);
			return $q.when(data);
		}

		// ******************************
		//-- TTirociniSpese         
		function tTirociniSpese_getAllList() {
			var data = getAllList('tTirocinioSpesa');
			return $q.when(data);
		}

		function tTirociniSpese_get(id) {
			var data = getById('tTirocinioSpesa', id);
			return $q.when(data);
		}

		// ******************************
		//-- ContenutoFormativo          
		function contenutoFormativo_getAllList() {
			var data = getAllList('contenutoFormativo');
			return $q.when(data);
		}

		function contenutoFormativo_get(id) {
			var data = getById('contenutoFormativo', id);
			return $q.when(data);
		}

		// ******************************
		//-- TIndirizzo          
		function tIndirizzo_getAllList() {
			var data = getAllList('tIndirizzo');
			return $q.when(data);
		}

		function tIndirizzo_get(id) {
			var data = getById('tIndirizzo', id);
			return $q.when(data);
		}

		//--PROFILO ANPAL
		function tProfiloANPAL_getAll() {
			var data = getAllNoParam('TProfiloANPAL', 'GetAll');
			return $q.when(data);
		}

		// *****************************
		//--PROFILO DOCENTE
		function tProfiloDocente_getAll() {
			var data = getAllNoParam('TProfiloDocente', 'GetAll');
			return $q.when(data);
		}


		// *****************************
		// TRuolo
		function tRuolo_getAll(entitaCode, profiloCode, tMisuraCode) {
			if (typeof entitaCode == 'undefined') { entitaCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }

			var params = [];
			params.push({ name: 'code', value: '' });
			params.push({ name: 'entitaCode', value: entitaCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });

			var data = getAllByParams('TRuolo', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tRuolo_getByCode(code) {
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'code', value: code });

			var data = getAllByParams('TRuolo', 'GetByCode', params);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   SEDE
		function sede_setParams(isGet, pageSize, page, order, testuale, provinciaId, comuneId, tMisuraCode, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function sede_getAllList(testuale, provinciaId, comuneId, tMisuraCode, iStato) {
			var params = sede_setParams(false, 0, 0, '', testuale, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('sede', 'GetListByFilter', params);
			return $q.when(data);
		}

		function sede_getAll(pageSize, page, testuale, provinciaId, comuneId, tMisuraCode, iStato, order) {
			var params = sede_setParams(true, pageSize, page, order, testuale, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('sede', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function sede_countAll(testuale, provinciaId, comuneId, tMisuraCode, iStato) {
			var params = sede_setParams(false, 0, 0, '', testuale, provinciaId, comuneId, tMisuraCode, iStato);
			var data = getAllByParams('sede', 'CountByFilter', params);
			return $q.when(data);
		}

		function sede_get(id) {
			var data = getById('sede', id);
			return $q.when(data);
		}

		function sede_add(item) {
			var data = addObj('sede', item);
			return $q.when(data);
		}

		function sede_update(item) {
			var data = updateObj('sede', item);
			return $q.when(data);
		}

		function sede_merge(item) {
			var data = mergeObj('sede', item);
			return $q.when(data);
		}

		function sede_delete(id) {
			var data = deleteObj('sede', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   SIGNATURE
		function signature_getAllList() {
			var data = getAllList('signature');
			return $q.when(data);
		}

		function signature_getAll(pageSize, page, nome, cognome, dtAcq, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof dtAcq == 'undefined') { dtAcq = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'dtAcq', value: dtAcq });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('signature', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function signature_countAll(nome, cognome, dtAcq) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof cognome == 'undefined') { cognome = ''; }
			if (typeof dtAcq == 'undefined') { dtAcq = ''; }
			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'cognome', value: cognome });
			params.push({ name: 'dtAcq', value: dtAcq });

			var data = getAllByParams('signature', 'CountByFilter', params);
			return $q.when(data);
		}

		function signature_upload(filename, file) {
			var objName = 'signature';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed signature_upload for %s: %s', objName, message);
					return message.status;
				});

		}

		function signature_get(id) {
			var data = getById('signature', id);
			return $q.when(data);
		}

		function signature_add(item) {
			var data = addObj('signature', item);
			return $q.when(data);
		}

		function signature_update(item) {
			var data = updateObj('signature', item);
			return $q.when(data);
		}

		function signature_delete(id) {
			console.log("deleteSede(%s)", id);

			var data = deleteObj('signature', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region   SOGGETTO COLLEGATO
		function soggettoC_setParams(isGet, pageSize, page, order, testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tProfiloDocenteCode == 'undefined') { tProfiloDocenteCode = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tProfiloDocenteCode', value: tProfiloDocenteCode });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function soggettoC_getAllList(testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato) {
			var params = soggettoC_setParams(false, 0, 0, '', testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato);
			var data = getAllByParams('SoggettoCollegato', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function soggettoC_getAll(pageSize, page, testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato, order) {
			var params = soggettoC_setParams(true, pageSize, page, order, testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato);
			var data = getAllByParams('SoggettoCollegato', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function soggettoC_countAll(testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato) {
			var params = soggettoC_setParams(false, 0, 0, '', testuale, tRuoloCode, profiloCode, tMisuraCode, tProfiloDocenteCode, aziendaId, iStato);
			var data = getAllByParams('SoggettoCollegato', 'CountByFilter', params);
			return $q.when(data);
		}
		function soggettoC_exists(soggettoId, aziendaId, codiceFiscale, tRuoloCode, profiloCode, tMisuraCode) {
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }

			var params = [];
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });

			var data = getAllByParams('SoggettoCollegato', 'Exists', params);
			return $q.when(data);
		}

		function soggettoC_get(id) {
			var data = getById('SoggettoCollegato', id);
			return $q.when(data);
		}

		function soggettoC_add(item) {
			var data = addObj('SoggettoCollegato', item);
			return $q.when(data);
		}

		function soggettoC_update(item) {
			var data = updateObj('SoggettoCollegato', item);
			return $q.when(data);
		}

		function soggettoC_merge(item) {
			var data = mergeObj('SoggettoCollegato', item);
			return $q.when(data);
		}

		function soggettoC_delete(id) {
			var data = deleteObj('SoggettoCollegato', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   AZIENDA
		function azienda_setParams(pageSize, page, testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof sourceCode == 'undefined') { sourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof province == 'undefined') { province = ''; }
			if (typeof misure == 'undefined') { misure = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'sourceCode', value: sourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'province', value: province });
			params.push({ name: 'misure', value: misure });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function azienda_getAllList(testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato) {
			var params = azienda_setParams(0, 0, testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato, '', false);

			var data = getAllByParams('azienda', 'GetAllList', params);
			return $q.when(data);
		}

		function azienda_getAll(pageSize, page, testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato, order) {
			var params = azienda_setParams(pageSize, page, testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato, order, true);

			var data = getAllByParams('azienda', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function azienda_countAll(testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato) {
			var params = azienda_setParams(0, 0, testuale, sourceCode, sourceId, tRuoloCode, profiloCode, tMisuraCode, provinciaId, parentId, partecipazioneId, percorso, province, misure, iStato, '', false);

			var data = getAllByParams('azienda', 'CountByFilter', params);
			return $q.when(data);
		}

		function azienda_exists(aziendaId, parentId, partecipazioneId, tRuoloCode, profiloCode, tMisuraCode, codiceFiscale, piva) {
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof parentId == 'undefined') { parentId = 0; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof profiloCode == 'undefined') { profiloCode = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }
			var params = [];
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'parentId', value: parentId });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'profiloCode', value: profiloCode });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });

			var data = getAllByParams('azienda', 'Exists', params);
			return $q.when(data);
		}

		function azienda_statusFondi(aplId, tMisuraCode, tProfiloId, dest_CF, corsoId) {
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tProfiloId == 'undefined') { tProfiloId = 0; }
			if (typeof dest_CF == 'undefined') { dest_CF = ''; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }

			var params = [];
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tProfiloId', value: tProfiloId });
			params.push({ name: 'dest_CF', value: dest_CF });
			params.push({ name: 'asse1', value: false });
			params.push({ name: 'asse1B', value: false });
			params.push({ name: 'corsoId', value: corsoId });

			var data = getAllByParams('azienda', 'StatusFondi', params);
			return $q.when(data);
		}

		function azienda_getDecretato(tRuoloCode) {
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			var data = getAllByParam('azienda', 'GetDecretato', 'tRuoloCode', tRuoloCode);
			return $q.when(data);
		}

		function azienda_getByUsername() {
			var data = getAllNoParam('azienda', 'GetByUsername');
			return $q.when(data);
		}

		function azienda_getByUsername2(username) {
			if (typeof username == 'undefined') { username = ''; }

			var params = [];
			params.push({ name: 'username', value: username });

			var data = getAllByParams('azienda', 'GetByUsername2', params);
			return $q.when(data);
		}

		function azienda_get(id) {
			var data = getById('azienda', id);
			return $q.when(data);
		}

		function azienda_add(item) {
			var data = addObj('azienda', item);
			return $q.when(data);
		}

		function azienda_update(item) {
			var data = updateObj('azienda', item);
			return $q.when(data);
		}

		function azienda_merge(item) {
			var data = mergeObj('azienda', item);
			return $q.when(data);
		}

		function azienda_saveComplete(item) {
			return $http.put(urlAPI + '/Azienda/SaveComplete', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed mergeObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function azienda_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'azienda';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function azienda_delete(id) {
			var data = deleteObj('azienda', id);
			return $q.when(data);
		}

		function azienda_upload(filename, file) {
			var objName = 'azienda';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed azienda_upload for %s: %s', objName, message);
					return message.status;
				});

		}

		function azienda_deleteCartaIntestata(id) {
			var objName = 'azienda';
			var method = 'DeleteCartaIntestata';

			var url = urlAPI + '/' + objName + '/' + method + '/' + id;

			return $http.delete(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed azienda_deleteCartaIntestata for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region   AZIENDA SEDI-
		function aziendaSede_setParams(pageSize, page, testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'partecipazioneId', value: partecipazioneId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function aziendaSede_getAllList(testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato) {
			var params = aziendaSede_setParams(0, 0, testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato, '', false);

			var data = getAllByParams('aziendaSede', 'GetAllList', params);
			return $q.when(data);
		}

		function aziendaSede_getAll(pageSize, page, testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato, order) {
			var params = aziendaSede_setParams(pageSize, page, testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato, order, true);

			var data = getAllByParams('aziendaSede', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function aziendaSede_countAll(testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato) {
			var params = aziendaSede_setParams(0, 0, testuale, tRuoloCode, aziendaId, provinciaId, comuneId, partecipazioneId, iStato, '', false);

			var data = getAllByParams('aziendaSede', 'CountByFilter', params);
			return $q.when(data);
		}

		function aziendaSede_changeState(id, status, bInConvenzione, dtEndConv, convalidaNote, tRuoloCode) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof status == 'undefined') { status = ''; }
			if (typeof bInConvenzione == 'undefined') { bInConvenzione = false; }
			if (typeof dtEndConv == 'undefined') { dtEndConv = ''; }
			if (typeof convalidaNote == 'undefined') { convalidaNote = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'status', value: status });
			params.push({ name: 'bInConvenzione', value: bInConvenzione });
			params.push({ name: 'dtEndConv', value: dtEndConv });
			params.push({ name: 'convalidaNote', value: convalidaNote });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });

			var data = getAllByParams('aziendaSede', 'ChangeState', params);
			return $q.when(data);
		}

		function aziendaSede_get(id) {
			var data = getById('aziendaSede', id);
			return $q.when(data);
		}

		function aziendaSede_add(item) {
			var data = addObj('aziendaSede', item);
			return $q.when(data);
		}

		function aziendaSede_update(item) {
			var data = updateObj('aziendaSede', item);
			return $q.when(data);
		}

		function aziendaSede_merge(item) {
			var data = mergeObj('aziendaSede', item);
			return $q.when(data);
		}

		function aziendaSede_delete(id) {
			var data = deleteObj('aziendaSede', id);
			return $q.when(data);
		}

		function aziendaSede_unlock(item) {
			var objName = 'aziendaSede';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed aziendaSede_unlock for %s: %s', objName, message);
					return message.status;
				});
		}

		function aziendaSede_changePresaIncarico(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'aziendaSede';

			return $http.put(urlAPI + '/' + objName + '/ChangePresaIncarico?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborso_changePresaIncarico for %s: %s', objName, message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   AZIENDA PROVINCIA
		function aziendaProvincia_setParams(isGet, pageSize, page, order, testuale, aziendaId, provinciaId, comuneId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function aziendaProvincia_getAllList(testuale, aziendaId, provinciaId, comuneId, iStato) {
			var params = aziendaProvincia_setParams(false, 0, 0, '', testuale, aziendaId, provinciaId, comuneId, iStato);

			var data = getAllByParams('aziendaProvincia', 'GetAllList', params);
			return $q.when(data);
		}

		function aziendaProvincia_getAll(pageSize, page, testuale, aziendaId, provinciaId, comuneId, iStato, order) {
			var params = aziendaProvincia_setParams(true, pageSize, page, order, testuale, aziendaId, provinciaId, comuneId, iStato);

			var data = getAllByParams('aziendaProvincia', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function aziendaProvincia_countAll(testuale, aziendaId, provinciaId, comuneId, iStato) {
			var params = aziendaProvincia_setParams(false, 0, 0, '', testuale, aziendaId, provinciaId, comuneId, iStato);

			var data = getAllByParams('aziendaProvincia', 'CountByFilter', params);
			return $q.when(data);
		}

		function aziendaProvincia_get(id) {
			var data = getById('aziendaProvincia', id);
			return $q.when(data);
		}

		function aziendaProvincia_add(item) {
			var data = addObj('aziendaProvincia', item);
			return $q.when(data);
		}

		function aziendaProvincia_update(item) {
			var data = updateObj('aziendaProvincia', item);
			return $q.when(data);
		}

		function aziendaProvincia_delete(id) {
			var data = deleteObj('aziendaProvincia', id);
			return $q.when(data);
		}

		function aziendaProvincia_unlock(item) {
			var objName = 'aziendaProvincia';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed aziendaProvincia_unlock for %s: %s', objName, message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   AZIENDA SEDI ACCREDITATE
		function azSedeAccr_getAllList(testuale, aziendaId, provinciaId, comuneId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('AziendaSedeAccr', 'GetAllList', params);

			return $q.when(data);
		}

		function azSedeAccr_getAll(pageSize, page, testuale, aziendaId, provinciaId, comuneId, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('AziendaSedeAccr', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function azSedeAccr_countAll(testuale, aziendaId, provinciaId, comuneId, iStato) {
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('AziendaSedeAccr', 'CountByFilter', params);
			return $q.when(data);
		}

		function azSedeAccr_get(id) {
			var data = getById('AziendaSedeAccr', id);
			return $q.when(data);
		}

		function azSedeAccr_add(item) {
			var data = addObj('AziendaSedeAccr', item);
			return $q.when(data);
		}

		function azSedeAccr_update(item) {
			var data = updateObj('AziendaSedeAccr', item);
			return $q.when(data);
		}

		function azSedeAccr_delete(id) {
			var data = deleteObj('AziendaSedeAccr', id);
			return $q.when(data);
		}




		// #endregion  ******************************

		// #region   AZIENDA CODICE INTERMEDIARIO
		function aziendaCodiceIntermediario_setParams(pageSize, page, testuale, aplId, codiceIntermediario, tRuoloCode, iStato, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof codiceIntermediario == 'undefined') { codiceIntermediario = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'codiceIntermediario', value: codiceIntermediario });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function aziendaCodiceIntermediario_getAllList(testuale, aplId, codiceIntermediario, tRuoloCode, iStato) {
			var params = aziendaCodiceIntermediario_setParams(0, 0, testuale, aplId, codiceIntermediario, tRuoloCode, iStato, '', false);

			var data = getAllByParams('AziendaCodiceIntermediario', 'GetAllList', params);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_getAll(pageSize, page, testuale, aplId, codiceIntermediario, tRuoloCode, iStato, order) {
			var params = aziendaCodiceIntermediario_setParams(pageSize, page, testuale, aplId, codiceIntermediario, tRuoloCode, iStato, order, true);

			var data = getAllByParams('AziendaCodiceIntermediario', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_countAll(testuale, aplId, codiceIntermediario, tRuoloCode, iStato) {
			var params = aziendaCodiceIntermediario_setParams(0, 0, testuale, aplId, codiceIntermediario, tRuoloCode, iStato, '', false);

			var data = getAllByParams('AziendaCodiceIntermediario', 'CountByFilter', params);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_get(id) {
			var data = getById('AziendaCodiceIntermediario', id);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_add(item) {
			var data = addObj('AziendaCodiceIntermediario', item);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_update(item) {
			var data = updateObj('AziendaCodiceIntermediario', item);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_merge(item) {
			var data = mergeObj('AziendaCodiceIntermediario', item);
			return $q.when(data);
		}

		function aziendaCodiceIntermediario_delete(id) {
			var data = deleteObj('AziendaCodiceIntermediario', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   TIROCINIO
		function tirocinio_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof ospitanteId == 'undefined') { ospitanteId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof soggCollCode == 'undefined') { soggCollCode = ''; }
			if (typeof soggCollId == 'undefined') { soggCollId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }


			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'ospitanteId', value: ospitanteId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'soggCollCode', value: soggCollCode });
			params.push({ name: 'soggCollId', value: soggCollId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}
		function tirocinio_getAllList(testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato) {
			var params = tirocinio_setParams(false, 0, 0, '', testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato);
			var data = getAllByParams('tirocinio', 'GetAllList', params);
			return $q.when(data);
		}
		function tirocinio_getAll(pageSize, page, testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato, order) {
			var params = tirocinio_setParams(true, pageSize, page, order, testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato);
			var data = getAllByParams('tirocinio', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function tirocinio_countAll(testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato) {
			var params = tirocinio_setParams(false, 0, 0, '', testuale, tMisuraCode, destinatarioId, promotoreId, ospitanteId, cpiId, dtStart, dtEnd, anno, mese, soggCollCode, soggCollId, percorso, iStato);
			var data = getAllByParams('tirocinio', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinio_exists(tMisuraCode, tirocinioId, destinatarioId, promotoreId, ospitanteId, percorso) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof ospitanteId == 'undefined') { ospitanteId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'ospitanteId', value: ospitanteId });
			params.push({ name: 'percorso', value: percorso });

			var data = getAllByParams('tirocinio', 'Exists', params);
			return $q.when(data);
		}

		function tirocinio_getAllByIndennita(pageSize, page, testuale, tMisuraCode, promotoreId, anno, mese, percorso, iStato, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { order = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof promotoreId == 'undefined') { promotoreId = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'promotoreId', value: promotoreId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tirocinio', 'GetAllByIndennita', params);
			return $q.when(data);
		}

		function tirocinio_get(id) {
			var data = getById('tirocinio', id);
			return $q.when(data);
		}

		function tirocinio_add(item) {
			var data = addObj('tirocinio', item);
			return $q.when(data);
		}

		function tirocinio_update(item) {
			var data = updateObj('tirocinio', item);
			return $q.when(data);
		}

		function tirocinio_merge(item) {
			var data = mergeObj('tirocinio', item);
			return $q.when(data);
		}

		function tirocinio_change(item) {
			var data = putMethod('tirocinio', 'Change', item);
			return $q.when(data);
		}

		function tirocinio_delete(id) {
			console.log("deletetirocinio(%s)", id);

			var data = deleteObj('tirocinio', id);
			return $q.when(data);
		}

		function tirocinio_unlock(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_changeState(code, id, tSourceCode) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') tSourceCode = '';

			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id + '&tSourceCode=' + tSourceCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborso_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setNoBenefit(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetNoBenefit', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed setNoBenefit for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setFuoriOrario(id, value) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetFuoriOrario?id=' + id + '&value=' + value)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed setFuoriOrario for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_unsetNoBenefit(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/UnsetNoBenefit', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed unsetNoBenefit for %s: %s', objName, message);
					return message.status;
				});
		}


		function tirocinio_disassignRlz(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/DisassignRlz', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed disassignRlz for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_status(tMisuraCode, aziendaId, codiceFiscale) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });

			var data = getAllByParams('tirocinio', 'Status', params);
			return $q.when(data);
		}

		function tirocinio_assign(item) {
			var data = postMethod('tirocinio', 'Assign', item);
			return $q.when(data);
		}

		function tirocinio_reassign(tMisuraCode, destinatarioId) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'destinatarioId', value: destinatarioId });

			var data = getAllByParams('tirocinio', 'Reassign', params);
			return $q.when(data);
		}

		function tirocinio_rinuncia(tirocinioId, motivazione, yes, bClone) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof motivazione == 'undefined') { motivazione = ''; }
			if (typeof yes == 'undefined') { yes = true; }
			if (typeof bClone == 'undefined') { bClone = false; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'motivazione', value: motivazione });
			params.push({ name: 'yes', value: yes });
			params.push({ name: 'bClone', value: bClone });

			var data = getAllByParams('tirocinio', 'Rinuncia', params);
			return $q.when(data);
		}

		function tirocinio_rlzSuspended(tirocinioId, yes) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof yes == 'undefined') { yes = true; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'yes', value: yes });

			var data = getAllByParams('tirocinio', 'RlzSuspended', params);
			return $q.when(data);
		}

		function tirocinio_unsetPresaIncarico(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_unsetPresaIncaricoCPI(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		//-------------------ANOMALIE--------------------------------------
		function tirocinio_setPresaIncarico(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_unsetPresaIncarico(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncarico', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_setPresaIncaricoCPI(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/SetPresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirocinio_unsetPresaIncaricoCPI(item) {
			var objName = 'tirocinio';

			return $http.put(urlAPI + '/' + objName + '/RemovePresaIncaricoCPI', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}
		//-------------------ANOMALIE--------------------------------------


		// #endregion  ******************************

		// #region  TIROCINIO LOG

		function tirLog_setParams(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tirocinanteId == 'undefined') { tirocinanteId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tirocinanteId', value: tirocinanteId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function tirLog_getAllList(testuale, tirocinanteId, aziendaId, cpiId, dt, iStato) {
			var params = tirLog_setParams(0, 0, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, '', false);

			var data = getAllByParams('tirLog', 'GetAllList', params);
			return $q.when(data);
		}

		function tirLog_getAll(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order) {
			var params = tirLog_setParams(pageSize, page, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, order, true);

			var data = getAllByParams('tirLog', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function tirLog_countAll(testuale, tirocinanteId, aziendaId, cpiId, dt, iStato) {
			var params = tirLog_setParams(0, 0, testuale, tirocinanteId, aziendaId, cpiId, dt, iStato, '', false);

			var data = getAllByParams('tirLog', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirLog_get(id) {
			var data = getById('tirLog', id);
			return $q.when(data);
		}

		function tirLog_add(item) {
			var data = addObj('tirLog', item);
			return $q.when(data);
		}

		function tirLog_update(item) {
			var data = updateObj('tirLog', item);
			return $q.when(data);
		}

		function tirLog_delete(id) {
			var data = deleteObj('tirLog', id);
			return $q.when(data);
		}



		// #endregion  ******************************

		// #region   TIROCINI-SPESE
		function tirocinioSpesa_getAllList(bAttivo, bCompleted) {
			if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'bCompleted', value: bCompleted });

			var data = getAllByParams('TirocinioSpesa', 'GetAllList', params);

			return $q.when(data);
		}

		function tirocinioSpesa_getAll(pageSize, page, nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('TirocinioSpesa', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tirocinioSpesa_countAll(nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });

			var data = getAllByParams('TirocinioSpesa', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinioSpesa_get(id) {
			var data = getById('TirocinioSpesa', id);
			return $q.when(data);
		}

		function tirocinioSpesa_add(item) {
			var data = addObj('TirocinioSpesa', item);
			return $q.when(data);
		}

		function tirocinioSpesa_update(item) {
			var data = updateObj('TirocinioSpesa', item);
			return $q.when(data);
		}

		function tirocinioSpesa_delete(id) {
			var data = deleteObj('TirocinioSpesa', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   TIROCINI-PAGAMENTI
		function tirocinioPagamento_getAllList(nominativo, tirocinioId, iProgr, tipologiaSpesaId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });

			var data = getAllByParams('tirocinioPagamento', 'GetAllList', params);

			return $q.when(data);
		}

		function tirocinioPagamento_getAll(pageSize, page, nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tirocinioPagamento', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tirocinioPagamento_countAll(nominativo, tirocinioId, iProgr, tipologiaSpesaId, aziendaId, ruoloSoggettoId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iProgr == 'undefined') { iProgr = 0; }
			if (typeof tipologiaSpesaId == 'undefined') { tipologiaSpesaId = 0; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof ruoloSoggettoId == 'undefined') { ruoloSoggettoId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iProgr', value: iProgr });
			params.push({ name: 'tipologiaSpesaId', value: tipologiaSpesaId });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'ruoloSoggettoId', value: ruoloSoggettoId });

			var data = getAllByParams('tirocinioPagamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirocinioPagamento_get(id) {
			var data = getById('tirocinioPagamento', id);
			return $q.when(data);
		}

		function tirocinioPagamento_add(item) {
			var data = addObj('tirocinioPagamento', item);
			return $q.when(data);
		}

		function tirocinioPagamento_update(item) {
			var data = updateObj('tirocinioPagamento', item);
			return $q.when(data);
		}

		function tirocinioPagamento_delete(id) {
			var data = deleteObj('tirocinioPagamento', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   TIROCINIO RIMBORSO
		function tirRimborso_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function tirRimborso_getAllList(testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato) {
			var params = tirRimborso_setParams(false, 0, 0, '', testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato);
			var data = getAllByParams('tirRimborso', 'GetAllList', params);
			return $q.when(data);
		}
		function tirRimborso_getAll(pageSize, page, testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato, order) {
			var params = tirRimborso_setParams(true, pageSize, page, order, testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato);
			var data = getAllByParams('tirRimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function tirRimborso_countAll(testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato) {
			var params = tirRimborso_setParams(false, 0, 0, '', testuale, tMisuraCode, aplId, cpiId, tirocinioId, mese, anno, iStato);
			var data = getAllByParams('tirRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirRimborso_get(id) {
			var data = getById('tirRimborso', id);
			return $q.when(data);
		}

		function tirRimborso_add(item) {
			var data = addObj('tirRimborso', item);
			return $q.when(data);
		}

		function tirRimborso_update(item) {
			var data = updateObj('tirRimborso', item);
			return $q.when(data);
		}

		function tirRimborso_merge(item) {
			var data = mergeObj('tirRimborso', item);
			return $q.when(data);
		}

		function tirRimborso_delete(id) {
			var data = deleteObj('tirRimborso', id);
			return $q.when(data);
		}

		function tirRimborso_changePeriodo(item) {
			var objName = 'tirRimborso';
			var objValue = item;

			return $http.put(urlAPI + '/' + objName + '/ChangePeriodo', objValue)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_calcolaImportoRichiesto(tirocinioId, dtInizio, dtFine) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof dtInizio == 'undefined') { dtInizio = ''; }
			if (typeof dtFine == 'undefined') { dtFine = ''; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'dtInizio', value: dtInizio });
			params.push({ name: 'dtFine', value: dtFine });

			var data = getAllByParams('tirRimborso', 'CalcolaImportoRichiesto', params);
			return $q.when(data);
		}

		function tirRimborso_updateDatiAssess(item) {
			var data = putMethod('tirRimborso', 'PutDatiAssess', item);
			return $q.when(data);
		}

		function tirRimborso_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function tirRimborso_changePresaIncarico(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'tirRimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangePresaIncarico?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}



		// #endregion  ******************************

		// #region   TIROCINIO RIMBORSO DTL
		function tirRimborsoDtl_setParams(pageSize, page, order, bGet, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tirRimborsoId == 'undefined') { tirRimborsoId = 0; }
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tirRimborsoId', value: tirRimborsoId });
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function tirRimborsoDtl_getAllList(testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			var params = tirRimborsoDtl_setParams(0, 0, '', false, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'GetAllList', params);
			return $q.when(data);
		}
		function tirRimborsoDtl_getAll(pageSize, page, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato, order) {
			var params = tirRimborsoDtl_setParams(pageSize, page, order, true, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function tirRimborsoDtl_countAll(testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato) {
			var params = tirRimborsoDtl_setParams(0, 0, '', false, testuale, tirRimborsoId, tirocinioId, aplId, cpiId, anno, mese, iStato);

			var data = getAllByParams('tirRimborsoDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function tirRimborsoDtl_get(id) {
			var data = getById('tirRimborsoDtl', id);
			return $q.when(data);
		}

		function tirRimborsoDtl_add(item) {
			var data = addObj('tirRimborsoDtl', item);
			return $q.when(data);
		}

		function tirRimborsoDtl_update(item) {
			var data = updateObj('tirRimborsoDtl', item);
			return $q.when(data);
		}

		function tirRimborsoDtl_delete(id) {
			var data = deleteObj('tirRimborsoDtl', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   TIROCINIO SOSPENSIONE
		function tirSospensione_getAllByTirocinioId(tirocinioId, iFestivo, iStato) {
			if (typeof tirocinioId == 'undefined') { tirocinioId = 0; }
			if (typeof iFestivo == 'undefined') { iFestivo = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'tirocinioId', value: tirocinioId });
			params.push({ name: 'iFestivo', value: iFestivo });
			params.push({ name: 'iStato', value: iStato });

			var data = getAllByParams('tirSospensione', 'GetAllByTirocinioId', params);
			return $q.when(data);

		}

		function tirSospensione_get(id) {
			var data = getById('tirSospensione', id);
			return $q.when(data);
		}

		function tirSospensione_add(item) {
			var data = addObj('tirSospensione', item);
			return $q.when(data);
		}

		function tirSospensione_update(item) {
			var data = updateObj('tirSospensione', item);
			return $q.when(data);
		}

		function tirSospensione_merge(item) {
			var data = mergeObj('tirSospensione', item);
			return $q.when(data);
		}

		function tirSospensione_delete(id) {
			var data = deleteObj('tirSospensione', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region  COLLOCAMENTO
		function collocamento_setParams(isGet, pageSize, page, testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato, order) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aziendaId', value: aziendaId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function collocamento_getAllList(testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato) {
			var params = collocamento_setParams(false, 0, 0, testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato, '');
			var data = getAllByParams('collocamento', 'GetAllList', params);
			return $q.when(data);
		}
		function collocamento_getAll(pageSize, page, testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato, order) {
			var params = collocamento_setParams(true, pageSize, page, testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato, order);
			var data = getAllByParams('collocamento', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function collocamento_countAll(testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato) {
			var params = collocamento_setParams(false, 0, 0, testuale, aziendaId, destinatarioId, tMisuraCode, cpiId, dtStart, dtEnd, iStato, '');
			var data = getAllByParams('collocamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function collocamento_statusCF(codiceFiscale, tMisuraCode /*, aziendaId*/) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			//if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			//params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('collocamento', 'StatusCF', params);
			return $q.when(data);
		}

		function collocamento_assign(codiceFiscale, tMisuraCode, /* aplId,*/ cpiId) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			//if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			//params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });

			var data = getAllByParams('collocamento', 'Assign', params);
			return $q.when(data);
		}

		function collocamento_get(id) {
			var data = getById('collocamento', id);
			return $q.when(data);
		}

		function collocamento_add(item) {
			var data = addObj('collocamento', item);
			return $q.when(data);
		}

		function collocamento_update(item) {
			var data = updateObj('collocamento', item);
			return $q.when(data);
		}

		function collocamento_merge(item) {
			var data = mergeObj('collocamento', item);
			return $q.when(data);
		}

		function collocamento_delete(id) {
			console.log("deletetirocinio(%s)", id);

			var data = deleteObj('collocamento', id);
			return $q.when(data);
		}

		function collocamento_unlock(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_setSent(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/SetSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_unlockSent(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/UnlockSent', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_setCompleted(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_proroga(id, dtEndPrev) {
			var objName = 'collocamento';
			if (typeof id == 'undefined') { id = 0; }
			if (typeof dtEndPrev == 'undefined') { dtEndPrev = ''; }


			var item = {};
			item.Id = id;
			item.DtEndPrev = dtEndPrev;

			return $http.put(urlAPI + '/' + objName + '/Proroga', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function collocamento_unlockProroga(item) {
			var objName = 'collocamento';

			return $http.put(urlAPI + '/' + objName + '/UnlockProroga', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion  ******************************

		// #region   COLL-RIMBORSO
		function collRimborso_setParams(isPaging, pageSize, page, order, testuale, aplId, cpiId, collocamentoId, collServizioId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof collServizioId == 'undefined') { collServizioId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'collServizioId', value: collServizioId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function collRimborso_getAllList(testuale, aplId, cpiId, collocamentoId, collServizioId, iStato) {
			var params = collRimborso_setParams(false, 0, 0, '', testuale, aplId, cpiId, collocamentoId, collServizioId, iStato);
			var data = getAllByParams('collRimborso', 'GetAllList', params);
			return $q.when(data);
		}
		function collRimborso_getAll(pageSize, page, testuale, aplId, cpiId, collocamentoId, collServizioId, iStato, order) {
			var params = collRimborso_setParams(true, pageSize, page, order, testuale, aplId, cpiId, collocamentoId, collServizioId, iStato);
			var data = getAllByParams('collRimborso', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function collRimborso_countAll(testuale, aplId, cpiId, collocamentoId, collServizioId, iStato) {
			var params = collRimborso_setParams(false, 0, 0, '', testuale, aplId, cpiId, collocamentoId, collServizioId, iStato);
			var data = getAllByParams('collRimborso', 'CountByFilter', params);
			return $q.when(data);
		}

		function collRimborso_get(id) {
			var data = getById('collRimborso', id);
			return $q.when(data);
		}

		function collRimborso_add(item) {
			var data = addObj('collRimborso', item);
			return $q.when(data);
		}

		function collRimborso_update(item) {
			var data = updateObj('collRimborso', item);
			return $q.when(data);
		}

		function collRimborso_merge(item) {
			var data = mergeObj('collRimborso', item);
			return $q.when(data);
		}

		function collRimborso_delete(id) {
			var data = deleteObj('collRimborso', id);
			return $q.when(data);
		}

		function collRimborso_changeState(rmbId, status) {
			if (typeof rmbId == 'undefined') { rmbId = 0; }
			if (typeof status == 'undefined') { status = ''; }

			var params = [];
			params.push({ name: 'rmbId', value: rmbId });
			params.push({ name: 'status', value: status });

			var data = getAllByParams('collRimborso', 'ChangeState', params);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region --  TContratto
		function tContratto_getAllList() {
			var data = getAllList('tContratto');
			return $q.when(data);
		}

		function tContratto_getAll() {
			var data = getAll('tContratto');
			return $q.when(data);
		}

		function tContratto_get(id) {
			var data = getById('tContratto', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   COLL-SERVIZIO
		function collServizio_setParams(isGet, pageSize, page, order, descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }
			if (typeof tContrattoId == 'undefined') { tContrattoId = 0; }
			if (typeof aplId == 'undefined') { aplId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });
			params.push({ name: 'tContrattoId', value: tContrattoId });
			params.push({ name: 'aplId', value: aplId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function collServizio_getAllList(descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato) {
			var params = collServizio_setParams(false, 0, 0, '', descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllList('collServizio');
			return $q.when(data);
		}
		function collServizio_getAll(pageSize, page, descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato, order) {
			var params = collServizio_setParams(true, pageSize, page, order, descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllByParams('collServizio', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function collServizio_countAll(descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato) {
			var params = collServizio_setParams(false, 0, 0, '', descrizione, collocamentoId, tContrattoId, aplId, cpiId, iStato);
			var data = getAllByParams('collServizio', 'CountByFilter', params);
			return $q.when(data);
		}

		function collServizio_get(id) {
			var data = getById('collServizio', id);
			return $q.when(data);
		}

		function collServizio_add(item) {
			var data = addObj('collServizio', item);
			return $q.when(data);
		}

		function collServizio_update(item) {
			var data = updateObj('collServizio', item);
			return $q.when(data);
		}

		function collServizio_delete(id) {
			var data = deleteObj('collServizio', id);
			return $q.when(data);
		}

		function collServizio_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'collServizio';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   COLL-CONTRATTO (ASSUNZIONE)
		function collContratto_getAllList() {
			var data = getAllList('collContratto');
			return $q.when(data);
		}

		function collContratto_getOneByFilter(collocamentoId) {
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'collocamentoId', value: collocamentoId });

			var data = getAllByParams('collContratto', 'GetOneByFilter', params);
			return $q.when(data);

		}

		function collContratto_getAll(pageSize, page, bStato, descrizione, collocamentoId) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });

			var data = getAllByParams('collContratto', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function collContratto_countAll(bStato, descrizione, collocamentoId) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof descrizione == 'undefined') { descrizione = ''; }
			if (typeof collocamentoId == 'undefined') { collocamentoId = 0; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'descrizione', value: descrizione });
			params.push({ name: 'collocamentoId', value: collocamentoId });


			var data = getAllByParams('collContratto', 'CountByFilter', params);
			return $q.when(data);
		}

		function collContratto_get(id) {
			var data = getById('collContratto', id);
			return $q.when(data);
		}


		function collContratto_add(item) {
			var data = addObj('collContratto', item);
			return $q.when(data);
		}

		function collContratto_update(item) {
			var data = updateObj('collContratto', item);
			return $q.when(data);
		}

		function collContratto_delete(id) {
			var data = deleteObj('collContratto', id);
			return $q.when(data);
		}

		function collContratto_unlock(item) {
			var objName = 'collContratto';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed unlockObj for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region  AUTHORIZATION
		function authorization_get(area) {
			if (typeof area == 'undefined') { area = ''; }

			var params = [];
			params.push({ name: 'area', value: area });

			var data = getAllByParams('user', 'GetAuthorization', params);
			return $q.when(data);
		}

		function authorization_getAllByFilter(pageSize, page, userId, roleId, areaId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof areaId == 'undefined') { areaId = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'areaId', value: areaId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'Auth_GetAllByFilter', params);
			return $q.when(data);
		}

		function authorization_countAllByFilter(userId, roleId, areaId) {
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof areaId == 'undefined') { areaId = -1; }

			var params = [];
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'areaId', value: areaId });

			var data = getAllByParams('user', 'Auth_CountAllByFilter', params);
			return $q.when(data);
		}

		function authorization_getById(id) {
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'id', value: id });

			var data = getAllByParams('user', 'Auth_Get', params);
			return $q.when(data);
		}

		/*
		function authorization_getAllByUser(userId) {
			if (typeof userId == 'undefined') { userId = 0; }
	 
			var params = [];
			params.push({ name: 'userId', value: userId });
	 
			var data = getAllByParams('user', 'Auth_GetAllByUser', params);
			return $q.when(data);
	 
		    
			var objName = 'user';
			var actionName = 'Auth_GetAllByUser';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?'
			}
	 
			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}
	 
			return $http.get(url)
						.then(function (response) {
							return response.data;
						})
						.catch(function (message) {
							//console.info('XHR Failed authorization_getAllByUser for %s: %s', objName, message);
							return message.status;
						});
				    
		}
		*/

		function authorization_getAllByUser(userId) {
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('user', 'Auth_GetAllByUser', params);
			return $q.when(data);
		}

		function authorization_add(item) {
			var objName = 'user';
			var actionName = 'Auth_Post';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed authorization_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function authorization_update(item) {
			var objName = 'user';
			var actionName = 'Auth_Put';

			return $http.put(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed authorization_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function authorization_delete(id) {
			var objName = 'user';
			var actionName = 'Auth_Delete';
			return $http.delete(urlAPI + '/' + objName + '/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed authorization_delete for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region  AREA

		function area_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListAreas';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_getAll() {
			var objName = 'user';
			var actionName = 'Area_GetAll';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_getAll NO Param for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_getAllByFilter(nominativo) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('user', 'Area_GetAllByFilter', params);
			return $q.when(data);

		}


		function area_getMaxId() {
			var actionName = 'Area_GetMaxId';
			return $http.get(urlAPI + '/User/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_getMaxId for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_get(id) {
			var actionName = 'Area_Get';
			return $http.get(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_get for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_add(item) {
			var action = 'Area_Post';
			return $http.post(urlAPI + '/User/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_update(item) {
			var action = 'Area_Put';
			return $http.put(urlAPI + '/User/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function area_delete(id) {
			var actionName = 'Area_Delete';

			var data = $http.delete(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed area_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		// #endregion 

		// #region ============================== NEWSLETTER
		// -- MAIL_EMAIL
		function newsletter_email_getAllList() {
			var data = getAllNoParam('Newsletter_Email', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_email_getAll(pageSize, page, bSent, obj, body, dtSent, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof obj == 'undefined') { obj = ''; }
			if (typeof body == 'undefined') { body = ''; }
			if (typeof dtSent == 'undefined') { dtSent = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'obj', value: obj });
			params.push({ name: 'body', value: body });
			params.push({ name: 'dtSent', value: dtSent });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Email', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_email_countAll(pageSize, page, bSent, obj, body, dtSent, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof obj == 'undefined') { obj = ''; }
			if (typeof body == 'undefined') { body = ''; }
			if (typeof dtSent == 'undefined') { dtSent = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'obj', value: obj });
			params.push({ name: 'body', value: body });
			params.push({ name: 'dtSent', value: dtSent });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Email', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_email_get(id) {
			var data = getById('Newsletter_Email', id);
			return $q.when(data);
		}

		function newsletter_email_add(item) {
			var data = addObj('Newsletter_Email', item);
			return $q.when(data);
		}

		function newsletter_email_update(item) {
			var data = updateObj('Newsletter_Email', item);
			return $q.when(data);
		}

		function newsletter_email_confirmSent(item) {
			var objName = 'Newsletter_Email';
			var objAction = 'ConfirmSent';
			return $http.put(urlAPI + '/' + objName + '/' + objAction, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function newsletter_email_delete(id) {
			var data = deleteObj('Newsletter_Email', id);
			return $q.when(data);
		}

		function newsletter_email_invioEmail(email, id) {
			var url = urlAPI + '/Newsletter_Email/invioEmail?email=' + email + '&emailId=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function newsletter_email_invioEmails(id) {
			var url = urlAPI + '/Newsletter_Email/invioEmails?emailId=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function newsletter_email_getTemplate(template) {
			var url = urlAPI + '/Newsletter_Email/GetTemplate?template=' + template;
			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getTemplate for %s: %s', objName, message);
					return message.status;
				});
		}

		// -- MAIL_ATTACHMENT
		function newsletter_attachment_getAllList() {
			var data = getAllNoParam('Newsletter_Attachment', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_attachment_getAll(pageSize, page, emailId, filename, username, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof username == 'undefined') { username = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'filename', value: filename });
			params.push({ name: 'username', value: username });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Attachment', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_attachment_getByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Attachment', 'GetByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_attachment_countByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Attachment', 'CountByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_attachment_countAll(emailId, filename, username) {
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof username == 'undefined') { username = ''; }

			var params = [];
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'filename', value: filename });
			params.push({ name: 'username', value: username });

			var data = getAllByParams('Newsletter_Attachment', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_attachment_get(id) {
			var data = getById('Newsletter_Attachment', id);
			return $q.when(data);
		}

		function newsletter_attachment_add(item) {
			var data = addObj('Newsletter_Attachment', item);
			return $q.when(data);
		}

		function newsletter_attachment_update(item) {
			var data = updateObj('Newsletter_Attachment', item);
			return $q.when(data);
		}

		function newsletter_attachment_delete(id) {
			var data = deleteObj('Newsletter_Attachment', id);
			return $q.when(data);
		}

		// -- MAIL_TSOURCE
		function newsletter_tSource_getAllList() {
			var data = getAllNoParam('Newsletter_tSource', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_tSource_getAll(pageSize, page, table, keyfield, valuefield, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof table == 'undefined') { table = ''; }
			if (typeof keyfield == 'undefined') { keyfield = ''; }
			if (typeof valuefield == 'undefined') { valuefield = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'table', value: table });
			params.push({ name: 'keyfield', value: keyfield });
			params.push({ name: 'valuefield', value: valuefield });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_tSource', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_tSource_countAll(table, keyfield, valuefield) {
			if (typeof table == 'undefined') { table = ''; }
			if (typeof keyfield == 'undefined') { keyfield = ''; }
			if (typeof valuefield == 'undefined') { valuefield = ''; }

			var params = [];
			params.push({ name: 'table', value: table });
			params.push({ name: 'keyfield', value: keyfield });
			params.push({ name: 'valuefield', value: valuefield });

			var data = getAllByParams('Newsletter_tSource', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_tSource_get(id) {
			var data = getById('Newsletter_tSource', id);
			return $q.when(data);
		}

		function newsletter_tSource_getByTable(table) {
			var data = getAllByParam('Newsletter_tSource', 'GetByTable', 'table', table);
			return $q.when(data);
		}

		function newsletter_tSource_Entity_getList(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_GetList';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}

		function newsletter_tSource_Entity_countByFilter(id, queryParams) {
			if (typeof id == 'undefined') { id = ''; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_CountAll';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}

		function newsletter_tSource_Entity_getAllByFilter(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'Newsletter_tSource';
			var actionName = 'Entity_GetAllByPage';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}



		// -- MAIL_RECEIVERS
		function newsletter_receivers_getAllList() {
			var data = getAllNoParam('Newsletter_Receivers', 'GetAllList');
			return $q.when(data);
		}

		function newsletter_receivers_getAll(pageSize, page, emailId, address, bSent, bProcessed, tSourceId, sourceId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof address == 'undefined') { address = ''; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof bProcessed == 'undefined') { bProcessed = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'address', value: address });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'bProcessed', value: bProcessed });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Newsletter_Receivers', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function newsletter_receivers_getByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Receivers', 'GetByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_receivers_countByEmailId(emailId) {
			var data = getAllByParam('Newsletter_Receivers', 'CountByEmailId', 'emailId', emailId);
			return $q.when(data);
		}

		function newsletter_receivers_getByTSourceId(tSourceId) {
			var data = getAllByParam('Newsletter_Receivers', 'GetByTSourceId', 'tSourceId', tSourceId);
			return $q.when(data);
		}

		function newsletter_receivers_countAll(emailId, address, bSent, bProcessed, tSourceId, sourceId) {
			if (typeof emailId == 'undefined') { emailId = 0; }
			if (typeof address == 'undefined') { address = ''; }
			if (typeof bSent == 'undefined') { bSent = 0; }
			if (typeof bProcessed == 'undefined') { bProcessed = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'emailId', value: emailId });
			params.push({ name: 'address', value: address });
			params.push({ name: 'bSent', value: bSent });
			params.push({ name: 'bProcessed', value: bProcessed });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('Newsletter_Receivers', 'CountByFilter', params);
			return $q.when(data);
		}

		function newsletter_receivers_get(id) {
			var data = getById('Newsletter_Receivers', id);
			return $q.when(data);
		}

		function newsletter_receivers_add(item) {
			var data = addObj('Newsletter_Receivers', item);
			return $q.when(data);
		}

		function newsletter_receivers_update(item) {
			var data = updateObj('Newsletter_Receivers', item);
			return $q.when(data);
		}

		function newsletter_receivers_delete(id) {
			var data = deleteObj('Newsletter_Receivers', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region   FAQ - NUOVI METODI
		function faq_setParams(isGet, pageSize, page, order, tFaqId, iHomepage, misuraCode, code) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof tFaqId == 'undefined') { tFaqId = 0; }
			if (typeof iHomepage == 'undefined') { iHomepage = 0; }
			if (typeof misuraCode == 'undefined') { misuraCode = ''; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'tFaqId', value: tFaqId });
			params.push({ name: 'iHomepage', value: iHomepage });
			params.push({ name: 'misuraCode', value: misuraCode });
			params.push({ name: 'code', value: code });

			return params;
		}
		function faq_getAllList(tFaqId, iHomepage, misuraCode, code) {
			var params = faq_setParams(false, 0, 0, '', tFaqId, iHomepage, misuraCode, code);
			var data = getAllByParams('faq', 'GetAllList', params);
			return $q.when(data);
		}
		function faq_getAll(pageSize, page, order, tFaqId, iHomepage, misuraCode, code) {
			var params = faq_setParams(true, pageSize, page, order, tFaqId, iHomepage, misuraCode, code);
			var data = getAllByParams('faq', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function faq_countAll(tFaqId, iHomepage, misuraCode, code) {
			var params = faq_setParams(false, 0, 0, '', tFaqId, iHomepage, misuraCode, code);
			var data = getAllByParams('faq', 'CountByFilter', params);
			return $q.when(data);
		}

		function faq_get(id) {
			var data = getById('faq', id);
			return $q.when(data);
		}

		function faq_add(item) {
			var data = addObj('faq', item);
			return $q.when(data);
		}

		function faq_update(item) {
			var data = updateObj('faq', item);
			return $q.when(data);
		}

		function faq_merge(item) {
			var data = mergeObj('faq', item);
			return $q.when(data);
		}

		function faq_delete(id) {
			var data = deleteObj('faq', id);
			return $q.when(data);
		}


		// ******************************
		//  tFaq - NUOVI METODI
		function tFaq_getAllList() {
			var data = getAllList('tFaq');
			return $q.when(data);
		}


		function tFaq_get(id) {
			var data = getById('tFaq', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region   ATTACH - NUOVI METODI
		function attach_setParams(isGet, pageSize, page, order, sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceRefId == 'undefined') { sourceRefId = 0; }
			if (typeof tSourceRefId == 'undefined') { tSourceRefId = 0; }
			if (typeof tSourceRefCode == 'undefined') { tSourceRefCode = ''; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			//iStato=1, non rimossi, ISNULL(Att.IssueCPI, 0) = 0 AND ISNULL(Att.IssueUMC, 0) = 0
			//iStato=2, rimossi, (ISNULL(Att.IssueCPI, 0) = 2 OR ISNULL(Att.IssueUMC, 0) = 2 )
			//iStato=3, in anomalia, (ISNULL(Att.IssueCPI, 0) = 1 OR ISNULL(Att.IssueUMC, 0) = 1 )

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceRefId', value: sourceRefId });
			params.push({ name: 'tSourceRefId', value: tSourceRefId });
			params.push({ name: 'tSourceRefCode', value: tSourceRefCode });
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function attach_getAllList(sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato) {
			var params = attach_setParams(false, 0, 0, '', sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato);

			var data = getAllByParams('attach', 'GetAllList', params);
			return $q.when(data);
		}

		function attach_getAll(pageSize, page, sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato, order) {
			var params = attach_setParams(true, pageSize, page, order, sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato);

			var data = getAllByParams('attach', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function attach_countAll(sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato) {
			var params = attach_setParams(false, 0, 0, '', sourceId, tSourceId, tSourceCode, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, iStato);

			var data = getAllByParams('attach', 'CountByFilter', params);
			return $q.when(data);
		}

		function attach_setParamsCND(pageSize, page, progettoUID, sourceUID, sourceId, tSourceId, tSourceCode, sourceRefUID, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof progettoUID == 'undefined') { progettoUID = '00000000-0000-0000-0000-000000000000'; }
			if (typeof sourceUID == 'undefined') { sourceUID = '00000000-0000-0000-0000-000000000000'; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceRefUID == 'undefined') { sourceRefUID = '00000000-0000-0000-0000-000000000000'; }
			if (typeof sourceRefId == 'undefined') { sourceRefId = 0; }
			if (typeof tSourceRefId == 'undefined') { tSourceRefId = 0; }
			if (typeof tSourceRefCode == 'undefined') { tSourceRefCode = ''; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'sourceUID', value: sourceUID });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceRefUID', value: sourceRefUID });
			params.push({ name: 'sourceRefId', value: sourceRefId });
			params.push({ name: 'tSourceRefId', value: tSourceRefId });
			params.push({ name: 'tSourceRefCode', value: tSourceRefCode });
			params.push({ name: 'tAttachId', value: tAttachId });

			return params;
		}

		function attach_getAllCND(pageSize, page, progettoUID, sourceUID, sourceId, tSourceId, tSourceCode, sourceRefUID, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, order) {
			var params = attach_setParamsCND(pageSize, page, progettoUID, sourceUID, sourceId, tSourceId, tSourceCode, sourceRefUID, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, order, true);

			var data = getAllByParams('attachCND', 'GetAllByFilterCND', params);
			return $q.when(data);
		}

		function attach_countAllCND(progettoUID, sourceUID, sourceId, tSourceId, tSourceCode, sourceRefUID, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId) {
			var params = attach_setParamsCND(0, 0, progettoUID, sourceUID, sourceId, tSourceId, tSourceCode, sourceRefUID, sourceRefId, tSourceRefId, tSourceRefCode, tAttachId, '', false);

			var data = getAllByParams('attachCND', 'CountAllByFilterCND', params);
			return $q.when(data);
		}

		function attach_getReadyToLockCND(progettoUID, tSourceCode, sourceId) {
			if (typeof progettoUID == 'undefined') { progettoUID = '00000000-0000-0000-0000-000000000000'; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('attachCND', 'GetReadyToLockCND', params);
			return $q.when(data);
		}

		function attach_get(id) {
			var data = getById('attach', id);
			return $q.when(data);
		}

		function attach_add(item) {
			var data = addObj('attach', item);
			return $q.when(data);
		}

		function attach_AddMultiplo(list) {
			var objName = 'Attach';
			var actionName = 'AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed attach_AddMultiplo for %s: %s', objName, message);
					return message.status;
				});

		}

		function attach_update(item) {
			var data = updateObj('attach', item);
			return $q.when(data);
		}

		function attach_merge(item) {
			var data = mergeObj('attach', item);
			return $q.when(data);
		}

		function attach_delete(id) {
			var data = deleteObj('attach', id);
			return $q.when(data);
		}

		function attach_changeState(id, code) {
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') code = '';

			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?id=' + id + '&code=' + code)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_setCompleted(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/SetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_unsetCompleted(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/UnsetCompleted/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_setIssue(item) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/SetIssue/', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_unsetIssue(id) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/UnsetIssue/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		

		//      function attach_updateIssue(item) {
		//          var objName = 'attach';

		//          return $http.put(urlAPI + '/' + objName + '/UpdateIssue/', item)
		//              .then(function (response) {
		//                  return response.status;
		//              })
		//              .catch(function (message) {
		//                  console.log('XHR Failed att_UnsetCompleted for %s: %s', objName, message);
		//                  return message.status;
		//              });
		//}

		function attach_updateIssue(item, replacedId, bAnomalia) {
			var objName = 'attach';
			var method = 'UpdateIssue';

			if (typeof (item) == 'undefined') { item = {}; }

			var url = urlAPI + '/' + objName + '/' + method + '?replacedId=' + replacedId + '&bAnomalia=' + bAnomalia;

			return $http.put(url, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.info('XHR Failed add for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_unlock(item) {
			var objName = 'attach';

			return $http.put(urlAPI + '/' + objName + '/Unlock/', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					console.log('XHR Failed att_SetCompleted for %s: %s', objName, message);
					return message.status;
				});
		}

		function attach_download(sourceId, tSourceCode, tSourceId, tEstrazioneId) {
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tEstrazioneId == 'undefined') { tEstrazioneId = 0; }

			var params = [];
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tEstrazioneId', value: tEstrazioneId });

			var data = getAllByParams('attach', 'Download', params);
			return $q.when(data);
		}

		function attach_getBySource(tSourceCode, sourceId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: 0 });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('attach', 'GetBySource', params);
			return $q.when(data);
		}

		function attach_extract(id) {
			return $http.get(urlAPI + '/Attach/Extract/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getById for Extract: %s', message);
					return message.status;
				});
		}

		function attach_extractDigitalSignInfo(id) {
			return $http.get(urlAPI + '/Attach/ExtractDigitalSignInfo/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getById for Extract: %s', message);
					return message.status;
				});
		}

		function attach_safeDownload(id) {
			return $http.get(urlAPI + '/Attach/SafeDownload/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed getById for Extract: %s', message);
					return message.status;
				});
		}

		// ******************************
		//  ATTACHHASH - NUOVI METODI
		function attachHash_setParams(isGet, pageSize, page, order, testuale, tSourceId, tAttachId, sourceId, iStato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}
		function attachHash_getAllList(testuale, tSourceId, tAttachId, sourceId, iStato) {
			var params = attachHash_setParams(false, 0, 0, '', testuale, tSourceId, tAttachId, sourceId, iStato);

			var data = getAllByParams('attachHash', 'GetAllList', params);
			return $q.when(data);
		}
		function attachHash_getAll(pageSize, page, testuale, tSourceId, tAttachId, sourceId, iStato, order) {
			var params = attachHash_setParams(true, pageSize, page, order, testuale, tSourceId, tAttachId, sourceId, iStato);

			var data = getAllByParams('attachHash', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function attachHash_countAll(testuale, tSourceId, tAttachId, sourceId, iStato) {
			var params = attachHash_setParams(false, 0, 0, '', testuale, tSourceId, tAttachId, sourceId, iStato);

			var data = getAllByParams('attachHash', 'CountByFilter', params);
			return $q.when(data);
		}

		function attachHash_get(id) {
			var data = getById('attachHash', id);
			return $q.when(data);
		}

		function attachHash_create(pathfile) {
			var data = getAllByParam('attachHash', 'create', 'pathfile', pathfile);
			return $q.when(data);
		}

		function attachHash_add(item) {
			var data = addObj('attachHash', item);
			return $q.when(data);
		}

		function attachHash_delete(id) {
			var data = deleteObj('attachHash', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region   TATTACH - NUOVI METODI
		function tAttach_getAllList(tSourceCode, tSourceId, sourceId, onlyMissing, tAttachId) {
			/*
				onlyMissing:
					1: solo mancanti
					0: tutte
					-1: sono presenti
			*/
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof onlyMissing == 'undefined') { onlyMissing = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'onlyMissing', value: onlyMissing });
			params.push({ name: 'tAttachId', value: tAttachId });

			var data = getAllByParams('tAttach', 'GetAllList', params);
			return $q.when(data);
		}

		function tAttach_getAllModal(tSourceCode, tSourceId, sourceId, onlyMissing, order) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof onlyMissing == 'undefined') { onlyMissing = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'onlyMissing', value: onlyMissing });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tAttach', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function tAttach_getAll(pageSize, page, tSourceCode, tSourceId, testuale, roleId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('tAttach', 'GetAllWithoutVisibility', params);
			return $q.when(data);
		}

		function tAttach_countAll(tSourceCode, tSourceId, testuale, roleId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });

			var data = getAllByParams('tAttach', 'CountWithoutVisibility', params);
			return $q.when(data);
		}


		function tAttach_get(id) {
			var data = getById('tAttach', id);
			return $q.when(data);
		}

		function tAttach_getByCode(code, tSourceId) {
			if (typeof code == 'undefined') { code = ''; }
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }

			var params = [];
			params.push({ name: 'code', value: code });
			params.push({ name: 'tSourceId', value: tSourceId });

			var data = getAllByParams('tAttach', 'GetByCode', params);
			return $q.when(data);
		}

		function tAttach_add(item) {
			var data = addObj('tAttach', item);
			return $q.when(data);
		}

		function tAttach_update(item) {
			var data = updateObj('tAttach', item);
			return $q.when(data);
		}

		function tAttach_delete(id) {
			var data = deleteObj('tAttach', id);
			return $q.when(data);
		}

		// ******************************
		//  TATTACHVISIBILITY - NUOVI METODI

		function tAttachVisibility_getAuth(tSourceCode) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });

			var data = getAllByParams('TAttach', 'TAttachVisibility_GetAuth', params);
			return $q.when(data);
		}

		function tAttachVisibility_getAll(tAttachId, roleId, tSourceCode) {
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'tSourceCode', value: tSourceCode });

			var data = getAllByParams('TAttach', 'TAttachVisibility_GetAllByFilter', params);
			return $q.when(data);
		}

		function tAttachVisibility_add(item) {
			return $http.post(urlAPI + '/TAttach/TAttachVisibility_Add', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed tAttachVisibility_add for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachVisibility_update(item) {
			return $http.put(urlAPI + '/TAttach/TAttachVisibility_Update', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed tAttachVisibility_update for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachVisibility_delete(id) {
			return $http.delete(urlAPI + '/TAttach/TAttachVisibility_Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for TAttach: %s', message);
					return message.status;
				});
		}

		// ******************************
		//  TATTACHFILETYPE - NUOVI METODI

		function tAttachFileType_getAll(tAttachId, title, extension) {
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }
			if (typeof title == 'undefined') { title = ''; }
			if (typeof extension == 'undefined') { extension = ''; }

			var params = [];
			params.push({ name: 'tAttachId', value: tAttachId });
			params.push({ name: 'title', value: title });
			params.push({ name: 'extension', value: extension });

			var data = getAllByParams('TAttach', 'TAttachFileType_GetAllByFilter', params);
			return $q.when(data);
		}

		function tAttachFileType_add(item) {
			return $http.post(urlAPI + '/TAttach/TAttachFileType_Add', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed TAttachFileType_Add for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachFileType_update(item) {
			return $http.put(urlAPI + '/TAttach/TAttachFileType_Update', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed TAttachFileType_Update for TAttach: %s', message);
					return message.status;
				});

		}

		function tAttachFileType_delete(id) {
			return $http.delete(urlAPI + '/TAttach/TAttachFileType_Delete/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for TAttachFileType: %s', message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   TSOURCE - NUOVI METODI
		function tSource_getAllList(testuale) {
			if (typeof testuale == 'undefined') { testuale = ''; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });

			var data = getAllByParams('tSource', 'GetAllList', params);
			return $q.when(data);
		}

		function tSource_getAll(pageSize, page, testuale, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof order == 'undefined') { order = ''; }

			if (typeof testuale == 'undefined') { testuale = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'order', value: order });

			params.push({ name: 'testuale', value: testuale });

			var data = getAllByParams('tSource', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function tSource_countAll(testuale) {
			if (typeof testuale == 'undefined') { testuale = ''; }

			var params = [];
			params.push({ name: 'testuale', value: testuale });

			var data = getAllByParams('tSource', 'CountByFilter', params);
			return $q.when(data);
		}

		function tSource_get(id) {
			var data = getById('tSource', id);
			return $q.when(data);
		}

		function tSource_getByCode(code) {
			var data = getAllByParam('tSource', 'GetByCode', 'code', code);
			return $q.when(data);
		}

		function tSource_add(item) {
			var data = addObj('tSource', item);
			return $q.when(data);
		}

		function tSource_update(item) {
			var data = updateObj('tSource', item);
			return $q.when(data);
		}

		function tSource_delete(id) {
			var data = deleteObj('tSource', id);
			return $q.when(data);
		}


		// #endregion  ******************************

		// #region   SOURCE
		function source_getAllList(code) {
			var data = null;
			if (code == 'STD') {
				data = destinatario_getAllList();
			}
			else if (code == 'CRS') {
				data = corso_getAllList();
			}
			else if (code == 'CLS') {
				data = classe_getAllList();
			}
			else if (code == 'AZD') {
				data = azienda_getAllList();
			}
			else if (code == 'TIR') {
				data = tirocinante_getAllList();
			}
			else if (code == 'RMB') {
				data = rimborso_getAllList();
			}
			else if (code == 'RDT') {
				data = rimborsoDtl_getAllList();
			}
			else if (code == 'TRC') {
				data = tirocinio_getAllList();
			}
			else if (code == 'CRB') {
				data = collRimborso_getAllList();
			}
			else if (code == 'CRS_2A') {
				data = pCorso_getAllList();
			}
			else if (code == 'CRS_2B') {
				data = pCorso_getAllList();
			}
			else if (code == 'DED') {
				data = destinatario_getAllList();
			}
			else if (code == 'DocsF1') {
				data = tMisura_getAllList();
			}
			else if (code == 'DocsF2') {
				data = tMisura_getAllList();
			}
			else if (code == 'DocsF3') {
				data = tMisura_getAllList();
			}

			return $q.when(data);
		}

		// #endregion ******************************

		// #region   USER
		function user_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListUsers';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_getAllListActive() {
			var objName = 'user';
			var actionName = 'GetAllListUsersActive';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_getAll(pageSize, page, testuale, roleId, userId, bAttivo, bloccato, order) {
			if (typeof bAttivo == 'undefined') { bAttivo = 1; }
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof bloccato == 'undefined') { bloccato = 0; }
			if (typeof order == 'undefined') { order = 'username'; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'bloccato', value: bloccato });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function user_countAll(testuale, roleId, userId, bAttivo, bloccato) {
			if (typeof bAttivo == 'undefined') { bAttivo = 1; }
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof bloccato == 'undefined') { bloccato = 0; }
			var params = [];
			params.push({ name: 'bAttivo', value: bAttivo });
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'bloccato', value: bloccato });

			var data = getAllByParams('user', 'CountByFilter', params);
			return $q.when(data);
		}

		function user_createNewAccount(item) {
			var objName = 'user';
			var action = 'CreateNewAccount';
			return $http.post(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_get(id) {
			var data = getById('user', id);
			return $q.when(data);
		}

		function user_add(item) {
			console.log("user_add(item)");
			//console.dir(item);

			var data = addObj('user', item);
			return $q.when(data);
		}

		function user_update(item) {
			var data = updateObj('user', item);
			return $q.when(data);
		}

		function user_exists(username, email, userId) {
			if (typeof username == 'undefined') { username = ''; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'username', value: username });
			params.push({ name: 'email', value: email });
			params.push({ name: 'userId', value: userId });

			var data = getAllByParams('validazione', 'ExistsUsername', params);
			return $q.when(data);
		}

		function user_setPassword(item) {
			var objName = 'user';
			var action = 'SetPassword';
			return $http.put(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_activate(id) {
			var url = urlAPI + '/user/activate?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed activate for user: %s', message);
					return message.status;
				});
		}

		function user_deactivate(id) {
			var url = urlAPI + '/user/deactivate?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed deactivate for user: %s', message);
					return message.status;
				});
		}

		function user_resetPassword(username) {
			var url = urlAPI + '/user/resetpassword?username=' + username;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function user_invioCredenziali(username) {
			var url = urlAPI + '/user/invioCredenziali?username=' + username;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed Reset Password for user: %s', message);
					return message.status;
				});
		}

		function user_GeneraPassword(id) {
			if (typeof id == 'undefined') { id = 0; }

			var url = urlAPI + '/User/GeneraPassword?id=' + id;
			return $http.post(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed GeneraObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_UnlockAccount(item) {
			return $http.put(urlAPI + '/User/UnlockAccount', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed UnlockAccountObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_changePassword(item) {
			var objName = 'user';
			var action = 'ChangePassword';
			return $http.put(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed changePassword for %s: %s', objName, message);
					return message.status;
				});
		}

		function user_sendMassive() {
			var data = getAllNoParam('user', 'SendMassive');
			return $q.when(data);
		}

		/*
		function user_delete(id) {
			console.log("deleteUser(%s)", id);
	 
			var data = deleteObj('user', id);
			return $q.when(data);
		}
		*/

		// #endregion  ******************************

		// #region   ROLE
		function role_getAllList() {
			var objName = 'user';
			var actionName = 'GetAllListRoles';
			return $http.get(urlAPI + '/' + objName + '/' + actionName)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getAll(nome) {
			if (typeof nome == 'undefined') { nome = ''; }

			var params = [];
			params.push({ name: 'nome', value: nome });

			var data = getAllByParams('user', 'GetAllRoles', params);
			return $q.when(data);
		}

		/*function role_getAll() {
			var objName = 'user';
			var actionName = 'GetAllRoles';
			var url = urlAPI + '/' + objName + '/' + actionName;
			return $http.get(url)
									.then(function (response) {
										return response.data;
									})
									.catch(function (message) {
										//console.info('XHR Failed role_getAll for %s: %s', objName, message);
										return message.status;
									});
		}*/

		function role_get(id) {
			var objName = 'user';
			var actionName = 'GetRole';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getDto(id) {
			var objName = 'user';
			var actionName = 'Role_GetDto';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed role_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_getAllUser(pageSize, page, nome, roleId, userId, iAttivo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof iAttivo == 'undefined') { iAttivo = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'iAttivo', value: iAttivo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('user', 'Role_GetAllUserByFilter', params);
			return $q.when(data);
		}

		function role_countAllUser(nome, roleId, userId, iAttivo) {
			if (typeof nome == 'undefined') { nome = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof iAttivo == 'undefined') { iAttivo = 0; }

			var params = [];
			params.push({ name: 'nome', value: nome });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'iAttivo', value: iAttivo });

			var data = getAllByParams('user', 'Role_CountUserByFilter', params);
			return $q.when(data);
		}

		function role_add(item) {
			var objName = 'user';
			var action = 'Role_Post';
			return $http.post(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed role_addObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_update(item) {
			var objName = 'user';
			var action = 'Role_Put';
			return $http.put(urlAPI + '/' + objName + '/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed role_updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function role_delete(id) {
			var actionName = 'Role_Delete';

			var data = $http.delete(urlAPI + '/User/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed role_deleteObj for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		function roleUser_add(roleId, userId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'user';
			var actionName = 'RoleUser_Add';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});

		}

		function roleUser_delete(roleId, userId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'user';
			var actionName = 'RoleUser_Delete';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}

		/*
		questo metodo cancella fisicamente i record da 
			- dbo.Att_TAttachVisibility
			- dbo.WEB_RolesAuthorizations
			- dbo.WEB_UsersInRole
		funziona solo quando uno dei due � diverso da zero e l'altro � zero
		*/
		function deleteChildrenOfRoleIdOrUserId(roleId, tAttachId) {
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof tAttachId == 'undefined') { tAttachId = 0; }

			var params = [];
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'tAttachId', value: tAttachId });

			var objName = 'user';
			var actionName = 'DeleteChildren';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteChildrenObj for %s: %s', objName, message);
					return message.status;
				});
		}



		// #endregion  ******************************

		// #region   USER ROLE
		function userRole_getAll(id) {
			var objName = 'user';
			var actionName = 'GetUserRoles';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function userRole_add(risorsaId, roleId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'user';
			var actionName = 'AddUserRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}
			return $http.post(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed addObj for %s: %s', objName, message);
					return message.status;
				});

		}

		function userRole_delete(risorsaId, roleId) {
			if (typeof risorsaId == 'undefined') { risorsaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'risorsaId', value: risorsaId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'user';
			var actionName = 'DeleteUserRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed deleteObj for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region  QUERY
		function query_getAllByFilter(pageSize, page, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = 'alfabetico'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('query', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function query_countByFilter(nominativo) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('query', 'CountByFilter', params);

			return $q.when(data);
		}

		function query_get(id) {
			var data = getById('query', id);
			return $q.when(data);
		}

		function query_add(item) {
			var data = addObj('query', item);
			return $q.when(data);
		}

		function query_update(item) {
			var data = updateObj('query', item);
			return $q.when(data);
		}

		function query_delete(id) {
			var data = deleteObj('query', id);
			return $q.when(data);
		}

		function queryEntity_download(id, queryParams) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Download';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
			/*
			var data = getAllByParam('query', 'Download', 'id', id);
	
			return $q.when(data);
			*/
		}

		function queryEntity_getAllByFilter(pageSize, page, id, queryParams) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Entity_GetAllByPage';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
		}

		function queryEntity_countByFilter(id, queryParams) {
			if (typeof id == 'undefined') { id = ''; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'Entity_CountAll';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed Exec for %s: %s', objName, message);
					return message.status;
				});
			/*
					var data = getAllByParams('query', 'Entity_CountAll', params);
	
					return $q.when(data);
					*/
		}

		function query_exportToExcel(id, queryParams) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'ExportToExcel';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed query_exportToExcel for %s: %s', objName, message);
					return message.status;
				});
		}

		function query_exportToPDF(id, queryParams) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof queryParams == 'undefined') { queryParams = []; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'queryParams', value: queryParams });

			var objName = 'query';
			var actionName = 'ExportToPdf';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed query_exportToPDF for %s: %s', objName, message);
					return message.status;
				});
		}

		function query_make(item) {
			var objName = 'query';

			return $http.put(urlAPI + '/' + objName + '/MakeQuery', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					return message.status;
				});
		}

		function query_generateExcel(id) {
			var objName = 'query';
			var actionName = 'GenerateExcel';

			return $http.get(urlAPI + '/' + objName + '/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.info('XHR Failed query_generateExcel for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion

		// #region  QUERYVISIBILITY
		function queryVisibility_getAllByFilter(queryId) {
			if (typeof queryId == 'undefined') { queryId = 0; }
			var params = [];
			params.push({ name: 'queryId', value: queryId });

			var data = getAllByParams('queryVisibility', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function queryVisibility_countByFilter(queryId) {
			if (typeof queryId == 'undefined') { queryId = 0; }

			var params = [];
			params.push({ name: 'queryId', value: queryId });

			var data = getAllByParams('queryVisibility', 'CountByFilter', params);

			return $q.when(data);
		}

		function queryVisibility_get(id) {
			var data = getById('queryVisibility', id);
			return $q.when(data);
		}

		function queryVisibility_add(item) {
			var data = addObj('queryVisibility', item);
			return $q.when(data);
		}

		function queryVisibility_AddMultiplo(list) {
			var objName = 'queryVisibility';
			var actionName = 'AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed QueryVisibility_AddMultiplo for %s: %s', objName, message);
					return message.status;
				});
		}

		function queryVisibility_update(item) {
			var data = updateObj('queryVisibility', item);
			return $q.when(data);
		}

		function queryVisibility_delete(id) {
			var data = deleteObj('queryVisibility', id);
			return $q.when(data);
		}

		// #endregion


		// #region  NOTIFICATION
		function notification_getAllByFilter(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('notification', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function notification_countByFilter(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('notification', 'CountByFilter', params);

			return $q.when(data);
		}

		//Metodi per BACKOFFICE
		function notification_setParams(isGet, testuale, onlyActive, bRead, iHome, iSistema, iStato, tSourceId_Rmb, sourceId_Rmb, pageSize, page, order) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = 'data'; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof bRead == 'undefined') { bRead = 0; }
			if (typeof iHome == 'undefined') { iHome = 0; }
			if (typeof iSistema == 'undefined') { iSistema = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			if (typeof tSourceId_Rmb == 'undefined') { tSourceId_Rmb = 0; }
			if (typeof sourceId_Rmb == 'undefined') { sourceId_Rmb = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'bRead', value: bRead });
			params.push({ name: 'iHome', value: iHome });
			params.push({ name: 'iSistema', value: iSistema });
			params.push({ name: 'iStato', value: iStato });

			params.push({ name: 'tSourceId_Rmb', value: tSourceId_Rmb });
			params.push({ name: 'sourceId_Rmb', value: sourceId_Rmb });

			return params;
		}
		function notification_getAll(pageSize, page, testuale, onlyActive, bRead, iHome, iSistema, iStato, tSourceId_Rmb, sourceId_Rmb, order) {
			var params = notification_setParams(true, testuale, onlyActive, bRead, iHome, iSistema, iStato, tSourceId_Rmb, sourceId_Rmb, pageSize, page, order);
			var data = getAllByParams('notification', 'GetAll', params);
			return $q.when(data);
		}
		function notification_countAll(testuale, onlyActive, bRead, iHome, iSistema, iStato, tSourceId_Rmb, sourceId_Rmb) {
			var params = notification_setParams(false, testuale, onlyActive, bRead, iHome, iSistema, iStato, tSourceId_Rmb, sourceId_Rmb, 0, 0, '');
			var data = getAllByParams('notification', 'CountAll', params);
			return $q.when(data);
		}

		function notification_getDto(id) {
			var actionName = 'GetDto';
			return $http.get(urlAPI + '/Notification/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notification_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_add(item) {
			var action = 'Post';
			return $http.post(urlAPI + '/Notification/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notification_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_update(item) {
			var action = 'Put';
			return $http.put(urlAPI + '/Notification/' + action, item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed notification_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function notification_delete(id) {
			var actionName = 'Delete';

			var data = $http.delete(urlAPI + '/Notification/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed notification_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		// ******************************
		//  NOTIFICATION VISIBILITY - NUOVI METODI

		function notificationVisibility_getAll(notificationId, roleId, userId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }
			if (typeof userId == 'undefined') { userId = 0; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });
			params.push({ name: 'roleId', value: roleId });
			params.push({ name: 'userId', value: userId });

			var objName = 'notification';
			var actionName = 'notificationVisibility_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function notificationVisibility_add(item) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Add';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_add for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationVisibility_addList(list) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_addList';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_addList for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationVisibility_update(item) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Update';

			return $http.put(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_update for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationVisibility_delete(id) {
			var objName = 'notification';
			var actionName = 'notificationVisibility_Delete';
			var url = urlAPI + '/' + objName + '/' + actionName + '/' + id;

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationVisibility_delete for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  NOTIFICATION USER - NUOVI METODI

		function notificationUser_getAll(notificationId, dtRead) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }
			if (typeof dtRead == 'undefined') { dtRead = ""; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });
			params.push({ name: 'dtRead', value: dtRead });

			var objName = 'notification';
			var actionName = 'notificationUser_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}



		function notificationUser_push(notificationId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }

			var item = {};
			item.NotificationId = notificationId;

			var objName = 'notification';
			var actionName = 'notificationUser_Push';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationUser_add for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationUser_update(notificationId) {
			if (typeof notificationId == 'undefined') { notificationId = 0; }

			var params = [];
			params.push({ name: 'notificationId', value: notificationId });

			var objName = 'notification';
			var actionName = 'notificationUser_Update';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.put(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationUser_update for %s: %s', objName, message);
					return message.status;
				});

		}

		function notificationUser_delete(id) {
			if (typeof id == 'undefined') { id = 0; }
			var objName = 'notification';
			var actionName = 'notificationUser_Delete';

			return $http.delete(urlAPI + '/' + objName + '/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed notificationUser_delete for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region --DOWNLOAD
		function download_getAllByFilter(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('download', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function download_countByFilter(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('download', 'CountByFilter', params);

			return $q.when(data);
		}

		function download_getList() {
			var data = getAllNoParam('Download', 'GetList');
			return $q.when(data);
		}


		function download_getAll(pageSize, page, onlyActive, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('Download', 'GetAll', params);
			return $q.when(data);
		}

		function download_countAll(onlyActive) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });

			var data = getAllByParams('Download', 'CountAll', params);

			return $q.when(data);
		}

		function download_getDto(id) {
			var actionName = 'GetDto';
			return $http.get(urlAPI + '/Download/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed download_getDto for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_add(item) {
			var action = 'Post';
			return $http.post(urlAPI + '/Download/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed download_add for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_update(item) {
			var action = 'Put';
			return $http.put(urlAPI + '/Download/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed download_update for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_merge(item) {
			var action = 'Merge';
			return $http.put(urlAPI + '/Download/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed download_merge for %s: %s', objName, message);
					return message.status;
				});
		}

		function download_delete(id) {
			var actionName = 'Delete';

			var data = $http.delete(urlAPI + '/Download/' + actionName + '/' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed download_delete for %s: %s', objName, message);
					return message.status;
				});
			return $q.when(data);
		}

		// ******************************
		//  DOWNLOAD VISIBILITY - NUOVI METODI

		function downloadVisibility_getAll(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'download';
			var actionName = 'downloadVisibility_GetAllByFilter';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;

			}

			return $http.get(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAll for %s: %s', objName, message);
					return message.status;
				});
		}

		function downloadVisibility_addRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var item = {};
			item.downloadId = downloadId;
			item.RoleId = roleId;

			var objName = 'download';
			var actionName = 'downloadVisibility_AddRole';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed downloadVisibility_addRole for %s: %s', objName, message);
					return message.status;
				});

		}

		function downloadVisibility_updateRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var item = {};
			item.downloadId = downloadId;
			item.RoleId = roleId;

			var objName = 'download';
			var actionName = 'downloadVisibility_UpdateRole';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed downloadVisibility_updateRole for %s: %s', objName, message);
					return message.status;
				});

		}

		function downloadVisibility_deleteRole(downloadId, roleId) {
			if (typeof downloadId == 'undefined') { downloadId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'downloadId', value: downloadId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'download';
			var actionName = 'downloadVisibility_RemoveRole';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed downloadVisibility_deleteRole for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region --VIDEOGUIDA
		function videoGuida_getAllByFilter(pageSize, page, onlyActive, bHome, code, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof bHome == 'undefined') { bHome = 0; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'bHome', value: bHome });
			params.push({ name: 'code', value: code });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('VideoGuida', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function videoGuida_countByFilter(onlyActive, bHome, code) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof bHome == 'undefined') { bHome = 0; }
			if (typeof code == 'undefined') { code = ''; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'bHome', value: bHome });
			params.push({ name: 'code', value: code });

			var data = getAllByParams('VideoGuida', 'CountByFilter', params);
			return $q.when(data);
		}


		function videoGuida_getAll(pageSize, page, onlyActive, bHome, code, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof bHome == 'undefined') { bHome = 0; }
			if (typeof code == 'undefined') { code = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'bHome', value: bHome });
			params.push({ name: 'code', value: code });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('VideoGuida', 'GetAll', params);
			return $q.when(data);
		}

		function videoGuida_countAll(onlyActive, bHome, code) {
			if (typeof onlyActive == 'undefined') { onlyActive = true; }
			if (typeof bHome == 'undefined') { bHome = 0; }
			if (typeof code == 'undefined') { code = ''; }
			var params = [];
			params.push({ name: 'onlyActive', value: onlyActive });
			params.push({ name: 'bHome', value: bHome });
			params.push({ name: 'code', value: code });

			var data = getAllByParams('VideoGuida', 'CountAll', params);
			return $q.when(data);
		}

		function videoGuida_getDto(id) {
			var actionName = 'GetDto';
			return $http.get(urlAPI + '/VideoGuida/' + actionName + '/' + id)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed videoGuida_getDto for VideoGuida: %s', message);
					return message.status;
				});
		}

		function videoGuida_add(item) {
			var data = addObj('VideoGuida', item);
			return $q.when(data);
		}

		function videoGuida_update(item) {
			var data = updateObj('VideoGuida', item);
			return $q.when(data);
		}

		function videoGuida_merge(item) {
			var action = 'Merge';
			return $http.put(urlAPI + '/VideoGuida/' + action, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed videoGuida_merge for VideoGuida: %s', message);
					return message.status;
				});
		}

		function videoGuida_delete(id) {
			var data = deleteObj('VideoGuida', id);
			return $q.when(data);
		}

		// ******************************
		//  VIDEOGUIDA VISIBILITY - NUOVI METODI

		function videoGuidaVisibility_getAll(videoGuidaId, roleId) {
			if (typeof videoGuidaId == 'undefined') { videoGuidaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'videoGuidaId', value: videoGuidaId });
			params.push({ name: 'roleId', value: roleId });

			var data = getAllByParams('VideoGuidaVisibility', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function videoGuidaVisibility_add(videoGuidaId, roleId) {
			if (typeof videoGuidaId == 'undefined') { videoGuidaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var item = {};
			item.videoGuidaId = videoGuidaId;
			item.RoleId = roleId;

			var data = addObj('VideoGuidaVisibility', item);
			return $q.when(data);
		}

		function videoGuidaVisibility_update(videoGuidaId, roleId) {
			if (typeof videoGuidaId == 'undefined') { videoGuidaId = ''; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'videoGuidaId', value: videoGuidaId });
			params.push({ name: 'roleId', value: roleId });

			var item = {};
			item.videoGuidaId = videoGuidaId;
			item.RoleId = roleId;

			var data = updateObj('VideoGuidaVisibility', item);
			return $q.when(data);
		}

		function videoGuidaVisibility_delete(videoGuidaId, roleId) {
			if (typeof videoGuidaId == 'undefined') { videoGuidaId = 0; }
			if (typeof roleId == 'undefined') { roleId = 0; }

			var params = [];
			params.push({ name: 'videoGuidaId', value: videoGuidaId });
			params.push({ name: 'roleId', value: roleId });

			var objName = 'VideoGuidaVisibility';
			var actionName = 'Delete';
			var url = urlAPI + '/' + objName + '/' + actionName;
			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.delete(url)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed for %s_delete: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region --ACCOUNT
		function account_getDaysValidityPassword() {
			return $http.get('/Account/ValidityPassword_GetLastDays')
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed lastDaysValidityPassword for %s: %s', objName, message);
					return message.status;
				});
		}
		// #endregion 

		// #region -- PARAMS
		function params_get(tSourceCode, sourceId) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getAllByParams('Params', 'Get', params);
			return $q.when(data);
		}

		function params_exists(tSourceCode, sourceId, id) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'id', value: id });

			var data = getAllByParams('Params', 'Exists', params);
			return $q.when(data);
		}

		function params_setParams(bPaging, pageSize, page, order, testuale, tSourceCode, sourceId, dt, iStato) {
			if (bPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = -1; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}

		function params_getAllList(testuale, tSourceCode, sourceId, dt, iStato) {
			var params = params_setParams(false, 0, 0, '', testuale, tSourceCode, sourceId, dt, iStato);
			var data = getAllByParams('Params', 'GetAllList', params);
			return $q.when(data);
		}

		function params_getAll(pageSize, page, testuale, tSourceCode, sourceId, dt, iStato, order) {
			var params = params_setParams(true, pageSize, page, order, testuale, tSourceCode, sourceId, dt, iStato);
			var data = getAllByParams('Params', 'GetAll', params);
			return $q.when(data);
		}

		function params_countAll(testuale, tSourceCode, sourceId, dt, iStato) {
			var params = params_setParams(false, 0, 0, '', testuale, tSourceCode, sourceId, dt, iStato);
			var data = getAllByParams('Params', 'CountAll', params);
			return $q.when(data);
		}

		function params_getById(id) {
			var data = getById('Params', id);
			return $q.when(data);
		}

		function params_add(item) {
			var data = addObj('Params', item);
			return $q.when(data);
		}

		function params_update(item) {
			var data = updateObj('Params', item);
			return $q.when(data);
		}

		function params_merge(item) {
			var data = mergeObj('Params', item);
			return $q.when(data);
		}

		function params_delete(id) {
			var data = deleteObj('Params', id);
			return $q.when(data);
		}

		// #endregion  ******************************


		//-- PROTOCOLLO
		function protocollo_setParams(bPaging, pageSize, page, order, testuale, percorso, lep, tSourceCode, sourceId, cf, iStato) {
			if (bPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof lep == 'undefined') { lep = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cf == 'undefined') { cf = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'lep', value: lep });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cf', value: cf });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}
		function protocollo_getAll(pageSize, page, testuale, percorso, lep, tSourceCode, sourceId, cf, iStato, order) {
			var params = protocollo_setParams(true, pageSize, page, order, testuale, percorso, lep, tSourceCode, sourceId, cf, iStato);
			var data = getAllByParams('Protocollo', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function protocollo_countAll(testuale, percorso, lep, tSourceCode, sourceId, cf, iStato) {
			var params = protocollo_setParams(false, 0, 0, '', testuale, percorso, lep, tSourceCode, sourceId, cf, iStato);
			var data = getAllByParams('Protocollo', 'CountByFilter', params);
			return $q.when(data);
		}

		function protocollo_syncImport() {
			var data = getAllNoParam('Protocollo', 'SyncImport');
			return $q.when(data);
		}
		function protocollo_syncImportAnagrafica() {
			var data = getAllNoParam('Protocollo', 'SyncImportAnagrafica');
			return $q.when(data);
		}


		function protocollo_setParams2(bPaging, pageSize, page, order, testuale, codiceIntermediario, iStato) {
			if (bPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof codiceIntermediario == 'undefined') { codiceIntermediario = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (bPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'codiceIntermediario', value: codiceIntermediario });
			params.push({ name: 'iStato', value: iStato });


			return params;
		}
		function protocolloAPL_getAll(pageSize, page, testuale, codiceIntermediario, iStato, order) {
			var params = protocollo_setParams2(true, pageSize, page, order, testuale, codiceIntermediario, iStato);
			var data = getAllByParams('Protocollo', 'APL_GetAllByFilter', params);
			return $q.when(data);
		}
		function protocolloAPL_countAll(testuale, codiceIntermediario, iStato) {
			var params = protocollo_setParams2(false, 0, 0, '', testuale, codiceIntermediario, iStato);
			var data = getAllByParams('Protocollo', 'APL_CountByFilter', params);
			return $q.when(data);
		}
		function protocolloCPI_getAll(pageSize, page, testuale, codiceIntermediario, iStato, order) {
			var params = protocollo_setParams2(true, pageSize, page, order, testuale, codiceIntermediario, iStato);
			var data = getAllByParams('Protocollo', 'CPI_GetAllByFilter', params);
			return $q.when(data);
		}
		function protocolloCPI_countAll(testuale, codiceIntermediario, iStato) {
			var params = protocollo_setParams2(false, 0, 0, '', testuale, codiceIntermediario, iStato);
			var data = getAllByParams('Protocollo', 'CPI_CountByFilter', params);
			return $q.when(data);
		}
		function protocolloCodEvento_getAll(codice) {
			if (typeof codice == 'undefined') { codice = ''; }
			var data = getAllByParam('Protocollo', 'CodEvento_GetAllByFilter', 'codice', codice);
			return $q.when(data);
		}

		function protocollo_getEnteSAC(codiceFiscale) {
			var data = getAllByParam('Protocollo', 'RegisterCheckEnte', 'codiceFiscale', codiceFiscale);
			return $q.when(data);
		}

		// #region   RIMBORSO
		function rimborso_setParams(isPaging, pageSize, page, order, testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, umc_UserId, serv3_UserId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof type == 'undefined') { type = ''; }
			if (typeof iStep == 'undefined') { iStep = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof tPercorsoId == 'undefined') { tPercorsoId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof umc_UserId == 'undefined') { umc_UserId = 0; }
			if (typeof serv3_UserId == 'undefined') { serv3_UserId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'type', value: type });
			params.push({ name: 'iStep', value: iStep });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'tPercorsoId', value: tPercorsoId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'umc_UserId', value: umc_UserId });
			params.push({ name: 'serv3_UserId', value: serv3_UserId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function rimborso_getAllList(testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, iStato) {
			var params = rimborso_setParams(false, 0, 0, '', testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, 0, 0, iStato);
			var data = getAllByParams('Rimborso', 'GetAllList', params);
			return $q.when(data);
		}
		function rimborso_getAll(pageSize, page, testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, umc_UserId, serv3_UserId, iStato, order) {
			var params = rimborso_setParams(true, pageSize, page, order, testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, umc_UserId, serv3_UserId, iStato);
			var data = getAllByParams('Rimborso', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function rimborso_countAll(testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, umc_UserId, serv3_UserId, iStato) {
			var params = rimborso_setParams(false, 0, 0, '', testuale, filterCode, type, iStep, tSourceCode, sourceId, cpiId, soggettoCode, soggettoId, mese, anno, tPercorsoId, destinatarioId, umc_UserId, serv3_UserId, iStato);
			var data = getAllByParams('Rimborso', 'CountByFilter', params);
			return $q.when(data);
		}
		function rimborso_exists(filterCode, dt, tSourceCode, sourceId, soggettoCode, soggettoId, rimborsoId, percorso) {
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof rimborsoId == 'undefined') { rimborsoId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }

			var params = [];
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'rimborsoId', value: rimborsoId });
			params.push({ name: 'percorso', value: percorso });

			var data = getAllByParams('Rimborso', 'Exists', params);
			return $q.when(data);
		}

		function rimborso_get(id) {
			var data = getById('Rimborso', id);
			return $q.when(data);
		}

		function rimborso_add(item) {
			var data = addObj('Rimborso', item);
			return $q.when(data);
		}

		function rimborso_update(item) {
			var data = updateObj('Rimborso', item);
			return $q.when(data);
		}

		function rimborso_merge(item) {
			var data = mergeObj('Rimborso', item);
			return $q.when(data);
		}

		function rimborso_delete(id) {
			var data = deleteObj('Rimborso', id);
			return $q.when(data);
		}

		function rimborso_changeState(code, id, tSourceCode) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') tSourceCode = '';

			var objName = 'Rimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id + '&tSourceCode=' + tSourceCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborso_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		function rimborso_changePresaIncarico(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'Rimborso';

			return $http.put(urlAPI + '/' + objName + '/ChangePresaIncarico?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborso_changePresaIncarico for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END RIMBORSO

		// #region  RIMBORSO DESTINATARIO

		function rimborsoDest_setParams(isGet, pageSize, page, order, testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof rimborsoId == 'undefined') { rimborsoId = 0; }
			if (typeof destinatarioId == 'undefined') { destinatarioId = 0; }
			if (typeof dtStart == 'undefined') { dtStart = ''; }
			if (typeof dtEnd == 'undefined') { dtEnd = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof stato == 'undefined') { stato = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'rimborsoId', value: rimborsoId });
			params.push({ name: 'destinatarioId', value: destinatarioId });
			params.push({ name: 'dtStart', value: dtStart });
			params.push({ name: 'dtEnd', value: dtEnd });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'stato', value: stato });

			return params;
		}
		function rimborsoDest_getList(testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato) {
			var params = rimborsoDest_setParams(false, 0, 0, '', testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato);
			var data1 = getAllByParams('rimborsoDest', 'GetAllList', params);
			return $q.when(data1);
		}
		function rimborsoDest_getAll(pageSize, page, testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato, order) {
			var params = rimborsoDest_setParams(true, pageSize, page, order, testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato);
			var data1 = getAllByParams('rimborsoDest', 'GetAllByFilter', params);
			return $q.when(data1);
		}
		function rimborsoDest_countAll(testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato) {
			var params = rimborsoDest_setParams(false, 0, 0, '', testuale, rimborsoId, destinatarioId, dtStart, dtEnd, percorso, stato);
			var data1 = getAllByParams('rimborsoDest', 'CountByFilter', params);
			return $q.when(data1);
		}

		function rimborsoDest_get(id) {
			var data = getById('rimborsoDest', id);
			return $q.when(data);
		}

		function rimborsoDest_add(item) {
			var data = addObj('rimborsoDest', item);
			return $q.when(data);
		}

		function rimborsoDest_update(item) {
			var data = updateObj('rimborsoDest', item);
			return $q.when(data);
		}

		function rimborsoDest_delete(id) {
			var data = deleteObj('rimborsoDest', id);
			return $q.when(data);
		}

		// #endregion  ******************************

		// #region   RIMBORSO DTL
		function rimborsoDtl_setParams(isPaging, pageSize, page, order, testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof rimborsoId == 'undefined') { rimborsoId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof tContrattoCode == 'undefined') { tContrattoCode = ''; }
			if (typeof data == 'undefined') { data = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'rimborsoId', value: rimborsoId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'tContrattoCode', value: tContrattoCode });
			params.push({ name: 'data', value: data });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function rimborsoDtl_getAllList(testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato) {
			var params = rimborsoDtl_setParams(false, 0, 0, '', testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato);
			var data = getAllByParams('RimborsoDtl', 'GetAllList', params);
			return $q.when(data);
		}
		function rimborsoDtl_getAll(pageSize, page, testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato, order) {
			var params = rimborsoDtl_setParams(true, pageSize, page, order, testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato);
			var data = getAllByParams('RimborsoDtl', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function rimborsoDtl_countAll(testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato) {
			var params = rimborsoDtl_setParams(false, 0, 0, '', testuale, rimborsoId, percorso, filterCode, tContrattoCode, data, iStato);
			var data = getAllByParams('RimborsoDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function rimborsoDtl_get(id) {
			var data = getById('RimborsoDtl', id);
			return $q.when(data);
		}

		function rimborsoDtl_add(item) {
			var data = addObj('RimborsoDtl', item);
			return $q.when(data);
		}

		function rimborsoDtl_addUpdate(item) {
			var data = postMethod('RimborsoDtl', 'AddUpdate', item);
			return $q.when(data);
		}

		function rimborsoDtl_update(item) {
			var data = updateObj('RimborsoDtl', item);
			return $q.when(data);
		}

		function rimborsoDtl_merge(item) {
			var data = mergeObj('RimborsoDtl', item);
			return $q.when(data);
		}

		function rimborsoDtl_delete(id) {
			var data = deleteObj('RimborsoDtl', id);
			return $q.when(data);
		}

		function rimborsoDtl_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'RimborsoDtl';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed rimborsoDtl_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END RIMBORSO

		// #region   OUTCOMES
		function outcome_setParams(isPaging, pageSize, page, order, testuale, filterCode, soggettoCode, soggettoId, mese, anno, serv3_UserId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof serv3_UserId == 'undefined') { serv3_UserId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'serv3_UserId', value: serv3_UserId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function outcome_getAllList(testuale, filterCode, soggettoCode, soggettoId, mese, anno, iStato) {
			var params = outcome_setParams(false, 0, 0, '', testuale, filterCode, soggettoCode, soggettoId, mese, anno, 0, iStato);
			var data = getAllByParams('Outcome', 'GetAllList', params);
			return $q.when(data);
		}
		function outcome_getAll(pageSize, page, testuale, filterCode, soggettoCode, soggettoId, mese, anno, serv3_UserId, iStato, order) {
			var params = outcome_setParams(true, pageSize, page, order, testuale, filterCode, soggettoCode, soggettoId, mese, anno, serv3_UserId, iStato);
			var data = getAllByParams('Outcome', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function outcome_countAll(testuale, filterCode, soggettoCode, soggettoId, mese, anno, serv3_UserId, iStato) {
			var params = outcome_setParams(false, 0, 0, '', testuale, filterCode, soggettoCode, soggettoId, mese, anno, serv3_UserId, iStato);
			var data = getAllByParams('Outcome', 'CountByFilter', params);
			return $q.when(data);
		}

		function outcome_get(id) {
			var data = getById('Outcome', id);
			return $q.when(data);
		}

		function outcome_add(item) {
			var data = addObj('Outcome', item);
			return $q.when(data);
		}

		function outcome_update(item) {
			var data = updateObj('Outcome', item);
			return $q.when(data);
		}

		function outcome_merge(item) {
			var data = mergeObj('Outcome', item);
			return $q.when(data);
		}

		function outcome_delete(id) {
			var data = deleteObj('Outcome', id);
			return $q.when(data);
		}

		function outcome_changeState(code, id, tSourceCode) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') tSourceCode = '';

			var objName = 'Outcome';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id + '&tSourceCode=' + tSourceCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed outcome_changeState for %s: %s', objName, message);
					return message.status;
				});
		}
		function outcome_changePresaIncarico(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'Outcome';

			return $http.put(urlAPI + '/' + objName + '/ChangePresaIncarico?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed outcome_changePresaIncarico for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END OUTCOMES

		// #region   OUTCOMES-DTL
		function outcomeDtl_setParams(isPaging, pageSize, page, order, testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof outcomeId == 'undefined') { outcomeId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof tReferenceCode == 'undefined') { tReferenceCode = ''; }
			if (typeof referenceId == 'undefined') { referenceId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'outcomeId', value: outcomeId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'tReferenceCode', value: tReferenceCode });
			params.push({ name: 'referenceId', value: referenceId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function outcomeDtl_getAllList(testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato) {
			var params = outcomeDtl_setParams(false, 0, 0, '', testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato);
			var data = getAllByParams('OutcomeDtl', 'GetAllList', params);
			return $q.when(data);
		}
		function outcomeDtl_getAll(pageSize, page, testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato, order) {
			var params = outcomeDtl_setParams(true, pageSize, page, order, testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato);
			var data = getAllByParams('OutcomeDtl', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function outcomeDtl_countAll(testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato) {
			var params = outcomeDtl_setParams(false, 0, 0, '', testuale, outcomeId, tSourceCode, sourceId, tReferenceCode, referenceId, iStato);
			var data = getAllByParams('OutcomeDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function outcomeDtl_get(id) {
			var data = getById('OutcomeDtl', id);
			return $q.when(data);
		}

		function outcomeDtl_add(item) {
			var data = addObj('OutcomeDtl', item);
			return $q.when(data);
		}

		function outcomeDtl_update(item) {
			var data = updateObj('OutcomeDtl', item);
			return $q.when(data);
		}

		function outcomeDtl_merge(item) {
			var data = mergeObj('OutcomeDtl', item);
			return $q.when(data);
		}

		function outcomeDtl_delete(id) {
			var data = deleteObj('OutcomeDtl', id);
			return $q.when(data);
		}

		function outcomeDtl_AddMultiplo(list) {
			var objName = 'OutcomeDtl';
			var actionName = 'OutcomeDtl_AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed OutcomeDtl_AddMultiplo for %s: %s', objName, message);
					return message.status;
				});

		}

		function outcomeDtl_AddMultiploByProc(list) {
			var objName = 'OutcomeDtl';
			var actionName = 'OutcomeDtl_AddMultiploByProc';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed OutcomeDtl_AddMultiploByProc for %s: %s', objName, message);
					return message.status;
				});

		}

		function outcomeDtl_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'OutcomeDtl';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed outcomeDtl_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END OUTCOMES-DTL

		// #region   COMMISSIONS
		function commission_setParams(isPaging, pageSize, page, order, testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iExport == 'undefined') { iExport = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iExport', value: iExport });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function commission_getAllList(testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato) {
			var params = commission_setParams(false, 0, 0, '', testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato);
			var data = getAllByParams('commission', 'GetAllList', params);
			return $q.when(data);
		}
		function commission_getAll(pageSize, page, testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato, order) {
			var params = commission_setParams(true, pageSize, page, order, testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato);
			var data = getAllByParams('commission', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function commission_countAll(testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato) {
			var params = commission_setParams(false, 0, 0, '', testuale, filterCode, soggettoCode, soggettoId, anno, iExport, iStato);
			var data = getAllByParams('commission', 'CountByFilter', params);
			return $q.when(data);
		}

		function commission_get(id) {
			var data = getById('commission', id);
			return $q.when(data);
		}

		function commission_add(item) {
			var data = addObj('commission', item);
			return $q.when(data);
		}

		function commission_addSpecial(item) {
			var data = postMethod('commission', 'AddSpecial', item);
			return $q.when(data);
		}

		function commission_update(item) {
			var data = updateObj('commission', item);
			return $q.when(data);
		}

		function commission_merge(item) {
			var data = mergeObj('commission', item);
			return $q.when(data);
		}

		function commission_delete(id) {
			var data = deleteObj('commission', id);
			return $q.when(data);
		}

		function commission_changeState(code, id, tSourceCode) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;
			if (typeof code == 'undefined') tSourceCode = '';

			var objName = 'commission';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id + '&tSourceCode=' + tSourceCode)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed commission_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END COMMISSIONS

		// #region   FATTURE
		function fatture_setParams(isPaging, pageSize, page, order, testuale, tSourceCode, sourceId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function fatture_merge(item) {
			var data = mergeObj('fatture', item);
			return $q.when(data);
		}

		function fatture_add(item) {
			var data = addObj('fatture', item);
			return $q.when(data);
		}

		function fatture_delete(item) {
			var data = deleteObj('fatture', item);
			return $q.when(data);
		}

		function fatture_getAll(pageSize, page, testuale, tSourceCode, sourceId, iStato, order) {
			var params = fatture_setParams(true, pageSize, page, order, testuale, tSourceCode, sourceId, iStato);
			var data = getAllByParams('fatture', 'GetAllByFilter', params);
			return $q.when(data);
		}

		// #endregion END FATTURE

		// #region   COMMISSIONS-DTL
		function commissionDtl_setParams(isPaging, pageSize, page, order, testuale, commissionId, tSourceCode, sourceId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof commissionId == 'undefined') { commissionId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'commissionId', value: commissionId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function commissionDtl_getAllList(testuale, commissionId, tSourceCode, sourceId, iStato) {
			var params = commissionDtl_setParams(false, 0, 0, '', testuale, commissionId, tSourceCode, sourceId, iStato);
			var data = getAllByParams('commissionDtl', 'GetAllList', params);
			return $q.when(data);
		}
		function commissionDtl_getAll(pageSize, page, testuale, commissionId, tSourceCode, sourceId, iStato, order) {
			var params = commissionDtl_setParams(true, pageSize, page, order, testuale, commissionId, tSourceCode, sourceId, iStato);
			var data = getAllByParams('commissionDtl', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function commissionDtl_countAll(testuale, commissionId, tSourceCode, sourceId, iStato) {
			var params = commissionDtl_setParams(false, 0, 0, '', testuale, commissionId, tSourceCode, sourceId, iStato);
			var data = getAllByParams('commissionDtl', 'CountByFilter', params);
			return $q.when(data);
		}

		function commissionDtl_get(id) {
			var data = getById('commissionDtl', id);
			return $q.when(data);
		}

		function commissionDtl_add(item) {
			var data = addObj('commissionDtl', item);
			return $q.when(data);
		}

		function commissionDtl_update(item) {
			var data = updateObj('commissionDtl', item);
			return $q.when(data);
		}

		function commissionDtl_merge(item) {
			var data = mergeObj('commissionDtl', item);
			return $q.when(data);
		}

		function commissionDtl_delete(id) {
			var data = deleteObj('commissionDtl', id);
			return $q.when(data);
		}

		function commissionDtl_AddMultiplo(list) {
			var objName = 'commissionDtl';
			var actionName = 'commissionDtl_AddMultiplo';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed commissionDtl_AddMultiplo for %s: %s', objName, message);
					return message.status;
				});

		}

		function commissionDtl_AddMultiploByProc(list) {
			var objName = 'commissionDtl';
			var actionName = 'commissionDtl_AddMultiploByProc';

			return $http.post(urlAPI + '/' + objName + '/' + actionName, list)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed commissionDtl_AddMultiploByProc for %s: %s', objName, message);
					return message.status;
				});

		}

		function commissionDtl_changeState(code, id) {
			if (typeof code == 'undefined') code = '';
			if (typeof id == 'undefined') id = 0;

			var objName = 'commissionDtl';

			return $http.put(urlAPI + '/' + objName + '/ChangeState?code=' + code + '&id=' + id)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed commissionDtl_changeState for %s: %s', objName, message);
					return message.status;
				});
		}

		// #endregion END COMMISSIONS-DTL

		// #region   ASSISTANCES
		function assistance_setParams(isPaging, pageSize, page, order, testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof mese == 'undefined') { mese = 0; }
			if (typeof anno == 'undefined') { anno = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function assistance_getAllList(testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato) {
			var params = assistance_setParams(false, 0, 0, '', testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato);
			var data = getAllByParams('Assistance', 'GetAllList', params);
			return $q.when(data);
		}
		function assistance_getAll(pageSize, page, testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato, order) {
			var params = assistance_setParams(true, pageSize, page, order, testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato);
			var data = getAllByParams('Assistance', 'GetAllByFilter', params);
			return $q.when(data);

		}
		function assistance_countAll(testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato) {
			var params = assistance_setParams(false, 0, 0, '', testuale, percorso, filterCode, soggettoCode, soggettoId, tSourceCode, sourceId, codiceFiscale, mese, anno, iStato);
			var data = getAllByParams('Assistance', 'CountByFilter', params);
			return $q.when(data);
		}

		function assistance_get(id) {
			var data = getById('Assistance', id);
			return $q.when(data);
		}

		function assistance_add(item) {
			var data = addObj('Assistance', item);
			return $q.when(data);
		}

		function assistance_update(item) {
			var data = updateObj('Assistance', item);
			return $q.when(data);
		}

		function assistance_merge(item) {
			var data = mergeObj('Assistance', item);
			return $q.when(data);
		}

		function assistance_delete(id) {
			var data = deleteObj('Assistance', id);
			return $q.when(data);
		}

		// #endregion END ASSISTANCES

		// #region EDUP
		//------------------------------------------------------------------

		//-- TEST
		function test_getAllList() {
			var data = getAllList('test');
			return $q.when(data);
		}

		function test_getAllListExclude(testId) {
			var objName = 'test';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListExclude?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed GetAllListExclude for %s: %s', objName, message);
					return message.status;
				});
		}

		function test_count() {
			var data = getAllByParams('test', 'Count');
			return $q.when(data);
		}

		function test_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('test', 'CountByFilter', params);
			return $q.when(data);
		}

		function test_getAll() {
			var data = getAllNoParam('test', 'getAll');
			return $q.when(data);
		}

		function test_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('test', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function test_get(id) {
			var data = getById('test', id);
			return $q.when(data);
		}

		function test_update(item) {
			var data = updateObj('Test', item);
			return $q.when(data);
		}

		function test_delete(id) {
			var data = deleteObj('test', id);
			return $q.when(data);
		}


		function test_add(item) {
			var data = addObj('test', item);
			return $q.when(data);
		}

		//-- question
		function question_getAllList() {
			var data = getAllList('question');
			return $q.when(data);
		}

		function question_getAllListInTest(testId) {
			var objName = 'question';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListInTest?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function question_getAllListNotInTest(testId) {
			var objName = 'question';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/GetAllListNotInTest?testId=' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}

		function question_count() {
			var data = getAllByParams('question', 'Count');
			return $q.when(data);
		}

		function question_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('question', 'CountByFilter', params);
			return $q.when(data);
		}

		function question_getAll() {
			var data = getAllNoParam('question', 'getAll');
			return $q.when(data);
		}

		function question_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('question', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function question_getAllByTest(testId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('question', 'getAllByTest', params);
			return $q.when(data);
		}

		function question_get(id) {
			var data = getById('question', id);
			return $q.when(data);
		}

		function question_update(item) {
			var data = updateObj('question', item);
			return $q.when(data);
		}

		function question_delete(id) {
			var data = deleteObj('question', id);
			return $q.when(data);
		}

		function question_add(item) {
			var data = addObj('question', item);
			return $q.when(data);
		}

		function question_addToTest(item, testId) {
			var objName = 'questionTest';
			var method = 'AddQuestionToTest';

			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof item == 'undefined') { item = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			item.testId = testId;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed question_addToTest for %s: %s', objName, message);
					return message.status;
				});

			/*
			return addObj('question', item).then(function (data) {
				return questionTest_addByParams(testId, data.Id).then(function (data2) {
				});
				/*
				var data2 = questionTest_addByParams(testId, data.Id);
				var dataUnion = {};
				dataUnion.question = data;
				dataUnion.questionTest = data2;
				return $q.when(dataUnion);
				//
			});
			*/
		}



		function question_upload(filename, file) {
			var objName = 'question';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed question_upload for %s: %s', objName, message);
					return message.status;
				});

		}


		function question_deleteFiles(filesList) {
			var objName = 'question';
			if (typeof filesList == 'undefined') { filesList = []; }

			var obj = {
				filesList: filesList
			};

			var url = urlAPI + '/' + objName + '/DeleteFiles';
			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed DeleteFiles for %s: %s', objName, message);
					return message.status;
				});

		}

		//-- choice
		function choice_getAllList() {
			var data = getAllList('choice');
			return $q.when(data);
		}

		function choice_count() {
			var data = getAllByParams('choice', 'Count');
			return $q.when(data);
		}

		function choice_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('choice', 'CountByFilter', params);
			return $q.when(data);
		}

		function choice_getAll() {
			var data = getAllNoParam('choice', 'getAll');
			return $q.when(data);
		}

		function choice_getAllByQuestion(questionId, order) {
			if (typeof questionId == 'undefined') { questionId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'questionId', value: questionId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('choice', 'getAllByQuestion', params);
			return $q.when(data);
		}

		function choice_get(id) {
			var data = getById('choice', id);
			return $q.when(data);
		}

		function choice_add(item) {
			var data = addObj('choice', item);
			return $q.when(data);
		}

		function choice_upload(filename, file) {
			var objName = 'choice';
			var method = 'Upload';

			if (typeof filename == 'undefined') { filename = ''; }
			if (typeof file == 'undefined') { file = {}; }

			var url = urlAPI + '/' + objName + '/' + method;

			var item = {};
			item.filename = filename;
			item.file = file;


			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed choice_upload for %s: %s', objName, message);
					return message.status;
				});

		}

		function choice_update(item) {
			var data = updateObj('choice', item);
			return $q.when(data);
		}

		function choice_delete(id) {
			var data = deleteObj('choice', id);
			return $q.when(data);
		}

		//-- questionTest
		function questionTest_getAllList(testId) {
			var objName = 'questionTest';
			var action = 'GetAllList';
			if (typeof testId == 'undefined') { testId = 0; }

			return $http.get(urlAPI + '/' + objName + '/' + action + '/' + testId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getAllList for %s: %s', objName, message);
					return message.status;
				});
		}


		function questionTest_count() {
			var data = getAllByParams('questionTest', 'Count');
			return $q.when(data);
		}

		function questionTest_countByFilter(testo) {
			if (typeof testo == 'undefined') { testo = ''; }
			var params = [];
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('questionTest', 'CountByFilter', params);
			return $q.when(data);
		}

		function questionTest_getAll() {
			var data = getAllNoParam('questionTest', 'getAll');
			return $q.when(data);
		}

		function questionTest_getAllByFilter(pageSize, page, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function questionTest_getAllByTest(testId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'getAllByTest', params);
			return $q.when(data);
		}

		function questionTest_getAllByQuestion(testId, questionId, order) {
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof questionId == 'undefined') { questionId = 0; }
			if (typeof order == 'undefined') { order = 'id'; }

			var params = [];
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'questionId', value: questionId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('questionTest', 'getAllByQuestion', params);
			return $q.when(data);
		}

		function questionTest_get(id) {
			var data = getById('questionTest', id);
			return $q.when(data);
		}

		function questionTest_update(item) {
			var data = updateObj('questionTest', item);
			return $q.when(data);
		}


		function questionTest_changeSequence(orderList) {
			var objName = 'questionTest';
			if (typeof orderList == 'undefined') { orderList = []; }

			var obj = {
				orderList: orderList
			};

			var url = urlAPI + '/' + objName + '/ChangeSequence';
			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed ChangeSequence for %s: %s', objName, message);
					return message.status;
				});

		}

		function questionTest_delete(id) {
			var data = deleteObj('questionTest', id);
			return $q.when(data);
		}

		function questionTest_add(item) {
			var data = addObj('questionTest', item);
			return $q.when(data);
		}

		function questionTest_importList(testId, questionsList) {
			var objName = 'questionTest';
			var method = 'ImportList';

			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof questionsList == 'undefined') { questionsList = []; }

			var url = urlAPI + '/' + objName + '/' + method;

			var obj = {
				testId: testId,
				questionsList: questionsList
			};

			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed ImportList for %s: %s', objName, message);
					return message.status;
				});
		}

		function questionTest_addByParams(testId, questionId) {
			var item = {};
			item.testId = testId;
			item.questionId = questionId;
			var data = addObj('questionTest', item);
			return $q.when(data);
		}


		//-- SESSION
		function session_getAllList() {
			var data = getAllList('session');
			return $q.when(data);
		}

		function session_count() {
			var data = getAllByParams('session', 'Count');
			return $q.when(data);
		}

		function session_countByFilter(bStato, testId, testo) {
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof testo == 'undefined') { testo = ''; }

			var params = [];
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'testo', value: testo });

			var data = getAllByParams('session', 'CountByFilter', params);
			return $q.when(data);
		}

		function session_getAll() {
			var data = getAllNoParam('session', 'getAll');
			return $q.when(data);
		}

		function session_getAllByFilter(pageSize, page, bStato, testId, testo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof bStato == 'undefined') { bStato = 0; }
			if (typeof testId == 'undefined') { testId = 0; }
			if (typeof testo == 'undefined') { testo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'bStato', value: bStato });
			params.push({ name: 'testId', value: testId });
			params.push({ name: 'testo', value: testo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('session', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function session_get(id) {
			var data = getById('session', id);
			return $q.when(data);
		}

		function session_add(item) {
			var data = addObj('session', item);
			return $q.when(data);
		}

		function session_update(item) {
			var data = updateObj('session', item);
			return $q.when(data);
		}

		function session_delete(id) {
			var data = deleteObj('session', id);
			return $q.when(data);
		}

		function session_activate(sessionId) {
			var objName = 'Session';
			var actionName = 'Activate';
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
			return $http.put(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed session_activate for %s: %s', objName, message);
					return message.status;
				});
		}

		function session_inactivate(sessionId) {
			var objName = 'Session';
			var actionName = 'Inactive';
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var url = urlAPI + '/' + objName + '/' + actionName + '?sessionId=' + sessionId;
			return $http.put(url)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed session_inactivate for %s: %s', objName, message);
					return message.status;
				});
		}

		//-- SESSIONSTUDENTE
		function studenteSession_getAllList(sessionId) {
			var data = getAllByParam('studenteSession', 'GetAllList', 'sessionId', sessionId);
			return $q.when(data);
		}

		function studenteSession_addList(sessionId, studentiList) {
			var objName = 'studenteSession';
			var method = 'AddList';

			if (typeof sessionId == 'undefined') { sessionId = 0; }
			if (typeof studentiList == 'undefined') { studentiList = []; }

			var url = urlAPI + '/' + objName + '/' + method;

			var obj = {
				sessionId: sessionId,
				studentiList: studentiList
			};

			return $http.put(url, obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed AddList for %s: %s', objName, message);
					return message.status;
				});
		}

		function studenteSession_count() {
			var data = getAllByParams('studenteSession', 'Count');
			return $q.when(data);
		}

		function studenteSession_countByFilter(sessionId) {
			if (typeof sessionId == 'undefined') { sessionId = 0; }

			var params = [];
			params.push({ name: 'sessionId', value: sessionId });

			var data = getAllByParams('studenteSession', 'CountByFilter', params);
			//console.dir(data);
			return $q.when(data);
		}

		function studenteSession_getAll() {
			var data = getAllNoParam('studenteSession', 'getAll');
			return $q.when(data);
		}

		function studenteSession_getAllByFilter(pageSize, page, sessionId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof sessionId == 'undefined') { sessionId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'sessionId', value: sessionId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('studenteSession', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function studenteSession_get(id) {
			var data = getById('studenteSession', id);
			return $q.when(data);
		}

		function studenteSession_update(item) {
			var data = updateObj('studenteSession', item);
			return $q.when(data);
		}

		function studenteSession_delete(id) {
			var data = deleteObj('studenteSession', id);
			return $q.when(data);
		}

		// #endregion ***********

		// #region   DASHBOARD - APP
		function app_dashboard_get() {
			var data = getAllNoParam('dashboard', 'get');
			return $q.when(data);
		}

		function app_dashboard_getByProfileId(profileId) {
			if (typeof profileId == 'undefined') { profileId = 0; }

			var params = [];
			params.push({ name: 'profileId', value: profileId });

			var data = getAllByParams('dashboard', 'getByProfileId', params);
			return $q.when(data);
		}

		function app_dashboard_getAllProfiles() {
			var data = getAllNoParam('dashboard', 'getAllProfiles');
			return $q.when(data);
		}

		// ******************************
		//  APP PROFILES
		function app_profiles_getAllList(nominativo, aziendaId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof aziendaId == 'undefined') { aziendaId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'aziendaId', value: aziendaId });

			var data = getAllByParams('App_Profile', 'GetAllList', params);
			return $q.when(data);
		}

		// ******************************
		//  APP PROFILES USER
		function app_profilesUser_getAll(ProfileId, UserId) {
			if (typeof ProfileId == 'undefined') { ProfileId = 0; }
			if (typeof UserId == 'undefined') { UserId = 0; }

			var params = [];
			params.push({ name: 'pageSize', value: 0 });
			params.push({ name: 'page', value: 0 });
			params.push({ name: 'ProfileId', value: ProfileId });
			params.push({ name: 'UserId', value: UserId });
			params.push({ name: 'order', value: '' });

			var data = getAllByParams('App_ProfilesUser', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function app_userProfile_exists(userId, profileId, id) {
			if (typeof userId == 'undefined') { userId = 0; }
			if (typeof profileId == 'undefined') { profileId = 0; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'userId', value: userId });
			params.push({ name: 'profileId', value: profileId });
			params.push({ name: 'id', value: id });

			var data = getAllByParams('App_ProfilesUser', 'Exists', params);
			return $q.when(data);
		}

		function app_userProfile_get(id) {
			var data = getById('App_ProfilesUser', id);
			return $q.when(data);
		}

		function app_userProfile_add(item) {
			var data = addObj('App_ProfilesUser', item);
			return $q.when(data);
		}

		function app_userProfile_update(item) {
			var data = updateObj('App_ProfilesUser', item);
			return $q.when(data);
		}

		function app_userProfile_delete(id) {
			var data = deleteObj('App_ProfilesUser', id);
			return $q.when(data);
		}



		// #endregion *********************************

		// #region DASHBOARD
		function dashboard_getAll() {
			var data = getAllNoParam('dashboardBO', 'GetAll');
			return $q.when(data);
		}

		// #endregion *********************************

		// #region SYSTEM
		function getWhoAmI() {
			return $http.get(urlAPI + '/system/whoami')
				.then(getWhoAmIComplete)
				.catch(function (message) {
					//console.info('XHR Failed for whoami: %s', message);
				});

			function getWhoAmIComplete(response) {
				return response.data;
			}
		}

		// #endregion  ******************************

		// #region  REGISTER



		function cndRegister_save(item) {
			var url = '/Account/RegisterSave';

			return $http.post(url, item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed register_save', item, message);
					return message.status;
				});
		}


		// #endregion  ******************************

		// #region   ACCREDITAMENTO-CONVENZIONI-CV-etc
		function cndAccreditamento_setParams(pageSize, page, isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, tMisuraCode, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}

			if (typeof isWhole == 'undefined') { isWhole = 0; }
			//if (typeof bAttivo == 'undefined') { bAttivo = 0; }
			//if (typeof bCompleted == 'undefined') { bCompleted = 0; }
			if (typeof azienda == 'undefined') { azienda = ''; }
			if (typeof atecoId == 'undefined') { atecoId = 0; }
			if (typeof formaGiuridicaId == 'undefined') { formaGiuridicaId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof bSuspended == 'undefined') { bSuspended = -1; }
			if (typeof email == 'undefined') { email = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }


			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}

			params.push({ name: 'isWhole', value: isWhole });
			//params.push({ name: 'bAttivo', value: bAttivo });
			//params.push({ name: 'bCompleted', value: bCompleted });
			params.push({ name: 'azienda', value: azienda });
			params.push({ name: 'atecoId', value: atecoId });
			params.push({ name: 'formaGiuridicaId', value: formaGiuridicaId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'bSuspended', value: bSuspended });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });


			return params;
		}

		function cndAccreditamento_getAllList(azienda, provinciaId, tMisuraCode, iStato) {
			var params = cndAccreditamento_setParams(0, 0, 0, azienda, 0, 0, provinciaId, -1, '', '', iStato, 0, tMisuraCode, '', false);
			var data = getAllByParams('cndAccreditamento', 'GetAllList', params);
			return $q.when(data);
		}

		function cndAccreditamento_getAll(pageSize, page, isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, tMisuraCode, order) {
			var params = cndAccreditamento_setParams(pageSize, page, isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, tMisuraCode, order, true);
			var data = getAllByParams('cndAccreditamento', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndAccreditamento_countAll(isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, tMisuraCode) {
			var params = cndAccreditamento_setParams(0, 0, isWhole, azienda, atecoId, formaGiuridicaId, provinciaId, bSuspended, email, codiceFiscale, iStato, progettoId, tMisuraCode, '', false);
			var data = getAllByParams('cndAccreditamento', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamento_exists(cndAccreditamentoId, codiceFiscale, piva, ipa, progettoId) {
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof piva == 'undefined') { piva = ''; }
			if (typeof ipa == 'undefined') { ipa = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			var params = [];
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'piva', value: piva });
			params.push({ name: 'ipa', value: ipa });
			params.push({ name: 'progettoId', value: progettoId });

			var data = getAllByParams('cndAccreditamento', 'Exists', params);
			return $q.when(data);
		}

		function cndAccreditamento_restore(accreditamentoId) {
			if (typeof accreditamentoId == 'undefined') { accreditamentoId = 0; }

			var params = [];
			params.push({ name: 'accreditamentoId', value: accreditamentoId });

			var data = getAllByParams('cndAccreditamento', 'Restore', params);
			return $q.when(data);
		}

		function cndAccreditamento_getByUsername() {
			var data = getAllNoParam('cndAccreditamento', 'GetByUsername');
			return $q.when(data);
		}

		function cndAccreditamento_get(id) {
			var data = getById('cndAccreditamento', id);
			return $q.when(data);
		}

		function cndAccreditamento_getByUID(uid, progettoUID) {
			var params = [];
			params.push({ name: 'Uid', value: uid });
			params.push({ name: 'progettoUID', value: progettoUID });

			var data = getAllByParams('cndAccreditamento', 'GetByUID', params);
			return $q.when(data);
		}

		function cndAccreditamento_unlock(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_setStatus(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/SetStatus', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_printAll(progettoUId, accredUId, misura, index) {
			if (typeof index == 'undefined') { index = 0; }

			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'index', value: index });

			var data = getAllByParams('PDF', 'GetAllegato', params);
			return $q.when(data);
		}

		function cndAccreditamento_findAll(UId, progettoUID, misura) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'misura', value: misura });
			var data = getAllByParams('PDF', 'FindAllegato', params);
			return $q.when(data);
		}

		function cndAccreditamento_printRicevuta(progettoUId, accredUId, misura) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			params.push({ name: 'misura', value: misura });
			var data = getAllByParams('PDF', 'PrintRicevuta', params);
			return $q.when(data);
		}



		function cndAccreditamento_add(item) {
			var data = addObj('cndAccreditamento', item);
			return $q.when(data);
		}

		function cndAccreditamento_update(item) {
			var data = updateObj('cndAccreditamento', item);
			return $q.when(data);
		}

		function cndAccreditamento_delete(id) {
			var data = deleteObj('cndAccreditamento', id);
			return $q.when(data);
		}

		function cndAccreditamento_setAnnulled(id, locked, noteAnnulled) {
			if (typeof noteAnnulled == 'undefined') { noteAnnulled = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'locked', value: locked });
			params.push({ name: 'noteAnnulled', value: noteAnnulled });

			var data = getAllByParams('cndAccreditamento', 'SetAnnulled', params);
			return $q.when(data);
		}

		function cndAccreditamento_setProtSent(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/SetProtSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setProtSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_unsetProtSent(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/UnsetProtSent', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed unsetProtSent for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_setConvalida(item, elencoSediAmmesse) {
			var objName = 'cndAccreditamento';

			if (typeof elencoSediAmmesse == 'undefined') { elencoSediAmmesse = {}; }

			var params = [];
			params.push({ name: 'item', value: item });
			params.push({ name: 'elencoSediAmmesse', value: elencoSediAmmesse });
			var obj = {};
			obj.CNDAccreditamento = item;
			obj.Sedi = elencoSediAmmesse;


			return $http.put(urlAPI + '/' + objName + '/SetConvalida', obj)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setConvalida for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndAccreditamento_unsetConvalida(item) {
			var objName = 'cndAccreditamento';

			return $http.put(urlAPI + '/' + objName + '/UnsetConvalida', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					console.log('XHR Failed setConvalida for %s: %s', objName, message);
					return message.status;
				});
		}

		// ******************************
		//  CNDAccreditamento SEDI
		function cndAccreditamentoSede_getAllList(nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'GetAllList', params);
			return $q.when(data);
		}

		function cndAccreditamentoSede_getAll(pageSize, page, nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndAccreditamentoSede', 'GetAllByFilter', params);
			return $q.when(data);

		}

		function cndAccreditamentoSede_countAll(nominativo, cndProgettoId, cndAccreditamentoId, provinciaId, comuneId) {
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof provinciaId == 'undefined') { provinciaId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'provinciaId', value: provinciaId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamentoSede_get(id) {
			var data = getById('cndAccreditamentoSede', id);
			return $q.when(data);
		}

		function cndAccreditamentoSede_add(item) {
			var data = addObj('cndAccreditamentoSede', item);
			return $q.when(data);
		}

		function cndAccreditamentoSede_update(item) {
			var data = updateObj('cndAccreditamentoSede', item);
			return $q.when(data);
		}

		function cndAccreditamentoSede_delete(id) {
			var data = deleteObj('cndAccreditamentoSede', id);
			return $q.when(data);
		}

		function cndAccreditamentoSede_exists(cndProgettoId, cndAccreditamentoId, comuneId) {
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof comuneId == 'undefined') { comuneId = 0; }

			var params = [];
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'comuneId', value: comuneId });

			var data = getAllByParams('cndAccreditamentoSede', 'Exists', params);
			return $q.when(data);
		}

		// ******************************
		//  CNDAccreditamento SETTORI
		function cndAccreditamentoSettore_setParams(pageSize, page, nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId, order, isGet) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof cndSettoreId == 'undefined') { cndSettoreId = 0; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'cndSettoreId', value: cndSettoreId });

			return params;
		}

		function cndAccreditamentoSettore_getAllList(nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId) {
			var params = cndAccreditamentoSettore_setParams(0, 0, nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId, '', false);
			var data = getAllByParams('cndAccreditamentoSettore', 'GetAllList', params);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_getAll(pageSize, page, nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId, order) {
			var params = cndAccreditamentoSettore_setParams(pageSize, page, nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId, order, true);
			var data = getAllByParams('cndAccreditamentoSettore', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_countAll(nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId) {
			var params = cndAccreditamentoSettore_setParams(0, 0, nominativo, cndProgettoId, cndAccreditamentoId, cndSettoreId, '', false);
			var data = getAllByParams('cndAccreditamentoSettore', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_get(id) {
			var data = getById('cndAccreditamentoSettore', id);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_add(item) {
			var data = addObj('cndAccreditamentoSettore', item);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_update(item) {
			var data = updateObj('cndAccreditamentoSettore', item);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_delete(id) {
			var data = deleteObj('cndAccreditamentoSettore', id);
			return $q.when(data);
		}

		function cndAccreditamentoSettore_exists(cndProgettoId, cndAccreditamentoId, cndSettoreId, id) {
			if (typeof cndProgettoId == 'undefined') { cndProgettoId = 0; }
			if (typeof cndAccreditamentoId == 'undefined') { cndAccreditamentoId = 0; }
			if (typeof cndSettoreId == 'undefined') { cndSettoreId = 0; }
			if (typeof id == 'undefined') { id = 0; }

			var params = [];
			params.push({ name: 'cndProgettoId', value: cndProgettoId });
			params.push({ name: 'cndAccreditamentoId', value: cndAccreditamentoId });
			params.push({ name: 'cndSettoreId', value: cndSettoreId });
			params.push({ name: 'id', value: id });

			var data = getAllByParams('cndAccreditamentoSettore', 'Exists', params);
			return $q.when(data);
		}

		// ******************************
		//--  CNDSETTORE 
		function cndSettore_getAllList() {
			var data = getAllList('cndSettore');
			return $q.when(data);
		}

		function cndSettore_getAll() {
			var data = getAllNoParam('cndSettore', 'GetAll');
			return $q.when(data);
		}

		function cndSettore_get(id) {
			var data = getById('cndSettore', id);
			return $q.when(data);
		}

		// ******************************
		//  Adesione
		function cndAdesione_setParams(isPaging, pageSize, page, order, testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato) {
			if (isPaging) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }
			if (typeof cpiId == 'undefined') { cpiId = 0; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			if (isPaging) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });
			params.push({ name: 'cpiId', value: cpiId });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iStato', value: iStato });

			return params;
		}

		function cndAdesione_getAllList(testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato) {
			var params = cndAdesione_setParams(false, 0, 0, '', testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato);
			var data = getAllByParams('cndAdesione', 'GetAllList', params);
			return $q.when(data);
		}
		function cndAdesione_getAll(pageSize, page, testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato, order) {
			var params = cndAdesione_setParams(true, pageSize, page, order, testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato);
			var data = getAllByParams('cndAdesione', 'GetAllByFilter', params);
			return $q.when(data);
		}		
		function cndAdesione_countAll(testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato) {
			var params = cndAdesione_setParams(false, 0, 0, '', testuale, codiceFiscale, soggettoCode, soggettoId, cpiId, progettoId, iStato);
			var data = getAllByParams('cndAdesione', 'CountByFilter', params);
			return $q.when(data);
		}
		function cndAdesione_exists(domandaAdesioneId, codiceFiscale, soggettoCode, soggettoId) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }
			if (typeof soggettoCode == 'undefined') { soggettoCode = ''; }
			if (typeof soggettoId == 'undefined') { soggettoId = 0; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'soggettoCode', value: soggettoCode });
			params.push({ name: 'soggettoId', value: soggettoId });

			var data = getAllByParams('cndAdesione', 'Exists', params);
			return $q.when(data);
		}

		function cndAdesione_status(codiceFiscale) {
			if (typeof codiceFiscale == 'undefined') { codiceFiscale = ''; }

			var params = [];
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tMisuraCode', value: 'E' });
			params.push({ name: 'percorso', value: 'P4;' });

			var data = getAllByParams('cndAdesione', 'Status', params);
			return $q.when(data);
		}

		function cndAdesione_get(id) {
			var data = getById('cndAdesione', id);
			return $q.when(data);
		}

		function cndAdesione_getByUID(UID, progettoUID) {
			var params = [];
			params.push({ name: 'UID', value: UID });
			params.push({ name: 'progettoUID', value: progettoUID });

			var data = getAllByParams('cndAdesione', 'GetByUID', params);
			return $q.when(data);
		}

		function cndAdesione_add(item) {
			var data = addObj('cndAdesione', item);
			return $q.when(data);
		}

		function cndAdesione_update(item) {
			var data = updateObj('cndAdesione', item);
			return $q.when(data);
		}

		function cndAdesione_delete(id) {
			var data = deleteObj('cndAdesione', id);
			return $q.when(data);
		}

		function cndAdesione_changeStatus(id, action, tSourceCode) {
			if (typeof id == 'undefined') { id = 0; }
			if (typeof action == 'undefined') { action = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'action', value: action });
			params.push({ name: 'tSourceCode', value: tSourceCode });


			var url = urlAPI + '/cndAdesione/ChangeStatus';

			var numParams = params.length;
			if (numParams > 0) {
				url += '?';
			}

			for (var i = 0; i < numParams; i++) {
				if (i > 0) url += '&';
				url += params[i].name + '=' + params[i].value;
			}

			return $http.get(url)
				.then(function (response) {
					//console.info('XHR Success cndAdesione_changeStatus for %s: %s', 'ChangeStatus', response);
					return response;
				})
				.catch(function (message) {
					console.info('XHR Failed cndAdesione_changeStatus for %s: %s', 'ChangeStatus', message);
					return message;
				});
		}

		//Metodi senza [Authorize]
		function cndAdesione_getListCPI() {
			var data = getAllNoParam('cndAdesione', 'GetListCPI');
			return $q.when(data);
		}
		function cndAdesione_getAllPartecipazione(tRuoloCode) {
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = 'AZD_FORM-FAM1'; }
			var data = getAllByParam('cndAdesione', 'GetAllPartecipazione', 'tRuoloCode', tRuoloCode);
			return $q.when(data);
		}
		function cndAdesione_getAllPsede(partecipazioneId) {
			if (typeof partecipazioneId == 'undefined') { partecipazioneId = 0; }
			var data = getAllByParam('cndAdesione', 'GetAllPsede', 'partecipazioneId', partecipazioneId);
			return $q.when(data);
		}

		// ******************************
		//  CONVENZIONE

		function cndConvenzione_setParams(isGet, pageSize, page, order, testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid) {
			if (isGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}

			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof iSentConv == 'undefined') { iSentConv = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof uid == 'undefined') { uid = ''; }

			var params = [];
			if (isGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}

			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'iSentConv', value: iSentConv });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'uid', value: uid });

			return params;
		}
		function cndConvenzione_getAllList(testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid) {
			var params = cndConvenzione_setParams(false, 0, 0, '', testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid);
			var data = getAllByParams('cndConvenzione', 'GetAllListByFilter', params);
			return $q.when(data);
		}
		function cndConvenzione_getAll(pageSize, page, testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid, order) {
			var params = cndConvenzione_setParams(true, pageSize, page, order, testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid);
			var data = getAllByParams('cndConvenzione', 'GetAllByFilter', params);
			return $q.when(data);
		}
		function cndConvenzione_countAll(testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid) {
			var params = cndConvenzione_setParams(false, 0, 0, '', testuale, tMisuraCode, progettoId, tSourceCode, sourceId, iFinestra, iSentConv, iStato, uid);
			var data = getAllByParams('cndConvenzione', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndConvenzione_create(tRuoloCode, cndPartecipazioneId, bClone) {
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof cndPartecipazioneId == 'undefined') { cndPartecipazioneId = 0; }
			if (typeof bClone == 'undefined') { bClone = false; }

			var params = [];
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'cndPartecipazioneId', value: cndPartecipazioneId });
			params.push({ name: 'bClone', value: bClone });

			var data = getAllByParams('cndConvenzione', 'Create', params);
			return $q.when(data);
		}

		function cndConvenzione_exists(tMisuraCode, progettoId, convenzioneId, tSourceCode, sourceId, iFinestra) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof convenzioneId == 'undefined') { convenzioneId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'convenzioneId', value: convenzioneId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'iFinestra', value: iFinestra });

			var data = getAllByParams('cndConvenzione', 'Exists', params);
			return $q.when(data);
		}

		function cndConvenzione_specialAnnulled(convenzioneId, noteAnnulled) {
			if (typeof convenzioneId == 'undefined') { convenzioneId = 0; }
			if (typeof noteAnnulled == 'undefined') { noteAnnulled = ''; }

			var params = [];
			params.push({ name: 'convenzioneId', value: convenzioneId });
			params.push({ name: 'noteAnnulled', value: noteAnnulled });

			var data = getAllByParams('cndConvenzione', 'SpecialAnnulled', params);
			return $q.when(data);
		}

		function cndConvenzione_get(id) {
			var data = getById('cndConvenzione', id);
			return $q.when(data);
		}

		function cndConvenzione_getByUID(uid, progettoUID) {
			var params = [];
			params.push({ name: 'Uid', value: uid });
			params.push({ name: 'progettoUID', value: progettoUID });

			var data = getAllByParams('cndConvenzione', 'GetByUID', params);
			return $q.when(data);
		}

		function cndConvenzione_setStatus(item) {
			var objName = 'cndConvenzione';

			return $http.put(urlAPI + '/' + objName + '/SetStatus', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

        function cndConvenzione_addOrUpdate(item) {
            var objName = 'cndConvenzione';

            return $http.post(urlAPI + '/' + objName + '/AddOrUpdate', item)
                .then(function (response) {
                    return response.data;
                })
                .catch(function (message) {
                    //console.info('XHR Failed updateObj for %s: %s', objName, message);
                    return message.status;
                });
        }

        function cndConvenzione_add(item) {
            var data = addObj('cndConvenzione', item);
            return $q.when(data);
        }

		function cndConvenzione_update(item) {
			var data = updateObj('cndConvenzione', item);
			return $q.when(data);
		}

		function cndConvenzione_merge(item) {
			var data = mergeObj('cndConvenzione', item);
			return $q.when(data);
		}

		function cndConvenzione_delete(id) {
			var data = deleteObj('cndConvenzione', id);
			return $q.when(data);
		}

		function cndConvenzione_setAnnulled(id, locked, noteAnnulled) {
			if (typeof noteAnnulled == 'undefined') { noteAnnulled = ''; }
			var params = [];
			params.push({ name: 'id', value: id });
			params.push({ name: 'locked', value: locked });
			params.push({ name: 'noteAnnulled', value: noteAnnulled });

			var data = getAllByParams('cndConvenzione', 'SetAnnulled', params);
			return $q.when(data);
		}

		function cndConvenzione_unlock(item) {
			var objName = 'cndConvenzione';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndConvenzione_sendConvenzione(progettoId, iFinestra, iStato) {
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'iStato', value: iStato });
			var data = getAllByParams('cndConvenzione', 'SendConvenzione', params);
			return $q.when(data);
		}

		function cndConvenzione_sendConvenzioneReOpen(progettoId, iFinestra, iStato) {
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }

			var params = [];
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'iStato', value: iStato });
			var data = getAllByParams('cndConvenzione', 'SendConvenzioneReOpen', params);
			return $q.when(data);
		}

		function cndConvenzione_sendConvEsito(progettoId, iFinestra, iStato, esito) {
			if (typeof progettoId == 'undefined') { progettoId = 0; }
			if (typeof iFinestra == 'undefined') { iFinestra = 0; }
			if (typeof iStato == 'undefined') { iStato = 0; }
			if (typeof esito == 'undefined') { esito = ''; }

			var params = [];
			params.push({ name: 'progettoId', value: progettoId });
			params.push({ name: 'iFinestra', value: iFinestra });
			params.push({ name: 'iStato', value: iStato });
			params.push({ name: 'esito', value: esito });
			var data = getAllByParams('cndConvenzione', 'SendEsitoPEC', params);
			return $q.when(data);
		}


		//*********************************
		//--  CANDIDATURE: CONVENZIONI-DETTAGLIO
		function cndConvenzioneDtl_get(id) {
			var data = getById('CNDConvenzioneDtl', id);
			return $q.when(data);
		}

		function cndConvenzioneDtl_merge(item) {
			var data = mergeObj('CNDConvenzioneDtl', item);
			return $q.when(data);
		}


		//*********************************
		//-- SEND LINK ACCESSO FROM EMAIL AND CODICE FISCALE
		function cndProgetto_sendLnkAccesso(progettoUID, email, codiceFiscale, tipoCandidatura) {
			var params = [];
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'email', value: email });
			params.push({ name: 'codiceFiscale', value: codiceFiscale });
			params.push({ name: 'tipoCandidatura', value: tipoCandidatura });

			var data = getAllByParams('CNDProgetto', 'SendLnkAccesso', params);
			return $q.when(data);
		}


		// ******************************
		//  Progetto
		function cndProgetto_setParams(pageSize, page, testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data, order, bGet) {
			if (bGet) {
				if (typeof pageSize == 'undefined') { pageSize = 0; }
				if (typeof page == 'undefined') { page = 0; }
				if (typeof order == 'undefined') { order = ''; }
			}
			if (typeof testuale == 'undefined') { testuale = ''; }
			if (typeof codeUID == 'undefined') { codeUID = ''; }
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tRuoloCode == 'undefined') { tRuoloCode = ''; }
			if (typeof progetto == 'undefined') { progetto = ''; }
			if (typeof iTipoCandidatura == 'undefined') { iTipoCandidatura = 0; }
			if (typeof _data == 'undefined') { _data = ''; }

			var params = [];
			if (bGet) {
				params.push({ name: 'pageSize', value: pageSize });
				params.push({ name: 'page', value: page });
				params.push({ name: 'order', value: order });
			}
			params.push({ name: 'testuale', value: testuale });
			params.push({ name: 'codeUID', value: codeUID });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tRuoloCode', value: tRuoloCode });
			params.push({ name: 'progetto', value: progetto });
			params.push({ name: 'iTipoCandidatura', value: iTipoCandidatura });
			params.push({ name: '_data', value: _data });

			return params;
		}

		function cndProgetto_getAllList(testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data) {
			var params = cndProgetto_setParams(0, 0, testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data, '', false);

			var data = getAllByParams('CNDProgetto', 'GetAllList', params);
			return $q.when(data);
		}

		function cndProgetto_getAll(pageSize, page, testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data, order) {
			var params = cndProgetto_setParams(pageSize, page, testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data, order, true);

			var data = getAllByParams('CNDProgetto', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndProgetto_countAll(testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data) {
			var params = cndProgetto_setParams(0, 0, testuale, codeUID, tMisuraCode, tRuoloCode, progetto, iTipoCandidatura, _data, '', false);

			var data = getAllByParams('CNDProgetto', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndProgetto_get(id) {
			var data = getById('CNDProgetto', id);
			return $q.when(data);
		}

		function cndProgetto_getByUID(UID) {
			var objName = 'CNDProgetto';
			return $http.get(urlAPI + '/' + objName + '/GetByUID?UID=' + UID)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getByUID for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndProgetto_add(item) {
			var data = addObj('CNDProgetto', item);
			return $q.when(data);
		}

		function cndProgetto_update(item) {
			var data = updateObj('CNDProgetto', item);
			return $q.when(data);
		}

		function cndProgetto_delete(id) {
			var data = deleteObj('CNDProgetto', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV
		function cndCV_getAllList(domandaAdesioneId, nominativo) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('cndCV', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCV_getAll(pageSize, page, domandaAdesioneId, nominativo, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCV', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCV_countAll(domandaAdesioneId, nominativo) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof nominativo == 'undefined') { nominativo = ''; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'nominativo', value: nominativo });

			var data = getAllByParams('cndCV', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCV_get(id) {
			var data = getById('cndCV', id);
			return $q.when(data);
		}

		function cndCV_getByDomandaId(domandaId) {
			var objName = 'cndCV';
			return $http.get(urlAPI + '/' + objName + '/GetByDomandaId?domandaId=' + domandaId)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getByDomandaId for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_getByDomandaUID(uid) {
			var objName = 'cndCV';
			return $http.get(urlAPI + '/' + objName + '/GetByDomandaUID?Uid=' + uid)
				.then(function (response) {
					return response.data;
				})
				.catch(function (message) {
					//console.info('XHR Failed getByUID for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_unlock(item) {
			var objName = 'cndCV';

			return $http.put(urlAPI + '/' + objName + '/Unlock', item)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCV_printPDF(progettoUId, domandaUId) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'domandaUId', value: domandaUId });
			var data = getAllByParams('cndCV', 'GetAllegatoCV', params);
			return $q.when(data);
		}

		function cndCV_findCV(UId, progettoUID) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			var data = getAllByParams('cndCV', 'FindCV', params);
			return $q.when(data);
		}

		function cndCV_add(item) {
			var data = addObj('cndCV', item);
			return $q.when(data);
		}

		function cndCV_update(item) {
			var data = updateObj('cndCV', item);
			return $q.when(data);
		}

		function cndCV_delete(id) {
			var data = deleteObj('cndCV', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Abilit
		function cndCVAbilit_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVAbilit', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVAbilit_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVAbilit', 'GetAllByFilter', params);
			return $q.when(data);
		}

		function cndCVAbilit_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVAbilit', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVAbilit_get(id) {
			var data = getById('cndCVAbilit', id);
			return $q.when(data);
		}

		function cndCVAbilit_add(item) {
			var data = addObj('cndCVAbilit', item);
			return $q.when(data);
		}

		function cndCVAbilit_update(item) {
			var data = updateObj('cndCVAbilit', item);
			return $q.when(data);
		}

		function cndCVAbilit_delete(id) {
			var data = deleteObj('cndCVAbilit', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Corso
		function cndCVCorso_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVCorso', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVCorso_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVCorso', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVCorso_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVCorso', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVCorso_get(id) {
			var data = getById('cndCVCorso', id);
			return $q.when(data);
		}

		function cndCVCorso_add(item) {
			var data = addObj('cndCVCorso', item);
			return $q.when(data);
		}

		function cndCVCorso_update(item) {
			var data = updateObj('cndCVCorso', item);
			return $q.when(data);
		}

		function cndCVCorso_delete(id) {
			var data = deleteObj('cndCVCorso', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Servizio
		function cndCVServizio_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVServizio', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVServizio_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVServizio', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVServizio_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVServizio', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVServizio_get(id) {
			var data = getById('cndCVServizio', id);
			return $q.when(data);
		}


		function cndCVServizio_saveAll(objValue) {
			var objName = 'cndCVServizio';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCVServizio_add(item) {
			var data = addObj('cndCVServizio', item);
			return $q.when(data);
		}

		function cndCVServizio_update(item) {
			var data = updateObj('cndCVServizio', item);
			return $q.when(data);
		}

		function cndCVServizio_delete(id) {
			var data = deleteObj('cndCVServizio', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Pubb
		function cndCVPubb_getAllList(domandaAdesioneId, tipoPubbId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVPubb', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVPubb_getAll(pageSize, page, domandaAdesioneId, tipoPubbId, anno, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVPubb', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVPubb_countAll(domandaAdesioneId, tipoPubbId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof tipoPubbId == 'undefined') { tipoPubbId = -1; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'tipoPubbId', value: tipoPubbId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVPubb', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVPubb_get(id) {
			var data = getById('cndCVPubb', id);
			return $q.when(data);
		}

		function cndCVPubb_add(item) {
			var data = addObj('cndCVPubb', item);
			return $q.when(data);
		}

		function cndCVPubb_update(item) {
			var data = updateObj('cndCVPubb', item);
			return $q.when(data);
		}

		function cndCVPubb_delete(id) {
			var data = deleteObj('cndCVPubb', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Spec
		function cndCVSpec_getAllList(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVSpec', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVSpec_getAll(pageSize, page, domandaAdesioneId, anno, mese, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVSpec', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVSpec_countAll(domandaAdesioneId, anno, mese, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof mese == 'undefined') { mese = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'mese', value: mese });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVSpec', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVSpec_get(id) {
			var data = getById('cndCVSpec', id);
			return $q.when(data);
		}


		function cndCVSpec_saveAll(objValue) {
			var objName = 'cndCVSpec';
			return $http.post(urlAPI + '/' + objName + '/SaveAll', objValue)
				.then(function (response) {
					return response.status;
				})
				.catch(function (message) {
					//console.info('XHR Failed updateObj for %s: %s', objName, message);
					return message.status;
				});
		}

		function cndCVSpec_add(item) {
			var data = addObj('cndCVSpec', item);
			return $q.when(data);
		}

		function cndCVSpec_update(item) {
			var data = updateObj('cndCVSpec', item);
			return $q.when(data);
		}

		function cndCVSpec_delete(id) {
			var data = deleteObj('cndCVSpec', id);
			return $q.when(data);
		}

		// ******************************
		//  CND CV Idoneita
		function cndCVIdoneita_getAllList(domandaAdesioneId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVIdoneita', 'GetAllList', params);

			return $q.when(data);
		}

		function cndCVIdoneita_getAll(pageSize, page, domandaAdesioneId, anno, bValide, bDelete, order) {
			if (typeof pageSize == 'undefined') { pageSize = 0; }
			if (typeof page == 'undefined') { page = 0; }
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }
			if (typeof order == 'undefined') { order = ''; }

			var params = [];
			params.push({ name: 'pageSize', value: pageSize });
			params.push({ name: 'page', value: page });
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });
			params.push({ name: 'order', value: order });

			var data = getAllByParams('cndCVIdoneita', 'GetAllByFilter', params);
			return $q.when(data);
		}


		function cndCVIdoneita_countAll(domandaAdesioneId, anno, bValide, bDelete) {
			if (typeof domandaAdesioneId == 'undefined') { domandaAdesioneId = 0; }
			if (typeof anno == 'undefined') { anno = -1; }
			if (typeof bValide == 'undefined') { bValide = -1; }
			if (typeof bDelete == 'undefined') { bDelete = -1; }

			var params = [];
			params.push({ name: 'domandaAdesioneId', value: domandaAdesioneId });
			params.push({ name: 'anno', value: anno });
			params.push({ name: 'bValide', value: bValide });
			params.push({ name: 'bDelete', value: bDelete });

			var data = getAllByParams('cndCVIdoneita', 'CountByFilter', params);
			return $q.when(data);
		}

		function cndCVIdoneita_get(id) {
			var data = getById('cndCVIdoneita', id);
			return $q.when(data);
		}

		function cndCVIdoneita_add(item) {
			var data = addObj('cndCVIdoneita', item);
			return $q.when(data);
		}

		function cndCVIdoneita_update(item) {
			var data = updateObj('cndCVIdoneita', item);
			return $q.when(data);
		}

		function cndCVIdoneita_delete(id) {
			var data = deleteObj('cndCVIdoneita', id);
			return $q.when(data);
		}

		// #endregion 

		// #region PDF CONTROLLER

		function pdf_printAttach(filterCode, progettoUID, sourceUID, misura, codeAttach) {
			if (typeof filterCode == 'undefined') { filterCode = ''; }
			if (typeof progettoUID == 'undefined') { progettoUID = ''; }
			if (typeof sourceUID == 'undefined') { sourceUID = '00000000-0000-0000-0000-000000000000'; }
			if (typeof misura == 'undefined') { misura = ''; }
			if (typeof codeAttach == 'undefined') { codeAttach = ''; }

			var params = [];
			params.push({ name: 'filterCode', value: filterCode });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'sourceUID', value: sourceUID });
			params.push({ name: 'misura', value: misura });
			params.push({ name: 'codeAttach', value: codeAttach });

			var data = getPDFByParams('PDF', 'GetAllegato', params);
			return $q.when(data);
		}

		function pdf_printAttach2(tSourceId, tSourceCode, sourceId, corsoId, codeAttach, pAziendaId) {
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof corsoId == 'undefined') { corsoId = 0; }
			if (typeof codeAttach == 'undefined') { codeAttach = ''; }
			if (typeof pAziendaId == 'undefined') { pAziendaId = 0; }

			var params = [];
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'corsoId', value: corsoId });
			params.push({ name: 'codeAttach', value: codeAttach });
			params.push({ name: 'pAziendaId', value: pAziendaId });

			var data = getPDFByParams('PDF', 'GetAllegato', params);
			return $q.when(data);
		}

		function pdf_findAttach(UId, progettoUID, misura) {
			var params = [];
			params.push({ name: 'UId', value: UId });
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'misura', value: misura });

			var data = getPDFByParams('PDF', 'FindAllegato', params);
			return $q.when(data);
		}

		function pdf_printRicevuta(progettoUId, accredUId, misura) {
			var params = [];
			params.push({ name: 'progettoUId', value: progettoUId });
			params.push({ name: 'accredUId', value: accredUId });
			params.push({ name: 'misura', value: misura });

			var data = getPDFByParams('PDF', 'PrintRicevuta', params);
			return $q.when(data);
		}

		function pdf_printRicevuta2(tSourceId, tSourceCode, sourceId) {
			if (typeof tSourceId == 'undefined') { tSourceId = 0; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }

			var params = [];
			params.push({ name: 'tSourceId', value: tSourceId });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getPDFByParams('PDF', 'PrintRicevuta', params);
			return $q.when(data);
		}

		function pdf_printConvenzione(progettoUID, convenzioneUID, misura) {
			var params = [];
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'convenzioneUID', value: convenzioneUID });
			params.push({ name: 'misura', value: misura });

			var data = getPDFByParams('PDF', 'CNDConvenzione_Print', params);
			return $q.when(data);
		}

		function pdf_printConvenzioneRicevuta(progettoUID, convenzioneUID, misura) {
			var params = [];
			params.push({ name: 'progettoUID', value: progettoUID });
			params.push({ name: 'convenzioneUID', value: convenzioneUID });
			params.push({ name: 'misura', value: misura });

			var data = getPDFByParams('PDF', 'CNDConvenzione_PrintRicevuta', params);

			return $q.when(data);
		}

		function pdf_printClasseRmb(classeRimborsoId, tMisuraCode, type, index) {
			if (typeof index == 'undefined') { index = 0; }

			var params = [];
			params.push({ name: 'classeRimborsoId', value: classeRimborsoId });
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'type', value: type });
			params.push({ name: 'index', value: index });

			var data = getPDFByParams('PDF', 'GetClasseRimborso', params);

			return $q.when(data);
		}

		function pdf_printRegistro(tMisuraCode, lezGGId, dt, sMode, pagina, _completed) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof lezGGId == 'undefined') { lezGGId = 0; }
			if (typeof dt == 'undefined') { dt = ''; }
			if (typeof sMode == 'undefined') { sMode = 'all'; }
			if (typeof pagina == 'undefined') { pagina = 0; }
			if (typeof _completed == 'undefined') { _completed = false; }
			var params = [];

			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'lezGGId', value: lezGGId });
			params.push({ name: 'dt', value: dt });
			params.push({ name: 'sMode', value: sMode });
			params.push({ name: 'pagina', value: pagina });
			params.push({ name: '_completed', value: _completed });

			var data = getPDFByParams('PDF', 'GetRegistroPresenze', params);

			return $q.when(data);
		}

		function pdf_printConv1C3(tMisuraCode, sourceId) {
			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getPDFByParams('PDF', 'Mis1C3_Print', params);
			return $q.when(data);
		}

		function pdf_printConv7(tMisuraCode, sourceId) {
			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'sourceId', value: sourceId });

			var data = getPDFByParams('PDF', 'Mis7_Print', params);
			return $q.when(data);
		}

		function pdf_printRmb(tMisuraCode, tSourceCode, sourceId, percorso, code) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'code', value: code });

			var data = getPDFByParams('PDF', 'Rmb_Print', params);
			return $q.when(data);
		}

		function pdf_printFormazione(tMisuraCode, tSourceCode, sourceId, percorso, code) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'code', value: code });

			var data = getPDFByParams('PDF', 'Formazione_Print', params);
			return $q.when(data);
		}

		function pdf_printOrientamenti(tMisuraCode, tSourceCode, sourceId, percorso, code) {
			if (typeof tMisuraCode == 'undefined') { tMisuraCode = ''; }
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof percorso == 'undefined') { percorso = ''; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'tMisuraCode', value: tMisuraCode });
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'percorso', value: percorso });
			params.push({ name: 'code', value: code });

			var data = getPDFByParams('PDF', 'Orientamenti_Print', params);
			return $q.when(data);
		}

		function pdf_printOutcome(outcomeId, codeName) {
			if (typeof outcomeId == 'undefined') { outcomeId = 0; }
			if (typeof codeName == 'undefined') { codeName = 'VERIFICA'; }

			var params = [];
			params.push({ name: 'outcomeId', value: outcomeId });
			params.push({ name: 'codeName', value: codeName });

			var data = getPDFByParams('PDF', 'Outcome_Print', params);
			return $q.when(data);
		}

		function pdf_printCommission(commissionId, codeName) {
			if (typeof commissionId == 'undefined') { commissionId = 0; }
			if (typeof codeName == 'undefined') { codeName = 'DRS'; }

			var params = [];
			params.push({ name: 'commissionId', value: commissionId });
			params.push({ name: 'codeName', value: codeName });

			var data = getPDFByParams('PDF', 'Commission_Print', params);
			return $q.when(data);
		}

		function pdf_formazione_GetAllegato(tSourceCode, sourceId, code) {
			if (typeof tSourceCode == 'undefined') { tSourceCode = ''; }
			if (typeof sourceId == 'undefined') { sourceId = 0; }
			if (typeof code == 'undefined') { code = ''; }

			var params = [];
			params.push({ name: 'tSourceCode', value: tSourceCode });
			params.push({ name: 'sourceId', value: sourceId });
			params.push({ name: 'code', value: code });

			var data = getPDFByParams('PDF', 'Formazione_GetAllegato', params);
			return $q.when(data);
		}

		// #endregion

	}
})();